webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(273);
	__webpack_require__(275);
	__webpack_require__(277);
	__webpack_require__(279);
	__webpack_require__(282);
	__webpack_require__(284);
	module.exports = __webpack_require__(285);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	    'use strict';

	    __webpack_require__(2);

	    angular.module('app', [
	        /*
	         * Everybody has access to these.
	         * We could place these under every feature area,
	         * but this is easier to maintain.
	         */
	        'app.core',
	        'app.data', // needs core
	        'app.widgets', // needs core
	        /*SHELL*/
	        'app.layout',
	        'app.login',
	        'app.language',
	        'app.booking',
	        /* features*/
	        //'app.association',
	        //'app.therapistMaster',
	        //'app.therapist',
	        //'app.clinicMaster',
	        //'app.clinic',

	        //'app.preference',
	        //'app.dynamic',
	        //'app.advisor',
	        //'app.formly'
	    ]);

	    __webpack_require__(232);
	})();


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	//app.require.js
	//var angular = require('angular');
	__webpack_require__(7);
	// require('bootstrap');
	// require("obtBower/bootstrap/dist/css/bootstrap.min.css");
	// require("obtBower/bootstrap/dist/css/bootstrap-theme.min.css");


	// require("css-loader?minimize!./file.css");

	__webpack_require__(8);
	__webpack_require__(15);
	__webpack_require__(17);

	__webpack_require__(24);
	__webpack_require__(26);
	__webpack_require__(28);


	__webpack_require__(30);
	__webpack_require__(32);

	__webpack_require__(34);
	__webpack_require__(35); /* or .min.css */
	__webpack_require__(37);
	__webpack_require__(38);


	__webpack_require__(39);
	__webpack_require__(41);
	__webpack_require__(42);

	__webpack_require__(43);
	__webpack_require__(45);



	__webpack_require__(46),
	__webpack_require__(49),
	__webpack_require__(52),
	__webpack_require__(3);
	__webpack_require__(54);
	__webpack_require__(56);
	__webpack_require__(58);
	__webpack_require__(60);

	// require("obtStyle/skin-navy.css");
	__webpack_require__(62);
	__webpack_require__(64);
	__webpack_require__(66);

	__webpack_require__(68);
	__webpack_require__(70);

	// require('obtStyle/skins/_all-skins.min.css');

	__webpack_require__(72);
	// app/widgets/obtSection/same_col_height.css

	// require("css!obtStyle/AdminLTE.css"),
	// require("css!obtStyle/calendar.css"),
	// require("css!obtStyle/parallax.css"),
	// require("css!obtStyle/recaptchaResponsive.css");

	__webpack_require__(78);


	__webpack_require__(80);
	__webpack_require__(99);
	__webpack_require__(157);
	__webpack_require__(172);
	__webpack_require__(210);
	__webpack_require__(215);
	__webpack_require__(218);
	__webpack_require__(225);
	 __webpack_require__(231);

	// require('obtBower/fullcalendar/dist/gcal.js');
	// require('obtBower/fullcalendar/dist/lang/en-ca.js');
	// require('obtBower/fullcalendar/dist/lang/fr-ca.js');


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(4);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./recaptchaResponsive.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./recaptchaResponsive.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "div#recaptcha_image,div#recaptcha_widget{width:100%!important}div#recaptcha_image{height:auto!important}div#recaptcha_image>img{width:100%!important}", ""]);

	// exports


/***/ },
/* 5 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(9);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./bootstrap.min.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./bootstrap.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}legend{padding:0;border:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:0 0!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(10) + ");src:url(" + __webpack_require__(10) + "?#iefix) format('embedded-opentype'),url(" + __webpack_require__(11) + ") format('woff2'),url(" + __webpack_require__(12) + ") format('woff'),url(" + __webpack_require__(13) + ") format('truetype'),url(" + __webpack_require__(14) + "#glyphicons_halflingsregular) format('svg')}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;width:100%;height:300px;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:'\\2014   \\A0'}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:''}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:'\\A0   \\2014'}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled=false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;-webkit-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),all and (transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000',endColorstr='#00000000',GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000',endColorstr='#80000000',GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:'\\2039'}.carousel-control .icon-next:before{content:'\\203A'}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);

	// exports


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4769f9bdb7466be65088239c12046d1.eot";

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89889688147bd7575d6327160d64e760.svg";

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(16);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./bootstrap-theme.min.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./bootstrap-theme.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */.btn-danger,.btn-default,.btn-info,.btn-primary,.btn-success,.btn-warning{text-shadow:0 -1px 0 rgba(0,0,0,.2);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}.btn-danger.active,.btn-danger:active,.btn-default.active,.btn-default:active,.btn-info.active,.btn-info:active,.btn-primary.active,.btn-primary:active,.btn-success.active,.btn-success:active,.btn-warning.active,.btn-warning:active{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-danger.disabled,.btn-danger[disabled],.btn-default.disabled,.btn-default[disabled],.btn-info.disabled,.btn-info[disabled],.btn-primary.disabled,.btn-primary[disabled],.btn-success.disabled,.btn-success[disabled],.btn-warning.disabled,.btn-warning[disabled],fieldset[disabled] .btn-danger,fieldset[disabled] .btn-default,fieldset[disabled] .btn-info,fieldset[disabled] .btn-primary,fieldset[disabled] .btn-success,fieldset[disabled] .btn-warning{box-shadow:none}.btn-danger .badge,.btn-default .badge,.btn-info .badge,.btn-primary .badge,.btn-success .badge,.btn-warning .badge{text-shadow:none}.btn.active,.btn:active{background-image:none}.btn-default{text-shadow:0 1px 0 #fff;background-image:-webkit-linear-gradient(top,#fff,#e0e0e0);background-image:-webkit-gradient(linear,left top,left bottom,from(#fff),to(#e0e0e0));background-image:linear-gradient(180deg,#fff 0,#e0e0e0);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff',endColorstr='#ffe0e0e0',GradientType=0);filter:progid:DXImageTransform.Microsoft.gradient(enabled=false);background-repeat:repeat-x;border-color:#dbdbdb;border-color:#ccc}.btn-default:focus,.btn-default:hover{background-color:#e0e0e0;background-position:0 -15px}.btn-default.active,.btn-default:active{background-color:#e0e0e0;border-color:#dbdbdb}.btn-default.disabled,.btn-default.disabled.active,.btn-default.disabled.focus,.btn-default.disabled:active,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled],.btn-default[disabled].active,.btn-default[disabled].focus,.btn-default[disabled]:active,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default,fieldset[disabled] .btn-default.active,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:active,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#e0e0e0;background-image:none}.btn-primary{background-image:-webkit-linear-gradient(top,#337ab7,#265a88);background-image:-webkit-gradient(linear,left top,left bottom,from(#337ab7),to(#265a88));background-image:linear-gradient(180deg,#337ab7 0,#265a88);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff337ab7',endColorstr='#ff265a88',GradientType=0);filter:progid:DXImageTransform.Microsoft.gradient(enabled=false);background-repeat:repeat-x;border-color:#245580}.btn-primary:focus,.btn-primary:hover{background-color:#265a88;background-position:0 -15px}.btn-primary.active,.btn-primary:active{background-color:#265a88;border-color:#245580}.btn-primary.disabled,.btn-primary.disabled.active,.btn-primary.disabled.focus,.btn-primary.disabled:active,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled],.btn-primary[disabled].active,.btn-primary[disabled].focus,.btn-primary[disabled]:active,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary,fieldset[disabled] .btn-primary.active,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:active,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#265a88;background-image:none}.btn-success{background-image:-webkit-linear-gradient(top,#5cb85c,#419641);background-image:-webkit-gradient(linear,left top,left bottom,from(#5cb85c),to(#419641));background-image:linear-gradient(180deg,#5cb85c 0,#419641);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5cb85c',endColorstr='#ff419641',GradientType=0);filter:progid:DXImageTransform.Microsoft.gradient(enabled=false);background-repeat:repeat-x;border-color:#3e8f3e}.btn-success:focus,.btn-success:hover{background-color:#419641;background-position:0 -15px}.btn-success.active,.btn-success:active{background-color:#419641;border-color:#3e8f3e}.btn-success.disabled,.btn-success.disabled.active,.btn-success.disabled.focus,.btn-success.disabled:active,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled],.btn-success[disabled].active,.btn-success[disabled].focus,.btn-success[disabled]:active,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success,fieldset[disabled] .btn-success.active,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:active,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#419641;background-image:none}.btn-info{background-image:-webkit-linear-gradient(top,#5bc0de,#2aabd2);background-image:-webkit-gradient(linear,left top,left bottom,from(#5bc0de),to(#2aabd2));background-image:linear-gradient(180deg,#5bc0de 0,#2aabd2);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5bc0de',endColorstr='#ff2aabd2',GradientType=0);filter:progid:DXImageTransform.Microsoft.gradient(enabled=false);background-repeat:repeat-x;border-color:#28a4c9}.btn-info:focus,.btn-info:hover{background-color:#2aabd2;background-position:0 -15px}.btn-info.active,.btn-info:active{background-color:#2aabd2;border-color:#28a4c9}.btn-info.disabled,.btn-info.disabled.active,.btn-info.disabled.focus,.btn-info.disabled:active,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled],.btn-info[disabled].active,.btn-info[disabled].focus,.btn-info[disabled]:active,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info,fieldset[disabled] .btn-info.active,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:active,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#2aabd2;background-image:none}.btn-warning{background-image:-webkit-linear-gradient(top,#f0ad4e,#eb9316);background-image:-webkit-gradient(linear,left top,left bottom,from(#f0ad4e),to(#eb9316));background-image:linear-gradient(180deg,#f0ad4e 0,#eb9316);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff0ad4e',endColorstr='#ffeb9316',GradientType=0);filter:progid:DXImageTransform.Microsoft.gradient(enabled=false);background-repeat:repeat-x;border-color:#e38d13}.btn-warning:focus,.btn-warning:hover{background-color:#eb9316;background-position:0 -15px}.btn-warning.active,.btn-warning:active{background-color:#eb9316;border-color:#e38d13}.btn-warning.disabled,.btn-warning.disabled.active,.btn-warning.disabled.focus,.btn-warning.disabled:active,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled],.btn-warning[disabled].active,.btn-warning[disabled].focus,.btn-warning[disabled]:active,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning,fieldset[disabled] .btn-warning.active,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:active,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#eb9316;background-image:none}.btn-danger{background-image:-webkit-linear-gradient(top,#d9534f,#c12e2a);background-image:-webkit-gradient(linear,left top,left bottom,from(#d9534f),to(#c12e2a));background-image:linear-gradient(180deg,#d9534f 0,#c12e2a);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffd9534f',endColorstr='#ffc12e2a',GradientType=0);filter:progid:DXImageTransform.Microsoft.gradient(enabled=false);background-repeat:repeat-x;border-color:#b92c28}.btn-danger:focus,.btn-danger:hover{background-color:#c12e2a;background-position:0 -15px}.btn-danger.active,.btn-danger:active{background-color:#c12e2a;border-color:#b92c28}.btn-danger.disabled,.btn-danger.disabled.active,.btn-danger.disabled.focus,.btn-danger.disabled:active,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled],.btn-danger[disabled].active,.btn-danger[disabled].focus,.btn-danger[disabled]:active,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger,fieldset[disabled] .btn-danger.active,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:active,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#c12e2a;background-image:none}.img-thumbnail,.thumbnail{box-shadow:0 1px 2px rgba(0,0,0,.075)}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{background-color:#e8e8e8;background-image:-webkit-linear-gradient(top,#f5f5f5,#e8e8e8);background-image:-webkit-gradient(linear,left top,left bottom,from(#f5f5f5),to(#e8e8e8));background-image:linear-gradient(180deg,#f5f5f5 0,#e8e8e8);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff5f5f5',endColorstr='#ffe8e8e8',GradientType=0);background-repeat:repeat-x}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{background-color:#2e6da4;background-image:-webkit-linear-gradient(top,#337ab7,#2e6da4);background-image:-webkit-gradient(linear,left top,left bottom,from(#337ab7),to(#2e6da4));background-image:linear-gradient(180deg,#337ab7 0,#2e6da4);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff337ab7',endColorstr='#ff2e6da4',GradientType=0);background-repeat:repeat-x}.navbar-default{background-image:-webkit-linear-gradient(top,#fff,#f8f8f8);background-image:-webkit-gradient(linear,left top,left bottom,from(#fff),to(#f8f8f8));background-image:linear-gradient(180deg,#fff 0,#f8f8f8);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff',endColorstr='#fff8f8f8',GradientType=0);filter:progid:DXImageTransform.Microsoft.gradient(enabled=false);background-repeat:repeat-x;border-radius:4px;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 5px rgba(0,0,0,.075)}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.open>a{background-image:-webkit-linear-gradient(top,#dbdbdb,#e2e2e2);background-image:-webkit-gradient(linear,left top,left bottom,from(#dbdbdb),to(#e2e2e2));background-image:linear-gradient(180deg,#dbdbdb 0,#e2e2e2);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffdbdbdb',endColorstr='#ffe2e2e2',GradientType=0);background-repeat:repeat-x;box-shadow:inset 0 3px 9px rgba(0,0,0,.075)}.navbar-brand,.navbar-nav>li>a{text-shadow:0 1px 0 hsla(0,0%,100%,.25)}.navbar-inverse{background-image:-webkit-linear-gradient(top,#3c3c3c,#222);background-image:-webkit-gradient(linear,left top,left bottom,from(#3c3c3c),to(#222));background-image:linear-gradient(180deg,#3c3c3c 0,#222);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff3c3c3c',endColorstr='#ff222222',GradientType=0);filter:progid:DXImageTransform.Microsoft.gradient(enabled=false);background-repeat:repeat-x;border-radius:4px}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.open>a{background-image:-webkit-linear-gradient(top,#080808,#0f0f0f);background-image:-webkit-gradient(linear,left top,left bottom,from(#080808),to(#0f0f0f));background-image:linear-gradient(180deg,#080808 0,#0f0f0f);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff080808',endColorstr='#ff0f0f0f',GradientType=0);background-repeat:repeat-x;box-shadow:inset 0 3px 9px rgba(0,0,0,.25)}.navbar-inverse .navbar-brand,.navbar-inverse .navbar-nav>li>a{text-shadow:0 -1px 0 rgba(0,0,0,.25)}.navbar-fixed-bottom,.navbar-fixed-top,.navbar-static-top{border-radius:0}@media (max-width:767px){.navbar .navbar-nav .open .dropdown-menu>.active>a,.navbar .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-image:-webkit-linear-gradient(top,#337ab7,#2e6da4);background-image:-webkit-gradient(linear,left top,left bottom,from(#337ab7),to(#2e6da4));background-image:linear-gradient(180deg,#337ab7 0,#2e6da4);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff337ab7',endColorstr='#ff2e6da4',GradientType=0);background-repeat:repeat-x}}.alert{text-shadow:0 1px 0 hsla(0,0%,100%,.2);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.25),0 1px 2px rgba(0,0,0,.05)}.alert-success{background-image:-webkit-linear-gradient(top,#dff0d8,#c8e5bc);background-image:-webkit-gradient(linear,left top,left bottom,from(#dff0d8),to(#c8e5bc));background-image:linear-gradient(180deg,#dff0d8 0,#c8e5bc);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffdff0d8',endColorstr='#ffc8e5bc',GradientType=0);background-repeat:repeat-x;border-color:#b2dba1}.alert-info{background-image:-webkit-linear-gradient(top,#d9edf7,#b9def0);background-image:-webkit-gradient(linear,left top,left bottom,from(#d9edf7),to(#b9def0));background-image:linear-gradient(180deg,#d9edf7 0,#b9def0);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffd9edf7',endColorstr='#ffb9def0',GradientType=0);background-repeat:repeat-x;border-color:#9acfea}.alert-warning{background-image:-webkit-linear-gradient(top,#fcf8e3,#f8efc0);background-image:-webkit-gradient(linear,left top,left bottom,from(#fcf8e3),to(#f8efc0));background-image:linear-gradient(180deg,#fcf8e3 0,#f8efc0);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcf8e3',endColorstr='#fff8efc0',GradientType=0);background-repeat:repeat-x;border-color:#f5e79e}.alert-danger{background-image:-webkit-linear-gradient(top,#f2dede,#e7c3c3);background-image:-webkit-gradient(linear,left top,left bottom,from(#f2dede),to(#e7c3c3));background-image:linear-gradient(180deg,#f2dede 0,#e7c3c3);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff2dede',endColorstr='#ffe7c3c3',GradientType=0);border-color:#dca7a7}.alert-danger,.progress{background-repeat:repeat-x}.progress{background-image:-webkit-linear-gradient(top,#ebebeb,#f5f5f5);background-image:-webkit-gradient(linear,left top,left bottom,from(#ebebeb),to(#f5f5f5));background-image:linear-gradient(180deg,#ebebeb 0,#f5f5f5);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffebebeb',endColorstr='#fff5f5f5',GradientType=0)}.progress-bar{background-image:-webkit-linear-gradient(top,#337ab7,#286090);background-image:-webkit-gradient(linear,left top,left bottom,from(#337ab7),to(#286090));background-image:linear-gradient(180deg,#337ab7 0,#286090);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff337ab7',endColorstr='#ff286090',GradientType=0);background-repeat:repeat-x}.progress-bar-success{background-image:-webkit-linear-gradient(top,#5cb85c,#449d44);background-image:-webkit-gradient(linear,left top,left bottom,from(#5cb85c),to(#449d44));background-image:linear-gradient(180deg,#5cb85c 0,#449d44);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5cb85c',endColorstr='#ff449d44',GradientType=0);background-repeat:repeat-x}.progress-bar-info{background-image:-webkit-linear-gradient(top,#5bc0de,#31b0d5);background-image:-webkit-gradient(linear,left top,left bottom,from(#5bc0de),to(#31b0d5));background-image:linear-gradient(180deg,#5bc0de 0,#31b0d5);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5bc0de',endColorstr='#ff31b0d5',GradientType=0);background-repeat:repeat-x}.progress-bar-warning{background-image:-webkit-linear-gradient(top,#f0ad4e,#ec971f);background-image:-webkit-gradient(linear,left top,left bottom,from(#f0ad4e),to(#ec971f));background-image:linear-gradient(180deg,#f0ad4e 0,#ec971f);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff0ad4e',endColorstr='#ffec971f',GradientType=0);background-repeat:repeat-x}.progress-bar-danger{background-image:-webkit-linear-gradient(top,#d9534f,#c9302c);background-image:-webkit-gradient(linear,left top,left bottom,from(#d9534f),to(#c9302c));background-image:linear-gradient(180deg,#d9534f 0,#c9302c);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffd9534f',endColorstr='#ffc9302c',GradientType=0);background-repeat:repeat-x}.progress-bar-striped{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.list-group{border-radius:4px;box-shadow:0 1px 2px rgba(0,0,0,.075)}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{text-shadow:0 -1px 0 #286090;background-image:-webkit-linear-gradient(top,#337ab7,#2b669a);background-image:-webkit-gradient(linear,left top,left bottom,from(#337ab7),to(#2b669a));background-image:linear-gradient(180deg,#337ab7 0,#2b669a);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff337ab7',endColorstr='#ff2b669a',GradientType=0);background-repeat:repeat-x;border-color:#2b669a}.list-group-item.active .badge,.list-group-item.active:focus .badge,.list-group-item.active:hover .badge{text-shadow:none}.panel{box-shadow:0 1px 2px rgba(0,0,0,.05)}.panel-default>.panel-heading{background-image:-webkit-linear-gradient(top,#f5f5f5,#e8e8e8);background-image:-webkit-gradient(linear,left top,left bottom,from(#f5f5f5),to(#e8e8e8));background-image:linear-gradient(180deg,#f5f5f5 0,#e8e8e8);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff5f5f5',endColorstr='#ffe8e8e8',GradientType=0);background-repeat:repeat-x}.panel-primary>.panel-heading{background-image:-webkit-linear-gradient(top,#337ab7,#2e6da4);background-image:-webkit-gradient(linear,left top,left bottom,from(#337ab7),to(#2e6da4));background-image:linear-gradient(180deg,#337ab7 0,#2e6da4);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff337ab7',endColorstr='#ff2e6da4',GradientType=0);background-repeat:repeat-x}.panel-success>.panel-heading{background-image:-webkit-linear-gradient(top,#dff0d8,#d0e9c6);background-image:-webkit-gradient(linear,left top,left bottom,from(#dff0d8),to(#d0e9c6));background-image:linear-gradient(180deg,#dff0d8 0,#d0e9c6);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffdff0d8',endColorstr='#ffd0e9c6',GradientType=0);background-repeat:repeat-x}.panel-info>.panel-heading{background-image:-webkit-linear-gradient(top,#d9edf7,#c4e3f3);background-image:-webkit-gradient(linear,left top,left bottom,from(#d9edf7),to(#c4e3f3));background-image:linear-gradient(180deg,#d9edf7 0,#c4e3f3);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffd9edf7',endColorstr='#ffc4e3f3',GradientType=0);background-repeat:repeat-x}.panel-warning>.panel-heading{background-image:-webkit-linear-gradient(top,#fcf8e3,#faf2cc);background-image:-webkit-gradient(linear,left top,left bottom,from(#fcf8e3),to(#faf2cc));background-image:linear-gradient(180deg,#fcf8e3 0,#faf2cc);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffcf8e3',endColorstr='#fffaf2cc',GradientType=0);background-repeat:repeat-x}.panel-danger>.panel-heading{background-image:-webkit-linear-gradient(top,#f2dede,#ebcccc);background-image:-webkit-gradient(linear,left top,left bottom,from(#f2dede),to(#ebcccc));background-image:linear-gradient(180deg,#f2dede 0,#ebcccc);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff2dede',endColorstr='#ffebcccc',GradientType=0);background-repeat:repeat-x}.well{background-image:-webkit-linear-gradient(top,#e8e8e8,#f5f5f5);background-image:-webkit-gradient(linear,left top,left bottom,from(#e8e8e8),to(#f5f5f5));background-image:linear-gradient(180deg,#e8e8e8 0,#f5f5f5);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffe8e8e8',endColorstr='#fff5f5f5',GradientType=0);background-repeat:repeat-x;border-color:#dcdcdc;box-shadow:inset 0 1px 3px rgba(0,0,0,.05),0 1px 0 hsla(0,0%,100%,.1)}", ""]);

	// exports


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(18);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./font-awesome.min.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./font-awesome.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.2.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(20) + ");src:url(" + __webpack_require__(21) + "?#iefix&v=4.2.0) format('embedded-opentype'),url(" + __webpack_require__(19) + ") format('woff'),url(" + __webpack_require__(22) + ") format('truetype'),url(" + __webpack_require__(23) + "#fontawesomeregular) format('svg');font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);-webkit-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);-webkit-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}", ""]);

	// exports


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d95d6f5d5ab7cfefd09651800b69bd54.woff";

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7149833697a959306ec3012a8588dcfa.eot";

/***/ },
/* 21 */
20,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4668ed2440df82d3fd2f8be9d31d07d.ttf";

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "65bcbc899f379216109acd0b6c494618.svg";

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(25);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./toastr.min.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./toastr.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".toast-title{font-weight:700}.toast-message{-ms-word-wrap:break-word;word-wrap:break-word}.toast-message a,.toast-message label{color:#fff}.toast-message a:hover{color:#ccc;text-decoration:none}.toast-close-button{position:relative;right:-.3em;top:-.3em;float:right;font-size:20px;font-weight:700;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80);line-height:1}.toast-close-button:focus,.toast-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}.rtl .toast-close-button{left:-.3em;float:left;right:.3em}button.toast-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.toast-top-center{top:0;right:0;width:100%}.toast-bottom-center{bottom:0;right:0;width:100%}.toast-top-full-width{top:0;right:0;width:100%}.toast-bottom-full-width{bottom:0;right:0;width:100%}.toast-top-left{top:12px;left:12px}.toast-top-right{top:12px;right:12px}.toast-bottom-right{right:12px;bottom:12px}.toast-bottom-left{bottom:12px;left:12px}#toast-container{position:fixed;z-index:999999;pointer-events:none}#toast-container *{box-sizing:border-box}#toast-container>div{position:relative;pointer-events:auto;overflow:hidden;margin:0 0 6px;padding:15px 15px 15px 50px;width:300px;border-radius:3px;background-position:15px;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;opacity:.8;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=80);filter:alpha(opacity=80)}#toast-container>div.rtl{direction:rtl;padding:15px 50px 15px 15px;background-position:right 15px center}#toast-container>div:hover{box-shadow:0 0 12px #000;opacity:1;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);filter:alpha(opacity=100);cursor:pointer}#toast-container>.toast-info{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toast-container>.toast-error{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toast-container>.toast-success{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toast-container>.toast-warning{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toast-container.toast-bottom-center>div,#toast-container.toast-top-center>div{width:300px;margin-left:auto;margin-right:auto}#toast-container.toast-bottom-full-width>div,#toast-container.toast-top-full-width>div{width:96%;margin-left:auto;margin-right:auto}.toast{background-color:#030303}.toast-success{background-color:#51a351}.toast-error{background-color:#bd362f}.toast-info{background-color:#2f96b4}.toast-warning{background-color:#f89406}.toast-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4;-ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=40);filter:alpha(opacity=40)}@media all and (max-width:240px){#toast-container>div{padding:8px 8px 8px 50px;width:11em}#toast-container>div.rtl{padding:8px 50px 8px 8px}#toast-container .toast-close-button{right:-.2em;top:-.2em}#toast-container .rtl .toast-close-button{left:-.2em;right:.2em}}@media all and (min-width:241px) and (max-width:480px){#toast-container>div{padding:8px 8px 8px 50px;width:18em}#toast-container>div.rtl{padding:8px 50px 8px 8px}#toast-container .toast-close-button{right:-.2em;top:-.2em}#toast-container .rtl .toast-close-button{left:-.2em;right:.2em}}@media all and (min-width:481px) and (max-width:768px){#toast-container>div{padding:15px 15px 15px 50px;width:25em}#toast-container>div.rtl{padding:15px 50px 15px 15px}}", ""]);

	// exports


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(27);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./fullcalendar.min.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./fullcalendar.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "/*!\n * FullCalendar v2.9.1 Stylesheet\n * Docs & License: http://fullcalendar.io/\n * (c) 2016 Adam Shaw\n */.fc-bgevent,.fc-highlight{opacity:.3;filter:alpha(opacity=30)}.fc-icon,body .fc{font-size:1em}.fc-button-group,.fc-icon{display:inline-block}.fc-bg,.fc-row .fc-bgevent-skeleton,.fc-row .fc-highlight-skeleton{bottom:0}.fc-icon,.fc-unselectable{-khtml-user-select:none;-webkit-touch-callout:none}.fc-time-grid-event.fc-short .fc-content,.fc-time-grid-event .fc-time,.fc .fc-axis,.fc button{white-space:nowrap}.fc{direction:ltr;text-align:left}.fc-rtl{text-align:right}.fc-basic-view .fc-week-number,.fc-icon,.fc-toolbar,.fc th{text-align:center}.fc-unthemed .fc-content,.fc-unthemed .fc-divider,.fc-unthemed .fc-popover,.fc-unthemed .fc-row,.fc-unthemed tbody,.fc-unthemed td,.fc-unthemed th,.fc-unthemed thead{border-color:#ddd}.fc-unthemed .fc-popover{background-color:#fff}.fc-unthemed .fc-divider,.fc-unthemed .fc-popover .fc-header{background:#eee}.fc-unthemed .fc-popover .fc-header .fc-close{color:#666}.fc-unthemed .fc-today{background:#fcf8e3}.fc-highlight{background:#bce8f1}.fc-bgevent{background:#8fdf82}.fc-nonbusiness{background:#d7d7d7}.fc-icon{height:1em;line-height:1em;overflow:hidden;font-family:Courier New,Courier,monospace;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.fc-icon:after{position:relative}.fc-icon-left-single-arrow:after{content:\"\\2039\";font-weight:700;font-size:200%;top:-7%}.fc-icon-right-single-arrow:after{content:\"\\203A\";font-weight:700;font-size:200%;top:-7%}.fc-icon-left-double-arrow:after{content:\"\\AB\";font-size:160%;top:-7%}.fc-icon-right-double-arrow:after{content:\"\\BB\";font-size:160%;top:-7%}.fc-icon-left-triangle:after{content:\"\\25C4\";font-size:125%;top:3%}.fc-icon-right-triangle:after{content:\"\\25BA\";font-size:125%;top:3%}.fc-icon-down-triangle:after{content:\"\\25BC\";font-size:125%;top:2%}.fc-icon-x:after{content:\"\\D7\";font-size:200%;top:6%}.fc button{box-sizing:border-box;margin:0;height:2.1em;padding:0 .6em;font-size:1em;cursor:pointer}.fc button::-moz-focus-inner{margin:0;padding:0}.fc-state-default{border:1px solid;background-color:#f5f5f5;background-image:-webkit-gradient(linear,0 0,0 100%,from(#fff),to(#e6e6e6));background-image:-webkit-linear-gradient(top,#fff,#e6e6e6);background-image:linear-gradient(180deg,#fff,#e6e6e6);background-repeat:repeat-x;border-color:#e6e6e6 #e6e6e6 #bfbfbf;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#333;text-shadow:0 1px 1px hsla(0,0%,100%,.75);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.2),0 1px 2px rgba(0,0,0,.05)}.fc-state-default.fc-corner-left{border-top-left-radius:4px;border-bottom-left-radius:4px}.fc-state-default.fc-corner-right{border-top-right-radius:4px;border-bottom-right-radius:4px}.fc button .fc-icon{position:relative;top:-.05em;margin:0 .2em;vertical-align:middle}.fc-state-active,.fc-state-disabled,.fc-state-down,.fc-state-hover{color:#333;background-color:#e6e6e6}.fc-state-hover{color:#333;text-decoration:none;background-position:0 -15px;-webkit-transition:background-position .1s linear;transition:background-position .1s linear}.fc-state-active,.fc-state-down{background-color:#ccc;background-image:none;box-shadow:inset 0 2px 4px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.05)}.fc-state-disabled{cursor:default;background-image:none;opacity:.65;filter:alpha(opacity=65);box-shadow:none}.fc-event.fc-draggable,.fc-event[href],.fc-popover .fc-header .fc-close{cursor:pointer}.fc .fc-button-group>*{float:left;margin:0 0 0 -1px}.fc .fc-button-group>:first-child{margin-left:0}.fc-popover{position:absolute;box-shadow:0 2px 6px rgba(0,0,0,.15)}.fc-popover .fc-header{padding:2px 4px}.fc-popover .fc-header .fc-title{margin:0 2px}.fc-ltr .fc-popover .fc-header .fc-title,.fc-rtl .fc-popover .fc-header .fc-close{float:left}.fc-ltr .fc-popover .fc-header .fc-close,.fc-rtl .fc-popover .fc-header .fc-title{float:right}.fc-unthemed .fc-popover{border-width:1px;border-style:solid}.fc-unthemed .fc-popover .fc-header .fc-close{font-size:.9em;margin-top:2px}.fc-popover>.ui-widget-header+.ui-widget-content{border-top:0}.fc-divider{border-style:solid;border-width:1px}hr.fc-divider{height:0;margin:0;padding:0 0 2px;border-width:1px 0}.fc-bg table,.fc-row .fc-bgevent-skeleton table,.fc-row .fc-highlight-skeleton table{height:100%}.fc-clear{clear:both}.fc-bg,.fc-bgevent-skeleton,.fc-helper-skeleton,.fc-highlight-skeleton{position:absolute;top:0;left:0;right:0}.fc table{width:100%;box-sizing:border-box;table-layout:fixed;border-collapse:collapse;border-spacing:0;font-size:1em}.fc td,.fc th{border-style:solid;border-width:1px;padding:0;vertical-align:top}.fc td.fc-today{border-style:double}.fc .fc-row{border-style:solid;border-width:0}.fc-row table{border-left:0 hidden transparent;border-right:0 hidden transparent;border-bottom:0 hidden transparent}.fc-row:first-child table{border-top:0 hidden transparent}.fc-row{position:relative}.fc-row .fc-bg{z-index:1}.fc-row .fc-bgevent-skeleton td,.fc-row .fc-highlight-skeleton td{border-color:transparent}.fc-row .fc-bgevent-skeleton{z-index:2}.fc-row .fc-highlight-skeleton{z-index:3}.fc-row .fc-content-skeleton{position:relative;z-index:4;padding-bottom:2px}.fc-row .fc-helper-skeleton{z-index:5}.fc-row .fc-content-skeleton td,.fc-row .fc-helper-skeleton td{background:0 0;border-color:transparent;border-bottom:0}.fc-row .fc-content-skeleton tbody td,.fc-row .fc-helper-skeleton tbody td{border-top:0}.fc-scroller{-webkit-overflow-scrolling:touch}.fc-row.fc-rigid,.fc-time-grid-event{overflow:hidden}.fc-scroller>.fc-day-grid,.fc-scroller>.fc-time-grid{position:relative;width:100%}.fc-event{position:relative;display:block;font-size:.85em;line-height:1.3;border-radius:3px;border:1px solid #3a87ad;background-color:#3a87ad;font-weight:400}.fc-event,.fc-event:hover,.ui-widget .fc-event{color:#fff;text-decoration:none}.fc-not-allowed,.fc-not-allowed .fc-event{cursor:not-allowed}.fc-event .fc-bg{z-index:1;background:#fff;opacity:.25;filter:alpha(opacity=25)}.fc-event .fc-content{position:relative;z-index:2}.fc-event .fc-resizer{position:absolute;z-index:4;display:none}.fc-event.fc-allow-mouse-resize .fc-resizer,.fc-event.fc-selected .fc-resizer{display:block}.fc-event.fc-selected .fc-resizer:before{content:\"\";position:absolute;z-index:9999;top:50%;left:50%;width:40px;height:40px;margin-left:-20px;margin-top:-20px}.fc-event.fc-selected{z-index:9999!important;box-shadow:0 2px 5px rgba(0,0,0,.2)}.fc-event.fc-selected.fc-dragging{box-shadow:0 2px 7px rgba(0,0,0,.3)}.fc-h-event.fc-selected:before{content:\"\";position:absolute;z-index:3;top:-10px;bottom:-10px;left:0;right:0}.fc-ltr .fc-h-event.fc-not-start,.fc-rtl .fc-h-event.fc-not-end{margin-left:0;border-left-width:0;padding-left:1px;border-top-left-radius:0;border-bottom-left-radius:0}.fc-ltr .fc-h-event.fc-not-end,.fc-rtl .fc-h-event.fc-not-start{margin-right:0;border-right-width:0;padding-right:1px;border-top-right-radius:0;border-bottom-right-radius:0}.fc-ltr .fc-h-event .fc-start-resizer,.fc-rtl .fc-h-event .fc-end-resizer{cursor:w-resize;left:-1px}.fc-ltr .fc-h-event .fc-end-resizer,.fc-rtl .fc-h-event .fc-start-resizer{cursor:e-resize;right:-1px}.fc-h-event.fc-allow-mouse-resize .fc-resizer{width:7px;top:-1px;bottom:-1px}.fc-h-event.fc-selected .fc-resizer{border-radius:4px;border-width:1px;width:6px;height:6px;border-style:solid;border-color:inherit;background:#fff;top:50%;margin-top:-4px}.fc-ltr .fc-h-event.fc-selected .fc-start-resizer,.fc-rtl .fc-h-event.fc-selected .fc-end-resizer{margin-left:-4px}.fc-ltr .fc-h-event.fc-selected .fc-end-resizer,.fc-rtl .fc-h-event.fc-selected .fc-start-resizer{margin-right:-4px}.fc-day-grid-event{margin:1px 2px 0;padding:0 1px}.fc-day-grid-event.fc-selected:after{content:\"\";position:absolute;z-index:1;top:-1px;right:-1px;bottom:-1px;left:-1px;background:#000;opacity:.25;filter:alpha(opacity=25)}.fc-day-grid-event .fc-content{white-space:nowrap;overflow:hidden}.fc-day-grid-event .fc-time{font-weight:700}.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer,.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer{margin-left:-2px}.fc-ltr .fc-day-grid-event.fc-allow-mouse-resize .fc-end-resizer,.fc-rtl .fc-day-grid-event.fc-allow-mouse-resize .fc-start-resizer{margin-right:-2px}a.fc-more{margin:1px 3px;font-size:.85em;cursor:pointer;text-decoration:none}a.fc-more:hover{text-decoration:underline}.fc-limited{display:none}.fc-day-grid .fc-row{z-index:1}.fc-more-popover{z-index:2;width:220px}.fc-more-popover .fc-event-container{padding:10px}.fc-now-indicator{position:absolute;border:0 solid red}.fc-unselectable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fc-toolbar{margin-bottom:1em}.fc-toolbar .fc-left{float:left}.fc-toolbar .fc-right{float:right}.fc-toolbar .fc-center{display:inline-block}.fc .fc-toolbar>*>*{float:left;margin-left:.75em}.fc .fc-toolbar>*>:first-child{margin-left:0}.fc-toolbar h2{margin:0}.fc-toolbar button{position:relative}.fc-toolbar .fc-state-hover,.fc-toolbar .ui-state-hover{z-index:2}.fc-toolbar .fc-state-down{z-index:3}.fc-toolbar .fc-state-active,.fc-toolbar .ui-state-active{z-index:4}.fc-toolbar button:focus{z-index:5}.fc-view-container *,.fc-view-container :after,.fc-view-container :before{box-sizing:content-box}.fc-view,.fc-view>table{position:relative;z-index:1}.fc-basicDay-view .fc-content-skeleton,.fc-basicWeek-view .fc-content-skeleton{padding-top:1px;padding-bottom:1em}.fc-basic-view .fc-body .fc-row{min-height:4em}.fc-row.fc-rigid .fc-content-skeleton{position:absolute;top:0;left:0;right:0}.fc-basic-view .fc-day-number,.fc-basic-view .fc-week-number{padding:0 2px}.fc-basic-view td.fc-day-number,.fc-basic-view td.fc-week-number span{padding-top:2px;padding-bottom:2px}.fc-basic-view .fc-week-number span{display:inline-block;min-width:1.25em}.fc-ltr .fc-basic-view .fc-day-number{text-align:right}.fc-rtl .fc-basic-view .fc-day-number{text-align:left}.fc-day-number.fc-other-month{opacity:.3;filter:alpha(opacity=30)}.fc-agenda-view .fc-day-grid{position:relative;z-index:2}.fc-agenda-view .fc-day-grid .fc-row{min-height:3em}.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton{padding-top:1px;padding-bottom:1em}.fc .fc-axis{vertical-align:middle;padding:0 4px}.fc-ltr .fc-axis{text-align:right}.fc-rtl .fc-axis{text-align:left}.ui-widget td.fc-axis{font-weight:400}.fc-time-grid,.fc-time-grid-container{position:relative;z-index:1}.fc-time-grid{min-height:100%}.fc-time-grid table{border:0 hidden transparent}.fc-time-grid>.fc-bg{z-index:1}.fc-time-grid .fc-slats,.fc-time-grid>hr{position:relative;z-index:2}.fc-time-grid .fc-content-col{position:relative}.fc-time-grid .fc-content-skeleton{position:absolute;z-index:3;top:0;left:0;right:0}.fc-time-grid .fc-business-container{position:relative;z-index:1}.fc-time-grid .fc-bgevent-container{position:relative;z-index:2}.fc-time-grid .fc-highlight-container{z-index:3;position:relative}.fc-time-grid .fc-event-container{position:relative;z-index:4}.fc-time-grid .fc-now-indicator-line{z-index:5}.fc-time-grid .fc-helper-container{position:relative;z-index:6}.fc-time-grid .fc-slats td{height:1.5em;border-bottom:0}.fc-time-grid .fc-slats .fc-minor td{border-top-style:dotted}.fc-time-grid .fc-slats .ui-widget-content{background:0 0}.fc-time-grid .fc-highlight{position:absolute;left:0;right:0}.fc-ltr .fc-time-grid .fc-event-container{margin:0 2.5% 0 2px}.fc-rtl .fc-time-grid .fc-event-container{margin:0 2px 0 2.5%}.fc-time-grid .fc-bgevent,.fc-time-grid .fc-event{position:absolute;z-index:1}.fc-time-grid .fc-bgevent{left:0;right:0}.fc-v-event.fc-not-start{border-top-width:0;padding-top:1px;border-top-left-radius:0;border-top-right-radius:0}.fc-v-event.fc-not-end{border-bottom-width:0;padding-bottom:1px;border-bottom-left-radius:0;border-bottom-right-radius:0}.fc-time-grid-event.fc-selected{overflow:visible}.fc-time-grid-event.fc-selected .fc-bg{display:none}.fc-time-grid-event .fc-content{overflow:hidden}.fc-time-grid-event .fc-time,.fc-time-grid-event .fc-title{padding:0 1px}.fc-time-grid-event .fc-time{font-size:.85em}.fc-time-grid-event.fc-short .fc-time,.fc-time-grid-event.fc-short .fc-title{display:inline-block;vertical-align:top}.fc-time-grid-event.fc-short .fc-time span{display:none}.fc-time-grid-event.fc-short .fc-time:before{content:attr(data-start)}.fc-time-grid-event.fc-short .fc-time:after{content:\"\\A0-\\A0\"}.fc-time-grid-event.fc-short .fc-title{font-size:.85em;padding:0}.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer{left:0;right:0;bottom:0;height:8px;overflow:hidden;line-height:8px;font-size:11px;font-family:monospace;text-align:center;cursor:s-resize}.fc-time-grid-event.fc-allow-mouse-resize .fc-resizer:after{content:\"=\"}.fc-time-grid-event.fc-selected .fc-resizer{border-radius:5px;border-width:1px;width:8px;height:8px;border-style:solid;border-color:inherit;background:#fff;left:50%;margin-left:-5px;bottom:-5px}.fc-time-grid .fc-now-indicator-line{border-top-width:1px;left:0;right:0}.fc-time-grid .fc-now-indicator-arrow{margin-top:-5px}.fc-ltr .fc-time-grid .fc-now-indicator-arrow{left:0;border-width:5px 0 5px 6px;border-top-color:transparent;border-bottom-color:transparent}.fc-rtl .fc-time-grid .fc-now-indicator-arrow{right:0;border-width:5px 6px 5px 0;border-top-color:transparent;border-bottom-color:transparent}", ""]);

	// exports


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(29);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./angular-form-builder.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./angular-form-builder.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".fb-component{padding:10px;cursor:move}.fb-component input,.fb-component label,.fb-component select,.fb-component textarea{cursor:move}.fb-form-object-editable{padding:10px}.fb-form-object-editable.fb-draggable,.fb-form-object-editable.fb-draggable input{cursor:move}.fb-form-object-editable.fb-draggable label{cursor:pointer}.fb-form-object-editable.fb-draggable select,.fb-form-object-editable.fb-draggable textarea{cursor:move}.fb-form-object-editable.empty{cursor:default;margin:6px;height:80px;border:1px dashed #aaa;background-color:#eee}.fb-draggable.dragging{background-color:#fff;position:absolute;z-index:800;box-shadow:0 0 20px #666}.fb-required:after{color:#b94a48;content:' *'}.fb-builder{min-height:250px}.popover .control-label{text-align:left}.popover form{width:240px}", ""]);

	// exports


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(31);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./angular-wizard.min.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./angular-wizard.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".steps-indicator{right:0;bottom:0;left:0;height:30px;padding:20px 0 0;margin:0;list-style:none}.steps-indicator:before{position:absolute;height:1px;background-color:#e6e6e6;content:''}.steps-indicator.steps-2:before{right:25%;left:25%}.steps-indicator.steps-3:before{right:16.66667%;left:16.66667%}.steps-indicator.steps-4:before{right:12.5%;left:12.5%}.steps-indicator.steps-5:before{right:10%;left:10%}.steps-indicator.steps-6:before{right:8.33333%;left:8.33333%}.steps-indicator.steps-7:before{right:7.14286%;left:7.14286%}.steps-indicator.steps-8:before{right:6.25%;left:6.25%}.steps-indicator.steps-9:before{right:5.55556%;left:5.55556%}.steps-indicator.steps-10:before{right:5%;left:5%}.steps-indicator *{box-sizing:border-box}.steps-indicator li{position:relative;float:left;padding:0;padding-top:10px;margin:0;line-height:15px;text-align:center}.steps-indicator li a{font-weight:700;color:gray;text-decoration:none;text-transform:uppercase;cursor:pointer;transition:.25s}.steps-indicator li a:before{position:absolute;top:-7px;left:43%;width:14px;height:14px;background-color:#e6e6e6;border-radius:100%;content:'';transition:.25s}.steps-indicator li a:hover{color:#4d4d4d}.steps-indicator.steps-2 li{width:50%}.steps-indicator.steps-3 li{width:33.33333%}.steps-indicator.steps-4 li{width:25%}.steps-indicator.steps-5 li{width:20%}.steps-indicator.steps-6 li{width:16.66667%}.steps-indicator.steps-7 li{width:14.28571%}.steps-indicator.steps-8 li{width:12.5%}.steps-indicator.steps-9 li{width:11.11111%}.steps-indicator.steps-10 li{width:10%}.steps-indicator.steps-11 li{width:9.09091%}.steps-indicator li.default{pointer-events:none}.steps-indicator li.default a:hover{color:gray}.steps-indicator li.current,.steps-indicator li.editing{pointer-events:none}.steps-indicator li.current a:before{background-color:gray}.steps-indicator li.done a:before{background-color:#393}.steps-indicator li.editing a:before{background-color:red}", ""]);

	// exports


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(33);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./angular-ui-switch.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./angular-ui-switch.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".switch{background:#fff;border:1px solid #dfdfdf;position:relative;display:inline-block;box-sizing:content-box;overflow:visible;width:52px;height:30px;padding:0;margin:0;border-radius:20px;cursor:pointer;box-shadow:inset 0 0 0 0 #dfdfdf;transition:all .3s ease-out;-webkit-transition:all .3s ease-out;top:-1px}.switch.wide{width:80px}.switch small{background:#fff;border-radius:100%;box-shadow:0 1px 3px rgba(0,0,0,.4);width:30px;height:30px;position:absolute;top:0;left:0;transition:all .3s ease-out;-webkit-transition:all .3s ease-out}.switch.checked{background:#64bd63;border-color:#64bd63}.switch.checked small{left:22px}.switch.wide.checked small{left:52px}.switch .switch-text{font-family:Arial,Helvetica,sans-serif;font-size:13px}.switch .off{display:block;right:10%;color:#a9a9a9}.switch .off,.switch .on{position:absolute;top:25%;z-index:0}.switch .on{color:#fff;left:9%}.switch.checked .off,.switch .on{display:none}.switch.checked .on{display:block}.switch.disabled{opacity:.5;cursor:not-allowed}", ""]);

	// exports


/***/ },
/* 34 */
/***/ function(module, exports) {

	/*! ngCart v1.0.0 */
	 "use strict";angular.module("ngCart",["ngCart.directives"]).config([function(){}]).provider("$ngCart",function(){this.$get=function(){}}).run(["$rootScope","ngCart","ngCartItem","store",function(a,b,c,d){a.$on("ngCart:change",function(){b.$save()}),angular.isObject(d.get("cart"))?b.$restore(d.get("cart")):b.init()}]).service("ngCart",["$rootScope","ngCartItem","store",function(a,b,c){this.init=function(){this.$cart={shipping:null,taxRate:null,tax:null,items:[]}},this.addItem=function(c,d,e,f,g){var h=this.getItemById(c);if("object"==typeof h)h.setQuantity(f,!1);else{var i=new b(c,d,e,f,g);this.$cart.items.push(i),a.$broadcast("ngCart:itemAdded",i)}a.$broadcast("ngCart:change",{})},this.getItemById=function(a){var b=this.getCart().items,c=!1;return angular.forEach(b,function(b){b.getId()===a&&(c=b)}),c},this.setShipping=function(a){return this.$cart.shipping=a,this.getShipping()},this.getShipping=function(){return 0==this.getCart().items.length?0:this.getCart().shipping},this.setTaxRate=function(a){return this.$cart.taxRate=+parseFloat(a).toFixed(2),this.getTaxRate()},this.getTaxRate=function(){return this.$cart.taxRate},this.getTax=function(){return+parseFloat(this.getSubTotal()/100*this.getCart().taxRate).toFixed(2)},this.setCart=function(a){return this.$cart=a,this.getCart()},this.getCart=function(){return this.$cart},this.getItems=function(){return this.getCart().items},this.getTotalItems=function(){var a=0,b=this.getItems();return angular.forEach(b,function(b){a+=b.getQuantity()}),a},this.getTotalUniqueItems=function(){return this.getCart().items.length},this.getSubTotal=function(){var a=0;return angular.forEach(this.getCart().items,function(b){a+=b.getTotal()}),+parseFloat(a).toFixed(2)},this.totalCost=function(){return+parseFloat(this.getSubTotal()+this.getShipping()+this.getTax()).toFixed(2)},this.removeItem=function(b){this.$cart.items.splice(b,1),a.$broadcast("ngCart:itemRemoved",{}),a.$broadcast("ngCart:change",{})},this.removeItemById=function(b){var c=this.getCart();angular.forEach(c.items,function(a,d){a.getId()===b&&c.items.splice(d,1)}),this.setCart(c),a.$broadcast("ngCart:itemRemoved",{}),a.$broadcast("ngCart:change",{})},this.empty=function(){a.$broadcast("ngCart:change",{}),this.$cart.items=[],localStorage.removeItem("cart")},this.isEmpty=function(){return this.$cart.items.length>0?!1:!0},this.toObject=function(){if(0===this.getItems().length)return!1;var a=[];return angular.forEach(this.getItems(),function(b){a.push(b.toObject())}),{shipping:this.getShipping(),tax:this.getTax(),taxRate:this.getTaxRate(),subTotal:this.getSubTotal(),totalCost:this.totalCost(),items:a}},this.$restore=function(a){var c=this;c.init(),c.$cart.shipping=a.shipping,c.$cart.tax=a.tax,angular.forEach(a.items,function(a){c.$cart.items.push(new b(a._id,a._name,a._price,a._quantity,a._data))}),this.$save()},this.$save=function(){return c.set("cart",JSON.stringify(this.getCart()))}}]).factory("ngCartItem",["$rootScope","$log",function(a,b){var c=function(a,b,c,d,e){this.setId(a),this.setName(b),this.setPrice(c),this.setQuantity(d),this.setData(e)};return c.prototype.setId=function(a){a?this._id=a:b.error("An ID must be provided")},c.prototype.getId=function(){return this._id},c.prototype.setName=function(a){a?this._name=a:b.error("A name must be provided")},c.prototype.getName=function(){return this._name},c.prototype.setPrice=function(a){var c=parseFloat(a);c?0>=c?b.error("A price must be over 0"):this._price=c:b.error("A price must be provided")},c.prototype.getPrice=function(){return this._price},c.prototype.setQuantity=function(c,d){var e=parseInt(c);e%1===0?(d===!0?this._quantity+=e:this._quantity=e,this._quantity<1&&(this._quantity=1)):(this._quantity=1,b.info("Quantity must be an integer and was defaulted to 1")),a.$broadcast("ngCart:change",{})},c.prototype.getQuantity=function(){return this._quantity},c.prototype.setData=function(a){a&&(this._data=a)},c.prototype.getData=function(){return this._data?this._data:void b.info("This item has no data")},c.prototype.getTotal=function(){return+parseFloat(this.getQuantity()*this.getPrice()).toFixed(2)},c.prototype.toObject=function(){return{id:this.getId(),name:this.getName(),price:this.getPrice(),quantity:this.getQuantity(),data:this.getData(),total:this.getTotal()}},c}]).service("store",["$window",function(a){return{get:function(b){if(a.localStorage[b]){var c=angular.fromJson(a.localStorage[b]);return JSON.parse(c)}return!1},set:function(b,c){return void 0===c?a.localStorage.removeItem(b):a.localStorage[b]=angular.toJson(c),a.localStorage[b]}}}]).controller("CartController",["$scope","ngCart",function(a,b){a.ngCart=b}]).value("version","1.0.0"),angular.module("ngCart.directives",["ngCart.fulfilment"]).controller("CartController",["$scope","ngCart",function(a,b){a.ngCart=b}]).directive("ngcartAddtocart",["ngCart",function(a){return{restrict:"E",controller:"CartController",scope:{id:"@",name:"@",quantity:"@",quantityMax:"@",price:"@",data:"="},transclude:!0,templateUrl:function(a,b){return"undefined"==typeof b.templateUrl?"template/ngCart/addtocart.html":b.templateUrl},link:function(b,c,d){b.attrs=d,b.inCart=function(){return a.getItemById(d.id)},b.inCart()?b.q=a.getItemById(d.id).getQuantity():b.q=parseInt(b.quantity),b.qtyOpt=[];for(var e=1;e<=b.quantityMax;e++)b.qtyOpt.push(e)}}}]).directive("ngcartCart",[function(){return{restrict:"E",controller:"CartController",scope:{},templateUrl:function(a,b){return"undefined"==typeof b.templateUrl?"template/ngCart/cart.html":b.templateUrl},link:function(a,b,c){}}}]).directive("ngcartSummary",[function(){return{restrict:"E",controller:"CartController",scope:{},transclude:!0,templateUrl:function(a,b){return"undefined"==typeof b.templateUrl?"template/ngCart/summary.html":b.templateUrl}}}]).directive("ngcartCheckout",[function(){return{restrict:"E",controller:["$rootScope","$scope","ngCart","fulfilmentProvider",function(a,b,c,d){b.ngCart=c,b.checkout=function(){d.setService(b.service),d.setSettings(b.settings),d.checkout().success(function(b,c,d,e){a.$broadcast("ngCart:checkout_succeeded",b)}).error(function(b,c,d,e){a.$broadcast("ngCart:checkout_failed",{statusCode:c,error:b})})}}],scope:{service:"@",settings:"="},transclude:!0,templateUrl:function(a,b){return"undefined"==typeof b.templateUrl?"template/ngCart/checkout.html":b.templateUrl}}}]),angular.module("ngCart.fulfilment",[]).service("fulfilmentProvider",["$injector",function(a){this._obj={service:void 0,settings:void 0},this.setService=function(a){this._obj.service=a},this.setSettings=function(a){this._obj.settings=a},this.checkout=function(){var b=a.get("ngCart.fulfilment."+this._obj.service);return b.checkout(this._obj.settings)}}]).service("ngCart.fulfilment.log",["$q","$log","ngCart",function(a,b,c){this.checkout=function(){var d=a.defer();return b.info(c.toObject()),d.resolve({cart:c.toObject()}),d.promise}}]).service("ngCart.fulfilment.http",["$http","ngCart",function(a,b){this.checkout=function(c){return a.post(c.url,{data:b.toObject(),options:c.options})}}]).service("ngCart.fulfilment.paypal",["$http","ngCart",function(a,b){}]);

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(36);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./btnUpload.min.css", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./btnUpload.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".btn-upload{position:relative;overflow:hidden}.btn-upload input{position:absolute;top:0;right:0;margin:0;opacity:0;filter:alpha(opacity=0);transform:translate(-300px) scale(4);-webkit-transform:translate(-300px) scale(4);-ms-transform:translate(-300px) scale(4);-o-transform:translate(-300px) scale(4);font-size:23px;direction:ltr;cursor:pointer}* html .btn-upload{line-height:24px;margin:1px -3px 0 0}*+html .btn-upload{padding:2px 15px;margin:1px 0 0}", ""]);

	// exports


/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";angular.module("lr.upload",["lr.upload.formdata","lr.upload.iframe","lr.upload.directives"]),angular.module("lr.upload.directives",[]),angular.module("lr.upload.directives").directive("uploadButton",["upload",function(a){return{restrict:"EA",scope:{data:"=?data",url:"@",param:"@",method:"@",onUpload:"&",onSuccess:"&",onError:"&",onComplete:"&"},link:function(b,c,d){var e=angular.element(c),f=angular.element('<input type="file" />');if(e.append(f),f.on("change",function(){var c=angular.element(this);if(!c[0].files||0!==c[0].files.length){var e={url:b.url,method:b.method||"POST",forceIFrameUpload:b.$eval(d.forceIframeUpload)||!1,data:b.data||{}};e.data[b.param||"file"]=c,b.$apply(function(){b.onUpload({files:c[0].files})}),a(e).then(function(a){b.onSuccess({response:a}),b.onComplete({response:a})},function(a){b.onError({response:a}),b.onComplete({response:a})})}}),"required"in d&&d.$observe("required",function(a){var d=""===a?!0:b.$eval(a);f.attr("required",d),c.toggleClass("ng-valid",!d),c.toggleClass("ng-invalid ng-invalid-required",d)}),"accept"in d&&d.$observe("accept",function(a){f.attr("accept",a)}),a.support.formData){var g=function(){f.attr("multiple",!(!b.$eval(d.multiple)||b.$eval(d.forceIframeUpload)))};d.$observe("multiple",g),d.$observe("forceIframeUpload",g)}}}}]),angular.module("lr.upload.formdata",[]).factory("formDataTransform",function(){return function(a){var b=new FormData;return angular.forEach(a,function(a,c){if(angular.isElement(a)){var d=[];angular.forEach(a,function(a){angular.forEach(a.files,function(a){d.push(a)}),a.value=""}),0!==d.length&&(d.length>1?angular.forEach(d,function(a,d){b.append(c+"["+d+"]",a)}):b.append(c,d[0]))}else b.append(c,a)}),b}}).factory("formDataUpload",["$http","formDataTransform",function(a,b){return function(c){return c.transformRequest=b,c.method=c.method||"POST",c.headers=angular.extend(c.headers||{},{"Content-Type":void 0}),a(c)}}]),angular.module("lr.upload.iframe",[]).factory("iFrameUpload",["$q","$http","$document","$rootScope",function(a,b,c,d){function e(a,b){if(a.indexOf)return a.indexOf(b);for(var c=0;c<a.length;c++)if(b===a[c])return c;return-1}function f(f){var g=[],h=a.defer(),i=h.promise;angular.forEach(f.data||{},function(a,b){angular.isElement(a)&&(delete f.data[b],a.attr("name",b),g.push(a))});var j=/\?/.test(f.url)?"&":"?";"DELETE"===f.method?(f.url=f.url+j+"_method=DELETE",f.method="POST"):"PUT"===f.method?(f.url=f.url+j+"_method=PUT",f.method="POST"):"PATCH"===f.method&&(f.url=f.url+j+"_method=PATCH",f.method="POST");var k=angular.element(c[0].body),l=d.$new(),m="iframe-transport-"+l.$id;l.$destroy();var n=angular.element("<form></form>");n.attr("target",m),n.attr("action",f.url),n.attr("method",f.method||"POST"),n.css("display","none"),g.length&&(n.attr("enctype","multipart/form-data"),n.attr("encoding","multipart/form-data"));var o=angular.element('<iframe name="'+m+'" src="javascript:false;"></iframe>');return o.on("load",function(){function a(a,b){var c=[];return angular.isFunction(b)?b(a,c):(angular.forEach(b,function(b){a=b(a,c)}),a)}function c(){var a=e(b.pendingRequests,f);-1!==a&&(b.pendingRequests.splice(a,1),f.$iframeTransportForm.remove(),delete f.$iframeTransportForm)}o.off("load").on("load",function(){var c;try{var d=this.contentWindow?this.contentWindow.document:this.contentDocument;if(c=angular.element(d.body).text(),!c.length)throw new Error}catch(e){}n.append(angular.element('<iframe src="javascript:false;"></iframe>'));try{c=a(c,b.defaults.transformResponse)}catch(e){}h.resolve({data:c,status:200,headers:[],config:f})}),angular.forEach(f.data,function(a,b){var c=angular.element('<input type="hidden" />');c.attr("name",b),c.val(a),n.append(c)}),angular.forEach(g,function(a){var b=a.clone(!0);a.after(b),n.append(a)}),f.$iframeTransportForm=n,b.pendingRequests.push(f),n[0].submit(),i.then(c,c)}),n.append(o),k.append(n),i}return f}]),angular.module("lr.upload").factory("upload",["$window","formDataUpload","iFrameUpload",function(a,b,c){function d(a){return e.formData&&!a.forceIFrameUpload?b(a):c(a)}var e={fileInput:!(new RegExp("(Android (1\\.[0156]|2\\.[01]))|(Windows Phone (OS 7|8\\.0))|(XBLWP)|(ZuneWP)|(WPDesktop)|(w(eb)?OSBrowser)|(webOS)|(Kindle/(1\\.0|2\\.[05]|3\\.0))").test(a.navigator.userAgent)||angular.element('<input type="file">').prop("disabled")),fileUpload:!(!a.XMLHttpRequestUpload||!a.FileReader),formData:!!a.FormData};return d.support=e,d}]);

/***/ },
/* 38 */
/***/ function(module, exports) {

	/* global YT */
	angular.module('youtube-embed', [])
	.service ('youtubeEmbedUtils', ['$window', '$rootScope', function ($window, $rootScope) {
	    var Service = {}

	    // adapted from http://stackoverflow.com/a/5831191/1614967
	    var youtubeRegexp = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
	    var timeRegexp = /t=(\d+)[ms]?(\d+)?s?/;

	    function contains(str, substr) {
	        return (str.indexOf(substr) > -1);
	    }

	    Service.getIdFromURL = function getIdFromURL(url) {
	        var id = url.replace(youtubeRegexp, '$1');

	        if (contains(id, ';')) {
	            var pieces = id.split(';');

	            if (contains(pieces[1], '%')) {
	                // links like this:
	                // "http://www.youtube.com/attribution_link?a=pxa6goHqzaA&amp;u=%2Fwatch%3Fv%3DdPdgx30w9sU%26feature%3Dshare"
	                // have the real query string URI encoded behind a ';'.
	                // at this point, `id is 'pxa6goHqzaA;u=%2Fwatch%3Fv%3DdPdgx30w9sU%26feature%3Dshare'
	                var uriComponent = decodeURIComponent(pieces[1]);
	                id = ('http://youtube.com' + uriComponent)
	                        .replace(youtubeRegexp, '$1');
	            } else {
	                // https://www.youtube.com/watch?v=VbNF9X1waSc&amp;feature=youtu.be
	                // `id` looks like 'VbNF9X1waSc;feature=youtu.be' currently.
	                // strip the ';feature=youtu.be'
	                id = pieces[0];
	            }
	        } else if (contains(id, '#')) {
	            // id might look like '93LvTKF_jW0#t=1'
	            // and we want '93LvTKF_jW0'
	            id = id.split('#')[0];
	        }

	        return id;
	    };

	    Service.getTimeFromURL = function getTimeFromURL(url) {
	        url = url || '';

	        // t=4m20s
	        // returns ['t=4m20s', '4', '20']
	        // t=46s
	        // returns ['t=46s', '46']
	        // t=46
	        // returns ['t=46', '46']
	        var times = url.match(timeRegexp);

	        if (!times) {
	            // zero seconds
	            return 0;
	        }

	        // assume the first
	        var full = times[0],
	            minutes = times[1],
	            seconds = times[2];

	        // t=4m20s
	        if (typeof seconds !== 'undefined') {
	            seconds = parseInt(seconds, 10);
	            minutes = parseInt(minutes, 10);

	        // t=4m
	        } else if (contains(full, 'm')) {
	            minutes = parseInt(minutes, 10);
	            seconds = 0;

	        // t=4s
	        // t=4
	        } else {
	            seconds = parseInt(minutes, 10);
	            minutes = 0;
	        }

	        // in seconds
	        return seconds + (minutes * 60);
	    };

	    Service.ready = false;

	    function applyServiceIsReady() {
	        $rootScope.$apply(function () {
	            Service.ready = true;
	        });
	    };

	    // If the library isn't here at all,
	    if (typeof YT === "undefined") {
	        // ...grab on to global callback, in case it's eventually loaded
	        $window.onYouTubeIframeAPIReady = applyServiceIsReady;
	        console.log('Unable to find YouTube iframe library on this page.')
	    } else if (YT.loaded) {
	        Service.ready = true;
	    } else {
	        YT.ready(applyServiceIsReady);
	    }

	    return Service;
	}])
	.directive('youtubeVideo', ['$window', 'youtubeEmbedUtils', function ($window, youtubeEmbedUtils) {
	    var uniqId = 1;

	    // from YT.PlayerState
	    var stateNames = {
	        '-1': 'unstarted',
	        0: 'ended',
	        1: 'playing',
	        2: 'paused',
	        3: 'buffering',
	        5: 'queued'
	    };

	    var eventPrefix = 'youtube.player.';

	    $window.YTConfig = {
	        host: 'https://www.youtube.com'
	    };

	    return {
	        restrict: 'EA',
	        scope: {
	            videoId: '=?',
	            videoUrl: '=?',
	            player: '=?',
	            playerVars: '=?',
	            playerHeight: '=?',
	            playerWidth: '=?'
	        },
	        link: function (scope, element, attrs) {
	            // allows us to $watch `ready`
	            scope.utils = youtubeEmbedUtils;

	            // player-id attr > id attr > directive-generated ID
	            var playerId = attrs.playerId || element[0].id || 'unique-youtube-embed-id-' + uniqId++;
	            element[0].id = playerId;

	            // Attach to element
	            scope.playerHeight = scope.playerHeight || 390;
	            scope.playerWidth = scope.playerWidth || 640;
	            scope.playerVars = scope.playerVars || {};

	            // YT calls callbacks outside of digest cycle
	            function applyBroadcast () {
	                var args = Array.prototype.slice.call(arguments);
	                scope.$apply(function () {
	                    scope.$emit.apply(scope, args);
	                });
	            }

	            function onPlayerStateChange (event) {
	                var state = stateNames[event.data];
	                if (typeof state !== 'undefined') {
	                    applyBroadcast(eventPrefix + state, scope.player, event);
	                }
	                scope.$apply(function () {
	                    scope.player.currentState = state;
	                });
	            }

	            function onPlayerReady (event) {
	                applyBroadcast(eventPrefix + 'ready', scope.player, event);
	            }

	            function onPlayerError (event) {
	                applyBroadcast(eventPrefix + 'error', scope.player, event);
	            }

	            function createPlayer () {
	                var playerVars = angular.copy(scope.playerVars);
	                playerVars.start = playerVars.start || scope.urlStartTime;
	                var player = new YT.Player(playerId, {
	                    height: scope.playerHeight,
	                    width: scope.playerWidth,
	                    videoId: scope.videoId,
	                    playerVars: playerVars,
	                    events: {
	                        onReady: onPlayerReady,
	                        onStateChange: onPlayerStateChange,
	                        onError: onPlayerError
	                    }
	                });

	                player.id = playerId;
	                return player;
	            }

	            function loadPlayer () {
	                if (scope.videoId || scope.playerVars.list) {
	                    if (scope.player && typeof scope.player.destroy === 'function') {
	                        scope.player.destroy();
	                    }

	                    scope.player = createPlayer();
	                }
	            };

	            var stopWatchingReady = scope.$watch(
	                function () {
	                    return scope.utils.ready
	                        // Wait until one of them is defined...
	                        && (typeof scope.videoUrl !== 'undefined'
	                        ||  typeof scope.videoId !== 'undefined'
	                        ||  typeof scope.playerVars.list !== 'undefined');
	                },
	                function (ready) {
	                    if (ready) {
	                        stopWatchingReady();

	                        // URL takes first priority
	                        if (typeof scope.videoUrl !== 'undefined') {
	                            scope.$watch('videoUrl', function (url) {
	                                scope.videoId = scope.utils.getIdFromURL(url);
	                                scope.urlStartTime = scope.utils.getTimeFromURL(url);

	                                loadPlayer();
	                            });

	                        // then, a video ID
	                        } else if (typeof scope.videoId !== 'undefined') {
	                            scope.$watch('videoId', function () {
	                                scope.urlStartTime = null;
	                                loadPlayer();
	                            });

	                        // finally, a list
	                        } else {
	                            scope.$watch('playerVars.list', function () {
	                                scope.urlStartTime = null;
	                                loadPlayer();
	                            });
	                        }
	                    }
	            });

	            scope.$watchCollection(['playerHeight', 'playerWidth'], function() {
	                if (scope.player) {
	                    scope.player.setSize(scope.playerWidth, scope.playerHeight);
	                }
	            });

	            scope.$on('$destroy', function () {
	                scope.player && scope.player.destroy();
	            });
	        }
	    };
	}]);


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(40);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./loading-bar.min.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./loading-bar.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "#loading-bar,#loading-bar-spinner{pointer-events:none;-webkit-pointer-events:none;-webkit-transition:all .35s linear;transition:all .35s linear}#loading-bar-spinner.ng-enter,#loading-bar-spinner.ng-leave.ng-leave-active,#loading-bar.ng-enter,#loading-bar.ng-leave.ng-leave-active{opacity:0}#loading-bar-spinner.ng-enter.ng-enter-active,#loading-bar-spinner.ng-leave,#loading-bar.ng-enter.ng-enter-active,#loading-bar.ng-leave{opacity:1}#loading-bar .bar{-webkit-transition:width .35s;transition:width .35s;background:#29d;position:fixed;z-index:10002;top:0;left:0;width:100%;height:2px;border-bottom-right-radius:1px;border-top-right-radius:1px}#loading-bar .peg{position:absolute;width:70px;right:0;top:0;height:2px;opacity:.45;-ms-box-shadow:#29d 1px 0 6px 1px;box-shadow:1px 0 6px 1px #29d;border-radius:100%}#loading-bar-spinner{display:block;position:fixed;z-index:10002;top:10px;left:10px}#loading-bar-spinner .spinner-icon{width:14px;height:14px;border:2px solid transparent;border-top-color:#29d;border-left-color:#29d;border-radius:50%;-webkit-animation:loading-bar-spinner .4s linear infinite;animation:loading-bar-spinner .4s linear infinite}@-webkit-keyframes loading-bar-spinner{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-bar-spinner{0%{transform:rotate(0)}to{transform:rotate(1turn)}}", ""]);

	// exports


/***/ },
/* 41 */
/***/ function(module, exports) {

	/*! 
	 * angular-loading-bar v0.9.0
	 * https://chieffancypants.github.io/angular-loading-bar
	 * Copyright (c) 2016 Wes Cruver
	 * License: MIT
	 */
	!function(){"use strict";angular.module("angular-loading-bar",["cfp.loadingBarInterceptor"]),angular.module("chieffancypants.loadingBar",["cfp.loadingBarInterceptor"]),angular.module("cfp.loadingBarInterceptor",["cfp.loadingBar"]).config(["$httpProvider",function(a){var b=["$q","$cacheFactory","$timeout","$rootScope","$log","cfpLoadingBar",function(b,c,d,e,f,g){function h(){d.cancel(j),g.complete(),l=0,k=0}function i(b){var d,e=c.get("$http"),f=a.defaults;!b.cache&&!f.cache||b.cache===!1||"GET"!==b.method&&"JSONP"!==b.method||(d=angular.isObject(b.cache)?b.cache:angular.isObject(f.cache)?f.cache:e);var g=void 0!==d?void 0!==d.get(b.url):!1;return void 0!==b.cached&&g!==b.cached?b.cached:(b.cached=g,g)}var j,k=0,l=0,m=g.latencyThreshold;return{request:function(a){return a.ignoreLoadingBar||i(a)||(e.$broadcast("cfpLoadingBar:loading",{url:a.url}),0===k&&(j=d(function(){g.start()},m)),k++,g.set(l/k)),a},response:function(a){return a&&a.config?(a.config.ignoreLoadingBar||i(a.config)||(l++,e.$broadcast("cfpLoadingBar:loaded",{url:a.config.url,result:a}),l>=k?h():g.set(l/k)),a):(f.error("Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50"),a)},responseError:function(a){return a&&a.config?(a.config.ignoreLoadingBar||i(a.config)||(l++,e.$broadcast("cfpLoadingBar:loaded",{url:a.config.url,result:a}),l>=k?h():g.set(l/k)),b.reject(a)):(f.error("Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50"),b.reject(a))}}}];a.interceptors.push(b)}]),angular.module("cfp.loadingBar",[]).provider("cfpLoadingBar",function(){this.autoIncrement=!0,this.includeSpinner=!0,this.includeBar=!0,this.latencyThreshold=100,this.startSize=.02,this.parentSelector="body",this.spinnerTemplate='<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>',this.loadingBarTemplate='<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>',this.$get=["$injector","$document","$timeout","$rootScope",function(a,b,c,d){function e(){if(k||(k=a.get("$animate")),c.cancel(m),!r){var e=b[0],g=e.querySelector?e.querySelector(n):b.find(n)[0];g||(g=e.getElementsByTagName("body")[0]);var h=angular.element(g),i=g.lastChild&&angular.element(g.lastChild);d.$broadcast("cfpLoadingBar:started"),r=!0,v&&k.enter(o,h,i),u&&k.enter(q,h,o),f(w)}}function f(a){if(r){var b=100*a+"%";p.css("width",b),s=a,t&&(c.cancel(l),l=c(function(){g()},250))}}function g(){if(!(h()>=1)){var a=0,b=h();a=b>=0&&.25>b?(3*Math.random()+3)/100:b>=.25&&.65>b?3*Math.random()/100:b>=.65&&.9>b?2*Math.random()/100:b>=.9&&.99>b?.005:0;var c=h()+a;f(c)}}function h(){return s}function i(){s=0,r=!1}function j(){k||(k=a.get("$animate")),d.$broadcast("cfpLoadingBar:completed"),f(1),c.cancel(m),m=c(function(){var a=k.leave(o,i);a&&a.then&&a.then(i),k.leave(q)},500)}var k,l,m,n=this.parentSelector,o=angular.element(this.loadingBarTemplate),p=o.find("div").eq(0),q=angular.element(this.spinnerTemplate),r=!1,s=0,t=this.autoIncrement,u=this.includeSpinner,v=this.includeBar,w=this.startSize;return{start:e,set:f,status:h,inc:g,complete:j,autoIncrement:this.autoIncrement,includeSpinner:this.includeSpinner,latencyThreshold:this.latencyThreshold,parentSelector:this.parentSelector,startSize:this.startSize}}]})}();

/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * @license angular-recaptcha build:2017-11-22
	 * https://github.com/vividcortex/angular-recaptcha
	 * Copyright (c) 2017 VividCortex
	**/


	!function(a){"use strict";a.module("vcRecaptcha",[])}(angular),function(a){"use strict";function b(){throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create')}a.module("vcRecaptcha").provider("vcRecaptchaService",function(){var c=this,d={};c.onLoadFunctionName="vcRecaptchaApiLoaded",c.setDefaults=function(b){a.copy(b,d)},c.setSiteKey=function(a){d.key=a},c.setTheme=function(a){d.theme=a},c.setStoken=function(a){d.stoken=a},c.setSize=function(a){d.size=a},c.setType=function(a){d.type=a},c.setLang=function(a){d.lang=a},c.setBadge=function(a){d.badge=a},c.setOnLoadFunctionName=function(a){c.onLoadFunctionName=a},c.$get=["$rootScope","$window","$q","$document","$interval",function(e,f,g,h,i){function j(){return l?g.when(l):n}function k(){if(!l)throw new Error("reCaptcha has not been loaded yet.")}var l,m=g.defer(),n=m.promise,o={};f.vcRecaptchaApiLoadedCallback=f.vcRecaptchaApiLoadedCallback||[];var p=function(){l=f.grecaptcha,m.resolve(l)};if(f.vcRecaptchaApiLoadedCallback.push(p),f[c.onLoadFunctionName]=function(){f.vcRecaptchaApiLoadedCallback.forEach(function(a){a()})},a.isDefined(f.grecaptcha))p();else if(f.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]'))var q=i(function(){a.isDefined(f.grecaptcha)&&(i.cancel(q),p())},25);else{var r=f.document.createElement("script");r.async=!0,r.defer=!0,r.src="https://www.google.com/recaptcha/api.js?onload="+c.onLoadFunctionName+"&render=explicit",h.find("body")[0].appendChild(r)}return{create:function(a,c){return c.sitekey=c.key||d.key,c.theme=c.theme||d.theme,c.stoken=c.stoken||d.stoken,c.size=c.size||d.size,c.type=c.type||d.type,c.hl=c.lang||d.lang,c.badge=c.badge||d.badge,c.sitekey&&40===c.sitekey.length||b(),j().then(function(b){var d=b.render(a,c);return o[d]=a,d})},reload:function(a){k(),l.reset(a),e.$broadcast("reCaptchaReset",a)},execute:function(a){k(),l.execute(a)},useLang:function(a,b){var c=o[a];if(!c)throw new Error("reCaptcha Widget ID not exists",a);var d=c.querySelector("iframe");if(!b)return d&&d.src&&/[?&]hl=\w+/.test(d.src)?d.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/,"$1"):null;if(d&&d.src){var e=d.src;/[?&]hl=/.test(e)?e=e.replace(/([?&]hl=)\w+/,"$1"+b):e+=(-1===e.indexOf("?")?"?":"&")+"hl="+b,d.src=e}},getResponse:function(a){return k(),l.getResponse(a)},getInstance:function(a){return o[a]},destroy:function(a){delete o[a]}}}]})}(angular),function(a){"use strict";a.module("vcRecaptcha").directive("vcRecaptcha",["$document","$timeout","vcRecaptchaService",function(b,c,d){return{restrict:"A",require:"?^^form",scope:{response:"=?ngModel",key:"=?",stoken:"=?",theme:"=?",size:"=?",type:"=?",lang:"=?",badge:"=?",tabindex:"=?",required:"=?",onCreate:"&",onSuccess:"&",onExpire:"&"},link:function(e,f,g,h){function i(){h&&h.$setValidity("recaptcha",null),l()}function j(){c(function(){e.response="",k(),e.onExpire({widgetId:e.widgetId})})}function k(){h&&h.$setValidity("recaptcha",!1===e.required?null:Boolean(e.response))}function l(){d.destroy(e.widgetId),a.element(b[0].querySelectorAll(".pls-container")).parent().remove()}e.widgetId=null,h&&a.isDefined(g.required)&&e.$watch("required",k);var m=e.$watch("key",function(b){var h=function(a){c(function(){e.response=a,k(),e.onSuccess({response:a,widgetId:e.widgetId})})};d.create(f[0],{callback:h,key:b,stoken:e.stoken||g.stoken||null,theme:e.theme||g.theme||null,type:e.type||g.type||null,lang:e.lang||g.lang||null,tabindex:e.tabindex||g.tabindex||null,size:e.size||g.size||null,badge:e.badge||g.badge||null,"expired-callback":j}).then(function(b){k(),e.widgetId=b,e.onCreate({widgetId:b}),e.$on("$destroy",i),e.$on("reCaptchaReset",function(c,d){(a.isUndefined(d)||b===d)&&(e.response="",k())})}),m()})}}}])}(angular);

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(44);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./angular-bootstrap-lightbox.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./angular-bootstrap-lightbox.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".lightbox-nav{position:relative;margin-bottom:12px;height:22px;text-align:center;font-size:0}.lightbox-nav .btn-group{vertical-align:top}.lightbox-nav .close{position:absolute;top:0;right:0}.lightbox-image-container{position:relative;text-align:center}.lightbox-image-caption{position:absolute;top:0;left:0;margin:.5em .9em;color:#000;font-size:1.5em;font-weight:700;text-align:left;text-shadow:.1em .1em .2em hsla(0,0%,100%,.5)}.lightbox-image-caption span{padding-top:.1em;padding-bottom:.1em;background-color:hsla(0,0%,100%,.75);box-shadow:.4em 0 0 hsla(0,0%,100%,.75),-.4em 0 0 hsla(0,0%,100%,.75)}", ""]);

	// exports


/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * @namespace bootstrapLightbox
	 */
	angular.module('bootstrapLightbox', [
	  'ui.bootstrap'
	]);

	// optional dependencies
	try {
	  angular.module('angular-loading-bar');
	  angular.module('bootstrapLightbox').requires.push('angular-loading-bar');
	} catch (e) {}

	try {
	  angular.module('ngTouch');
	  angular.module('bootstrapLightbox').requires.push('ngTouch');
	} catch (e) {}

	try {
	  angular.module('videosharing-embed');
	  angular.module('bootstrapLightbox').requires.push('videosharing-embed');
	} catch (e) {}
	angular.module('bootstrapLightbox').run(['$templateCache', function($templateCache) {
	  'use strict';

	  $templateCache.put('lightbox.html',
	    "<div class=modal-body ng-swipe-left=Lightbox.nextImage() ng-swipe-right=Lightbox.prevImage()><div class=lightbox-nav><button class=close aria-hidden=true ng-click=$dismiss()>×</button><div class=btn-group ng-if=\"Lightbox.images.length > 1\"><a class=\"btn btn-xs btn-default\" ng-click=Lightbox.prevImage()>‹ Previous</a> <a ng-href={{Lightbox.imageUrl}} target=_blank class=\"btn btn-xs btn-default\" title=\"Open in new tab\">Open image in new tab</a> <a class=\"btn btn-xs btn-default\" ng-click=Lightbox.nextImage()>Next ›</a></div></div><div class=lightbox-image-container><div class=lightbox-image-caption><span>{{Lightbox.imageCaption}}</span></div><img ng-if=!Lightbox.isVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}}><div ng-if=Lightbox.isVideo(Lightbox.image) class=\"embed-responsive embed-responsive-16by9\"><video ng-if=!Lightbox.isSharedVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}} controls autoplay></video><embed-video ng-if=Lightbox.isSharedVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}} ng-href={{Lightbox.imageUrl}} iframe-id=lightbox-video class=embed-responsive-item><a ng-href={{Lightbox.imageUrl}}>Watch video</a></embed-video></div></div></div>"
	  );

	}]);
	/**
	 * @class     ImageLoader
	 * @classdesc Service for loading an image.
	 * @memberOf  bootstrapLightbox
	 */
	angular.module('bootstrapLightbox').service('ImageLoader', ['$q',
	    function ($q) {
	  /**
	   * Load the image at the given URL.
	   * @param    {String} url
	   * @return   {Promise} A $q promise that resolves when the image has loaded
	   *   successfully.
	   * @type     {Function}
	   * @name     load
	   * @memberOf bootstrapLightbox.ImageLoader
	   */
	  this.load = function (url) {
	    var deferred = $q.defer();

	    var image = new Image();

	    // when the image has loaded
	    image.onload = function () {
	      // check image properties for possible errors
	      if ((typeof this.complete === 'boolean' && this.complete === false) ||
	          (typeof this.naturalWidth === 'number' && this.naturalWidth === 0)) {
	        deferred.reject();
	      }

	      deferred.resolve(image);
	    };

	    // when the image fails to load
	    image.onerror = function () {
	      deferred.reject();
	    };

	    // start loading the image
	    image.src = url;

	    return deferred.promise;
	  };
	}]);
	/**
	 * @class     Lightbox
	 * @classdesc Lightbox service.
	 * @memberOf  bootstrapLightbox
	 */
	angular.module('bootstrapLightbox').provider('Lightbox', function () {
	  /**
	   * Template URL passed into `$uibModal.open()`.
	   * @type     {String}
	   * @name     templateUrl
	   * @memberOf bootstrapLightbox.Lightbox
	   */
	  this.templateUrl = 'lightbox.html';

	  /**
	   * Whether images should be scaled to the maximum possible dimensions.
	   * @type     {Boolean}
	   * @name     fullScreenMode
	   * @memberOf bootstrapLightbox.Lightbox
	   */
	  this.fullScreenMode = false;

	  /**
	   * @param    {*} image An element in the array of images.
	   * @return   {String} The URL of the given image.
	   * @type     {Function}
	   * @name     getImageUrl
	   * @memberOf bootstrapLightbox.Lightbox
	   */
	  this.getImageUrl = function (image) {
	    return typeof image === 'string' ? image : image.url;
	  };

	  /**
	   * @param    {*} image An element in the array of images.
	   * @return   {String} The caption of the given image.
	   * @type     {Function}
	   * @name     getImageCaption
	   * @memberOf bootstrapLightbox.Lightbox
	   */
	  this.getImageCaption = function (image) {
	    return image.caption;
	  };

	  /**
	   * Calculate the max and min limits to the width and height of the displayed
	   *   image (all are optional). The max dimensions override the min
	   *   dimensions if they conflict.
	   * @param    {Object} dimensions Contains the properties `windowWidth`,
	   *   `windowHeight`, `imageWidth`, and `imageHeight`.
	   * @return   {Object} May optionally contain the properties `minWidth`,
	   *   `minHeight`, `maxWidth`, and `maxHeight`.
	   * @type     {Function}
	   * @name     calculateImageDimensionLimits
	   * @memberOf bootstrapLightbox.Lightbox
	   */
	  this.calculateImageDimensionLimits = function (dimensions) {
	    if (dimensions.windowWidth >= 768) {
	      return {
	        // 92px = 2 * (30px margin of .modal-dialog
	        //             + 1px border of .modal-content
	        //             + 15px padding of .modal-body)
	        // with the goal of 30px side margins; however, the actual side margins
	        // will be slightly less (at 22.5px) due to the vertical scrollbar
	        'maxWidth': dimensions.windowWidth - 92,
	        // 126px = 92px as above
	        //         + 34px outer height of .lightbox-nav
	        'maxHeight': dimensions.windowHeight - 126
	      };
	    } else {
	      return {
	        // 52px = 2 * (10px margin of .modal-dialog
	        //             + 1px border of .modal-content
	        //             + 15px padding of .modal-body)
	        'maxWidth': dimensions.windowWidth - 52,
	        // 86px = 52px as above
	        //        + 34px outer height of .lightbox-nav
	        'maxHeight': dimensions.windowHeight - 86
	      };
	    }
	  };

	  /**
	   * Calculate the width and height of the modal. This method gets called
	   *   after the width and height of the image, as displayed inside the modal,
	   *   are calculated.
	   * @param    {Object} dimensions Contains the properties `windowWidth`,
	   *   `windowHeight`, `imageDisplayWidth`, and `imageDisplayHeight`.
	   * @return   {Object} Must contain the properties `width` and `height`.
	   * @type     {Function}
	   * @name     calculateModalDimensions
	   * @memberOf bootstrapLightbox.Lightbox
	   */
	  this.calculateModalDimensions = function (dimensions) {
	    // 400px = arbitrary min width
	    // 32px = 2 * (1px border of .modal-content
	    //             + 15px padding of .modal-body)
	    var width = Math.max(400, dimensions.imageDisplayWidth + 32);

	    // 200px = arbitrary min height
	    // 66px = 32px as above
	    //        + 34px outer height of .lightbox-nav
	    var height = Math.max(200, dimensions.imageDisplayHeight + 66);

	    // first case:  the modal width cannot be larger than the window width
	    //              20px = arbitrary value larger than the vertical scrollbar
	    //                     width in order to avoid having a horizontal scrollbar
	    // second case: Bootstrap modals are not centered below 768px
	    if (width >= dimensions.windowWidth - 20 || dimensions.windowWidth < 768) {
	      width = 'auto';
	    }

	    // the modal height cannot be larger than the window height
	    if (height >= dimensions.windowHeight) {
	      height = 'auto';
	    }

	    return {
	      'width': width,
	      'height': height
	    };
	  };

	  /**
	   * @param    {*} image An element in the array of images.
	   * @return   {Boolean} Whether the provided element is a video.
	   * @type     {Function}
	   * @name     isVideo
	   * @memberOf bootstrapLightbox.Lightbox
	   */
	  this.isVideo = function (image) {
	    if (typeof image === 'object' && image && image.type) {
	      return image.type === 'video';
	    }

	    return false;
	  };

	  /**
	   * @param    {*} image An element in the array of images.
	   * @return   {Boolean} Whether the provided element is a video that is to be
	   *   embedded with an external service like YouTube. By default, this is
	   *   determined by the url not ending in `.mp4`, `.ogg`, or `.webm`.
	   * @type     {Function}
	   * @name     isSharedVideo
	   * @memberOf bootstrapLightbox.Lightbox
	   */
	  this.isSharedVideo = function (image) {
	    return this.isVideo(image) &&
	      !this.getImageUrl(image).match(/\.(mp4|ogg|webm)$/);
	  };

	  this.$get = ['$document', '$injector', '$uibModal', '$timeout', 'ImageLoader',
	      function ($document, $injector, $uibModal, $timeout, ImageLoader) {
	    // optional dependency
	    var cfpLoadingBar = $injector.has('cfpLoadingBar') ?
	      $injector.get('cfpLoadingBar'): null;

	    var Lightbox = {};

	    /**
	     * Array of all images to be shown in the lightbox (not `Image` objects).
	     * @type     {Array}
	     * @name     images
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.images = [];

	    /**
	     * The index in the `Lightbox.images` aray of the image that is currently
	     *   shown in the lightbox.
	     * @type     {Number}
	     * @name     index
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.index = -1;

	    // set the configurable properties and methods, the defaults of which are
	    // defined above
	    Lightbox.templateUrl = this.templateUrl;
	    Lightbox.fullScreenMode = this.fullScreenMode;
	    Lightbox.getImageUrl = this.getImageUrl;
	    Lightbox.getImageCaption = this.getImageCaption;
	    Lightbox.calculateImageDimensionLimits = this.calculateImageDimensionLimits;
	    Lightbox.calculateModalDimensions = this.calculateModalDimensions;
	    Lightbox.isVideo = this.isVideo;
	    Lightbox.isSharedVideo = this.isSharedVideo;

	    /**
	     * Whether keyboard navigation is currently enabled for navigating through
	     *   images in the lightbox.
	     * @type     {Boolean}
	     * @name     keyboardNavEnabled
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.keyboardNavEnabled = false;

	    /**
	     * The image currently shown in the lightbox.
	     * @type     {*}
	     * @name     image
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.image = {};

	    /**
	     * The UI Bootstrap modal instance. See {@link
	     *   http://angular-ui.github.io/bootstrap/#/modal}.
	     * @type     {Object}
	     * @name     modalInstance
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.modalInstance = null;

	    /**
	     * The URL of the current image. This is a property of the service rather
	     *   than of `Lightbox.image` because `Lightbox.image` need not be an
	     *   object, and besides it would be poor practice to alter the given
	     *   objects.
	     * @type     {String}
	     * @name     imageUrl
	     * @memberOf bootstrapLightbox.Lightbox
	     */

	    /**
	     * The optional caption of the current image.
	     * @type     {String}
	     * @name     imageCaption
	     * @memberOf bootstrapLightbox.Lightbox
	     */

	    /**
	     * Whether an image is currently being loaded.
	     * @type     {Boolean}
	     * @name     loading
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.loading = false;

	    /**
	     * Open the lightbox modal.
	     * @param    {Array}  newImages An array of images. Each image may be of
	     *   any type.
	     * @param    {Number} newIndex  The index in `newImages` to set as the
	     *   current image.
	     * @param    {Object} modalParams  Custom params for the angular UI
	     *   bootstrap modal (in $uibModal.open()).
	     * @return   {Object} The created UI Bootstrap modal instance.
	     * @type     {Function}
	     * @name     openModal
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.openModal = function (newImages, newIndex, modalParams) {
	      Lightbox.images = newImages;
	      Lightbox.setImage(newIndex);

	      // store the modal instance so we can close it manually if we need to
	      Lightbox.modalInstance = $uibModal.open(angular.extend({
	        'templateUrl': Lightbox.templateUrl,
	        'controller': ['$scope', function ($scope) {
	          // $scope is the modal scope, a child of $rootScope
	          $scope.Lightbox = Lightbox;

	          Lightbox.keyboardNavEnabled = true;
	        }],
	        'windowClass': 'lightbox-modal'
	      }, modalParams || {}));

	      // modal close handler
	      Lightbox.modalInstance.result['finally'](function () {
	        // prevent the lightbox from flickering from the old image when it gets
	        // opened again
	        Lightbox.images = [];
	        Lightbox.index = 1;
	        Lightbox.image = {};
	        Lightbox.imageUrl = null;
	        Lightbox.imageCaption = null;

	        Lightbox.keyboardNavEnabled = false;

	        // complete any lingering loading bar progress
	        if (cfpLoadingBar) {
	          cfpLoadingBar.complete();
	        }
	      });

	      return Lightbox.modalInstance;
	    };

	    /**
	     * Close the lightbox modal.
	     * @param    {*} result This argument can be useful if the modal promise
	     *   gets handler(s) attached to it.
	     * @type     {Function}
	     * @name     closeModal
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.closeModal = function (result) {
	      return Lightbox.modalInstance.close(result);
	    };

	    /**
	     * This method can be used in all methods which navigate/change the
	     *   current image.
	     * @param    {Number} newIndex The index in the array of images to set as
	     *   the new current image.
	     * @type     {Function}
	     * @name     setImage
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.setImage = function (newIndex) {
	      if (!(newIndex in Lightbox.images)) {
	        throw 'Invalid image.';
	      }

	      // update the loading flag and start the loading bar
	      Lightbox.loading = true;
	      if (cfpLoadingBar) {
	        cfpLoadingBar.start();
	      }

	      var image = Lightbox.images[newIndex];
	      var imageUrl = Lightbox.getImageUrl(image);

	      var success = function (properties) {
	        // update service properties for the image
	        properties = properties || {};
	        Lightbox.index = properties.index || newIndex;
	        Lightbox.image = properties.image || image;
	        Lightbox.imageUrl = properties.imageUrl || imageUrl;
	        Lightbox.imageCaption = properties.imageCaption ||
	          Lightbox.getImageCaption(image);

	        // restore the loading flag and complete the loading bar
	        Lightbox.loading = false;
	        if (cfpLoadingBar) {
	          cfpLoadingBar.complete();
	        }
	      };

	      if (!Lightbox.isVideo(image)) {
	        // load the image before setting it, so everything in the view is
	        // updated at the same time; otherwise, the previous image remains while
	        // the current image is loading
	        ImageLoader.load(imageUrl).then(function () {
	          success();
	        }, function () {
	          success({
	            'imageUrl': '#', // blank image
	            // use the caption to show the user an error
	            'imageCaption': 'Failed to load image'
	          });
	        });
	      } else {
	        success();
	      }
	    };

	    /**
	     * Navigate to the first image.
	     * @type     {Function}
	     * @name     firstImage
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.firstImage = function () {
	      Lightbox.setImage(0);
	    };

	    /**
	     * Navigate to the previous image.
	     * @type     {Function}
	     * @name     prevImage
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.prevImage = function () {
	      Lightbox.setImage((Lightbox.index - 1 + Lightbox.images.length) %
	        Lightbox.images.length);
	    };

	    /**
	     * Navigate to the next image.
	     * @type     {Function}
	     * @name     nextImage
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.nextImage = function () {
	      Lightbox.setImage((Lightbox.index + 1) % Lightbox.images.length);
	    };

	    /**
	     * Navigate to the last image.
	     * @type     {Function}
	     * @name     lastImage
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.lastImage = function () {
	      Lightbox.setImage(Lightbox.images.length - 1);
	    };

	    /**
	     * Call this method to set both the array of images and the current image
	     *   (based on the current index). A use case is when the image collection
	     *   gets changed dynamically in some way while the lightbox is still
	     *   open.
	     * @param {Array} newImages The new array of images.
	     * @type     {Function}
	     * @name     setImages
	     * @memberOf bootstrapLightbox.Lightbox
	     */
	    Lightbox.setImages = function (newImages) {
	      Lightbox.images = newImages;
	      Lightbox.setImage(Lightbox.index);
	    };

	    // Bind the left and right arrow keys for image navigation. This event
	    // handler never gets unbinded. Disable this using the `keyboardNavEnabled`
	    // flag. It is automatically disabled when the target is an input and or a
	    // textarea. TODO: Move this to a directive.
	    $document.bind('keydown', function (event) {
	      if (!Lightbox.keyboardNavEnabled) {
	        return;
	      }

	      // method of Lightbox to call
	      var method = null;

	      switch (event.which) {
	      case 39: // right arrow key
	        method = 'nextImage';
	        break;
	      case 37: // left arrow key
	        method = 'prevImage';
	        break;
	      }

	      if (method !== null && ['input', 'textarea'].indexOf(
	          event.target.tagName.toLowerCase()) === -1) {
	        // the view doesn't update without a manual digest
	        $timeout(function () {
	          Lightbox[method]();
	        });

	        event.preventDefault();
	      }
	    });

	    return Lightbox;
	  }];
	});
	/**
	 * @class     lightboxSrc
	 * @classdesc This attribute directive is used in an `<img>` element in the
	 *   modal template in place of `src`. It handles resizing both the `<img>`
	 *   element and its relevant parent elements within the modal.
	 * @memberOf  bootstrapLightbox
	 */
	angular.module('bootstrapLightbox').directive('lightboxSrc', ['$window',
	    'ImageLoader', 'Lightbox', function ($window, ImageLoader, Lightbox) {
	  // Calculate the dimensions to display the image. The max dimensions override
	  // the min dimensions if they conflict.
	  var calculateImageDisplayDimensions = function (dimensions, fullScreenMode) {
	    var w = dimensions.width;
	    var h = dimensions.height;
	    var minW = dimensions.minWidth;
	    var minH = dimensions.minHeight;
	    var maxW = dimensions.maxWidth;
	    var maxH = dimensions.maxHeight;

	    var displayW = w;
	    var displayH = h;

	    if (!fullScreenMode) {
	      // resize the image if it is too small
	      if (w < minW && h < minH) {
	        // the image is both too thin and short, so compare the aspect ratios to
	        // determine whether to min the width or height
	        if (w / h > maxW / maxH) {
	          displayH = minH;
	          displayW = Math.round(w * minH / h);
	        } else {
	          displayW = minW;
	          displayH = Math.round(h * minW / w);
	        }
	      } else if (w < minW) {
	        // the image is too thin
	        displayW = minW;
	        displayH = Math.round(h * minW / w);
	      } else if (h < minH) {
	        // the image is too short
	        displayH = minH;
	        displayW = Math.round(w * minH / h);
	      }

	      // resize the image if it is too large
	      if (w > maxW && h > maxH) {
	        // the image is both too tall and wide, so compare the aspect ratios
	        // to determine whether to max the width or height
	        if (w / h > maxW / maxH) {
	          displayW = maxW;
	          displayH = Math.round(h * maxW / w);
	        } else {
	          displayH = maxH;
	          displayW = Math.round(w * maxH / h);
	        }
	      } else if (w > maxW) {
	        // the image is too wide
	        displayW = maxW;
	        displayH = Math.round(h * maxW / w);
	      } else if (h > maxH) {
	        // the image is too tall
	        displayH = maxH;
	        displayW = Math.round(w * maxH / h);
	      }
	    } else {
	      // full screen mode
	      var ratio = Math.min(maxW / w, maxH / h);

	      var zoomedW = Math.round(w * ratio);
	      var zoomedH = Math.round(h * ratio);

	      displayW = Math.max(minW, zoomedW);
	      displayH = Math.max(minH, zoomedH);
	    }

	    return {
	      'width': displayW || 0,
	      'height': displayH || 0 // NaN is possible when dimensions.width is 0
	    };
	  };

	  // format the given dimension for passing into the `css()` method of `jqLite`
	  var formatDimension = function (dimension) {
	    return typeof dimension === 'number' ? dimension + 'px' : dimension;
	  };

	  // the dimensions of the image
	  var imageWidth = 0;
	  var imageHeight = 0;

	  return {
	    'link': function (scope, element, attrs) {
	      // resize the img element and the containing modal
	      var resize = function () {
	        // get the window dimensions
	        var windowWidth = $window.innerWidth;
	        var windowHeight = $window.innerHeight;

	        // calculate the max/min dimensions for the image
	        var imageDimensionLimits = Lightbox.calculateImageDimensionLimits({
	          'windowWidth': windowWidth,
	          'windowHeight': windowHeight,
	          'imageWidth': imageWidth,
	          'imageHeight': imageHeight
	        });

	        // calculate the dimensions to display the image
	        var imageDisplayDimensions = calculateImageDisplayDimensions(
	          angular.extend({
	            'width': imageWidth,
	            'height': imageHeight,
	            'minWidth': 1,
	            'minHeight': 1,
	            'maxWidth': 3000,
	            'maxHeight': 3000,
	          }, imageDimensionLimits),
	          Lightbox.fullScreenMode
	        );

	        // calculate the dimensions of the modal container
	        var modalDimensions = Lightbox.calculateModalDimensions({
	          'windowWidth': windowWidth,
	          'windowHeight': windowHeight,
	          'imageDisplayWidth': imageDisplayDimensions.width,
	          'imageDisplayHeight': imageDisplayDimensions.height
	        });

	        // resize the image
	        element.css({
	          'width': imageDisplayDimensions.width + 'px',
	          'height': imageDisplayDimensions.height + 'px'
	        });

	        // setting the height on .modal-dialog does not expand the div with the
	        // background, which is .modal-content
	        angular.element(
	          document.querySelector('.lightbox-modal .modal-dialog')
	        ).css({
	          'width': formatDimension(modalDimensions.width)
	        });

	        // .modal-content has no width specified; if we set the width on
	        // .modal-content and not on .modal-dialog, .modal-dialog retains its
	        // default width of 600px and that places .modal-content off center
	        angular.element(
	          document.querySelector('.lightbox-modal .modal-content')
	        ).css({
	          'height': formatDimension(modalDimensions.height)
	        });
	      };

	      // load the new image and/or resize the video whenever the attr changes
	      scope.$watch(function () {
	        return attrs.lightboxSrc;
	      }, function (src) {
	        // do nothing if there's no image
	        if (!Lightbox.image) {
	          return;
	        }

	        if (!Lightbox.isVideo(Lightbox.image)) { // image
	          // blank the image before resizing the element
	          element[0].src = '#';

	          // handle failure to load the image
	          var failure = function () {
	            imageWidth = 0;
	            imageHeight = 0;

	            resize();
	          };

	          if (src) {
	            ImageLoader.load(src).then(function (image) {
	              // these variables must be set before resize(), as they are used
	              // in it
	              imageWidth = image.naturalWidth;
	              imageHeight = image.naturalHeight;

	              // resize the img element and the containing modal
	              resize();

	              // show the image
	              element[0].src = src;
	            }, failure);
	          } else {
	            failure();
	          }
	        } else { // video
	          // default dimensions
	          imageWidth = 1280;
	          imageHeight = 720;

	          // resize the video element and the containing modal
	          resize();

	          // the src attribute applies to `<video>` and not `<embed-video>`
	          element[0].src = src;
	        }
	      });

	      // resize the image and modal whenever the window gets resized
	      angular.element($window).on('resize', resize);
	    }
	  };
	}]);


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(47);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./AdminLTE.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./AdminLTE.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "/*!\n *   AdminLTE v2.3.0\n *   Author: Almsaeed Studio\n *\t Website: Almsaeed Studio <http://almsaeedstudio.com>\n *   License: Open source - MIT\n *           Please visit http://opensource.org/licenses/MIT for more information\n!*/body,html{min-height:100%}.layout-boxed body,.layout-boxed html{height:100%}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Source Sans Pro,Helvetica Neue,Helvetica,Arial,sans-serif;font-weight:400;overflow-x:hidden;overflow-y:auto}.wrapper{min-height:100%;position:static;overflow:hidden}.wrapper:after,.wrapper:before{content:\" \";display:table}.wrapper:after{clear:both}.layout-boxed .wrapper{max-width:1250px;margin:0 auto;min-height:100%;box-shadow:0 0 8px rgba(0,0,0,.5);position:relative}.layout-boxed{background:url(" + __webpack_require__(48) + ") repeat fixed}.content-wrapper,.main-footer,.right-side{-webkit-transition:-webkit-transform .3s ease-in-out,margin .3s ease-in-out;transition:transform .3s ease-in-out,margin .3s ease-in-out;margin-left:230px;z-index:820}.layout-top-nav .content-wrapper,.layout-top-nav .main-footer,.layout-top-nav .right-side{margin-left:0}@media (max-width:767px){.content-wrapper,.main-footer,.right-side{margin-left:0}}@media (min-width:768px){.sidebar-collapse .content-wrapper,.sidebar-collapse .main-footer,.sidebar-collapse .right-side{margin-left:0}}@media (max-width:767px){.sidebar-open .content-wrapper,.sidebar-open .main-footer,.sidebar-open .right-side{-webkit-transform:translate(230px);transform:translate(230px)}}.content-wrapper,.right-side{min-height:100%;background-color:#ecf0f5;z-index:800}.main-footer{background:#fff;padding:15px;color:#444;border-top:1px solid #d2d6de}.fixed .left-side,.fixed .main-header,.fixed .main-sidebar{position:fixed}.fixed .main-header{top:0;right:0;left:0}.fixed .content-wrapper,.fixed .right-side{padding-top:50px}@media (max-width:767px){.fixed .content-wrapper,.fixed .right-side{padding-top:100px}}.fixed.layout-boxed .wrapper{max-width:100%}body.hold-transition .content-wrapper,body.hold-transition .left-side,body.hold-transition .main-footer,body.hold-transition .main-header .logo,body.hold-transition .main-header>.navbar,body.hold-transition .main-sidebar,body.hold-transition .right-side{-webkit-transition:none;transition:none}.content{padding:15px;margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:Source Sans Pro,sans-serif}a{color:#3c8dbc}a:active,a:focus,a:hover{outline:none;text-decoration:none;color:#72afd2}.page-header{margin:10px 0 20px;font-size:22px}.page-header>small{color:#666;display:block;margin-top:5px}.main-header{position:relative;max-height:100px;z-index:1030}.main-header>.navbar{-webkit-transition:margin-left .3s ease-in-out;transition:margin-left .3s ease-in-out;margin-bottom:0;margin-left:230px;border:none;min-height:50px;border-radius:0}.layout-top-nav .main-header>.navbar{margin-left:0}.main-header #navbar-search-input.form-control{background:hsla(0,0%,100%,.2);border-color:transparent}.main-header #navbar-search-input.form-control:active,.main-header #navbar-search-input.form-control:focus{border-color:rgba(0,0,0,.1);background:hsla(0,0%,100%,.9)}.main-header #navbar-search-input.form-control::-moz-placeholder{color:#ccc;opacity:1}.main-header #navbar-search-input.form-control:-ms-input-placeholder{color:#ccc}.main-header #navbar-search-input.form-control::-webkit-input-placeholder{color:#ccc}.main-header .navbar-custom-menu,.main-header .navbar-right{float:right}@media (max-width:991px){.main-header .navbar-custom-menu a,.main-header .navbar-right a{color:inherit;background:transparent}}@media (max-width:767px){.main-header .navbar-right{float:none}.navbar-collapse .main-header .navbar-right{margin:7.5px -15px}.main-header .navbar-right>li{color:inherit;border:0}}.main-header .sidebar-toggle{float:left;background-color:transparent;background-image:none;padding:15px;font-family:fontAwesome}.main-header .sidebar-toggle:before{content:\"\\F0C9\"}.main-header .sidebar-toggle:hover{color:#fff}.main-header .sidebar-toggle:active,.main-header .sidebar-toggle:focus{background:transparent}.main-header .sidebar-toggle .icon-bar{display:none}.main-header .navbar .nav>li.user>a>.fa,.main-header .navbar .nav>li.user>a>.glyphicon,.main-header .navbar .nav>li.user>a>.ion{margin-right:5px}.main-header .navbar .nav>li>a>.label{position:absolute;top:9px;right:7px;text-align:center;font-size:9px;padding:2px 3px;line-height:.9}.main-header .logo{-webkit-transition:width .3s ease-in-out;transition:width .3s ease-in-out;display:block;float:left;height:50px;font-size:20px;line-height:50px;text-align:center;width:230px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;padding:0 15px;font-weight:300;overflow:hidden}.main-header .logo .logo-lg{display:block}.main-header .logo .logo-mini{display:none}.main-header .navbar-brand{color:#fff}.content-header{position:relative;padding:15px 15px 0}.content-header>h1{margin:0;font-size:24px}.content-header>h1>small{font-size:15px;display:inline-block;padding-left:4px;font-weight:300}.content-header>.breadcrumb{float:right;background:transparent;margin-top:0;margin-bottom:0;font-size:12px;padding:7px 5px;position:absolute;top:15px;right:10px;border-radius:2px}.content-header>.breadcrumb>li>a{color:#444;text-decoration:none;display:inline-block}.content-header>.breadcrumb>li>a>.fa,.content-header>.breadcrumb>li>a>.glyphicon,.content-header>.breadcrumb>li>a>.ion{margin-right:5px}.content-header>.breadcrumb>li+li:before{content:'>\\A0'}@media (max-width:991px){.content-header>.breadcrumb{position:relative;margin-top:5px;top:0;right:0;float:none;background:#d2d6de;padding-left:10px}.content-header>.breadcrumb li:before{color:#97a0b3}}.navbar-toggle{color:#fff;border:0;margin:0;padding:15px}@media (max-width:991px){.navbar-custom-menu .navbar-nav>li{float:left}.navbar-custom-menu .navbar-nav{margin:0;float:left}.navbar-custom-menu .navbar-nav>li>a{padding-top:15px;padding-bottom:15px;line-height:20px}}@media (max-width:767px){.main-header{position:relative}.main-header .logo,.main-header .navbar{width:100%;float:none}.main-header .navbar{margin:0}.main-header .navbar-custom-menu{float:right}}@media (max-width:991px){.navbar-collapse.pull-left{float:none!important}.navbar-collapse.pull-left+.navbar-custom-menu{display:block;position:absolute;top:0;right:40px}}.left-side,.main-sidebar{position:absolute;top:0;left:0;padding-top:50px;min-height:100%;width:230px;z-index:810;-webkit-transition:-webkit-transform .3s ease-in-out,width .3s ease-in-out;transition:transform .3s ease-in-out,width .3s ease-in-out}@media (max-width:767px){.left-side,.main-sidebar{padding-top:100px;-webkit-transform:translate(-230px);transform:translate(-230px)}}@media (min-width:768px){.sidebar-collapse .left-side,.sidebar-collapse .main-sidebar{-webkit-transform:translate(-230px);transform:translate(-230px)}}@media (max-width:767px){.sidebar-open .left-side,.sidebar-open .main-sidebar{-webkit-transform:translate(0);transform:translate(0)}}.sidebar{padding-bottom:10px}.sidebar-form input:focus{border-color:transparent}.user-panel{position:relative;width:100%;padding:10px;overflow:hidden}.user-panel:after,.user-panel:before{content:\" \";display:table}.user-panel:after{clear:both}.user-panel>.image>img{width:100%;max-width:45px;height:auto}.user-panel>.info{padding:5px 5px 5px 15px;line-height:1;position:absolute;left:55px}.user-panel>.info>p{font-weight:600;margin-bottom:9px}.user-panel>.info>a{text-decoration:none;padding-right:5px;margin-top:3px;font-size:11px}.user-panel>.info>a>.fa,.user-panel>.info>a>.glyphicon,.user-panel>.info>a>.ion{margin-right:3px}.sidebar-menu{list-style:none;margin:0;padding:0}.sidebar-menu>li{position:relative;margin:0;padding:0}.sidebar-menu>li>a{padding:12px 5px 12px 15px;display:block}.sidebar-menu>li>a>.fa,.sidebar-menu>li>a>.glyphicon,.sidebar-menu>li>a>.ion{width:20px}.sidebar-menu>li .badge,.sidebar-menu>li .label{margin-top:3px;margin-right:5px}.sidebar-menu li.header{padding:10px 25px 10px 15px;font-size:12px}.sidebar-menu li>a>.fa-angle-left{width:auto;height:auto;padding:0;margin-right:10px;margin-top:3px}.sidebar-menu li.active>a>.fa-angle-left{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.sidebar-menu li.active>.treeview-menu{display:block}.sidebar-menu .treeview-menu{display:none;list-style:none;padding:0;margin:0;padding-left:5px}.sidebar-menu .treeview-menu .treeview-menu{padding-left:20px}.sidebar-menu .treeview-menu>li{margin:0}.sidebar-menu .treeview-menu>li>a{padding:5px 5px 5px 15px;display:block;font-size:14px}.sidebar-menu .treeview-menu>li>a>.fa,.sidebar-menu .treeview-menu>li>a>.glyphicon,.sidebar-menu .treeview-menu>li>a>.ion{width:20px}.sidebar-menu .treeview-menu>li>a>.fa-angle-down,.sidebar-menu .treeview-menu>li>a>.fa-angle-left{width:auto}@media (min-width:768px){.sidebar-mini.sidebar-collapse .content-wrapper,.sidebar-mini.sidebar-collapse .main-footer,.sidebar-mini.sidebar-collapse .right-side{margin-left:50px!important;z-index:840}.sidebar-mini.sidebar-collapse .main-sidebar{-webkit-transform:translate(0);transform:translate(0);width:50px!important;z-index:850}.sidebar-mini.sidebar-collapse .sidebar-menu>li{position:relative}.sidebar-mini.sidebar-collapse .sidebar-menu>li>a{margin-right:0}.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>span{border-top-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:not(.treeview)>a>span{border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li>.treeview-menu{padding-top:5px;padding-bottom:5px;border-bottom-right-radius:4px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>.treeview-menu,.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>span:not(.pull-right){display:block!important;position:absolute;width:180px;left:50px}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>a>span{top:0;margin-left:-3px;padding:12px 5px 12px 20px;background-color:inherit}.sidebar-mini.sidebar-collapse .sidebar-menu>li:hover>.treeview-menu{top:44px;margin-left:0}.sidebar-mini.sidebar-collapse .main-sidebar .user-panel>.info,.sidebar-mini.sidebar-collapse .sidebar-form,.sidebar-mini.sidebar-collapse .sidebar-menu>li>.treeview-menu,.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>.pull-right,.sidebar-mini.sidebar-collapse .sidebar-menu>li>a>span,.sidebar-mini.sidebar-collapse .sidebar-menu li.header{display:none!important;-webkit-transform:translateZ(0)}.sidebar-mini.sidebar-collapse .main-header .logo{width:50px}.sidebar-mini.sidebar-collapse .main-header .logo>.logo-mini{display:block;margin-left:-15px;margin-right:-15px;font-size:18px}.sidebar-mini.sidebar-collapse .main-header .logo>.logo-lg{display:none}.sidebar-mini.sidebar-collapse .main-header .navbar{margin-left:50px}}.main-sidebar .user-panel,.sidebar-menu,.sidebar-menu>li.header{white-space:nowrap;overflow:hidden}.sidebar-menu:hover{overflow:visible}.sidebar-form,.sidebar-menu>li.header{overflow:hidden;text-overflow:clip}.sidebar-menu li>a{position:relative}.sidebar-menu li>a>.pull-right{position:absolute;top:50%;right:10px;margin-top:-7px}.control-sidebar-bg{position:fixed;z-index:1000;bottom:0}.control-sidebar,.control-sidebar-bg{top:0;right:-230px;width:230px;-webkit-transition:right .3s ease-in-out;transition:right .3s ease-in-out}.control-sidebar{position:absolute;padding-top:50px;z-index:1010}@media (max-width:768px){.control-sidebar{padding-top:100px}}.control-sidebar>.tab-content{padding:10px 15px}.control-sidebar-open .control-sidebar,.control-sidebar-open .control-sidebar-bg,.control-sidebar.control-sidebar-open,.control-sidebar.control-sidebar-open+.control-sidebar-bg{right:0}@media (min-width:768px){.control-sidebar-open .content-wrapper,.control-sidebar-open .main-footer,.control-sidebar-open .right-side{margin-right:230px}}.nav-tabs.control-sidebar-tabs>li:first-of-type>a,.nav-tabs.control-sidebar-tabs>li:first-of-type>a:focus,.nav-tabs.control-sidebar-tabs>li:first-of-type>a:hover{border-left-width:0}.nav-tabs.control-sidebar-tabs>li>a{border-radius:0}.nav-tabs.control-sidebar-tabs>li>a,.nav-tabs.control-sidebar-tabs>li>a:hover{border-top:none;border-right:none;border-left:1px solid transparent;border-bottom:1px solid transparent}.nav-tabs.control-sidebar-tabs>li>a .icon{font-size:16px}.nav-tabs.control-sidebar-tabs>li.active>a,.nav-tabs.control-sidebar-tabs>li.active>a:active,.nav-tabs.control-sidebar-tabs>li.active>a:focus,.nav-tabs.control-sidebar-tabs>li.active>a:hover{border-top:none;border-right:none;border-bottom:none}@media (max-width:768px){.nav-tabs.control-sidebar-tabs{display:table}.nav-tabs.control-sidebar-tabs>li{display:table-cell}}.control-sidebar-heading{font-weight:400;font-size:16px;padding:10px 0;margin-bottom:10px}.control-sidebar-subheading{display:block;font-weight:400;font-size:14px}.control-sidebar-menu{list-style:none;padding:0;margin:0 -15px}.control-sidebar-menu>li>a{display:block;padding:10px 15px}.control-sidebar-menu>li>a:after,.control-sidebar-menu>li>a:before{content:\" \";display:table}.control-sidebar-menu>li>a:after{clear:both}.control-sidebar-menu>li>a>.control-sidebar-subheading{margin-top:0}.control-sidebar-menu .menu-icon{float:left;width:35px;height:35px;border-radius:50%;text-align:center;line-height:35px}.control-sidebar-menu .menu-info{margin-left:45px;margin-top:3px}.control-sidebar-menu .menu-info>.control-sidebar-subheading{margin:0}.control-sidebar-menu .menu-info>p{margin:0;font-size:11px}.control-sidebar-menu .progress{margin:0}.control-sidebar-dark{color:#b8c7ce}.control-sidebar-dark,.control-sidebar-dark+.control-sidebar-bg{background:#222d32}.control-sidebar-dark .nav-tabs.control-sidebar-tabs{border-bottom:#1c2529}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a{background:#181f23;color:#b8c7ce}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover{border-left-color:#141a1d;border-bottom-color:#141a1d}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:active,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover{background:#1c2529}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li>a:hover{color:#fff}.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:active,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:focus,.control-sidebar-dark .nav-tabs.control-sidebar-tabs>li.active>a:hover{background:#222d32;color:#fff}.control-sidebar-dark .control-sidebar-heading,.control-sidebar-dark .control-sidebar-subheading{color:#fff}.control-sidebar-dark .control-sidebar-menu>li>a:hover{background:#1e282c}.control-sidebar-dark .control-sidebar-menu>li>a .menu-info>p{color:#b8c7ce}.control-sidebar-light{color:#5e5e5e}.control-sidebar-light,.control-sidebar-light+.control-sidebar-bg{background:#f9fafc;border-left:1px solid #d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs{border-bottom:#d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a{background:#e8ecf4;color:#444}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:hover{border-left-color:#d2d6de;border-bottom-color:#d2d6de}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:active,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li>a:hover{background:#eff1f7}.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:active,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:focus,.control-sidebar-light .nav-tabs.control-sidebar-tabs>li.active>a:hover{background:#f9fafc;color:#111}.control-sidebar-light .control-sidebar-heading,.control-sidebar-light .control-sidebar-subheading{color:#111}.control-sidebar-light .control-sidebar-menu{margin-left:-14px}.control-sidebar-light .control-sidebar-menu>li>a:hover{background:#f4f4f5}.control-sidebar-light .control-sidebar-menu>li>a .menu-info>p{color:#5e5e5e}.dropdown-menu{box-shadow:none;border-color:#eee}.dropdown-menu>li>a{color:#777}.dropdown-menu>li>a>.fa,.dropdown-menu>li>a>.glyphicon,.dropdown-menu>li>a>.ion{margin-right:10px}.dropdown-menu>li>a:hover{background-color:#e1e3e9;color:#333}.dropdown-menu>.divider{background-color:#eee}.navbar-nav>.messages-menu>.dropdown-menu,.navbar-nav>.notifications-menu>.dropdown-menu,.navbar-nav>.tasks-menu>.dropdown-menu{width:280px;padding:0;margin:0;top:100%}.navbar-nav>.messages-menu>.dropdown-menu>li,.navbar-nav>.notifications-menu>.dropdown-menu>li,.navbar-nav>.tasks-menu>.dropdown-menu>li{position:relative}.navbar-nav>.messages-menu>.dropdown-menu>li.header,.navbar-nav>.notifications-menu>.dropdown-menu>li.header,.navbar-nav>.tasks-menu>.dropdown-menu>li.header{border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0;background-color:#fff;padding:7px 10px;border-bottom:1px solid #f4f4f4;color:#444;font-size:14px}.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a,.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px;font-size:12px;background-color:#fff;padding:7px 10px;border-bottom:1px solid #eee;color:#444!important;text-align:center}@media (max-width:991px){.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a,.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a{background:#fff!important;color:#444!important}}.navbar-nav>.messages-menu>.dropdown-menu>li.footer>a:hover,.navbar-nav>.notifications-menu>.dropdown-menu>li.footer>a:hover,.navbar-nav>.tasks-menu>.dropdown-menu>li.footer>a:hover{text-decoration:none;font-weight:400}.navbar-nav>.messages-menu>.dropdown-menu>li .menu,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu{max-height:200px;margin:0;padding:0;list-style:none;overflow-x:hidden}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a{display:block;white-space:nowrap;border-bottom:1px solid #f4f4f4}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:hover,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a:hover,.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background:#f4f4f4;text-decoration:none}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a{color:#444;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:10px}.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.fa,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.glyphicon,.navbar-nav>.notifications-menu>.dropdown-menu>li .menu>li>a>.ion{width:20px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a{margin:0;padding:10px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>div>img{margin:auto 10px auto auto;width:40px;height:40px}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>h4{padding:0;margin:0 0 0 45px;color:#444;font-size:15px;position:relative}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>h4>small{color:#999;font-size:10px;position:absolute;top:0;right:0}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a>p{margin:0 0 0 45px;font-size:12px;color:#888}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:after,.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:before{content:\" \";display:table}.navbar-nav>.messages-menu>.dropdown-menu>li .menu>li>a:after{clear:both}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a{padding:10px}@media screen and (max-width:500px){.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>h3{font-size:14px;padding:0;margin:0 0 10px;color:#fff}}@media screen and (min-width:500px) and (max-width:1023px){.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>h3{font-size:14px;padding:0;margin:0 0 10px;color:#666}}@media screen and (min-width:1024px){.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>h3{font-size:14px;padding:0;margin:0 0 10px;color:#666}}.navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a>.progress{padding:0;margin:0}.navbar-nav>.user-menu>.dropdown-menu{border-top-right-radius:0;border-top-left-radius:0;padding:1px 0 0;border-top-width:0;width:280px}.navbar-nav>.user-menu>.dropdown-menu,.navbar-nav>.user-menu>.dropdown-menu>.user-body{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.navbar-nav>.user-menu>.dropdown-menu>li.user-header{height:175px;padding:10px;text-align:center}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>img{z-index:5;height:90px;width:90px;border:3px solid;border-color:transparent;border-color:hsla(0,0%,100%,.2)}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>p{z-index:5;color:#fff;color:hsla(0,0%,100%,.8);font-size:17px;margin-top:10px}.navbar-nav>.user-menu>.dropdown-menu>li.user-header>p>small{display:block;font-size:12px}.navbar-nav>.user-menu>.dropdown-menu>.user-body{padding:15px;border-bottom:1px solid #f4f4f4;border-top:1px solid #ddd}.navbar-nav>.user-menu>.dropdown-menu>.user-body:after,.navbar-nav>.user-menu>.dropdown-menu>.user-body:before{content:\" \";display:table}.navbar-nav>.user-menu>.dropdown-menu>.user-body:after{clear:both}.navbar-nav>.user-menu>.dropdown-menu>.user-body a{color:#444!important}@media (max-width:991px){.navbar-nav>.user-menu>.dropdown-menu>.user-body a{background:#fff!important;color:#444!important}}.navbar-nav>.user-menu>.dropdown-menu>.user-footer{background-color:#f9f9f9;padding:10px}.navbar-nav>.user-menu>.dropdown-menu>.user-footer:after,.navbar-nav>.user-menu>.dropdown-menu>.user-footer:before{content:\" \";display:table}.navbar-nav>.user-menu>.dropdown-menu>.user-footer:after{clear:both}.navbar-nav>.user-menu>.dropdown-menu>.user-footer .btn-default{color:#666}@media (max-width:991px){.navbar-nav>.user-menu>.dropdown-menu>.user-footer .btn-default:hover{background-color:#f9f9f9}}.navbar-nav>.user-menu .user-image{float:left;width:25px;height:25px;border-radius:50%;margin-right:10px;margin-top:-2px}@media (max-width:767px){.navbar-nav>.user-menu .user-image{float:none;margin-right:0;margin-top:-8px;line-height:10px}}.open:not(.dropup)>.animated-dropdown-menu{backface-visibility:visible!important;-webkit-animation:flipInX .7s both;animation:flipInX .7s both}@keyframes flipInX{0%{transform:perspective(400px) rotateX(90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@-webkit-keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);-webkit-transition-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateX(-20deg);-webkit-transition-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px)}}.navbar-custom-menu>.navbar-nav>li{position:relative}.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{position:absolute;right:0;left:auto}@media (max-width:991px){.navbar-custom-menu>.navbar-nav{float:right}.navbar-custom-menu>.navbar-nav>li{position:static}.navbar-custom-menu>.navbar-nav>li>.dropdown-menu{position:absolute;right:5%;left:auto;border:1px solid #ddd;background:#fff}}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}.form-control:focus{border-color:#3c8dbc;box-shadow:none}.form-control:-ms-input-placeholder,.form-control::-moz-placeholder,.form-control::-webkit-input-placeholder{color:#bbb;opacity:1}.form-control:not(select){-webkit-appearance:none;-moz-appearance:none;appearance:none}.form-group.has-success label{color:#00a65a}.form-group.has-success .form-control{border-color:#00a65a;box-shadow:none}.form-group.has-warning label{color:#f39c12}.form-group.has-warning .form-control{border-color:#f39c12;box-shadow:none}.form-group.has-error label{color:#dd4b39}.form-group.has-error .form-control{border-color:#dd4b39;box-shadow:none}.input-group .input-group-addon{border-radius:0;border-color:#d2d6de;background-color:#fff}.btn-group-vertical .btn.btn-flat:first-of-type,.btn-group-vertical .btn.btn-flat:last-of-type{border-radius:0}.icheck>label{padding-left:0}.form-control-feedback.fa{line-height:34px}.form-group-lg .form-control+.form-control-feedback.fa,.input-group-lg+.form-control-feedback.fa,.input-lg+.form-control-feedback.fa{line-height:46px}.form-group-sm .form-control+.form-control-feedback.fa,.input-group-sm+.form-control-feedback.fa,.input-sm+.form-control-feedback.fa{line-height:30px}.progress,.progress>.progress-bar{box-shadow:none}.progress,.progress .progress-bar,.progress>.progress-bar,.progress>.progress-bar .progress-bar{border-radius:1px}.progress-sm,.progress.sm{height:10px}.progress-sm,.progress-sm .progress-bar,.progress.sm,.progress.sm .progress-bar{border-radius:1px}.progress-xs,.progress.xs{height:7px}.progress-xs,.progress-xs .progress-bar,.progress.xs,.progress.xs .progress-bar{border-radius:1px}.progress-xxs,.progress.xxs{height:3px}.progress-xxs,.progress-xxs .progress-bar,.progress.xxs,.progress.xxs .progress-bar{border-radius:1px}.progress.vertical{position:relative;width:30px;height:200px;display:inline-block;margin-right:10px}.progress.vertical>.progress-bar{width:100%;position:absolute;bottom:0}.progress.vertical.progress-sm,.progress.vertical.sm{width:20px}.progress.vertical.progress-xs,.progress.vertical.xs{width:10px}.progress.vertical.progress-xxs,.progress.vertical.xxs{width:3px}.progress-group .progress-text{font-weight:600}.progress-group .progress-number{float:right}.table tr>td .progress{margin:0}.progress-bar-light-blue,.progress-bar-primary{background-color:#3c8dbc}.progress-striped .progress-bar-light-blue,.progress-striped .progress-bar-primary{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-green,.progress-bar-success{background-color:#00a65a}.progress-striped .progress-bar-green,.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-aqua,.progress-bar-info{background-color:#00c0ef}.progress-striped .progress-bar-aqua,.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning,.progress-bar-yellow{background-color:#f39c12}.progress-striped .progress-bar-warning,.progress-striped .progress-bar-yellow{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger,.progress-bar-red{background-color:#dd4b39}.progress-striped .progress-bar-danger,.progress-striped .progress-bar-red{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.small-box{border-radius:2px;position:relative;display:block;margin-bottom:20px;box-shadow:0 1px 1px rgba(0,0,0,.1)}.small-box>.inner{padding:10px}.small-box>.small-box-footer{position:relative;text-align:center;padding:3px 0;color:#fff;color:hsla(0,0%,100%,.8);display:block;z-index:10;background:rgba(0,0,0,.1);text-decoration:none}.small-box>.small-box-footer:hover{color:#fff;background:rgba(0,0,0,.15)}.small-box h3{font-size:38px;font-weight:700;margin:0 0 10px;white-space:nowrap;padding:0}.small-box p{font-size:15px}.small-box p>small{display:block;color:#f9f9f9;font-size:13px;margin-top:5px}.small-box h3,.small-box p{z-index:5px}.small-box .icon{-webkit-transition:all .3s linear;transition:all .3s linear;position:absolute;top:-10px;right:10px;z-index:0;font-size:90px;color:rgba(0,0,0,.15)}.small-box:hover{text-decoration:none;color:#f9f9f9}.small-box:hover .icon{font-size:95px}@media (max-width:767px){.small-box{text-align:center}.small-box .icon{display:none}.small-box p{font-size:12px}}.box{position:relative;border-radius:3px;background:#fff;border-top:3px solid #d2d6de;margin-bottom:20px;width:100%;box-shadow:0 1px 1px rgba(0,0,0,.1)}.box.box-primary{border-top-color:#3c8dbc}.box.box-info{border-top-color:#00c0ef}.box.box-danger{border-top-color:#dd4b39}.box.box-warning{border-top-color:#f39c12}.box.box-success{border-top-color:#00a65a}.box.box-default{border-top-color:#d2d6de}.box.collapsed-box .box-body,.box.collapsed-box .box-footer{display:none}.box .nav-stacked>li{border-bottom:1px solid #f4f4f4;margin:0}.box .nav-stacked>li:last-of-type{border-bottom:none}.box.height-control .box-body{max-height:300px;overflow:auto}.box .border-right{border-right:1px solid #f4f4f4}.box .border-left{border-left:1px solid #f4f4f4}.box.box-solid{border-top:0}.box.box-solid>.box-header .btn.btn-default{background:transparent}.box.box-solid>.box-header .btn:hover,.box.box-solid>.box-header a:hover{background:rgba(0,0,0,.1)}.box.box-solid.box-default{border:1px solid #d2d6de}.box.box-solid.box-default>.box-header{color:#444;background:#d2d6de;background-color:#d2d6de}.box.box-solid.box-default>.box-header .btn,.box.box-solid.box-default>.box-header a{color:#444}.box.box-solid.box-primary{border:1px solid #3c8dbc}.box.box-solid.box-primary>.box-header{color:#fff;background:#3c8dbc;background-color:#3c8dbc}.box.box-solid.box-primary>.box-header .btn,.box.box-solid.box-primary>.box-header a{color:#fff}.box.box-solid.box-info{border:1px solid #00c0ef}.box.box-solid.box-info>.box-header{color:#fff;background:#00c0ef;background-color:#00c0ef}.box.box-solid.box-info>.box-header .btn,.box.box-solid.box-info>.box-header a{color:#fff}.box.box-solid.box-danger{border:1px solid #dd4b39}.box.box-solid.box-danger>.box-header{color:#fff;background:#dd4b39;background-color:#dd4b39}.box.box-solid.box-danger>.box-header .btn,.box.box-solid.box-danger>.box-header a{color:#fff}.box.box-solid.box-warning{border:1px solid #f39c12}.box.box-solid.box-warning>.box-header{color:#fff;background:#f39c12;background-color:#f39c12}.box.box-solid.box-warning>.box-header .btn,.box.box-solid.box-warning>.box-header a{color:#fff}.box.box-solid.box-success{border:1px solid #00a65a}.box.box-solid.box-success>.box-header{color:#fff;background:#00a65a;background-color:#00a65a}.box.box-solid.box-success>.box-header .btn,.box.box-solid.box-success>.box-header a{color:#fff}.box.box-solid>.box-header>.box-tools .btn{border:0;box-shadow:none}.box.box-solid[class*=bg]>.box-header{color:#fff}.box .box-group>.box{margin-bottom:5px}.box .knob-label{text-align:center;color:#333;font-weight:100;font-size:12px;margin-bottom:.3em}.box>.loading-img,.box>.overlay,.overlay-wrapper>.loading-img,.overlay-wrapper>.overlay{position:absolute;top:0;left:0;width:100%;height:100%}.box .overlay,.overlay-wrapper .overlay{z-index:50;background:hsla(0,0%,100%,.7);border-radius:3px}.box .overlay>.fa,.overlay-wrapper .overlay>.fa{position:absolute;top:50%;left:50%;margin-left:-15px;margin-top:-15px;color:#000;font-size:30px}.box .overlay.dark,.overlay-wrapper .overlay.dark{background:rgba(0,0,0,.5)}.box-body:after,.box-body:before,.box-footer:after,.box-footer:before,.box-header:after,.box-header:before{content:\" \";display:table}.box-body:after,.box-footer:after,.box-header:after{clear:both}.box-header{color:#444;display:block;padding:10px;position:relative}.box-header.with-border{border-bottom:1px solid #f4f4f4}.collapsed-box .box-header.with-border{border-bottom:none}.box-header .box-title,.box-header>.fa,.box-header>.glyphicon,.box-header>.ion{display:inline-block;font-size:18px;margin:0;line-height:1}.box-header>.fa,.box-header>.glyphicon,.box-header>.ion{margin-right:5px}.box-header>.box-tools{position:absolute;right:10px;top:5px}.box-header>.box-tools [data-toggle=tooltip]{position:relative}.box-header>.box-tools.pull-right .dropdown-menu{right:0;left:auto}.btn-box-tool{padding:5px;font-size:12px;background:transparent;color:#97a0b3}.btn-box-tool:hover,.open .btn-box-tool{color:#606c84}.btn-box-tool.btn:active{box-shadow:none}.box-body{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px;padding:10px}.no-header .box-body{border-top-right-radius:3px;border-top-left-radius:3px}.box-body>.table{margin-bottom:0}.box-body .fc{margin-top:5px}.box-body .full-width-chart{margin:-19px}.box-body.no-padding .full-width-chart{margin:-9px}.box-body .box-pane{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:3px}.box-body .box-pane-right{border-bottom-left-radius:0}.box-body .box-pane-right,.box-footer{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:3px}.box-footer{border-bottom-left-radius:3px;border-top:1px solid #f4f4f4;padding:10px;background-color:#fff}.chart-legend{margin:10px 0}@media (max-width:991px){.chart-legend>li{float:left;margin-right:10px}}.box-comments{background:#f7f7f7}.box-comments .box-comment{padding:8px 0;border-bottom:1px solid #eee}.box-comments .box-comment:after,.box-comments .box-comment:before{content:\" \";display:table}.box-comments .box-comment:after{clear:both}.box-comments .box-comment:last-of-type{border-bottom:0}.box-comments .box-comment:first-of-type{padding-top:0}.box-comments .box-comment img{float:left}.box-comments .comment-text{margin-left:40px;color:#555}.box-comments .username{color:#444;display:block;font-weight:600}.box-comments .text-muted{font-weight:400;font-size:12px}.todo-list{margin:0;padding:0;list-style:none;overflow:auto}.todo-list>li{border-radius:2px;padding:10px;background:#f4f4f4;margin-bottom:2px;border-left:2px solid #e6e7e8;color:#444}.todo-list>li:last-of-type{margin-bottom:0}.todo-list>li>input[type=checkbox]{margin:0 10px 0 5px}.todo-list>li .text{display:inline-block;margin-left:5px;font-weight:600}.todo-list>li .label{margin-left:10px;font-size:9px}.todo-list>li .tools{display:none;float:right;color:#dd4b39}.todo-list>li .tools>.fa,.todo-list>li .tools>.glyphicon,.todo-list>li .tools>.ion{margin-right:5px;cursor:pointer}.todo-list>li:hover .tools{display:inline-block}.todo-list>li.done{color:#999}.todo-list>li.done .text{text-decoration:line-through;font-weight:500}.todo-list>li.done .label{background:#d2d6de!important}.todo-list .danger{border-left-color:#dd4b39}.todo-list .warning{border-left-color:#f39c12}.todo-list .info{border-left-color:#00c0ef}.todo-list .success{border-left-color:#00a65a}.todo-list .primary{border-left-color:#3c8dbc}.todo-list .handle{display:inline-block;cursor:move;margin:0 5px}.chat{padding:5px 20px 5px 10px}.chat .item{margin-bottom:10px}.chat .item:after,.chat .item:before{content:\" \";display:table}.chat .item:after{clear:both}.chat .item>img{width:40px;height:40px;border:2px solid transparent;border-radius:50%}.chat .item>.online{border:2px solid #00a65a}.chat .item>.offline{border:2px solid #dd4b39}.chat .item>.message{margin-left:55px;margin-top:-40px}.chat .item>.message>.name{display:block;font-weight:600}.chat .item>.attachment{border-radius:3px;background:#f4f4f4;margin-left:65px;margin-right:15px;padding:10px}.chat .item>.attachment>h4{margin:0 0 5px;font-weight:600;font-size:14px}.chat .item>.attachment>.filename,.chat .item>.attachment>p{font-weight:600;font-size:13px;font-style:italic;margin:0}.chat .item>.attachment:after,.chat .item>.attachment:before{content:\" \";display:table}.chat .item>.attachment:after{clear:both}.box-input{max-width:200px}.modal .panel-body{color:#444}.info-box{display:block;min-height:90px;background:#fff;width:100%;box-shadow:0 1px 1px rgba(0,0,0,.1);border-radius:2px;margin-bottom:15px}.info-box small{font-size:14px}.info-box .progress{background:rgba(0,0,0,.2);margin:5px -10px;height:2px}.info-box .progress,.info-box .progress .progress-bar{border-radius:0}.info-box .progress .progress-bar{background:#fff}.info-box-icon{border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:left;height:90px;width:90px;text-align:center;font-size:45px;line-height:90px;background:rgba(0,0,0,.2)}.info-box-icon>img{max-width:100%}.info-box-content{padding:5px 10px;margin-left:90px}.info-box-number{display:block;font-weight:700;font-size:18px}.info-box-text,.progress-description{display:block;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.info-box-text{text-transform:uppercase}.info-box-more{display:block}.progress-description{margin:0}.timeline{position:relative;margin:0 0 30px;padding:0;list-style:none}.timeline:before{content:'';position:absolute;top:0;bottom:0;width:4px;background:#ddd;left:31px;margin:0;border-radius:2px}.timeline>li{position:relative;margin-right:10px;margin-bottom:15px}.timeline>li:after,.timeline>li:before{content:\" \";display:table}.timeline>li:after{clear:both}.timeline>li>.timeline-item{box-shadow:0 1px 1px rgba(0,0,0,.1);border-radius:3px;margin-top:0;background:#fff;color:#444;margin-left:60px;margin-right:15px;padding:0;position:relative}.timeline>li>.timeline-item>.time{color:#999;float:right;padding:10px;font-size:12px}.timeline>li>.timeline-item>.timeline-header{margin:0;color:#555;border-bottom:1px solid #f4f4f4;padding:10px;font-size:16px;line-height:1.1}.timeline>li>.timeline-item>.timeline-header>a{font-weight:600}.timeline>li>.timeline-item>.timeline-body,.timeline>li>.timeline-item>.timeline-footer{padding:10px}.timeline>li>.fa,.timeline>li>.glyphicon,.timeline>li>.ion{width:30px;height:30px;font-size:15px;line-height:30px;position:absolute;color:#666;background:#d2d6de;border-radius:50%;text-align:center;left:18px;top:0}.timeline>.time-label>span{font-weight:600;padding:5px;display:inline-block;background-color:#fff;border-radius:4px}.timeline-inverse>li>.timeline-item{background:#f0f0f0;border:1px solid #ddd;box-shadow:none}.timeline-inverse>li>.timeline-item>.timeline-header{border-bottom-color:#ddd}.btn{border-radius:3px;box-shadow:none;border:1px solid transparent}.btn.uppercase{text-transform:uppercase}.btn.btn-flat{border-radius:0;box-shadow:none;border-width:1px}.btn:active{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn:focus{outline:none}.btn.btn-file{position:relative;overflow:hidden}.btn.btn-file>input[type=file]{position:absolute;top:0;right:0;min-width:100%;min-height:100%;font-size:100px;text-align:right;opacity:0;filter:alpha(opacity=0);outline:none;background:#fff;cursor:inherit;display:block}.btn-default{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-default.hover,.btn-default:active,.btn-default:hover{background-color:#e7e7e7}.btn-primary{background-color:#3c8dbc;border-color:#367fa9}.btn-primary.hover,.btn-primary:active,.btn-primary:hover{background-color:#367fa9}.btn-success{background-color:#00a65a;border-color:#008d4c}.btn-success.hover,.btn-success:active,.btn-success:hover{background-color:#008d4c}.btn-info{background-color:#00c0ef;border-color:#00acd6}.btn-info.hover,.btn-info:active,.btn-info:hover{background-color:#00acd6}.btn-danger{background-color:#dd4b39;border-color:#d73925}.btn-danger.hover,.btn-danger:active,.btn-danger:hover{background-color:#d73925}.btn-warning{background-color:#f39c12;border-color:#e08e0b}.btn-warning.hover,.btn-warning:active,.btn-warning:hover{background-color:#e08e0b}.btn-outline{border:1px solid #fff;background:transparent;color:#fff}.btn-outline:active,.btn-outline:focus,.btn-outline:hover{color:hsla(0,0%,100%,.7);border-color:hsla(0,0%,100%,.7)}.btn-link{box-shadow:none}.btn[class*=bg-]:hover{box-shadow:inset 0 0 100px rgba(0,0,0,.2)}.btn-app{border-radius:3px;position:relative;padding:15px 5px;margin:0 0 10px 10px;min-width:80px;height:60px;text-align:center;color:#666;border:1px solid #ddd;background-color:#f4f4f4;font-size:12px}.btn-app>.fa,.btn-app>.glyphicon,.btn-app>.ion{font-size:20px;display:block}.btn-app:hover{background:#f4f4f4;color:#444;border-color:#aaa}.btn-app:active,.btn-app:focus{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-app>.badge{position:absolute;top:-3px;right:-10px;font-size:10px;font-weight:400}.callout{border-radius:3px;margin:0 0 20px;padding:15px 30px 15px 15px;border-left:5px solid #eee}.callout a{color:#fff;text-decoration:underline}.callout a:hover{color:#eee}.callout h4{margin-top:0;font-weight:600}.callout p:last-child{margin-bottom:0}.callout .highlight,.callout code{background-color:#fff}.callout.callout-danger{border-color:#c23321}.callout.callout-warning{border-color:#c87f0a}.callout.callout-info{border-color:#0097bc}.callout.callout-success{border-color:#00733e}.alert{border-radius:3px}.alert h4{font-weight:600}.alert .icon{margin-right:10px}.alert .close{color:#000;opacity:.2;filter:alpha(opacity=20)}.alert .close:hover{opacity:.5;filter:alpha(opacity=50)}.alert a{color:#fff;text-decoration:underline}.alert-success{border-color:#008d4c}.alert-danger,.alert-error{border-color:#d73925}.alert-warning{border-color:#e08e0b}.alert-info{border-color:#00acd6}.nav>li>a:active,.nav>li>a:focus,.nav>li>a:hover{color:#444;background:#f7f7f7}.nav-pills>li>a{border-radius:0;border-top:3px solid transparent;color:#444}.nav-pills>li>a>.fa,.nav-pills>li>a>.glyphicon,.nav-pills>li>a>.ion{margin-right:5px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{border-top-color:#3c8dbc}.nav-pills>li.active>a{font-weight:600}.nav-stacked>li>a{border-radius:0;border-top:0;border-left:3px solid transparent;color:#444}.nav-stacked>li.active>a,.nav-stacked>li.active>a:hover{background:transparent;color:#444;border-top:0;border-left-color:#3c8dbc}.nav-stacked>li.header{border-bottom:1px solid #ddd;color:#777;margin-bottom:10px;padding:5px 10px;text-transform:uppercase}.nav-tabs-custom{margin-bottom:20px;background:#fff;box-shadow:0 1px 1px rgba(0,0,0,.1);border-radius:3px}.nav-tabs-custom>.nav-tabs{margin:0;border-bottom-color:#f4f4f4;border-top-right-radius:3px;border-top-left-radius:3px}.nav-tabs-custom>.nav-tabs>li{border-top:3px solid transparent;margin-bottom:-2px;margin-right:5px}.nav-tabs-custom>.nav-tabs>li>a{color:#444;border-radius:0}.nav-tabs-custom>.nav-tabs>li>a.text-muted{color:#999}.nav-tabs-custom>.nav-tabs>li>a,.nav-tabs-custom>.nav-tabs>li>a:hover{background:transparent;margin:0}.nav-tabs-custom>.nav-tabs>li>a:hover{color:#999}.nav-tabs-custom>.nav-tabs>li:not(.active)>a:active,.nav-tabs-custom>.nav-tabs>li:not(.active)>a:focus,.nav-tabs-custom>.nav-tabs>li:not(.active)>a:hover{border-color:transparent}.nav-tabs-custom>.nav-tabs>li.active{border-top-color:#3c8dbc}.nav-tabs-custom>.nav-tabs>li.active:hover>a,.nav-tabs-custom>.nav-tabs>li.active>a{background-color:#fff;color:#444}.nav-tabs-custom>.nav-tabs>li.active>a{border-top-color:transparent;border-left-color:#f4f4f4;border-right-color:#f4f4f4}.nav-tabs-custom>.nav-tabs>li:first-of-type{margin-left:0}.nav-tabs-custom>.nav-tabs>li:first-of-type.active>a{border-left-color:transparent}.nav-tabs-custom>.nav-tabs.pull-right{float:none!important}.nav-tabs-custom>.nav-tabs.pull-right>li{float:right}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type{margin-right:0}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type>a{border-left-width:1px}.nav-tabs-custom>.nav-tabs.pull-right>li:first-of-type.active>a{border-left-color:#f4f4f4;border-right-color:transparent}.nav-tabs-custom>.nav-tabs>li.header{line-height:35px;padding:0 10px;font-size:20px;color:#444}.nav-tabs-custom>.nav-tabs>li.header>.fa,.nav-tabs-custom>.nav-tabs>li.header>.glyphicon,.nav-tabs-custom>.nav-tabs>li.header>.ion{margin-right:5px}.nav-tabs-custom>.tab-content{background:#fff;padding:10px;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.nav-tabs-custom .dropdown.open>a:active,.nav-tabs-custom .dropdown.open>a:focus{background:transparent;color:#999}.pagination>li>a{background:#fafafa;color:#666}.pagination.pagination-flat>li>a{border-radius:0!important}.products-list{list-style:none;margin:0;padding:0}.products-list>.item{border-radius:3px;box-shadow:0 1px 1px rgba(0,0,0,.1);padding:10px 0;background:#fff}.products-list>.item:after,.products-list>.item:before{content:\" \";display:table}.products-list>.item:after{clear:both}.products-list .product-img{float:left}.products-list .product-img img{width:50px;height:50px}.products-list .product-info{margin-left:60px}.products-list .product-title{font-weight:600}.products-list .product-description{display:block;color:#999;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.product-list-in-box>.item{box-shadow:none;border-radius:0;border-bottom:1px solid #f4f4f4}.product-list-in-box>.item:last-of-type{border-bottom-width:0}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{border-top:1px solid #f4f4f4}.table>thead>tr>th{border-bottom:2px solid #f4f4f4}.table tr td .progress{margin-top:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #f4f4f4}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table.no-border,.table.no-border td,.table.no-border th{border:0}table.text-center,table.text-center td,table.text-center th{text-align:center}.table.align th{text-align:left}.table.align td{text-align:right}.label-default{background-color:#d2d6de;color:#444}.direct-chat .box-body{border-bottom-right-radius:0;border-bottom-left-radius:0;position:relative;overflow-x:hidden;padding:0}.direct-chat-messages,.direct-chat.chat-pane-open .direct-chat-contacts{-webkit-transform:translate(0);transform:translate(0)}.direct-chat-messages{padding:10px;height:250px;overflow:auto}.direct-chat-msg,.direct-chat-text{display:block}.direct-chat-msg{margin-bottom:10px}.direct-chat-msg:after,.direct-chat-msg:before{content:\" \";display:table}.direct-chat-msg:after{clear:both}.direct-chat-contacts,.direct-chat-messages{-webkit-transition:-webkit-transform .5s ease-in-out;transition:transform .5s ease-in-out}.direct-chat-text{border-radius:5px;position:relative;padding:5px 10px;background:#d2d6de;border:1px solid #d2d6de;margin:5px 0 0 50px;color:#444}.direct-chat-text:after,.direct-chat-text:before{position:absolute;right:100%;top:15px;border:solid transparent;border-right-color:#d2d6de;content:' ';height:0;width:0;pointer-events:none}.direct-chat-text:after{border-width:5px;margin-top:-5px}.direct-chat-text:before{border-width:6px;margin-top:-6px}.right .direct-chat-text{margin-right:50px;margin-left:0}.right .direct-chat-text:after,.right .direct-chat-text:before{right:auto;left:100%;border-right-color:transparent;border-left-color:#d2d6de}.direct-chat-img{border-radius:50%;float:left;width:40px;height:40px}.right .direct-chat-img{float:right}.direct-chat-info{display:block;margin-bottom:2px;font-size:12px}.direct-chat-name{font-weight:600}.direct-chat-timestamp{color:#999}.direct-chat-contacts-open .direct-chat-contacts{-webkit-transform:translate(0);transform:translate(0)}.direct-chat-contacts{-webkit-transform:translate(101%);transform:translate(101%);position:absolute;top:0;bottom:0;height:250px;width:100%;background:#222d32;color:#fff;overflow:auto}.contacts-list>li{border-bottom:1px solid rgba(0,0,0,.2);padding:10px;margin:0}.contacts-list>li:after,.contacts-list>li:before{content:\" \";display:table}.contacts-list>li:after{clear:both}.contacts-list>li:last-of-type{border-bottom:none}.contacts-list-img{border-radius:50%;width:40px;float:left}.contacts-list-info{margin-left:45px;color:#fff}.contacts-list-name,.contacts-list-status{display:block}.contacts-list-name{font-weight:600}.contacts-list-status{font-size:12px}.contacts-list-date{color:#aaa;font-weight:400}.contacts-list-msg{color:#999}.direct-chat-danger .right>.direct-chat-text{background:#dd4b39;border-color:#dd4b39;color:#fff}.direct-chat-danger .right>.direct-chat-text:after,.direct-chat-danger .right>.direct-chat-text:before{border-left-color:#dd4b39}.direct-chat-primary .right>.direct-chat-text{background:#3c8dbc;border-color:#3c8dbc;color:#fff}.direct-chat-primary .right>.direct-chat-text:after,.direct-chat-primary .right>.direct-chat-text:before{border-left-color:#3c8dbc}.direct-chat-warning .right>.direct-chat-text{background:#f39c12;border-color:#f39c12;color:#fff}.direct-chat-warning .right>.direct-chat-text:after,.direct-chat-warning .right>.direct-chat-text:before{border-left-color:#f39c12}.direct-chat-info .right>.direct-chat-text{background:#00c0ef;border-color:#00c0ef;color:#fff}.direct-chat-info .right>.direct-chat-text:after,.direct-chat-info .right>.direct-chat-text:before{border-left-color:#00c0ef}.direct-chat-success .right>.direct-chat-text{background:#00a65a;border-color:#00a65a;color:#fff}.direct-chat-success .right>.direct-chat-text:after,.direct-chat-success .right>.direct-chat-text:before{border-left-color:#00a65a}.users-list>li{width:25%;float:left;padding:10px;text-align:center}.users-list>li img{border-radius:50%;max-width:100%;height:auto}.users-list>li>a:hover,.users-list>li>a:hover .users-list-name{color:#999}.users-list-date,.users-list-name{display:block}.users-list-name{font-weight:600;color:#444;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.users-list-date{color:#999;font-size:12px}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.modal{background:rgba(0,0,0,.3)}.modal-content{border-radius:0;box-shadow:0 2px 3px rgba(0,0,0,.125);border:0}@media (min-width:768px){.modal-content{box-shadow:0 2px 3px rgba(0,0,0,.125)}}.modal-header{border-bottom-color:#f4f4f4}.modal-footer{border-top-color:#f4f4f4}.modal-primary .modal-footer,.modal-primary .modal-header{border-color:#307095}.modal-warning .modal-footer,.modal-warning .modal-header{border-color:#c87f0a}.modal-info .modal-footer,.modal-info .modal-header{border-color:#0097bc}.modal-success .modal-footer,.modal-success .modal-header{border-color:#00733e}.modal-danger .modal-footer,.modal-danger .modal-header{border-color:#c23321}.box-widget{border:none;position:relative}.widget-user .widget-user-header{padding:20px;height:120px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user .widget-user-username{margin-top:0;margin-bottom:5px;font-size:25px;font-weight:300;text-shadow:0 1px 1px rgba(0,0,0,.2)}.widget-user .widget-user-desc{margin-top:0}.widget-user .widget-user-image{position:absolute;top:65px;left:50%;margin-left:-45px}.widget-user .widget-user-image>img{width:90px;height:auto;border:3px solid #fff}.widget-user .box-footer{padding-top:30px}.widget-user-2 .widget-user-header{padding:20px;border-top-right-radius:3px;border-top-left-radius:3px}.widget-user-2 .widget-user-username{margin-top:5px;margin-bottom:5px;font-size:25px;font-weight:300}.widget-user-2 .widget-user-desc{margin-top:0}.widget-user-2 .widget-user-desc,.widget-user-2 .widget-user-username{margin-left:75px}.widget-user-2 .widget-user-image>img{width:65px;height:auto;float:left}.mailbox-messages>.table{margin:0}.mailbox-controls{padding:5px}.mailbox-controls.with-border,.mailbox-read-info{border-bottom:1px solid #f4f4f4}.mailbox-read-info{padding:10px}.mailbox-read-info h3{font-size:20px;margin:0}.mailbox-read-info h5{margin:0;padding:5px 0 0}.mailbox-read-time{color:#999;font-size:13px}.mailbox-read-message{padding:10px}.mailbox-attachments li{float:left;width:200px;border:1px solid #eee;margin-bottom:10px;margin-right:10px}.mailbox-attachment-name{font-weight:700;color:#666}.mailbox-attachment-icon,.mailbox-attachment-info,.mailbox-attachment-size{display:block}.mailbox-attachment-info{padding:10px;background:#f4f4f4}.mailbox-attachment-size{color:#999;font-size:12px}.mailbox-attachment-icon{text-align:center;font-size:65px;color:#666;padding:20px 10px}.mailbox-attachment-icon.has-img{padding:0}.mailbox-attachment-icon.has-img>img{max-width:100%;height:auto}.lockscreen{background:#d2d6de}.lockscreen-logo{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.lockscreen-logo a{color:#444}.lockscreen-wrapper{max-width:400px;margin:0 auto;margin-top:10%}.lockscreen .lockscreen-name{text-align:center;font-weight:600}.lockscreen-item{border-radius:4px;padding:0;background:#fff;position:relative;margin:10px auto 30px;width:290px}.lockscreen-image{border-radius:50%;position:absolute;left:-10px;top:-25px;background:#fff;padding:5px;z-index:10}.lockscreen-image>img{border-radius:50%;width:70px;height:70px}.lockscreen-credentials{margin-left:70px}.lockscreen-credentials .form-control{border:0}.lockscreen-credentials .btn{background-color:#fff;border:0;padding:0 10px}.lockscreen-footer{margin-top:10px}.login-logo,.register-logo{font-size:35px;text-align:center;margin-bottom:25px;font-weight:300}.login-logo a,.register-logo a{color:#444}.login-page,.register-page{background:#d2d6de}.login-box,.register-box{width:360px;margin:7% auto}@media (max-width:768px){.login-box,.register-box{width:90%;margin-top:20px}}.login-box-body,.register-box-body{background:#fff;padding:20px;border-top:0;color:#666}.login-box-body .form-control-feedback,.register-box-body .form-control-feedback{color:#777}.login-box-msg,.register-box-msg{margin:0;text-align:center;padding:0 20px 20px}.social-auth-links{margin:10px 0}.error-page{width:600px;margin:20px auto 0}@media (max-width:991px){.error-page{width:100%}}.error-page>.headline{float:left;font-size:100px;font-weight:300}@media (max-width:991px){.error-page>.headline{float:none;text-align:center}}.error-page>.error-content{margin-left:190px;display:block}@media (max-width:991px){.error-page>.error-content{margin-left:0}}.error-page>.error-content>h3{font-weight:300;font-size:25px}@media (max-width:991px){.error-page>.error-content>h3{text-align:center}}.invoice{position:relative;background:#fff;border:1px solid #f4f4f4;padding:20px;margin:10px 25px}.invoice-title{margin-top:0}.profile-user-img{margin:0 auto;width:100px;padding:3px;border:3px solid #d2d6de}.profile-username{font-size:21px;margin-top:5px}.post{border-bottom:1px solid #d2d6de;margin-bottom:15px;padding-bottom:15px;color:#666}.post:last-of-type{border-bottom:0;margin-bottom:0;padding-bottom:0}.post .user-block{margin-bottom:15px}.btn-social{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.btn-social>:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgba(0,0,0,.2)}.btn-social.btn-lg{padding-left:61px}.btn-social.btn-lg>:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social.btn-sm{padding-left:38px}.btn-social.btn-sm>:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social.btn-xs{padding-left:30px}.btn-social.btn-xs>:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon{position:relative;padding-left:44px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;height:34px;width:34px;padding:0}.btn-social-icon>:first-child{position:absolute;left:0;top:0;bottom:0;width:32px;line-height:34px;font-size:1.6em;text-align:center;border-right:1px solid rgba(0,0,0,.2)}.btn-social-icon.btn-lg{padding-left:61px}.btn-social-icon.btn-lg>:first-child{line-height:45px;width:45px;font-size:1.8em}.btn-social-icon.btn-sm{padding-left:38px}.btn-social-icon.btn-sm>:first-child{line-height:28px;width:28px;font-size:1.4em}.btn-social-icon.btn-xs{padding-left:30px}.btn-social-icon.btn-xs>:first-child{line-height:20px;width:20px;font-size:1.2em}.btn-social-icon>:first-child{border:none;text-align:center;width:100%}.btn-social-icon.btn-lg{height:45px;width:45px;padding-left:0;padding-right:0}.btn-social-icon.btn-sm{height:30px;width:30px;padding-left:0;padding-right:0}.btn-social-icon.btn-xs{height:22px;width:22px;padding-left:0;padding-right:0}.btn-adn{color:#fff;background-color:#d87a68;border-color:rgba(0,0,0,.2)}.btn-adn.active,.btn-adn.focus,.btn-adn:active,.btn-adn:focus,.btn-adn:hover,.open>.dropdown-toggle.btn-adn{color:#fff;background-color:#ce563f;border-color:rgba(0,0,0,.2)}.btn-adn.active,.btn-adn:active,.open>.dropdown-toggle.btn-adn{background-image:none}.btn-adn .badge{color:#d87a68;background-color:#fff}.btn-bitbucket{color:#fff;background-color:#205081;border-color:rgba(0,0,0,.2)}.btn-bitbucket.active,.btn-bitbucket.focus,.btn-bitbucket:active,.btn-bitbucket:focus,.btn-bitbucket:hover,.open>.dropdown-toggle.btn-bitbucket{color:#fff;background-color:#163758;border-color:rgba(0,0,0,.2)}.btn-bitbucket.active,.btn-bitbucket:active,.open>.dropdown-toggle.btn-bitbucket{background-image:none}.btn-bitbucket .badge{color:#205081;background-color:#fff}.btn-dropbox{color:#fff;background-color:#1087dd;border-color:rgba(0,0,0,.2)}.btn-dropbox.active,.btn-dropbox.focus,.btn-dropbox:active,.btn-dropbox:focus,.btn-dropbox:hover,.open>.dropdown-toggle.btn-dropbox{color:#fff;background-color:#0d6aad;border-color:rgba(0,0,0,.2)}.btn-dropbox.active,.btn-dropbox:active,.open>.dropdown-toggle.btn-dropbox{background-image:none}.btn-dropbox .badge{color:#1087dd;background-color:#fff}.btn-facebook{color:#fff;background-color:#3b5998;border-color:rgba(0,0,0,.2)}.btn-facebook.active,.btn-facebook.focus,.btn-facebook:active,.btn-facebook:focus,.btn-facebook:hover,.open>.dropdown-toggle.btn-facebook{color:#fff;background-color:#2d4373;border-color:rgba(0,0,0,.2)}.btn-facebook.active,.btn-facebook:active,.open>.dropdown-toggle.btn-facebook{background-image:none}.btn-facebook .badge{color:#3b5998;background-color:#fff}.btn-flickr{color:#fff;background-color:#ff0084;border-color:rgba(0,0,0,.2)}.btn-flickr.active,.btn-flickr.focus,.btn-flickr:active,.btn-flickr:focus,.btn-flickr:hover,.open>.dropdown-toggle.btn-flickr{color:#fff;background-color:#cc006a;border-color:rgba(0,0,0,.2)}.btn-flickr.active,.btn-flickr:active,.open>.dropdown-toggle.btn-flickr{background-image:none}.btn-flickr .badge{color:#ff0084;background-color:#fff}.btn-foursquare{color:#fff;background-color:#f94877;border-color:rgba(0,0,0,.2)}.btn-foursquare.active,.btn-foursquare.focus,.btn-foursquare:active,.btn-foursquare:focus,.btn-foursquare:hover,.open>.dropdown-toggle.btn-foursquare{color:#fff;background-color:#f71752;border-color:rgba(0,0,0,.2)}.btn-foursquare.active,.btn-foursquare:active,.open>.dropdown-toggle.btn-foursquare{background-image:none}.btn-foursquare .badge{color:#f94877;background-color:#fff}.btn-github{color:#fff;background-color:#444;border-color:rgba(0,0,0,.2)}.btn-github.active,.btn-github.focus,.btn-github:active,.btn-github:focus,.btn-github:hover,.open>.dropdown-toggle.btn-github{color:#fff;background-color:#2b2b2b;border-color:rgba(0,0,0,.2)}.btn-github.active,.btn-github:active,.open>.dropdown-toggle.btn-github{background-image:none}.btn-github .badge{color:#444;background-color:#fff}.btn-google{color:#fff;background-color:#dd4b39;border-color:rgba(0,0,0,.2)}.btn-google.active,.btn-google.focus,.btn-google:active,.btn-google:focus,.btn-google:hover,.open>.dropdown-toggle.btn-google{color:#fff;background-color:#c23321;border-color:rgba(0,0,0,.2)}.btn-google.active,.btn-google:active,.open>.dropdown-toggle.btn-google{background-image:none}.btn-google .badge{color:#dd4b39;background-color:#fff}.btn-instagram{color:#fff;background-color:#3f729b;border-color:rgba(0,0,0,.2)}.btn-instagram.active,.btn-instagram.focus,.btn-instagram:active,.btn-instagram:focus,.btn-instagram:hover,.open>.dropdown-toggle.btn-instagram{color:#fff;background-color:#305777;border-color:rgba(0,0,0,.2)}.btn-instagram.active,.btn-instagram:active,.open>.dropdown-toggle.btn-instagram{background-image:none}.btn-instagram .badge{color:#3f729b;background-color:#fff}.btn-linkedin{color:#fff;background-color:#007bb6;border-color:rgba(0,0,0,.2)}.btn-linkedin.active,.btn-linkedin.focus,.btn-linkedin:active,.btn-linkedin:focus,.btn-linkedin:hover,.open>.dropdown-toggle.btn-linkedin{color:#fff;background-color:#005983;border-color:rgba(0,0,0,.2)}.btn-linkedin.active,.btn-linkedin:active,.open>.dropdown-toggle.btn-linkedin{background-image:none}.btn-linkedin .badge{color:#007bb6;background-color:#fff}.btn-microsoft{color:#fff;background-color:#2672ec;border-color:rgba(0,0,0,.2)}.btn-microsoft.active,.btn-microsoft.focus,.btn-microsoft:active,.btn-microsoft:focus,.btn-microsoft:hover,.open>.dropdown-toggle.btn-microsoft{color:#fff;background-color:#125acd;border-color:rgba(0,0,0,.2)}.btn-microsoft.active,.btn-microsoft:active,.open>.dropdown-toggle.btn-microsoft{background-image:none}.btn-microsoft .badge{color:#2672ec;background-color:#fff}.btn-openid{color:#fff;background-color:#f7931e;border-color:rgba(0,0,0,.2)}.btn-openid.active,.btn-openid.focus,.btn-openid:active,.btn-openid:focus,.btn-openid:hover,.open>.dropdown-toggle.btn-openid{color:#fff;background-color:#da7908;border-color:rgba(0,0,0,.2)}.btn-openid.active,.btn-openid:active,.open>.dropdown-toggle.btn-openid{background-image:none}.btn-openid .badge{color:#f7931e;background-color:#fff}.btn-pinterest{color:#fff;background-color:#cb2027;border-color:rgba(0,0,0,.2)}.btn-pinterest.active,.btn-pinterest.focus,.btn-pinterest:active,.btn-pinterest:focus,.btn-pinterest:hover,.open>.dropdown-toggle.btn-pinterest{color:#fff;background-color:#9f191f;border-color:rgba(0,0,0,.2)}.btn-pinterest.active,.btn-pinterest:active,.open>.dropdown-toggle.btn-pinterest{background-image:none}.btn-pinterest .badge{color:#cb2027;background-color:#fff}.btn-reddit{color:#000;background-color:#eff7ff;border-color:rgba(0,0,0,.2)}.btn-reddit.active,.btn-reddit.focus,.btn-reddit:active,.btn-reddit:focus,.btn-reddit:hover,.open>.dropdown-toggle.btn-reddit{color:#000;background-color:#bcddff;border-color:rgba(0,0,0,.2)}.btn-reddit.active,.btn-reddit:active,.open>.dropdown-toggle.btn-reddit{background-image:none}.btn-reddit .badge{color:#eff7ff;background-color:#000}.btn-soundcloud{color:#fff;background-color:#f50;border-color:rgba(0,0,0,.2)}.btn-soundcloud.active,.btn-soundcloud.focus,.btn-soundcloud:active,.btn-soundcloud:focus,.btn-soundcloud:hover,.open>.dropdown-toggle.btn-soundcloud{color:#fff;background-color:#c40;border-color:rgba(0,0,0,.2)}.btn-soundcloud.active,.btn-soundcloud:active,.open>.dropdown-toggle.btn-soundcloud{background-image:none}.btn-soundcloud .badge{color:#f50;background-color:#fff}.btn-tumblr{color:#fff;background-color:#2c4762;border-color:rgba(0,0,0,.2)}.btn-tumblr.active,.btn-tumblr.focus,.btn-tumblr:active,.btn-tumblr:focus,.btn-tumblr:hover,.open>.dropdown-toggle.btn-tumblr{color:#fff;background-color:#1c2d3f;border-color:rgba(0,0,0,.2)}.btn-tumblr.active,.btn-tumblr:active,.open>.dropdown-toggle.btn-tumblr{background-image:none}.btn-tumblr .badge{color:#2c4762;background-color:#fff}.btn-twitter{color:#fff;background-color:#55acee;border-color:rgba(0,0,0,.2)}.btn-twitter.active,.btn-twitter.focus,.btn-twitter:active,.btn-twitter:focus,.btn-twitter:hover,.open>.dropdown-toggle.btn-twitter{color:#fff;background-color:#2795e9;border-color:rgba(0,0,0,.2)}.btn-twitter.active,.btn-twitter:active,.open>.dropdown-toggle.btn-twitter{background-image:none}.btn-twitter .badge{color:#55acee;background-color:#fff}.btn-vimeo{color:#fff;background-color:#1ab7ea;border-color:rgba(0,0,0,.2)}.btn-vimeo.active,.btn-vimeo.focus,.btn-vimeo:active,.btn-vimeo:focus,.btn-vimeo:hover,.open>.dropdown-toggle.btn-vimeo{color:#fff;background-color:#1295bf;border-color:rgba(0,0,0,.2)}.btn-vimeo.active,.btn-vimeo:active,.open>.dropdown-toggle.btn-vimeo{background-image:none}.btn-vimeo .badge{color:#1ab7ea;background-color:#fff}.btn-vk{color:#fff;background-color:#587ea3;border-color:rgba(0,0,0,.2)}.btn-vk.active,.btn-vk.focus,.btn-vk:active,.btn-vk:focus,.btn-vk:hover,.open>.dropdown-toggle.btn-vk{color:#fff;background-color:#466482;border-color:rgba(0,0,0,.2)}.btn-vk.active,.btn-vk:active,.open>.dropdown-toggle.btn-vk{background-image:none}.btn-vk .badge{color:#587ea3;background-color:#fff}.btn-yahoo{color:#fff;background-color:#720e9e;border-color:rgba(0,0,0,.2)}.btn-yahoo.active,.btn-yahoo.focus,.btn-yahoo:active,.btn-yahoo:focus,.btn-yahoo:hover,.open>.dropdown-toggle.btn-yahoo{color:#fff;background-color:#500a6f;border-color:rgba(0,0,0,.2)}.btn-yahoo.active,.btn-yahoo:active,.open>.dropdown-toggle.btn-yahoo{background-image:none}.btn-yahoo .badge{color:#720e9e;background-color:#fff}.fc-button{background:#f4f4f4;background-image:none;color:#444;border-color:#ddd;border-bottom-color:#ddd}.fc-button.hover,.fc-button:active,.fc-button:hover{background-color:#e9e9e9}.fc-header-title h2{font-size:15px;line-height:1.6em;color:#666;margin-left:10px}.fc-header-right{padding-right:10px}.fc-header-left{padding-left:10px}.fc-widget-header{background:#fafafa}.fc-grid{width:100%;border:0}.fc-widget-content:first-of-type,.fc-widget-header:first-of-type{border-left:0;border-right:0}.fc-widget-content:last-of-type,.fc-widget-header:last-of-type{border-right:0}.fc-toolbar{padding:10px;margin:0}.fc-day-number{font-size:20px;font-weight:300;padding-right:10px}.fc-color-picker{list-style:none;margin:0;padding:0}.fc-color-picker>li{float:left;font-size:30px;margin-right:5px;line-height:30px}.fc-color-picker>li .fa{-webkit-transition:-webkit-transform .3s linear;transition:transform .3s linear}.fc-color-picker>li .fa:hover{-webkit-transform:rotate(30deg);transform:rotate(30deg)}#add-new-event{-webkit-transition:all .3s linear;transition:all .3s linear}.external-event{padding:5px 10px;font-weight:700;margin-bottom:4px;box-shadow:0 1px 1px rgba(0,0,0,.1);text-shadow:0 1px 1px rgba(0,0,0,.1);border-radius:3px;cursor:move}.external-event:hover{box-shadow:inset 0 0 90px rgba(0,0,0,.2)}.select2-container--default.select2-container--focus,.select2-container--default:active,.select2-container--default:focus,.select2-selection.select2-container--focus,.select2-selection:active,.select2-selection:focus{outline:none}.select2-container--default .select2-selection--single,.select2-selection .select2-selection--single{border:1px solid #d2d6de;border-radius:0;padding:6px 12px;height:34px}.select2-container--default.select2-container--open{border-color:#3c8dbc}.select2-dropdown{border:1px solid #d2d6de;border-radius:0}.select2-container--default .select2-results__option--highlighted[aria-selected]{background-color:#3c8dbc;color:#fff}.select2-results__option{padding:6px 12px;user-select:none;-webkit-user-select:none}.select2-container .select2-selection--single .select2-selection__rendered{padding-left:0;padding-right:0;height:auto;margin-top:-4px}.select2-container[dir=rtl] .select2-selection--single .select2-selection__rendered{padding-right:6px;padding-left:20px}.select2-container--default .select2-selection--single .select2-selection__arrow{height:28px;right:3px}.select2-container--default .select2-selection--single .select2-selection__arrow b{margin-top:0}.select2-dropdown .select2-search__field,.select2-search--inline .select2-search__field{border:1px solid #d2d6de}.select2-dropdown .select2-search__field:focus,.select2-search--inline .select2-search__field:focus{outline:none;border:1px solid #3c8dbc}.select2-container--default .select2-results__option[aria-disabled=true]{color:#999}.select2-container--default .select2-results__option[aria-selected=true]{background-color:#ddd}.select2-container--default .select2-results__option[aria-selected=true],.select2-container--default .select2-results__option[aria-selected=true]:hover{color:#444}.select2-container--default .select2-selection--multiple{border:1px solid #d2d6de;border-radius:0}.select2-container--default .select2-selection--multiple:focus{border-color:#3c8dbc}.select2-container--default.select2-container--focus .select2-selection--multiple{border-color:#d2d6de}.select2-container--default .select2-selection--multiple .select2-selection__choice{background-color:#3c8dbc;border-color:#367fa9;padding:1px 10px;color:#fff}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove{margin-right:5px;color:hsla(0,0%,100%,.7)}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover{color:#fff}.select2-container .select2-selection--single .select2-selection__rendered{padding-right:10px}.pad{padding:10px}.margin{margin:10px}.margin-bottom{margin-bottom:20px}.margin-bottom-none{margin-bottom:0}.margin-r-5{margin-right:5px}.inline{display:inline}.description-block{display:block;margin:10px 0;text-align:center}.description-block.margin-bottom{margin-bottom:25px}.description-block>.description-header{margin:0;padding:0;font-weight:600;font-size:16px}.description-block>.description-text{text-transform:uppercase}.alert-danger,.alert-error,.alert-info,.alert-success,.alert-warning,.bg-aqua,.bg-aqua-active,.bg-black,.bg-black-active,.bg-blue,.bg-blue-active,.bg-fuchsia,.bg-fuchsia-active,.bg-green,.bg-green-active,.bg-light-blue,.bg-light-blue-active,.bg-lime,.bg-lime-active,.bg-maroon,.bg-maroon-active,.bg-navy,.bg-navy-active,.bg-olive,.bg-olive-active,.bg-orange,.bg-orange-active,.bg-purple,.bg-purple-active,.bg-red,.bg-red-active,.bg-teal,.bg-teal-active,.bg-yellow,.bg-yellow-active,.callout.callout-danger,.callout.callout-info,.callout.callout-success,.callout.callout-warning,.label-danger,.label-info,.label-primary,.label-success,.label-warning,.modal-danger .modal-body,.modal-danger .modal-footer,.modal-danger .modal-header,.modal-info .modal-body,.modal-info .modal-footer,.modal-info .modal-header,.modal-primary .modal-body,.modal-primary .modal-footer,.modal-primary .modal-header,.modal-success .modal-body,.modal-success .modal-footer,.modal-success .modal-header,.modal-warning .modal-body,.modal-warning .modal-footer,.modal-warning .modal-header{color:#fff!important}.bg-gray{color:#000;background-color:#d2d6de!important}.bg-gray-light{background-color:#f7f7f7}.bg-black{background-color:#111!important}.alert-danger,.alert-error,.bg-red,.callout.callout-danger,.label-danger,.modal-danger .modal-body{background-color:#dd4b39!important}.alert-warning,.bg-yellow,.callout.callout-warning,.label-warning,.modal-warning .modal-body{background-color:#f39c12!important}.alert-info,.bg-aqua,.callout.callout-info,.label-info,.modal-info .modal-body{background-color:#00c0ef!important}.bg-blue{background-color:#0073b7!important}.bg-light-blue,.label-primary,.modal-primary .modal-body{background-color:#3c8dbc!important}.alert-success,.bg-green,.callout.callout-success,.label-success,.modal-success .modal-body{background-color:#00a65a!important}.bg-navy{background-color:#001f3f!important}.bg-teal{background-color:#39cccc!important}.bg-olive{background-color:#3d9970!important}.bg-lime{background-color:#01ff70!important}.bg-orange{background-color:#ff851b!important}.bg-fuchsia{background-color:#f012be!important}.bg-purple{background-color:#605ca8!important}.bg-maroon{background-color:#d81b60!important}.bg-gray-active{color:#000;background-color:#b5bbc8!important}.bg-black-active{background-color:#000!important}.bg-red-active,.modal-danger .modal-footer,.modal-danger .modal-header{background-color:#d33724!important}.bg-yellow-active,.modal-warning .modal-footer,.modal-warning .modal-header{background-color:#db8b0b!important}.bg-aqua-active,.modal-info .modal-footer,.modal-info .modal-header{background-color:#00a7d0!important}.bg-blue-active{background-color:#005384!important}.bg-light-blue-active,.modal-primary .modal-footer,.modal-primary .modal-header{background-color:#357ca5!important}.bg-green-active,.modal-success .modal-footer,.modal-success .modal-header{background-color:#008d4c!important}.bg-navy-active{background-color:#001a35!important}.bg-teal-active{background-color:#30bbbb!important}.bg-olive-active{background-color:#368763!important}.bg-lime-active{background-color:#00e765!important}.bg-orange-active{background-color:#ff7701!important}.bg-fuchsia-active{background-color:#db0ead!important}.bg-purple-active{background-color:#555299!important}.bg-maroon-active{background-color:#ca195a!important}[class^=bg-].disabled{opacity:.65;filter:alpha(opacity=65)}.text-red{color:#dd4b39!important}.text-yellow{color:#f39c12!important}.text-aqua{color:#00c0ef!important}.text-blue{color:#0073b7!important}.text-black{color:#111!important}.text-light-blue{color:#3c8dbc!important}.text-green{color:#00a65a!important}.text-gray{color:#d2d6de!important}.text-navy{color:#001f3f!important}.text-teal{color:#39cccc!important}.text-olive{color:#3d9970!important}.text-lime{color:#01ff70!important}.text-orange{color:#ff851b!important}.text-fuchsia{color:#f012be!important}.text-purple{color:#605ca8!important}.text-maroon{color:#d81b60!important}.link-muted{color:#7a869d}.link-muted:focus,.link-muted:hover{color:#606c84}.link-black{color:#666}.link-black:focus,.link-black:hover{color:#999}.hide{display:none!important}.no-border{border:0!important}.no-padding{padding:0!important}.no-margin{margin:0!important}.no-shadow{box-shadow:none!important}.chart-legend,.contacts-list,.list-unstyled,.mailbox-attachments,.users-list{list-style:none;margin:0;padding:0}.list-group-unbordered>.list-group-item{border-left:0;border-right:0;border-radius:0;padding-left:0;padding-right:0}.flat{border-radius:0!important}.text-bold,.text-bold.table td,.text-bold.table th{font-weight:700}.text-sm{font-size:12px}.jqstooltip{padding:5px!important;width:auto!important;height:auto!important}.bg-teal-gradient{background:#39cccc!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#39cccc),color-stop(1,#7adddd))!important;background:-o-linear-gradient(#7adddd,#39cccc)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#7adddd',endColorstr='#39cccc',GradientType=0)!important;color:#fff}.bg-light-blue-gradient{background:#3c8dbc!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#3c8dbc),color-stop(1,#67a8ce))!important;background:-o-linear-gradient(#67a8ce,#3c8dbc)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#67a8ce',endColorstr='#3c8dbc',GradientType=0)!important;color:#fff}.bg-blue-gradient{background:#0073b7!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#0073b7),color-stop(1,#0089db))!important;background:-o-linear-gradient(#0089db,#0073b7)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#0089db',endColorstr='#0073b7',GradientType=0)!important;color:#fff}.bg-aqua-gradient{background:#00c0ef!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#00c0ef),color-stop(1,#14d1ff))!important;background:-o-linear-gradient(#14d1ff,#00c0ef)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#14d1ff',endColorstr='#00c0ef',GradientType=0)!important;color:#fff}.bg-yellow-gradient{background:#f39c12!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#f39c12),color-stop(1,#f7bc60))!important;background:-o-linear-gradient(#f7bc60,#f39c12)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#f7bc60',endColorstr='#f39c12',GradientType=0)!important;color:#fff}.bg-purple-gradient{background:#605ca8!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#605ca8),color-stop(1,#9491c4))!important;background:-o-linear-gradient(#9491c4,#605ca8)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#9491c4',endColorstr='#605ca8',GradientType=0)!important;color:#fff}.bg-green-gradient{background:#00a65a!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#00a65a),color-stop(1,#00ca6d))!important;background:-o-linear-gradient(#00ca6d,#00a65a)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ca6d',endColorstr='#00a65a',GradientType=0)!important;color:#fff}.bg-red-gradient{background:#dd4b39!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#dd4b39),color-stop(1,#e47365))!important;background:-o-linear-gradient(#e47365,#dd4b39)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#e47365',endColorstr='#dd4b39',GradientType=0)!important;color:#fff}.bg-black-gradient{background:#111!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#111),color-stop(1,#2b2b2b))!important;background:-o-linear-gradient(#2b2b2b,#111)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#2b2b2b',endColorstr='#111111',GradientType=0)!important;color:#fff}.bg-maroon-gradient{background:#d81b60!important;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#d81b60),color-stop(1,#e73f7c))!important;background:-o-linear-gradient(#e73f7c,#d81b60)!important;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#e73f7c',endColorstr='#d81b60',GradientType=0)!important;color:#fff}.description-block .description-icon{font-size:16px}.no-pad-top{padding-top:0}.position-static{position:static!important}.list-header{font-size:15px;padding:10px 4px;font-weight:700;color:#666}.list-seperator{height:1px;background:#f4f4f4;margin:15px 0 9px}.list-link>a{padding:4px;color:#777}.list-link>a:hover{color:#222}.font-light{font-weight:300}.user-block:after,.user-block:before{content:\" \";display:table}.user-block:after{clear:both}.user-block img{width:40px;height:40px;float:left}.user-block .comment,.user-block .description,.user-block .username{display:block;margin-left:50px}.user-block .username{font-size:16px;font-weight:600}.user-block .description{color:#999;font-size:13px}.user-block.user-block-sm .comment,.user-block.user-block-sm .description,.user-block.user-block-sm .username{margin-left:40px}.user-block.user-block-sm .username{font-size:14px}.box-comments .box-comment img,.img-lg,.img-md,.img-sm,.user-block.user-block-sm img{float:left}.box-comments .box-comment img,.img-sm,.user-block.user-block-sm img{width:30px!important;height:30px!important}.img-sm+.img-push{margin-left:40px}.img-md{width:60px;height:60px}.img-md+.img-push{margin-left:70px}.img-lg{width:100px;height:100px}.img-lg+.img-push{margin-left:110px}.img-bordered{border:3px solid #d2d6de;padding:3px}.img-bordered-sm{border:2px solid #d2d6de;padding:2px}.attachment-block{border:1px solid #f4f4f4;padding:5px;margin-bottom:10px;background:#f7f7f7}.attachment-block .attachment-img{max-width:100px;max-height:100px;height:auto;float:left}.attachment-block .attachment-pushed{margin-left:110px}.attachment-block .attachment-heading{margin:0}.attachment-block .attachment-text{color:#555}.connectedSortable{min-height:100px}.ui-helper-hidden-accessible{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sort-highlight{background:#f4f4f4;border:1px dashed #ddd;margin-bottom:10px}.full-opacity-hover{opacity:.65;filter:alpha(opacity=65)}.full-opacity-hover:hover{opacity:1;filter:alpha(opacity=100)}.chart{position:relative;overflow:hidden;width:100%}.chart canvas,.chart svg{width:100%!important}@media print{.content-header,.left-side,.main-header,.main-sidebar,.no-print{display:none!important}.content-wrapper,.main-footer,.right-side{margin-left:0!important;min-height:0!important;-webkit-transform:translate(0)!important;transform:translate(0)!important}.fixed .content-wrapper,.fixed .right-side{padding-top:0!important}.invoice{width:100%;border:0;margin:0;padding:0}.invoice-col{float:left;width:33.3333333%}.table-responsive{overflow:auto}.table-responsive>.table tr td,.table-responsive>.table tr th{white-space:normal!important}}", ""]);

	// exports


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7799dece2c79854f63f09e7dfa528b88.jpg";

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(50);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./calendar.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./calendar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".info-window{min-width:200px;max-width:400px;border:1px solid grey;padding:8px;background-color:#fff;color:#000}.info-content img{float:right;margin:0 5px 5px 10px}.calendar_disabled{z-index:1000;background-color:#d3d3d3;opacity:.6;pointer-events:none}.calendar_loading_bg{background:url(" + __webpack_require__(51) + ") no-repeat 50%}.pinkStyle{border:1px solid #ff1493;background-color:#ff69b4}.lightPinkStyle,.pinkStyle{color:#000;font-size:.85em;cursor:default}.lightPinkStyle{border:1px solid #cd6889;background-color:#ffb6c1}.hotPinkStyle{background-color:#ff1493}.fuchsiaStyle,.hotPinkStyle{border:1px solid #c71585;color:#000;font-size:.85em;cursor:default}.fuchsiaStyle{background-color:#f0f}.brownStyle{background-color:brown}.brownStyle,.maroonStyle{border:1px solid #8b0000;color:#000;font-size:.85em;cursor:default}.maroonStyle{background-color:maroon}.redStyle{border:1px solid #b22222;background-color:red}.redStyle,.tomatoStyle{color:#000;font-size:.85em;cursor:default}.tomatoStyle{border:1px solid #dc143c;background-color:tomato}.slateGrayStyle{border:1px solid #708090;background-color:#789}.lightSlateGrayStyle,.slateGrayStyle{color:#000;font-size:.85em;cursor:default}.lightSlateGrayStyle{border:1px solid #789;background-color:#b0c4de}.GrayStyle{border:1px solid #696969;background-color:gray;color:#000;font-size:.85em;cursor:default}.greenStyle,.vertStyle{border:1px solid #68838b;background-color:#9ac0cd}.greenStyle,.orangeStyle,.vertStyle{color:#000;font-size:.85em;cursor:default}.orangeStyle{border:1px solid tan;background-color:#ffa54f}.blueStyle{border:1px solid #6c7b8b;background-color:#9fb6cd}.blueStyle,.lightBlueStyle{color:#000;font-size:.85em;cursor:default}.lightBlueStyle{border:1px solid #68838b;background-color:#bfefff}.royalBlueStyle{border:1px solid #27408b;background-color:#4876ff}.royalBlueStyle,.skyBlueStyle{color:#000;font-size:.85em;cursor:default}.skyBlueStyle{border:1px solid #6ca6cd;background-color:#87ceff}.goldStyle{border:1px solid #8b7500;background-color:gold}.goldStyle,.lightGoldenrodStyle{color:#000;font-size:.85em;cursor:default}.lightGoldenrodStyle{border:1px solid #cdbe70;background-color:#ffec8b}.darkGoldenrodStyle{border:1px solid #b8860b;background-color:#ffb90f}.darkGoldenrodStyle,.goldenrodStyle{color:#000;font-size:.85em;cursor:default}.goldenrodStyle{border:1px solid #8b6914;background-color:#daa520}.greenStyle{border:1px solid green;background-color:#0e0}.greenStyle,.lightGreenrodStyle{color:#000;font-size:.85em;cursor:default}.lightGreenrodStyle{border:1px solid #6b8e23;background-color:#c0ff3e}.darkOliveGreenStyle{border:1px solid #556b2f;background-color:#bcee68}.darkOliveGreenStyle,.darkSeaGreenStyle{color:#000;font-size:.85em;cursor:default}.darkSeaGreenStyle{border:1px solid #698b69;background-color:#b4eeb4}", ""]);

	// exports


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b7998fb83f2426a89721ce30d2a7bdc5.gif";

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(53);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./parallax2.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./parallax2.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "@media screen and (max-width:500px){.parallax,.parallax-5{background:no-repeat top fixed;height:650px}.parallaxx{background:no-repeat top fixed;height:700px;z-index:-1}.parallax__center{text-align:center;position:relative;left:50%;top:35%;height:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.parallax__center_button{z-index:1600;text-align:center;position:relative;padding-bottom:0;margin-bottom:0;float:right}.parallax__center__desc{text-align:center;position:relative;left:50%;top:50%;height:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}}@media screen and (min-width:500px) and (max-width:1023px){.parallax{height:1000px}.parallax,.parallax-5,.parallaxx{background:no-repeat top fixed}.parallaxx{height:1000px;z-index:-1}.parallax__center{height:auto}.parallax__center,.parallax__center__desc{text-align:center;position:relative;left:50%;top:40%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}}@media screen and (min-width:1024px){.parallax{height:500px;height:100vh}.parallax,.parallax-5,.parallaxx{background:no-repeat 50% fixed;background-size:cover}.parallaxx{height:500px;height:100vh}.parallax__center{top:50%}.parallax__center,.parallax__center__desc{text-align:center;position:relative;left:50%;height:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.parallax__center__desc{top:40%}}.parallax__centerr{text-align:center;position:relative;left:50%;height:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

	// exports


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(55);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./obt.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./obt.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "@media only screen and (min-width:768px){.is-table-row{display:table}.is-table-row [class*=col-]{float:none;display:table-cell;vertical-align:middle}}.row.is-flex{-ms-flex-wrap:wrap;flex-wrap:wrap}.row.is-flex,.row.is-flex [class*=col-]{display:-webkit-box;display:-ms-flexbox;display:flex}.row.is-flex [class*=col-]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.thumbnail-crop-square{position:relative;width:200px;height:200px;overflow:hidden}.thumbnail-crop-square img{position:absolute;left:50%;top:50%;height:100%;width:auto;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.thumbnail-crop-square img.portrait{width:100%;height:auto}.img-crop-square{object-fit:cover;object-position:center}.vcenter-flex{display:flex;align-items:center}.vcenter{display:inline-block;vertical-align:middle;float:none}.center-vertically{display:table;width:100%;height:100%;padding:0}.center-vertically>div{display:table-cell;vertical-align:middle}.cover-bg{background-size:cover;background:#663fb5 no-repeat bottom}.service-item{margin-bottom:15px}i.service-icon{border:3px solid #fff;border-radius:50%;display:inline-block;font-size:56px;width:140px;height:140px;line-height:136px;vertical-align:middle;text-align:center}.service-icon-140pxCercle{border-radius:50%;width:140px;height:140px}.service-icon-140pxRounded{border-radius:5%;width:140px;height:140px}.shuffle-animation.ng-enter,.shuffle-animation.ng-leave{position:relative}#splash-page{z-index:99999!important}#splash-page .bar{width:100%}.page-splash{z-index:99999!important;position:fixed!important;top:0;left:0;width:100%;height:100%;background-color:#fff;opacity:.9;pointer-events:auto;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transition:opacity .3s linear;transition:opacity .3s linear}.page-splash-message{text-align:center;margin:20% auto 0;font-size:400%;font-family:Segoe UI,Arial,Helvetica,sans-serif;font-weight:400;-webkit-text-shadow:2px 2px #000;text-shadow:2px 2px #000;text-shadow:2px 2px rgba(0,0,0,.15);text-transform:uppercase;text-decoration:none;color:#233140;padding:0}.page-splash-message.page-splash-message-subtle{margin:30% auto 0;font-size:200%}.flag-haschanges{position:fixed!important;display:inline}.fa-asterisk.fa-asterisk-large{font-size:180%;vertical-align:middle;color:#f58a00}.fa-asterisk.fa-asterisk-alert{color:#f58a00}.fa-asterisk-inline{padding:0 4px 0 0}.page-progress-bar,.progress{margin:30px 10%!important}.ngplus-overlay-background{top:0;left:0;padding-left:100px;position:absolute;z-index:10000;height:100%;width:100%;background-color:gray;opacity:.2}.ngplus-overlay-content{position:absolute;font-weight:700;height:100px;width:300px;height:15em;width:20em;z-index:10000;text-align:center}.page-spinner-message{text-align:center;font-size:400%;font-family:Segoe UI,Arial,Helvetica,sans-serif;font-weight:400;-webkit-text-shadow:2px 2px #000;text-shadow:2px 2px #000;text-shadow:2px 2px rgba(0,0,0,.15);text-transform:uppercase;text-decoration:none;color:#f58a00;padding:0}.page-spinner-message.page-spinner-message-subtle{margin:30% auto 0;font-size:200%}.overlay-message{font-size:200%}.spinner{margin:20% auto 0;left:auto;top:auto!important}.thumbnailSize{max-height:200px}#loading-bar .bar{background:#2c3e50}#loading-bar-spinner .spinner-icon{border-top-color:#2c3e50;border-left-color:#2c3e50}#loading-bar .peg{-ms-box-shadow:#2c3e50 1px 0 6px 1px;box-shadow:1px 0 6px 1px #2c3e50}.carousel,.nav,.pagination,.panel-title a{cursor:pointer}.carousel-indicators{top:auto;bottom:0}.fixed-top{top:50px;left:104px;position:fixed;z-index:10}.btn-secondary-outline,.btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff}.btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent}.bg-navy-grey{background-color:#f5f5f5;color:#333}.bg-navy{background-color:#333;color:#fff}.bg-white{background-color:#fff;color:#424753}.bg-grey-light{background-color:#e9e9e9;color:#424753}.bg-grey{background-color:#5a5960;color:#fff}.bg-grey-strong{background-color:#312f38;color:#fff}", ""]);

	// exports


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(57);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./webpack_css_fix.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./webpack_css_fix.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".content{background-color:#ecf0f5}", ""]);

	// exports


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(59);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./responsive_ul.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./responsive_ul.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".leftRigthMargin10{padding-left:40px;padding-right:40px}@media (min-width:768px){.list-inline-unstyled-XS{padding-left:0;list-style:none;margin-left:-5px}.list-inline-unstyled-XS>li{display:inline-block;padding-left:15px;padding-right:15px}}@media (max-width:768px){.list-inline-unstyled-XS{padding-left:0;list-style:none}}", ""]);

	// exports


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(61);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./full-slider.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./full-slider.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".active,.carousel,.carousel-inner,.item,body{height:100%}.fill{width:100%;min-height:100vh;background-position:50%;background-size:cover;-o-background-size:cover}.carousel-center{padding:40vh 10%;text-align:center}", ""]);

	// exports


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(63);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./skin-grey.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./skin-grey.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Bangers|Special+Elite);", ""]);

	// module
	exports.push([module.id, ".obt-skin-grey body{font-family:Open Sans,sans-serif}.obt-skin-grey .h1,.obt-skin-grey .h2,.obt-skin-grey .h3,.obt-skin-grey .h4,.obt-skin-grey .h5,.obt-skin-grey .h6,.obt-skin-grey h1,.obt-skin-grey h2,.obt-skin-grey h3,.obt-skin-grey h4,.obt-skin-grey h5,.obt-skin-grey h6{font-family:Volkswagen-Serial-Medium-Regular,Helvetica Neue,Helvetica,Arial,sans-serif}.skin-navy .bg-light{background-color:#fff;color:#312f38}.skin-navy .bg-medium{background-color:#e9e9e9;color:#333}.skin-navy .bg-medium2{background-color:#5a5960;color:#fff}.skin-navy .bg-dark{background-color:#312f38;color:#a9a9a9}.obt-skin-grey .bg-success{background-color:#18bc9c;color:#fff}.obt-skin-grey .bg-success .btn-link{color:#fff}.obt-skin-grey .bg-info{background-color:#f5f5f5;color:#9f9f9f}.obt-skin-grey .section-margin{padding:70px 0}.obt-skin-grey .main-header .navbar{background-color:#9f9f9f;border-color:#5baceb}.obt-skin-grey .content{background-color:#fff}.obt-skin-grey .main-footer{background-color:#9b9b9b;color:#fff;border-top:1px solid #5baceb}.obt-skin-grey .bg-info .btn-link,.obt-skin-grey .bg-info a{color:#fff}.obt-skin-grey .main-header .navbar-right a{//color:red}.obt-skin-grey .content a{color:#7566ad}@media (max-width:991px){.obt-skin-grey .main-header .navbar-right a{color:#9b9b9b}}@media (min-width:768px){.obt-skin-grey .main-header .navbar-right a{color:#9b9b9b}}.obt-skin-grey .calendar a{color:#000}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:0}}.btn-secondary-outline{color:#fff}.btn-secondary-outline,.btn-secondary-outline:focus{background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.main-header-margin{margin-bottom:50px}.navbar-brand-btn{margin-left:15px}.primary{color:#7566ad}.primary-strong{color:#515f82}.primary-light{color:#c2bcdb}.nav>li>a:focus{color:inherit;background:inherit}", ""]);

	// exports


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(65);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./skin-marianne.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./skin-marianne.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Bangers|Special+Elite);", ""]);

	// module
	exports.push([module.id, ".obt-skin-marianne body{font-family:Open Sans,sans-serif}.obt-skin-marianne .h3,.obt-skin-marianne .h4,.obt-skin-marianne .h5,.obt-skin-marianne .h6,.obt-skin-marianne h3,.obt-skin-marianne h4,.obt-skin-marianne h5,.obt-skin-marianne h6{font-family:Volkswagen-Serial-Medium-Regular,Helvetica Neue,Helvetica,Arial,sans-serif}.obt-skin-marianne .h1,.obt-skin-marianne .h2,.obt-skin-marianne h1,.obt-skin-marianne h2{font-family:Tangerine,cursive}.obt-skin-marianne .bg-light,.obt-skin-marianne .bg-light a{background-color:#fff;color:#000}.obt-skin-marianne .bg-medium,.obt-skin-marianne .bg-medium2,.obt-skin-marianne .bg-medium2 a,.obt-skin-marianne .bg-medium a{background-color:#7566ad;color:#fff}.obt-skin-marianne .bg-dark,.obt-skin-marianne .bg-dark a{background-color:#312f38;color:#a9a9a9}.obt-skin-marianne .bg-success{background-color:#18bc9c;color:#fff}.obt-skin-marianne .bg-success .btn-link{color:#fff}.obt-skin-marianne .bg-info{background-color:#7566ad;color:#fff}.obt-skin-marianne .section-margin{padding:70px 0}.obt-skin-marianne .main-header .navbar{background-color:#7566ad;border-color:#5baceb}.obt-skin-marianne .content{background-color:#fff}.obt-skin-marianne .main-footer{background-color:#7566ad;color:#fff;border-top:1px solid #7566ad}.obt-skin-marianne .bg-info .btn-link,.obt-skin-marianne .bg-info a,.obt-skin-marianne .main-header .navbar-right a{color:#fff}.obt-skin-marianne .content a{color:#7566ad}@media (max-width:991px){.obt-skin-marianne .main-header .navbar-right a{color:#fff}}@media (min-width:768px){.obt-skin-marianne .main-header .navbar-right a{color:#fff}}.obt-skin-marianne .calendar a{color:#000}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:0}}.btn-secondary-outline,.btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}\n\n    /*!*margin: 0px 5px;*!*/\n    /*!*margin:  2px 5px;*!*/\n\n    /*!*margin: 0px 5px;*!*/.main-header-margin{margin-bottom:50px}.navbar-brand-btn{margin-left:15px}.primary{color:#7566ad}.primary-strong{color:#515f82}.primary-light{color:#c2bcdb}.nav>li>a:focus{color:inherit;background:inherit}", ""]);

	// exports


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(67);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./skin-simplifystack-1.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./skin-simplifystack-1.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Bangers|Special+Elite);", ""]);

	// module
	exports.push([module.id, ".skin-simplifystack-1 body{font-family:Open Sans,sans-serif}.skin-simplifystack-1 .h2,.skin-simplifystack-1 .h3,.skin-simplifystack-1 .h4,.skin-simplifystack-1 .h5,.skin-simplifystack-1 .h6,.skin-simplifystack-1 h2,.skin-simplifystack-1 h3,.skin-simplifystack-1 h4,.skin-simplifystack-1 h5,.skin-simplifystack-1 h6{font-family:Volkswagen-Serial-Medium-Regular,Helvetica Neue,Helvetica,Arial,sans-serif}.skin-simplifystack-1 .h1,.skin-simplifystack-1 h1{font-family:Tangerine,cursive;color:#a05a2c}.skin-simplifystack-1 .bg-success{background-color:#18bc9c;color:#fff}.skin-simplifystack-1 .bg-success .btn-link{color:#fff}.skin-simplifystack-1 .bg-info{background-color:#5a5960;color:#fff}.skin-simplifystack-1 .section-margin{padding:70px 0}.skin-simplifystack-1 .main-header .navbar{background-color:#312f38;border-color:#2f4f6e;color:#fff}.skin-simplifystack-1 .content{background-color:#e9e9e9}.skin-simplifystack-1 .main-footer{background-color:#312f38;color:#fff;border-top:1px solid #312f38}.skin-simplifystack-1 .bg-info .btn-link,.skin-simplifystack-1 .bg-info a{color:#fff}.skin-simplifystack-1 .content a,.skin-simplifystack-1 .main-header .navbar-right a{color:#a9a9a9}@media (max-width:991px){.skin-simplifystack-1 .main-header .navbar-right a{color:#a9a9a9}}@media (min-width:768px){.skin-simplifystack-1 .main-header .navbar-right a{color:#a9a9a9}}.skin-simplifystack-1 .calendar a{color:#000}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:0}}.btn-secondary-outline,.btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.main-header-margin{margin-bottom:50px}.navbar-brand-btn{margin-left:15px}.primary{color:#7566ad}.primary-strong{color:#a05a2c}.primary-light{color:#c2bcdb}.nav>li>a:focus{color:inherit;background:inherit}.angular-google-map-container{height:400px}.small-map .angular-google-map-container{height:200px}", ""]);

	// exports


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(69);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./obtSection.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./obtSection.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".square-box{position:relative;max-width:300px;overflow:hidden}.square-box:before{content:\"\";display:block;padding-top:100%}.square-content{position:absolute;top:0;left:0;bottom:0;right:0;color:#fff;width:100%;height:100%}.square-content div{display:table;width:100%;height:100%}.square-content span{display:table-cell;text-align:center;vertical-align:middle;color:#fff}.ui-carousel .image img{display:block;border:5px solid #fff;width:70%;margin-left:15px;margin-right:15px}.media-carousel{margin-bottom:0;padding:0 40px 30px;margin-top:30px}.media-carousel .carousel-control.left{left:-12px}.media-carousel .carousel-control.left,.media-carousel .carousel-control.right{background-image:none;background:none repeat scroll 0 0 #222;border:4px solid #fff;border-radius:23px 23px 23px 23px;height:40px;width:40px;margin-top:30px}.media-carousel .carousel-control.right{right:-12px!important}.media-carousel .carousel-indicators{right:50%;top:auto;bottom:0;margin-right:-19px}.media-carousel .carousel-indicators li{background:silver}.media-carousel .carousel-indicators .active{background:#333}.media-carousel img{width:auto;height:300px}", ""]);

	// exports


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(71);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./same_col_height.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./same_col_height.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".fullHeight{height:100%}.container-xs-height{display:table;padding-left:0;padding-right:0}.row-xs-height{display:table-row}.col-xs-height{display:table-cell;float:none}@media (min-width:768px){.container-sm-height{display:table;padding-left:0;padding-right:0}.row-sm-height{display:table-row}.col-sm-height{display:table-cell;float:none}}@media (min-width:992px){.container-md-height{display:table;padding-left:0;padding-right:0}.row-md-height{display:table-row}.col-md-height{display:table-cell;float:none}}@media (min-width:1200px){.container-lg-height{display:table;padding-left:0;padding-right:0}.row-lg-height{display:table-row}.col-lg-height{display:table-cell;float:none}}.col-top{vertical-align:top}.col-middle{vertical-align:middle}.col-bottom{vertical-align:bottom}", ""]);

	// exports


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(73);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./ionicons.min.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./ionicons.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, "@charset \"UTF-8\";/*!\n  Ionicons, v2.0.0\n  Created by Ben Sperry for the Ionic Framework, http://ionicons.com/\n  https://twitter.com/benjsperry  https://twitter.com/ionicframework\n  MIT License: https://github.com/driftyco/ionicons\n\n  Android-style icons originally built by Google’s\n  Material Design Icons: https://github.com/google/material-design-icons\n  used under CC BY http://creativecommons.org/licenses/by/4.0/\n  Modified icons to fit ionicon’s grid from original.\n*/@font-face{font-family:Ionicons;src:url(" + __webpack_require__(75) + ");src:url(" + __webpack_require__(75) + "#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(74) + ") format(\"truetype\"),url(" + __webpack_require__(76) + ") format(\"woff\"),url(" + __webpack_require__(77) + "#Ionicons) format(\"svg\");font-weight:400;font-style:normal}.ion,.ion-alert-circled:before,.ion-alert:before,.ion-android-add-circle:before,.ion-android-add:before,.ion-android-alarm-clock:before,.ion-android-alert:before,.ion-android-apps:before,.ion-android-archive:before,.ion-android-arrow-back:before,.ion-android-arrow-down:before,.ion-android-arrow-dropdown-circle:before,.ion-android-arrow-dropdown:before,.ion-android-arrow-dropleft-circle:before,.ion-android-arrow-dropleft:before,.ion-android-arrow-dropright-circle:before,.ion-android-arrow-dropright:before,.ion-android-arrow-dropup-circle:before,.ion-android-arrow-dropup:before,.ion-android-arrow-forward:before,.ion-android-arrow-up:before,.ion-android-attach:before,.ion-android-bar:before,.ion-android-bicycle:before,.ion-android-boat:before,.ion-android-bookmark:before,.ion-android-bulb:before,.ion-android-bus:before,.ion-android-calendar:before,.ion-android-call:before,.ion-android-camera:before,.ion-android-cancel:before,.ion-android-car:before,.ion-android-cart:before,.ion-android-chat:before,.ion-android-checkbox-blank:before,.ion-android-checkbox-outline-blank:before,.ion-android-checkbox-outline:before,.ion-android-checkbox:before,.ion-android-checkmark-circle:before,.ion-android-clipboard:before,.ion-android-close:before,.ion-android-cloud-circle:before,.ion-android-cloud-done:before,.ion-android-cloud-outline:before,.ion-android-cloud:before,.ion-android-color-palette:before,.ion-android-compass:before,.ion-android-contact:before,.ion-android-contacts:before,.ion-android-contract:before,.ion-android-create:before,.ion-android-delete:before,.ion-android-desktop:before,.ion-android-document:before,.ion-android-done-all:before,.ion-android-done:before,.ion-android-download:before,.ion-android-drafts:before,.ion-android-exit:before,.ion-android-expand:before,.ion-android-favorite-outline:before,.ion-android-favorite:before,.ion-android-film:before,.ion-android-folder-open:before,.ion-android-folder:before,.ion-android-funnel:before,.ion-android-globe:before,.ion-android-hand:before,.ion-android-hangout:before,.ion-android-happy:before,.ion-android-home:before,.ion-android-image:before,.ion-android-laptop:before,.ion-android-list:before,.ion-android-locate:before,.ion-android-lock:before,.ion-android-mail:before,.ion-android-map:before,.ion-android-menu:before,.ion-android-microphone-off:before,.ion-android-microphone:before,.ion-android-more-horizontal:before,.ion-android-more-vertical:before,.ion-android-navigate:before,.ion-android-notifications-none:before,.ion-android-notifications-off:before,.ion-android-notifications:before,.ion-android-open:before,.ion-android-options:before,.ion-android-people:before,.ion-android-person-add:before,.ion-android-person:before,.ion-android-phone-landscape:before,.ion-android-phone-portrait:before,.ion-android-pin:before,.ion-android-plane:before,.ion-android-playstore:before,.ion-android-print:before,.ion-android-radio-button-off:before,.ion-android-radio-button-on:before,.ion-android-refresh:before,.ion-android-remove-circle:before,.ion-android-remove:before,.ion-android-restaurant:before,.ion-android-sad:before,.ion-android-search:before,.ion-android-send:before,.ion-android-settings:before,.ion-android-share-alt:before,.ion-android-share:before,.ion-android-star-half:before,.ion-android-star-outline:before,.ion-android-star:before,.ion-android-stopwatch:before,.ion-android-subway:before,.ion-android-sunny:before,.ion-android-sync:before,.ion-android-textsms:before,.ion-android-time:before,.ion-android-train:before,.ion-android-unlock:before,.ion-android-upload:before,.ion-android-volume-down:before,.ion-android-volume-mute:before,.ion-android-volume-off:before,.ion-android-volume-up:before,.ion-android-walk:before,.ion-android-warning:before,.ion-android-watch:before,.ion-android-wifi:before,.ion-aperture:before,.ion-archive:before,.ion-arrow-down-a:before,.ion-arrow-down-b:before,.ion-arrow-down-c:before,.ion-arrow-expand:before,.ion-arrow-graph-down-left:before,.ion-arrow-graph-down-right:before,.ion-arrow-graph-up-left:before,.ion-arrow-graph-up-right:before,.ion-arrow-left-a:before,.ion-arrow-left-b:before,.ion-arrow-left-c:before,.ion-arrow-move:before,.ion-arrow-resize:before,.ion-arrow-return-left:before,.ion-arrow-return-right:before,.ion-arrow-right-a:before,.ion-arrow-right-b:before,.ion-arrow-right-c:before,.ion-arrow-shrink:before,.ion-arrow-swap:before,.ion-arrow-up-a:before,.ion-arrow-up-b:before,.ion-arrow-up-c:before,.ion-asterisk:before,.ion-at:before,.ion-backspace-outline:before,.ion-backspace:before,.ion-bag:before,.ion-battery-charging:before,.ion-battery-empty:before,.ion-battery-full:before,.ion-battery-half:before,.ion-battery-low:before,.ion-beaker:before,.ion-beer:before,.ion-bluetooth:before,.ion-bonfire:before,.ion-bookmark:before,.ion-bowtie:before,.ion-briefcase:before,.ion-bug:before,.ion-calculator:before,.ion-calendar:before,.ion-camera:before,.ion-card:before,.ion-cash:before,.ion-chatbox-working:before,.ion-chatbox:before,.ion-chatboxes:before,.ion-chatbubble-working:before,.ion-chatbubble:before,.ion-chatbubbles:before,.ion-checkmark-circled:before,.ion-checkmark-round:before,.ion-checkmark:before,.ion-chevron-down:before,.ion-chevron-left:before,.ion-chevron-right:before,.ion-chevron-up:before,.ion-clipboard:before,.ion-clock:before,.ion-close-circled:before,.ion-close-round:before,.ion-close:before,.ion-closed-captioning:before,.ion-cloud:before,.ion-code-download:before,.ion-code-working:before,.ion-code:before,.ion-coffee:before,.ion-compass:before,.ion-compose:before,.ion-connection-bars:before,.ion-contrast:before,.ion-crop:before,.ion-cube:before,.ion-disc:before,.ion-document-text:before,.ion-document:before,.ion-drag:before,.ion-earth:before,.ion-easel:before,.ion-edit:before,.ion-egg:before,.ion-eject:before,.ion-email-unread:before,.ion-email:before,.ion-erlenmeyer-flask-bubbles:before,.ion-erlenmeyer-flask:before,.ion-eye-disabled:before,.ion-eye:before,.ion-female:before,.ion-filing:before,.ion-film-marker:before,.ion-fireball:before,.ion-flag:before,.ion-flame:before,.ion-flash-off:before,.ion-flash:before,.ion-folder:before,.ion-fork-repo:before,.ion-fork:before,.ion-forward:before,.ion-funnel:before,.ion-gear-a:before,.ion-gear-b:before,.ion-grid:before,.ion-hammer:before,.ion-happy-outline:before,.ion-happy:before,.ion-headphone:before,.ion-heart-broken:before,.ion-heart:before,.ion-help-buoy:before,.ion-help-circled:before,.ion-help:before,.ion-home:before,.ion-icecream:before,.ion-image:before,.ion-images:before,.ion-information-circled:before,.ion-information:before,.ion-ionic:before,.ion-ios-alarm-outline:before,.ion-ios-alarm:before,.ion-ios-albums-outline:before,.ion-ios-albums:before,.ion-ios-americanfootball-outline:before,.ion-ios-americanfootball:before,.ion-ios-analytics-outline:before,.ion-ios-analytics:before,.ion-ios-arrow-back:before,.ion-ios-arrow-down:before,.ion-ios-arrow-forward:before,.ion-ios-arrow-left:before,.ion-ios-arrow-right:before,.ion-ios-arrow-thin-down:before,.ion-ios-arrow-thin-left:before,.ion-ios-arrow-thin-right:before,.ion-ios-arrow-thin-up:before,.ion-ios-arrow-up:before,.ion-ios-at-outline:before,.ion-ios-at:before,.ion-ios-barcode-outline:before,.ion-ios-barcode:before,.ion-ios-baseball-outline:before,.ion-ios-baseball:before,.ion-ios-basketball-outline:before,.ion-ios-basketball:before,.ion-ios-bell-outline:before,.ion-ios-bell:before,.ion-ios-body-outline:before,.ion-ios-body:before,.ion-ios-bolt-outline:before,.ion-ios-bolt:before,.ion-ios-book-outline:before,.ion-ios-book:before,.ion-ios-bookmarks-outline:before,.ion-ios-bookmarks:before,.ion-ios-box-outline:before,.ion-ios-box:before,.ion-ios-briefcase-outline:before,.ion-ios-briefcase:before,.ion-ios-browsers-outline:before,.ion-ios-browsers:before,.ion-ios-calculator-outline:before,.ion-ios-calculator:before,.ion-ios-calendar-outline:before,.ion-ios-calendar:before,.ion-ios-camera-outline:before,.ion-ios-camera:before,.ion-ios-cart-outline:before,.ion-ios-cart:before,.ion-ios-chatboxes-outline:before,.ion-ios-chatboxes:before,.ion-ios-chatbubble-outline:before,.ion-ios-chatbubble:before,.ion-ios-checkmark-empty:before,.ion-ios-checkmark-outline:before,.ion-ios-checkmark:before,.ion-ios-circle-filled:before,.ion-ios-circle-outline:before,.ion-ios-clock-outline:before,.ion-ios-clock:before,.ion-ios-close-empty:before,.ion-ios-close-outline:before,.ion-ios-close:before,.ion-ios-cloud-download-outline:before,.ion-ios-cloud-download:before,.ion-ios-cloud-outline:before,.ion-ios-cloud-upload-outline:before,.ion-ios-cloud-upload:before,.ion-ios-cloud:before,.ion-ios-cloudy-night-outline:before,.ion-ios-cloudy-night:before,.ion-ios-cloudy-outline:before,.ion-ios-cloudy:before,.ion-ios-cog-outline:before,.ion-ios-cog:before,.ion-ios-color-filter-outline:before,.ion-ios-color-filter:before,.ion-ios-color-wand-outline:before,.ion-ios-color-wand:before,.ion-ios-compose-outline:before,.ion-ios-compose:before,.ion-ios-contact-outline:before,.ion-ios-contact:before,.ion-ios-copy-outline:before,.ion-ios-copy:before,.ion-ios-crop-strong:before,.ion-ios-crop:before,.ion-ios-download-outline:before,.ion-ios-download:before,.ion-ios-drag:before,.ion-ios-email-outline:before,.ion-ios-email:before,.ion-ios-eye-outline:before,.ion-ios-eye:before,.ion-ios-fastforward-outline:before,.ion-ios-fastforward:before,.ion-ios-filing-outline:before,.ion-ios-filing:before,.ion-ios-film-outline:before,.ion-ios-film:before,.ion-ios-flag-outline:before,.ion-ios-flag:before,.ion-ios-flame-outline:before,.ion-ios-flame:before,.ion-ios-flask-outline:before,.ion-ios-flask:before,.ion-ios-flower-outline:before,.ion-ios-flower:before,.ion-ios-folder-outline:before,.ion-ios-folder:before,.ion-ios-football-outline:before,.ion-ios-football:before,.ion-ios-game-controller-a-outline:before,.ion-ios-game-controller-a:before,.ion-ios-game-controller-b-outline:before,.ion-ios-game-controller-b:before,.ion-ios-gear-outline:before,.ion-ios-gear:before,.ion-ios-glasses-outline:before,.ion-ios-glasses:before,.ion-ios-grid-view-outline:before,.ion-ios-grid-view:before,.ion-ios-heart-outline:before,.ion-ios-heart:before,.ion-ios-help-empty:before,.ion-ios-help-outline:before,.ion-ios-help:before,.ion-ios-home-outline:before,.ion-ios-home:before,.ion-ios-infinite-outline:before,.ion-ios-infinite:before,.ion-ios-information-empty:before,.ion-ios-information-outline:before,.ion-ios-information:before,.ion-ios-ionic-outline:before,.ion-ios-keypad-outline:before,.ion-ios-keypad:before,.ion-ios-lightbulb-outline:before,.ion-ios-lightbulb:before,.ion-ios-list-outline:before,.ion-ios-list:before,.ion-ios-location-outline:before,.ion-ios-location:before,.ion-ios-locked-outline:before,.ion-ios-locked:before,.ion-ios-loop-strong:before,.ion-ios-loop:before,.ion-ios-medical-outline:before,.ion-ios-medical:before,.ion-ios-medkit-outline:before,.ion-ios-medkit:before,.ion-ios-mic-off:before,.ion-ios-mic-outline:before,.ion-ios-mic:before,.ion-ios-minus-empty:before,.ion-ios-minus-outline:before,.ion-ios-minus:before,.ion-ios-monitor-outline:before,.ion-ios-monitor:before,.ion-ios-moon-outline:before,.ion-ios-moon:before,.ion-ios-more-outline:before,.ion-ios-more:before,.ion-ios-musical-note:before,.ion-ios-musical-notes:before,.ion-ios-navigate-outline:before,.ion-ios-navigate:before,.ion-ios-nutrition-outline:before,.ion-ios-nutrition:before,.ion-ios-paper-outline:before,.ion-ios-paper:before,.ion-ios-paperplane-outline:before,.ion-ios-paperplane:before,.ion-ios-partlysunny-outline:before,.ion-ios-partlysunny:before,.ion-ios-pause-outline:before,.ion-ios-pause:before,.ion-ios-paw-outline:before,.ion-ios-paw:before,.ion-ios-people-outline:before,.ion-ios-people:before,.ion-ios-person-outline:before,.ion-ios-person:before,.ion-ios-personadd-outline:before,.ion-ios-personadd:before,.ion-ios-photos-outline:before,.ion-ios-photos:before,.ion-ios-pie-outline:before,.ion-ios-pie:before,.ion-ios-pint-outline:before,.ion-ios-pint:before,.ion-ios-play-outline:before,.ion-ios-play:before,.ion-ios-plus-empty:before,.ion-ios-plus-outline:before,.ion-ios-plus:before,.ion-ios-pricetag-outline:before,.ion-ios-pricetag:before,.ion-ios-pricetags-outline:before,.ion-ios-pricetags:before,.ion-ios-printer-outline:before,.ion-ios-printer:before,.ion-ios-pulse-strong:before,.ion-ios-pulse:before,.ion-ios-rainy-outline:before,.ion-ios-rainy:before,.ion-ios-recording-outline:before,.ion-ios-recording:before,.ion-ios-redo-outline:before,.ion-ios-redo:before,.ion-ios-refresh-empty:before,.ion-ios-refresh-outline:before,.ion-ios-refresh:before,.ion-ios-reload:before,.ion-ios-reverse-camera-outline:before,.ion-ios-reverse-camera:before,.ion-ios-rewind-outline:before,.ion-ios-rewind:before,.ion-ios-rose-outline:before,.ion-ios-rose:before,.ion-ios-search-strong:before,.ion-ios-search:before,.ion-ios-settings-strong:before,.ion-ios-settings:before,.ion-ios-shuffle-strong:before,.ion-ios-shuffle:before,.ion-ios-skipbackward-outline:before,.ion-ios-skipbackward:before,.ion-ios-skipforward-outline:before,.ion-ios-skipforward:before,.ion-ios-snowy:before,.ion-ios-speedometer-outline:before,.ion-ios-speedometer:before,.ion-ios-star-half:before,.ion-ios-star-outline:before,.ion-ios-star:before,.ion-ios-stopwatch-outline:before,.ion-ios-stopwatch:before,.ion-ios-sunny-outline:before,.ion-ios-sunny:before,.ion-ios-telephone-outline:before,.ion-ios-telephone:before,.ion-ios-tennisball-outline:before,.ion-ios-tennisball:before,.ion-ios-thunderstorm-outline:before,.ion-ios-thunderstorm:before,.ion-ios-time-outline:before,.ion-ios-time:before,.ion-ios-timer-outline:before,.ion-ios-timer:before,.ion-ios-toggle-outline:before,.ion-ios-toggle:before,.ion-ios-trash-outline:before,.ion-ios-trash:before,.ion-ios-undo-outline:before,.ion-ios-undo:before,.ion-ios-unlocked-outline:before,.ion-ios-unlocked:before,.ion-ios-upload-outline:before,.ion-ios-upload:before,.ion-ios-videocam-outline:before,.ion-ios-videocam:before,.ion-ios-volume-high:before,.ion-ios-volume-low:before,.ion-ios-wineglass-outline:before,.ion-ios-wineglass:before,.ion-ios-world-outline:before,.ion-ios-world:before,.ion-ipad:before,.ion-iphone:before,.ion-ipod:before,.ion-jet:before,.ion-key:before,.ion-knife:before,.ion-laptop:before,.ion-leaf:before,.ion-levels:before,.ion-lightbulb:before,.ion-link:before,.ion-load-a:before,.ion-load-b:before,.ion-load-c:before,.ion-load-d:before,.ion-location:before,.ion-lock-combination:before,.ion-locked:before,.ion-log-in:before,.ion-log-out:before,.ion-loop:before,.ion-magnet:before,.ion-male:before,.ion-man:before,.ion-map:before,.ion-medkit:before,.ion-merge:before,.ion-mic-a:before,.ion-mic-b:before,.ion-mic-c:before,.ion-minus-circled:before,.ion-minus-round:before,.ion-minus:before,.ion-model-s:before,.ion-monitor:before,.ion-more:before,.ion-mouse:before,.ion-music-note:before,.ion-navicon-round:before,.ion-navicon:before,.ion-navigate:before,.ion-network:before,.ion-no-smoking:before,.ion-nuclear:before,.ion-outlet:before,.ion-paintbrush:before,.ion-paintbucket:before,.ion-paper-airplane:before,.ion-paperclip:before,.ion-pause:before,.ion-person-add:before,.ion-person-stalker:before,.ion-person:before,.ion-pie-graph:before,.ion-pin:before,.ion-pinpoint:before,.ion-pizza:before,.ion-plane:before,.ion-planet:before,.ion-play:before,.ion-playstation:before,.ion-plus-circled:before,.ion-plus-round:before,.ion-plus:before,.ion-podium:before,.ion-pound:before,.ion-power:before,.ion-pricetag:before,.ion-pricetags:before,.ion-printer:before,.ion-pull-request:before,.ion-qr-scanner:before,.ion-quote:before,.ion-radio-waves:before,.ion-record:before,.ion-refresh:before,.ion-reply-all:before,.ion-reply:before,.ion-ribbon-a:before,.ion-ribbon-b:before,.ion-sad-outline:before,.ion-sad:before,.ion-scissors:before,.ion-search:before,.ion-settings:before,.ion-share:before,.ion-shuffle:before,.ion-skip-backward:before,.ion-skip-forward:before,.ion-social-android-outline:before,.ion-social-android:before,.ion-social-angular-outline:before,.ion-social-angular:before,.ion-social-apple-outline:before,.ion-social-apple:before,.ion-social-bitcoin-outline:before,.ion-social-bitcoin:before,.ion-social-buffer-outline:before,.ion-social-buffer:before,.ion-social-chrome-outline:before,.ion-social-chrome:before,.ion-social-codepen-outline:before,.ion-social-codepen:before,.ion-social-css3-outline:before,.ion-social-css3:before,.ion-social-designernews-outline:before,.ion-social-designernews:before,.ion-social-dribbble-outline:before,.ion-social-dribbble:before,.ion-social-dropbox-outline:before,.ion-social-dropbox:before,.ion-social-euro-outline:before,.ion-social-euro:before,.ion-social-facebook-outline:before,.ion-social-facebook:before,.ion-social-foursquare-outline:before,.ion-social-foursquare:before,.ion-social-freebsd-devil:before,.ion-social-github-outline:before,.ion-social-github:before,.ion-social-google-outline:before,.ion-social-google:before,.ion-social-googleplus-outline:before,.ion-social-googleplus:before,.ion-social-hackernews-outline:before,.ion-social-hackernews:before,.ion-social-html5-outline:before,.ion-social-html5:before,.ion-social-instagram-outline:before,.ion-social-instagram:before,.ion-social-javascript-outline:before,.ion-social-javascript:before,.ion-social-linkedin-outline:before,.ion-social-linkedin:before,.ion-social-markdown:before,.ion-social-nodejs:before,.ion-social-octocat:before,.ion-social-pinterest-outline:before,.ion-social-pinterest:before,.ion-social-python:before,.ion-social-reddit-outline:before,.ion-social-reddit:before,.ion-social-rss-outline:before,.ion-social-rss:before,.ion-social-sass:before,.ion-social-skype-outline:before,.ion-social-skype:before,.ion-social-snapchat-outline:before,.ion-social-snapchat:before,.ion-social-tumblr-outline:before,.ion-social-tumblr:before,.ion-social-tux:before,.ion-social-twitch-outline:before,.ion-social-twitch:before,.ion-social-twitter-outline:before,.ion-social-twitter:before,.ion-social-usd-outline:before,.ion-social-usd:before,.ion-social-vimeo-outline:before,.ion-social-vimeo:before,.ion-social-whatsapp-outline:before,.ion-social-whatsapp:before,.ion-social-windows-outline:before,.ion-social-windows:before,.ion-social-wordpress-outline:before,.ion-social-wordpress:before,.ion-social-yahoo-outline:before,.ion-social-yahoo:before,.ion-social-yen-outline:before,.ion-social-yen:before,.ion-social-youtube-outline:before,.ion-social-youtube:before,.ion-soup-can-outline:before,.ion-soup-can:before,.ion-speakerphone:before,.ion-speedometer:before,.ion-spoon:before,.ion-star:before,.ion-stats-bars:before,.ion-steam:before,.ion-stop:before,.ion-thermometer:before,.ion-thumbsdown:before,.ion-thumbsup:before,.ion-toggle-filled:before,.ion-toggle:before,.ion-transgender:before,.ion-trash-a:before,.ion-trash-b:before,.ion-trophy:before,.ion-tshirt-outline:before,.ion-tshirt:before,.ion-umbrella:before,.ion-university:before,.ion-unlocked:before,.ion-upload:before,.ion-usb:before,.ion-videocamera:before,.ion-volume-high:before,.ion-volume-low:before,.ion-volume-medium:before,.ion-volume-mute:before,.ion-wand:before,.ion-waterdrop:before,.ion-wifi:before,.ion-wineglass:before,.ion-woman:before,.ion-wrench:before,.ion-xbox:before,.ionicons{display:inline-block;font-family:Ionicons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;text-rendering:auto;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ion-alert:before{content:\"\\F101\"}.ion-alert-circled:before{content:\"\\F100\"}.ion-android-add:before{content:\"\\F2C7\"}.ion-android-add-circle:before{content:\"\\F359\"}.ion-android-alarm-clock:before{content:\"\\F35A\"}.ion-android-alert:before{content:\"\\F35B\"}.ion-android-apps:before{content:\"\\F35C\"}.ion-android-archive:before{content:\"\\F2C9\"}.ion-android-arrow-back:before{content:\"\\F2CA\"}.ion-android-arrow-down:before{content:\"\\F35D\"}.ion-android-arrow-dropdown:before{content:\"\\F35F\"}.ion-android-arrow-dropdown-circle:before{content:\"\\F35E\"}.ion-android-arrow-dropleft:before{content:\"\\F361\"}.ion-android-arrow-dropleft-circle:before{content:\"\\F360\"}.ion-android-arrow-dropright:before{content:\"\\F363\"}.ion-android-arrow-dropright-circle:before{content:\"\\F362\"}.ion-android-arrow-dropup:before{content:\"\\F365\"}.ion-android-arrow-dropup-circle:before{content:\"\\F364\"}.ion-android-arrow-forward:before{content:\"\\F30F\"}.ion-android-arrow-up:before{content:\"\\F366\"}.ion-android-attach:before{content:\"\\F367\"}.ion-android-bar:before{content:\"\\F368\"}.ion-android-bicycle:before{content:\"\\F369\"}.ion-android-boat:before{content:\"\\F36A\"}.ion-android-bookmark:before{content:\"\\F36B\"}.ion-android-bulb:before{content:\"\\F36C\"}.ion-android-bus:before{content:\"\\F36D\"}.ion-android-calendar:before{content:\"\\F2D1\"}.ion-android-call:before{content:\"\\F2D2\"}.ion-android-camera:before{content:\"\\F2D3\"}.ion-android-cancel:before{content:\"\\F36E\"}.ion-android-car:before{content:\"\\F36F\"}.ion-android-cart:before{content:\"\\F370\"}.ion-android-chat:before{content:\"\\F2D4\"}.ion-android-checkbox:before{content:\"\\F374\"}.ion-android-checkbox-blank:before{content:\"\\F371\"}.ion-android-checkbox-outline:before{content:\"\\F373\"}.ion-android-checkbox-outline-blank:before{content:\"\\F372\"}.ion-android-checkmark-circle:before{content:\"\\F375\"}.ion-android-clipboard:before{content:\"\\F376\"}.ion-android-close:before{content:\"\\F2D7\"}.ion-android-cloud:before{content:\"\\F37A\"}.ion-android-cloud-circle:before{content:\"\\F377\"}.ion-android-cloud-done:before{content:\"\\F378\"}.ion-android-cloud-outline:before{content:\"\\F379\"}.ion-android-color-palette:before{content:\"\\F37B\"}.ion-android-compass:before{content:\"\\F37C\"}.ion-android-contact:before{content:\"\\F2D8\"}.ion-android-contacts:before{content:\"\\F2D9\"}.ion-android-contract:before{content:\"\\F37D\"}.ion-android-create:before{content:\"\\F37E\"}.ion-android-delete:before{content:\"\\F37F\"}.ion-android-desktop:before{content:\"\\F380\"}.ion-android-document:before{content:\"\\F381\"}.ion-android-done:before{content:\"\\F383\"}.ion-android-done-all:before{content:\"\\F382\"}.ion-android-download:before{content:\"\\F2DD\"}.ion-android-drafts:before{content:\"\\F384\"}.ion-android-exit:before{content:\"\\F385\"}.ion-android-expand:before{content:\"\\F386\"}.ion-android-favorite:before{content:\"\\F388\"}.ion-android-favorite-outline:before{content:\"\\F387\"}.ion-android-film:before{content:\"\\F389\"}.ion-android-folder:before{content:\"\\F2E0\"}.ion-android-folder-open:before{content:\"\\F38A\"}.ion-android-funnel:before{content:\"\\F38B\"}.ion-android-globe:before{content:\"\\F38C\"}.ion-android-hand:before{content:\"\\F2E3\"}.ion-android-hangout:before{content:\"\\F38D\"}.ion-android-happy:before{content:\"\\F38E\"}.ion-android-home:before{content:\"\\F38F\"}.ion-android-image:before{content:\"\\F2E4\"}.ion-android-laptop:before{content:\"\\F390\"}.ion-android-list:before{content:\"\\F391\"}.ion-android-locate:before{content:\"\\F2E9\"}.ion-android-lock:before{content:\"\\F392\"}.ion-android-mail:before{content:\"\\F2EB\"}.ion-android-map:before{content:\"\\F393\"}.ion-android-menu:before{content:\"\\F394\"}.ion-android-microphone:before{content:\"\\F2EC\"}.ion-android-microphone-off:before{content:\"\\F395\"}.ion-android-more-horizontal:before{content:\"\\F396\"}.ion-android-more-vertical:before{content:\"\\F397\"}.ion-android-navigate:before{content:\"\\F398\"}.ion-android-notifications:before{content:\"\\F39B\"}.ion-android-notifications-none:before{content:\"\\F399\"}.ion-android-notifications-off:before{content:\"\\F39A\"}.ion-android-open:before{content:\"\\F39C\"}.ion-android-options:before{content:\"\\F39D\"}.ion-android-people:before{content:\"\\F39E\"}.ion-android-person:before{content:\"\\F3A0\"}.ion-android-person-add:before{content:\"\\F39F\"}.ion-android-phone-landscape:before{content:\"\\F3A1\"}.ion-android-phone-portrait:before{content:\"\\F3A2\"}.ion-android-pin:before{content:\"\\F3A3\"}.ion-android-plane:before{content:\"\\F3A4\"}.ion-android-playstore:before{content:\"\\F2F0\"}.ion-android-print:before{content:\"\\F3A5\"}.ion-android-radio-button-off:before{content:\"\\F3A6\"}.ion-android-radio-button-on:before{content:\"\\F3A7\"}.ion-android-refresh:before{content:\"\\F3A8\"}.ion-android-remove:before{content:\"\\F2F4\"}.ion-android-remove-circle:before{content:\"\\F3A9\"}.ion-android-restaurant:before{content:\"\\F3AA\"}.ion-android-sad:before{content:\"\\F3AB\"}.ion-android-search:before{content:\"\\F2F5\"}.ion-android-send:before{content:\"\\F2F6\"}.ion-android-settings:before{content:\"\\F2F7\"}.ion-android-share:before{content:\"\\F2F8\"}.ion-android-share-alt:before{content:\"\\F3AC\"}.ion-android-star:before{content:\"\\F2FC\"}.ion-android-star-half:before{content:\"\\F3AD\"}.ion-android-star-outline:before{content:\"\\F3AE\"}.ion-android-stopwatch:before{content:\"\\F2FD\"}.ion-android-subway:before{content:\"\\F3AF\"}.ion-android-sunny:before{content:\"\\F3B0\"}.ion-android-sync:before{content:\"\\F3B1\"}.ion-android-textsms:before{content:\"\\F3B2\"}.ion-android-time:before{content:\"\\F3B3\"}.ion-android-train:before{content:\"\\F3B4\"}.ion-android-unlock:before{content:\"\\F3B5\"}.ion-android-upload:before{content:\"\\F3B6\"}.ion-android-volume-down:before{content:\"\\F3B7\"}.ion-android-volume-mute:before{content:\"\\F3B8\"}.ion-android-volume-off:before{content:\"\\F3B9\"}.ion-android-volume-up:before{content:\"\\F3BA\"}.ion-android-walk:before{content:\"\\F3BB\"}.ion-android-warning:before{content:\"\\F3BC\"}.ion-android-watch:before{content:\"\\F3BD\"}.ion-android-wifi:before{content:\"\\F305\"}.ion-aperture:before{content:\"\\F313\"}.ion-archive:before{content:\"\\F102\"}.ion-arrow-down-a:before{content:\"\\F103\"}.ion-arrow-down-b:before{content:\"\\F104\"}.ion-arrow-down-c:before{content:\"\\F105\"}.ion-arrow-expand:before{content:\"\\F25E\"}.ion-arrow-graph-down-left:before{content:\"\\F25F\"}.ion-arrow-graph-down-right:before{content:\"\\F260\"}.ion-arrow-graph-up-left:before{content:\"\\F261\"}.ion-arrow-graph-up-right:before{content:\"\\F262\"}.ion-arrow-left-a:before{content:\"\\F106\"}.ion-arrow-left-b:before{content:\"\\F107\"}.ion-arrow-left-c:before{content:\"\\F108\"}.ion-arrow-move:before{content:\"\\F263\"}.ion-arrow-resize:before{content:\"\\F264\"}.ion-arrow-return-left:before{content:\"\\F265\"}.ion-arrow-return-right:before{content:\"\\F266\"}.ion-arrow-right-a:before{content:\"\\F109\"}.ion-arrow-right-b:before{content:\"\\F10A\"}.ion-arrow-right-c:before{content:\"\\F10B\"}.ion-arrow-shrink:before{content:\"\\F267\"}.ion-arrow-swap:before{content:\"\\F268\"}.ion-arrow-up-a:before{content:\"\\F10C\"}.ion-arrow-up-b:before{content:\"\\F10D\"}.ion-arrow-up-c:before{content:\"\\F10E\"}.ion-asterisk:before{content:\"\\F314\"}.ion-at:before{content:\"\\F10F\"}.ion-backspace:before{content:\"\\F3BF\"}.ion-backspace-outline:before{content:\"\\F3BE\"}.ion-bag:before{content:\"\\F110\"}.ion-battery-charging:before{content:\"\\F111\"}.ion-battery-empty:before{content:\"\\F112\"}.ion-battery-full:before{content:\"\\F113\"}.ion-battery-half:before{content:\"\\F114\"}.ion-battery-low:before{content:\"\\F115\"}.ion-beaker:before{content:\"\\F269\"}.ion-beer:before{content:\"\\F26A\"}.ion-bluetooth:before{content:\"\\F116\"}.ion-bonfire:before{content:\"\\F315\"}.ion-bookmark:before{content:\"\\F26B\"}.ion-bowtie:before{content:\"\\F3C0\"}.ion-briefcase:before{content:\"\\F26C\"}.ion-bug:before{content:\"\\F2BE\"}.ion-calculator:before{content:\"\\F26D\"}.ion-calendar:before{content:\"\\F117\"}.ion-camera:before{content:\"\\F118\"}.ion-card:before{content:\"\\F119\"}.ion-cash:before{content:\"\\F316\"}.ion-chatbox:before{content:\"\\F11B\"}.ion-chatbox-working:before{content:\"\\F11A\"}.ion-chatboxes:before{content:\"\\F11C\"}.ion-chatbubble:before{content:\"\\F11E\"}.ion-chatbubble-working:before{content:\"\\F11D\"}.ion-chatbubbles:before{content:\"\\F11F\"}.ion-checkmark:before{content:\"\\F122\"}.ion-checkmark-circled:before{content:\"\\F120\"}.ion-checkmark-round:before{content:\"\\F121\"}.ion-chevron-down:before{content:\"\\F123\"}.ion-chevron-left:before{content:\"\\F124\"}.ion-chevron-right:before{content:\"\\F125\"}.ion-chevron-up:before{content:\"\\F126\"}.ion-clipboard:before{content:\"\\F127\"}.ion-clock:before{content:\"\\F26E\"}.ion-close:before{content:\"\\F12A\"}.ion-close-circled:before{content:\"\\F128\"}.ion-close-round:before{content:\"\\F129\"}.ion-closed-captioning:before{content:\"\\F317\"}.ion-cloud:before{content:\"\\F12B\"}.ion-code:before{content:\"\\F271\"}.ion-code-download:before{content:\"\\F26F\"}.ion-code-working:before{content:\"\\F270\"}.ion-coffee:before{content:\"\\F272\"}.ion-compass:before{content:\"\\F273\"}.ion-compose:before{content:\"\\F12C\"}.ion-connection-bars:before{content:\"\\F274\"}.ion-contrast:before{content:\"\\F275\"}.ion-crop:before{content:\"\\F3C1\"}.ion-cube:before{content:\"\\F318\"}.ion-disc:before{content:\"\\F12D\"}.ion-document:before{content:\"\\F12F\"}.ion-document-text:before{content:\"\\F12E\"}.ion-drag:before{content:\"\\F130\"}.ion-earth:before{content:\"\\F276\"}.ion-easel:before{content:\"\\F3C2\"}.ion-edit:before{content:\"\\F2BF\"}.ion-egg:before{content:\"\\F277\"}.ion-eject:before{content:\"\\F131\"}.ion-email:before{content:\"\\F132\"}.ion-email-unread:before{content:\"\\F3C3\"}.ion-erlenmeyer-flask:before{content:\"\\F3C5\"}.ion-erlenmeyer-flask-bubbles:before{content:\"\\F3C4\"}.ion-eye:before{content:\"\\F133\"}.ion-eye-disabled:before{content:\"\\F306\"}.ion-female:before{content:\"\\F278\"}.ion-filing:before{content:\"\\F134\"}.ion-film-marker:before{content:\"\\F135\"}.ion-fireball:before{content:\"\\F319\"}.ion-flag:before{content:\"\\F279\"}.ion-flame:before{content:\"\\F31A\"}.ion-flash:before{content:\"\\F137\"}.ion-flash-off:before{content:\"\\F136\"}.ion-folder:before{content:\"\\F139\"}.ion-fork:before{content:\"\\F27A\"}.ion-fork-repo:before{content:\"\\F2C0\"}.ion-forward:before{content:\"\\F13A\"}.ion-funnel:before{content:\"\\F31B\"}.ion-gear-a:before{content:\"\\F13D\"}.ion-gear-b:before{content:\"\\F13E\"}.ion-grid:before{content:\"\\F13F\"}.ion-hammer:before{content:\"\\F27B\"}.ion-happy:before{content:\"\\F31C\"}.ion-happy-outline:before{content:\"\\F3C6\"}.ion-headphone:before{content:\"\\F140\"}.ion-heart:before{content:\"\\F141\"}.ion-heart-broken:before{content:\"\\F31D\"}.ion-help:before{content:\"\\F143\"}.ion-help-buoy:before{content:\"\\F27C\"}.ion-help-circled:before{content:\"\\F142\"}.ion-home:before{content:\"\\F144\"}.ion-icecream:before{content:\"\\F27D\"}.ion-image:before{content:\"\\F147\"}.ion-images:before{content:\"\\F148\"}.ion-information:before{content:\"\\F14A\"}.ion-information-circled:before{content:\"\\F149\"}.ion-ionic:before{content:\"\\F14B\"}.ion-ios-alarm:before{content:\"\\F3C8\"}.ion-ios-alarm-outline:before{content:\"\\F3C7\"}.ion-ios-albums:before{content:\"\\F3CA\"}.ion-ios-albums-outline:before{content:\"\\F3C9\"}.ion-ios-americanfootball:before{content:\"\\F3CC\"}.ion-ios-americanfootball-outline:before{content:\"\\F3CB\"}.ion-ios-analytics:before{content:\"\\F3CE\"}.ion-ios-analytics-outline:before{content:\"\\F3CD\"}.ion-ios-arrow-back:before{content:\"\\F3CF\"}.ion-ios-arrow-down:before{content:\"\\F3D0\"}.ion-ios-arrow-forward:before{content:\"\\F3D1\"}.ion-ios-arrow-left:before{content:\"\\F3D2\"}.ion-ios-arrow-right:before{content:\"\\F3D3\"}.ion-ios-arrow-thin-down:before{content:\"\\F3D4\"}.ion-ios-arrow-thin-left:before{content:\"\\F3D5\"}.ion-ios-arrow-thin-right:before{content:\"\\F3D6\"}.ion-ios-arrow-thin-up:before{content:\"\\F3D7\"}.ion-ios-arrow-up:before{content:\"\\F3D8\"}.ion-ios-at:before{content:\"\\F3DA\"}.ion-ios-at-outline:before{content:\"\\F3D9\"}.ion-ios-barcode:before{content:\"\\F3DC\"}.ion-ios-barcode-outline:before{content:\"\\F3DB\"}.ion-ios-baseball:before{content:\"\\F3DE\"}.ion-ios-baseball-outline:before{content:\"\\F3DD\"}.ion-ios-basketball:before{content:\"\\F3E0\"}.ion-ios-basketball-outline:before{content:\"\\F3DF\"}.ion-ios-bell:before{content:\"\\F3E2\"}.ion-ios-bell-outline:before{content:\"\\F3E1\"}.ion-ios-body:before{content:\"\\F3E4\"}.ion-ios-body-outline:before{content:\"\\F3E3\"}.ion-ios-bolt:before{content:\"\\F3E6\"}.ion-ios-bolt-outline:before{content:\"\\F3E5\"}.ion-ios-book:before{content:\"\\F3E8\"}.ion-ios-book-outline:before{content:\"\\F3E7\"}.ion-ios-bookmarks:before{content:\"\\F3EA\"}.ion-ios-bookmarks-outline:before{content:\"\\F3E9\"}.ion-ios-box:before{content:\"\\F3EC\"}.ion-ios-box-outline:before{content:\"\\F3EB\"}.ion-ios-briefcase:before{content:\"\\F3EE\"}.ion-ios-briefcase-outline:before{content:\"\\F3ED\"}.ion-ios-browsers:before{content:\"\\F3F0\"}.ion-ios-browsers-outline:before{content:\"\\F3EF\"}.ion-ios-calculator:before{content:\"\\F3F2\"}.ion-ios-calculator-outline:before{content:\"\\F3F1\"}.ion-ios-calendar:before{content:\"\\F3F4\"}.ion-ios-calendar-outline:before{content:\"\\F3F3\"}.ion-ios-camera:before{content:\"\\F3F6\"}.ion-ios-camera-outline:before{content:\"\\F3F5\"}.ion-ios-cart:before{content:\"\\F3F8\"}.ion-ios-cart-outline:before{content:\"\\F3F7\"}.ion-ios-chatboxes:before{content:\"\\F3FA\"}.ion-ios-chatboxes-outline:before{content:\"\\F3F9\"}.ion-ios-chatbubble:before{content:\"\\F3FC\"}.ion-ios-chatbubble-outline:before{content:\"\\F3FB\"}.ion-ios-checkmark:before{content:\"\\F3FF\"}.ion-ios-checkmark-empty:before{content:\"\\F3FD\"}.ion-ios-checkmark-outline:before{content:\"\\F3FE\"}.ion-ios-circle-filled:before{content:\"\\F400\"}.ion-ios-circle-outline:before{content:\"\\F401\"}.ion-ios-clock:before{content:\"\\F403\"}.ion-ios-clock-outline:before{content:\"\\F402\"}.ion-ios-close:before{content:\"\\F406\"}.ion-ios-close-empty:before{content:\"\\F404\"}.ion-ios-close-outline:before{content:\"\\F405\"}.ion-ios-cloud:before{content:\"\\F40C\"}.ion-ios-cloud-download:before{content:\"\\F408\"}.ion-ios-cloud-download-outline:before{content:\"\\F407\"}.ion-ios-cloud-outline:before{content:\"\\F409\"}.ion-ios-cloud-upload:before{content:\"\\F40B\"}.ion-ios-cloud-upload-outline:before{content:\"\\F40A\"}.ion-ios-cloudy:before{content:\"\\F410\"}.ion-ios-cloudy-night:before{content:\"\\F40E\"}.ion-ios-cloudy-night-outline:before{content:\"\\F40D\"}.ion-ios-cloudy-outline:before{content:\"\\F40F\"}.ion-ios-cog:before{content:\"\\F412\"}.ion-ios-cog-outline:before{content:\"\\F411\"}.ion-ios-color-filter:before{content:\"\\F414\"}.ion-ios-color-filter-outline:before{content:\"\\F413\"}.ion-ios-color-wand:before{content:\"\\F416\"}.ion-ios-color-wand-outline:before{content:\"\\F415\"}.ion-ios-compose:before{content:\"\\F418\"}.ion-ios-compose-outline:before{content:\"\\F417\"}.ion-ios-contact:before{content:\"\\F41A\"}.ion-ios-contact-outline:before{content:\"\\F419\"}.ion-ios-copy:before{content:\"\\F41C\"}.ion-ios-copy-outline:before{content:\"\\F41B\"}.ion-ios-crop:before{content:\"\\F41E\"}.ion-ios-crop-strong:before{content:\"\\F41D\"}.ion-ios-download:before{content:\"\\F420\"}.ion-ios-download-outline:before{content:\"\\F41F\"}.ion-ios-drag:before{content:\"\\F421\"}.ion-ios-email:before{content:\"\\F423\"}.ion-ios-email-outline:before{content:\"\\F422\"}.ion-ios-eye:before{content:\"\\F425\"}.ion-ios-eye-outline:before{content:\"\\F424\"}.ion-ios-fastforward:before{content:\"\\F427\"}.ion-ios-fastforward-outline:before{content:\"\\F426\"}.ion-ios-filing:before{content:\"\\F429\"}.ion-ios-filing-outline:before{content:\"\\F428\"}.ion-ios-film:before{content:\"\\F42B\"}.ion-ios-film-outline:before{content:\"\\F42A\"}.ion-ios-flag:before{content:\"\\F42D\"}.ion-ios-flag-outline:before{content:\"\\F42C\"}.ion-ios-flame:before{content:\"\\F42F\"}.ion-ios-flame-outline:before{content:\"\\F42E\"}.ion-ios-flask:before{content:\"\\F431\"}.ion-ios-flask-outline:before{content:\"\\F430\"}.ion-ios-flower:before{content:\"\\F433\"}.ion-ios-flower-outline:before{content:\"\\F432\"}.ion-ios-folder:before{content:\"\\F435\"}.ion-ios-folder-outline:before{content:\"\\F434\"}.ion-ios-football:before{content:\"\\F437\"}.ion-ios-football-outline:before{content:\"\\F436\"}.ion-ios-game-controller-a:before{content:\"\\F439\"}.ion-ios-game-controller-a-outline:before{content:\"\\F438\"}.ion-ios-game-controller-b:before{content:\"\\F43B\"}.ion-ios-game-controller-b-outline:before{content:\"\\F43A\"}.ion-ios-gear:before{content:\"\\F43D\"}.ion-ios-gear-outline:before{content:\"\\F43C\"}.ion-ios-glasses:before{content:\"\\F43F\"}.ion-ios-glasses-outline:before{content:\"\\F43E\"}.ion-ios-grid-view:before{content:\"\\F441\"}.ion-ios-grid-view-outline:before{content:\"\\F440\"}.ion-ios-heart:before{content:\"\\F443\"}.ion-ios-heart-outline:before{content:\"\\F442\"}.ion-ios-help:before{content:\"\\F446\"}.ion-ios-help-empty:before{content:\"\\F444\"}.ion-ios-help-outline:before{content:\"\\F445\"}.ion-ios-home:before{content:\"\\F448\"}.ion-ios-home-outline:before{content:\"\\F447\"}.ion-ios-infinite:before{content:\"\\F44A\"}.ion-ios-infinite-outline:before{content:\"\\F449\"}.ion-ios-information:before{content:\"\\F44D\"}.ion-ios-information-empty:before{content:\"\\F44B\"}.ion-ios-information-outline:before{content:\"\\F44C\"}.ion-ios-ionic-outline:before{content:\"\\F44E\"}.ion-ios-keypad:before{content:\"\\F450\"}.ion-ios-keypad-outline:before{content:\"\\F44F\"}.ion-ios-lightbulb:before{content:\"\\F452\"}.ion-ios-lightbulb-outline:before{content:\"\\F451\"}.ion-ios-list:before{content:\"\\F454\"}.ion-ios-list-outline:before{content:\"\\F453\"}.ion-ios-location:before{content:\"\\F456\"}.ion-ios-location-outline:before{content:\"\\F455\"}.ion-ios-locked:before{content:\"\\F458\"}.ion-ios-locked-outline:before{content:\"\\F457\"}.ion-ios-loop:before{content:\"\\F45A\"}.ion-ios-loop-strong:before{content:\"\\F459\"}.ion-ios-medical:before{content:\"\\F45C\"}.ion-ios-medical-outline:before{content:\"\\F45B\"}.ion-ios-medkit:before{content:\"\\F45E\"}.ion-ios-medkit-outline:before{content:\"\\F45D\"}.ion-ios-mic:before{content:\"\\F461\"}.ion-ios-mic-off:before{content:\"\\F45F\"}.ion-ios-mic-outline:before{content:\"\\F460\"}.ion-ios-minus:before{content:\"\\F464\"}.ion-ios-minus-empty:before{content:\"\\F462\"}.ion-ios-minus-outline:before{content:\"\\F463\"}.ion-ios-monitor:before{content:\"\\F466\"}.ion-ios-monitor-outline:before{content:\"\\F465\"}.ion-ios-moon:before{content:\"\\F468\"}.ion-ios-moon-outline:before{content:\"\\F467\"}.ion-ios-more:before{content:\"\\F46A\"}.ion-ios-more-outline:before{content:\"\\F469\"}.ion-ios-musical-note:before{content:\"\\F46B\"}.ion-ios-musical-notes:before{content:\"\\F46C\"}.ion-ios-navigate:before{content:\"\\F46E\"}.ion-ios-navigate-outline:before{content:\"\\F46D\"}.ion-ios-nutrition:before{content:\"\\F470\"}.ion-ios-nutrition-outline:before{content:\"\\F46F\"}.ion-ios-paper:before{content:\"\\F472\"}.ion-ios-paper-outline:before{content:\"\\F471\"}.ion-ios-paperplane:before{content:\"\\F474\"}.ion-ios-paperplane-outline:before{content:\"\\F473\"}.ion-ios-partlysunny:before{content:\"\\F476\"}.ion-ios-partlysunny-outline:before{content:\"\\F475\"}.ion-ios-pause:before{content:\"\\F478\"}.ion-ios-pause-outline:before{content:\"\\F477\"}.ion-ios-paw:before{content:\"\\F47A\"}.ion-ios-paw-outline:before{content:\"\\F479\"}.ion-ios-people:before{content:\"\\F47C\"}.ion-ios-people-outline:before{content:\"\\F47B\"}.ion-ios-person:before{content:\"\\F47E\"}.ion-ios-person-outline:before{content:\"\\F47D\"}.ion-ios-personadd:before{content:\"\\F480\"}.ion-ios-personadd-outline:before{content:\"\\F47F\"}.ion-ios-photos:before{content:\"\\F482\"}.ion-ios-photos-outline:before{content:\"\\F481\"}.ion-ios-pie:before{content:\"\\F484\"}.ion-ios-pie-outline:before{content:\"\\F483\"}.ion-ios-pint:before{content:\"\\F486\"}.ion-ios-pint-outline:before{content:\"\\F485\"}.ion-ios-play:before{content:\"\\F488\"}.ion-ios-play-outline:before{content:\"\\F487\"}.ion-ios-plus:before{content:\"\\F48B\"}.ion-ios-plus-empty:before{content:\"\\F489\"}.ion-ios-plus-outline:before{content:\"\\F48A\"}.ion-ios-pricetag:before{content:\"\\F48D\"}.ion-ios-pricetag-outline:before{content:\"\\F48C\"}.ion-ios-pricetags:before{content:\"\\F48F\"}.ion-ios-pricetags-outline:before{content:\"\\F48E\"}.ion-ios-printer:before{content:\"\\F491\"}.ion-ios-printer-outline:before{content:\"\\F490\"}.ion-ios-pulse:before{content:\"\\F493\"}.ion-ios-pulse-strong:before{content:\"\\F492\"}.ion-ios-rainy:before{content:\"\\F495\"}.ion-ios-rainy-outline:before{content:\"\\F494\"}.ion-ios-recording:before{content:\"\\F497\"}.ion-ios-recording-outline:before{content:\"\\F496\"}.ion-ios-redo:before{content:\"\\F499\"}.ion-ios-redo-outline:before{content:\"\\F498\"}.ion-ios-refresh:before{content:\"\\F49C\"}.ion-ios-refresh-empty:before{content:\"\\F49A\"}.ion-ios-refresh-outline:before{content:\"\\F49B\"}.ion-ios-reload:before{content:\"\\F49D\"}.ion-ios-reverse-camera:before{content:\"\\F49F\"}.ion-ios-reverse-camera-outline:before{content:\"\\F49E\"}.ion-ios-rewind:before{content:\"\\F4A1\"}.ion-ios-rewind-outline:before{content:\"\\F4A0\"}.ion-ios-rose:before{content:\"\\F4A3\"}.ion-ios-rose-outline:before{content:\"\\F4A2\"}.ion-ios-search:before{content:\"\\F4A5\"}.ion-ios-search-strong:before{content:\"\\F4A4\"}.ion-ios-settings:before{content:\"\\F4A7\"}.ion-ios-settings-strong:before{content:\"\\F4A6\"}.ion-ios-shuffle:before{content:\"\\F4A9\"}.ion-ios-shuffle-strong:before{content:\"\\F4A8\"}.ion-ios-skipbackward:before{content:\"\\F4AB\"}.ion-ios-skipbackward-outline:before{content:\"\\F4AA\"}.ion-ios-skipforward:before{content:\"\\F4AD\"}.ion-ios-skipforward-outline:before{content:\"\\F4AC\"}.ion-ios-snowy:before{content:\"\\F4AE\"}.ion-ios-speedometer:before{content:\"\\F4B0\"}.ion-ios-speedometer-outline:before{content:\"\\F4AF\"}.ion-ios-star:before{content:\"\\F4B3\"}.ion-ios-star-half:before{content:\"\\F4B1\"}.ion-ios-star-outline:before{content:\"\\F4B2\"}.ion-ios-stopwatch:before{content:\"\\F4B5\"}.ion-ios-stopwatch-outline:before{content:\"\\F4B4\"}.ion-ios-sunny:before{content:\"\\F4B7\"}.ion-ios-sunny-outline:before{content:\"\\F4B6\"}.ion-ios-telephone:before{content:\"\\F4B9\"}.ion-ios-telephone-outline:before{content:\"\\F4B8\"}.ion-ios-tennisball:before{content:\"\\F4BB\"}.ion-ios-tennisball-outline:before{content:\"\\F4BA\"}.ion-ios-thunderstorm:before{content:\"\\F4BD\"}.ion-ios-thunderstorm-outline:before{content:\"\\F4BC\"}.ion-ios-time:before{content:\"\\F4BF\"}.ion-ios-time-outline:before{content:\"\\F4BE\"}.ion-ios-timer:before{content:\"\\F4C1\"}.ion-ios-timer-outline:before{content:\"\\F4C0\"}.ion-ios-toggle:before{content:\"\\F4C3\"}.ion-ios-toggle-outline:before{content:\"\\F4C2\"}.ion-ios-trash:before{content:\"\\F4C5\"}.ion-ios-trash-outline:before{content:\"\\F4C4\"}.ion-ios-undo:before{content:\"\\F4C7\"}.ion-ios-undo-outline:before{content:\"\\F4C6\"}.ion-ios-unlocked:before{content:\"\\F4C9\"}.ion-ios-unlocked-outline:before{content:\"\\F4C8\"}.ion-ios-upload:before{content:\"\\F4CB\"}.ion-ios-upload-outline:before{content:\"\\F4CA\"}.ion-ios-videocam:before{content:\"\\F4CD\"}.ion-ios-videocam-outline:before{content:\"\\F4CC\"}.ion-ios-volume-high:before{content:\"\\F4CE\"}.ion-ios-volume-low:before{content:\"\\F4CF\"}.ion-ios-wineglass:before{content:\"\\F4D1\"}.ion-ios-wineglass-outline:before{content:\"\\F4D0\"}.ion-ios-world:before{content:\"\\F4D3\"}.ion-ios-world-outline:before{content:\"\\F4D2\"}.ion-ipad:before{content:\"\\F1F9\"}.ion-iphone:before{content:\"\\F1FA\"}.ion-ipod:before{content:\"\\F1FB\"}.ion-jet:before{content:\"\\F295\"}.ion-key:before{content:\"\\F296\"}.ion-knife:before{content:\"\\F297\"}.ion-laptop:before{content:\"\\F1FC\"}.ion-leaf:before{content:\"\\F1FD\"}.ion-levels:before{content:\"\\F298\"}.ion-lightbulb:before{content:\"\\F299\"}.ion-link:before{content:\"\\F1FE\"}.ion-load-a:before{content:\"\\F29A\"}.ion-load-b:before{content:\"\\F29B\"}.ion-load-c:before{content:\"\\F29C\"}.ion-load-d:before{content:\"\\F29D\"}.ion-location:before{content:\"\\F1FF\"}.ion-lock-combination:before{content:\"\\F4D4\"}.ion-locked:before{content:\"\\F200\"}.ion-log-in:before{content:\"\\F29E\"}.ion-log-out:before{content:\"\\F29F\"}.ion-loop:before{content:\"\\F201\"}.ion-magnet:before{content:\"\\F2A0\"}.ion-male:before{content:\"\\F2A1\"}.ion-man:before{content:\"\\F202\"}.ion-map:before{content:\"\\F203\"}.ion-medkit:before{content:\"\\F2A2\"}.ion-merge:before{content:\"\\F33F\"}.ion-mic-a:before{content:\"\\F204\"}.ion-mic-b:before{content:\"\\F205\"}.ion-mic-c:before{content:\"\\F206\"}.ion-minus:before{content:\"\\F209\"}.ion-minus-circled:before{content:\"\\F207\"}.ion-minus-round:before{content:\"\\F208\"}.ion-model-s:before{content:\"\\F2C1\"}.ion-monitor:before{content:\"\\F20A\"}.ion-more:before{content:\"\\F20B\"}.ion-mouse:before{content:\"\\F340\"}.ion-music-note:before{content:\"\\F20C\"}.ion-navicon:before{content:\"\\F20E\"}.ion-navicon-round:before{content:\"\\F20D\"}.ion-navigate:before{content:\"\\F2A3\"}.ion-network:before{content:\"\\F341\"}.ion-no-smoking:before{content:\"\\F2C2\"}.ion-nuclear:before{content:\"\\F2A4\"}.ion-outlet:before{content:\"\\F342\"}.ion-paintbrush:before{content:\"\\F4D5\"}.ion-paintbucket:before{content:\"\\F4D6\"}.ion-paper-airplane:before{content:\"\\F2C3\"}.ion-paperclip:before{content:\"\\F20F\"}.ion-pause:before{content:\"\\F210\"}.ion-person:before{content:\"\\F213\"}.ion-person-add:before{content:\"\\F211\"}.ion-person-stalker:before{content:\"\\F212\"}.ion-pie-graph:before{content:\"\\F2A5\"}.ion-pin:before{content:\"\\F2A6\"}.ion-pinpoint:before{content:\"\\F2A7\"}.ion-pizza:before{content:\"\\F2A8\"}.ion-plane:before{content:\"\\F214\"}.ion-planet:before{content:\"\\F343\"}.ion-play:before{content:\"\\F215\"}.ion-playstation:before{content:\"\\F30A\"}.ion-plus:before{content:\"\\F218\"}.ion-plus-circled:before{content:\"\\F216\"}.ion-plus-round:before{content:\"\\F217\"}.ion-podium:before{content:\"\\F344\"}.ion-pound:before{content:\"\\F219\"}.ion-power:before{content:\"\\F2A9\"}.ion-pricetag:before{content:\"\\F2AA\"}.ion-pricetags:before{content:\"\\F2AB\"}.ion-printer:before{content:\"\\F21A\"}.ion-pull-request:before{content:\"\\F345\"}.ion-qr-scanner:before{content:\"\\F346\"}.ion-quote:before{content:\"\\F347\"}.ion-radio-waves:before{content:\"\\F2AC\"}.ion-record:before{content:\"\\F21B\"}.ion-refresh:before{content:\"\\F21C\"}.ion-reply:before{content:\"\\F21E\"}.ion-reply-all:before{content:\"\\F21D\"}.ion-ribbon-a:before{content:\"\\F348\"}.ion-ribbon-b:before{content:\"\\F349\"}.ion-sad:before{content:\"\\F34A\"}.ion-sad-outline:before{content:\"\\F4D7\"}.ion-scissors:before{content:\"\\F34B\"}.ion-search:before{content:\"\\F21F\"}.ion-settings:before{content:\"\\F2AD\"}.ion-share:before{content:\"\\F220\"}.ion-shuffle:before{content:\"\\F221\"}.ion-skip-backward:before{content:\"\\F222\"}.ion-skip-forward:before{content:\"\\F223\"}.ion-social-android:before{content:\"\\F225\"}.ion-social-android-outline:before{content:\"\\F224\"}.ion-social-angular:before{content:\"\\F4D9\"}.ion-social-angular-outline:before{content:\"\\F4D8\"}.ion-social-apple:before{content:\"\\F227\"}.ion-social-apple-outline:before{content:\"\\F226\"}.ion-social-bitcoin:before{content:\"\\F2AF\"}.ion-social-bitcoin-outline:before{content:\"\\F2AE\"}.ion-social-buffer:before{content:\"\\F229\"}.ion-social-buffer-outline:before{content:\"\\F228\"}.ion-social-chrome:before{content:\"\\F4DB\"}.ion-social-chrome-outline:before{content:\"\\F4DA\"}.ion-social-codepen:before{content:\"\\F4DD\"}.ion-social-codepen-outline:before{content:\"\\F4DC\"}.ion-social-css3:before{content:\"\\F4DF\"}.ion-social-css3-outline:before{content:\"\\F4DE\"}.ion-social-designernews:before{content:\"\\F22B\"}.ion-social-designernews-outline:before{content:\"\\F22A\"}.ion-social-dribbble:before{content:\"\\F22D\"}.ion-social-dribbble-outline:before{content:\"\\F22C\"}.ion-social-dropbox:before{content:\"\\F22F\"}.ion-social-dropbox-outline:before{content:\"\\F22E\"}.ion-social-euro:before{content:\"\\F4E1\"}.ion-social-euro-outline:before{content:\"\\F4E0\"}.ion-social-facebook:before{content:\"\\F231\"}.ion-social-facebook-outline:before{content:\"\\F230\"}.ion-social-foursquare:before{content:\"\\F34D\"}.ion-social-foursquare-outline:before{content:\"\\F34C\"}.ion-social-freebsd-devil:before{content:\"\\F2C4\"}.ion-social-github:before{content:\"\\F233\"}.ion-social-github-outline:before{content:\"\\F232\"}.ion-social-google:before{content:\"\\F34F\"}.ion-social-google-outline:before{content:\"\\F34E\"}.ion-social-googleplus:before{content:\"\\F235\"}.ion-social-googleplus-outline:before{content:\"\\F234\"}.ion-social-hackernews:before{content:\"\\F237\"}.ion-social-hackernews-outline:before{content:\"\\F236\"}.ion-social-html5:before{content:\"\\F4E3\"}.ion-social-html5-outline:before{content:\"\\F4E2\"}.ion-social-instagram:before{content:\"\\F351\"}.ion-social-instagram-outline:before{content:\"\\F350\"}.ion-social-javascript:before{content:\"\\F4E5\"}.ion-social-javascript-outline:before{content:\"\\F4E4\"}.ion-social-linkedin:before{content:\"\\F239\"}.ion-social-linkedin-outline:before{content:\"\\F238\"}.ion-social-markdown:before{content:\"\\F4E6\"}.ion-social-nodejs:before{content:\"\\F4E7\"}.ion-social-octocat:before{content:\"\\F4E8\"}.ion-social-pinterest:before{content:\"\\F2B1\"}.ion-social-pinterest-outline:before{content:\"\\F2B0\"}.ion-social-python:before{content:\"\\F4E9\"}.ion-social-reddit:before{content:\"\\F23B\"}.ion-social-reddit-outline:before{content:\"\\F23A\"}.ion-social-rss:before{content:\"\\F23D\"}.ion-social-rss-outline:before{content:\"\\F23C\"}.ion-social-sass:before{content:\"\\F4EA\"}.ion-social-skype:before{content:\"\\F23F\"}.ion-social-skype-outline:before{content:\"\\F23E\"}.ion-social-snapchat:before{content:\"\\F4EC\"}.ion-social-snapchat-outline:before{content:\"\\F4EB\"}.ion-social-tumblr:before{content:\"\\F241\"}.ion-social-tumblr-outline:before{content:\"\\F240\"}.ion-social-tux:before{content:\"\\F2C5\"}.ion-social-twitch:before{content:\"\\F4EE\"}.ion-social-twitch-outline:before{content:\"\\F4ED\"}.ion-social-twitter:before{content:\"\\F243\"}.ion-social-twitter-outline:before{content:\"\\F242\"}.ion-social-usd:before{content:\"\\F353\"}.ion-social-usd-outline:before{content:\"\\F352\"}.ion-social-vimeo:before{content:\"\\F245\"}.ion-social-vimeo-outline:before{content:\"\\F244\"}.ion-social-whatsapp:before{content:\"\\F4F0\"}.ion-social-whatsapp-outline:before{content:\"\\F4EF\"}.ion-social-windows:before{content:\"\\F247\"}.ion-social-windows-outline:before{content:\"\\F246\"}.ion-social-wordpress:before{content:\"\\F249\"}.ion-social-wordpress-outline:before{content:\"\\F248\"}.ion-social-yahoo:before{content:\"\\F24B\"}.ion-social-yahoo-outline:before{content:\"\\F24A\"}.ion-social-yen:before{content:\"\\F4F2\"}.ion-social-yen-outline:before{content:\"\\F4F1\"}.ion-social-youtube:before{content:\"\\F24D\"}.ion-social-youtube-outline:before{content:\"\\F24C\"}.ion-soup-can:before{content:\"\\F4F4\"}.ion-soup-can-outline:before{content:\"\\F4F3\"}.ion-speakerphone:before{content:\"\\F2B2\"}.ion-speedometer:before{content:\"\\F2B3\"}.ion-spoon:before{content:\"\\F2B4\"}.ion-star:before{content:\"\\F24E\"}.ion-stats-bars:before{content:\"\\F2B5\"}.ion-steam:before{content:\"\\F30B\"}.ion-stop:before{content:\"\\F24F\"}.ion-thermometer:before{content:\"\\F2B6\"}.ion-thumbsdown:before{content:\"\\F250\"}.ion-thumbsup:before{content:\"\\F251\"}.ion-toggle:before{content:\"\\F355\"}.ion-toggle-filled:before{content:\"\\F354\"}.ion-transgender:before{content:\"\\F4F5\"}.ion-trash-a:before{content:\"\\F252\"}.ion-trash-b:before{content:\"\\F253\"}.ion-trophy:before{content:\"\\F356\"}.ion-tshirt:before{content:\"\\F4F7\"}.ion-tshirt-outline:before{content:\"\\F4F6\"}.ion-umbrella:before{content:\"\\F2B7\"}.ion-university:before{content:\"\\F357\"}.ion-unlocked:before{content:\"\\F254\"}.ion-upload:before{content:\"\\F255\"}.ion-usb:before{content:\"\\F2B8\"}.ion-videocamera:before{content:\"\\F256\"}.ion-volume-high:before{content:\"\\F257\"}.ion-volume-low:before{content:\"\\F258\"}.ion-volume-medium:before{content:\"\\F259\"}.ion-volume-mute:before{content:\"\\F25A\"}.ion-wand:before{content:\"\\F358\"}.ion-waterdrop:before{content:\"\\F25B\"}.ion-wifi:before{content:\"\\F25C\"}.ion-wineglass:before{content:\"\\F2B9\"}.ion-woman:before{content:\"\\F25D\"}.ion-wrench:before{content:\"\\F2BA\"}.ion-xbox:before{content:\"\\F30C\"}", ""]);

	// exports


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "24712f6c47821394fba7942fbb52c3b2.ttf";

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2c2ae068be3b089e0a5b59abb1831550.eot";

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "05acfdb568b3df49ad31355b19495d4a.woff";

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "621bd386841f74e0053cb8e67f8a0604.svg";

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(79);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/lib/loader.js!./obt-skin.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/sass-loader/lib/loader.js!./obt-skin.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Bangers|Special+Elite);", ""]);

	// module
	exports.push([module.id, ".obt-base body,.skin-BubleGum body,.skin-Camarone body,.skin-Cascade body,.skin-Coral body,.skin-Heliotrope body,.skin-JungleGreen body,.skin-Lima body,.skin-MilanoRed body,.skin-Patina body,.skin-pelorous body,.skin-Puce body,.skin-SchoolBusYellow body,.skin-simplifystack body,.skin-skyBlue body{font-family:Open Sans,sans-serif}.obt-base .h1,.obt-base .h2 h3,.obt-base .h3,.obt-base .h4,.obt-base .h5,.obt-base .h6,.obt-base h1,.obt-base h2,.obt-base h4,.obt-base h5,.obt-base h6,.skin-BubleGum .h1,.skin-BubleGum .h2 h3,.skin-BubleGum .h3,.skin-BubleGum .h4,.skin-BubleGum .h5,.skin-BubleGum .h6,.skin-BubleGum h1,.skin-BubleGum h2,.skin-BubleGum h4,.skin-BubleGum h5,.skin-BubleGum h6,.skin-Camarone .h1,.skin-Camarone .h2 h3,.skin-Camarone .h3,.skin-Camarone .h4,.skin-Camarone .h5,.skin-Camarone .h6,.skin-Camarone h1,.skin-Camarone h2,.skin-Camarone h4,.skin-Camarone h5,.skin-Camarone h6,.skin-Cascade .h1,.skin-Cascade .h2 h3,.skin-Cascade .h3,.skin-Cascade .h4,.skin-Cascade .h5,.skin-Cascade .h6,.skin-Cascade h1,.skin-Cascade h2,.skin-Cascade h4,.skin-Cascade h5,.skin-Cascade h6,.skin-Coral .h1,.skin-Coral .h2 h3,.skin-Coral .h3,.skin-Coral .h4,.skin-Coral .h5,.skin-Coral .h6,.skin-Coral h1,.skin-Coral h2,.skin-Coral h4,.skin-Coral h5,.skin-Coral h6,.skin-Heliotrope .h1,.skin-Heliotrope .h2 h3,.skin-Heliotrope .h3,.skin-Heliotrope .h4,.skin-Heliotrope .h5,.skin-Heliotrope .h6,.skin-Heliotrope h1,.skin-Heliotrope h2,.skin-Heliotrope h4,.skin-Heliotrope h5,.skin-Heliotrope h6,.skin-JungleGreen .h1,.skin-JungleGreen .h2 h3,.skin-JungleGreen .h3,.skin-JungleGreen .h4,.skin-JungleGreen .h5,.skin-JungleGreen .h6,.skin-JungleGreen h1,.skin-JungleGreen h2,.skin-JungleGreen h4,.skin-JungleGreen h5,.skin-JungleGreen h6,.skin-Lima .h1,.skin-Lima .h2 h3,.skin-Lima .h3,.skin-Lima .h4,.skin-Lima .h5,.skin-Lima .h6,.skin-Lima h1,.skin-Lima h2,.skin-Lima h4,.skin-Lima h5,.skin-Lima h6,.skin-MilanoRed .h1,.skin-MilanoRed .h2 h3,.skin-MilanoRed .h3,.skin-MilanoRed .h4,.skin-MilanoRed .h5,.skin-MilanoRed .h6,.skin-MilanoRed h1,.skin-MilanoRed h2,.skin-MilanoRed h4,.skin-MilanoRed h5,.skin-MilanoRed h6,.skin-Patina .h1,.skin-Patina .h2 h3,.skin-Patina .h3,.skin-Patina .h4,.skin-Patina .h5,.skin-Patina .h6,.skin-Patina h1,.skin-Patina h2,.skin-Patina h4,.skin-Patina h5,.skin-Patina h6,.skin-pelorous .h1,.skin-pelorous .h2 h3,.skin-pelorous .h3,.skin-pelorous .h4,.skin-pelorous .h5,.skin-pelorous .h6,.skin-pelorous h1,.skin-pelorous h2,.skin-pelorous h4,.skin-pelorous h5,.skin-pelorous h6,.skin-Puce .h1,.skin-Puce .h2 h3,.skin-Puce .h3,.skin-Puce .h4,.skin-Puce .h5,.skin-Puce .h6,.skin-Puce h1,.skin-Puce h2,.skin-Puce h4,.skin-Puce h5,.skin-Puce h6,.skin-SchoolBusYellow .h1,.skin-SchoolBusYellow .h2 h3,.skin-SchoolBusYellow .h3,.skin-SchoolBusYellow .h4,.skin-SchoolBusYellow .h5,.skin-SchoolBusYellow .h6,.skin-SchoolBusYellow h1,.skin-SchoolBusYellow h2,.skin-SchoolBusYellow h4,.skin-SchoolBusYellow h5,.skin-SchoolBusYellow h6,.skin-simplifystack .h1,.skin-simplifystack .h2 h3,.skin-simplifystack .h3,.skin-simplifystack .h4,.skin-simplifystack .h5,.skin-simplifystack .h6,.skin-simplifystack h1,.skin-simplifystack h2,.skin-simplifystack h4,.skin-simplifystack h5,.skin-simplifystack h6,.skin-skyBlue .h1,.skin-skyBlue .h2 h3,.skin-skyBlue .h3,.skin-skyBlue .h4,.skin-skyBlue .h5,.skin-skyBlue .h6,.skin-skyBlue h1,.skin-skyBlue h2,.skin-skyBlue h4,.skin-skyBlue h5,.skin-skyBlue h6{font-family:Arial,sans-serif}.obt-base .carousel-control>span,.skin-BubleGum .carousel-control>span,.skin-Camarone .carousel-control>span,.skin-Cascade .carousel-control>span,.skin-Coral .carousel-control>span,.skin-Heliotrope .carousel-control>span,.skin-JungleGreen .carousel-control>span,.skin-Lima .carousel-control>span,.skin-MilanoRed .carousel-control>span,.skin-Patina .carousel-control>span,.skin-pelorous .carousel-control>span,.skin-Puce .carousel-control>span,.skin-SchoolBusYellow .carousel-control>span,.skin-simplifystack .carousel-control>span,.skin-skyBlue .carousel-control>span{position:absolute;bottom:10px;top:auto}.obt-base .section-margin,.skin-BubleGum .section-margin,.skin-Camarone .section-margin,.skin-Cascade .section-margin,.skin-Coral .section-margin,.skin-Heliotrope .section-margin,.skin-JungleGreen .section-margin,.skin-Lima .section-margin,.skin-MilanoRed .section-margin,.skin-Patina .section-margin,.skin-pelorous .section-margin,.skin-Puce .section-margin,.skin-SchoolBusYellow .section-margin,.skin-simplifystack .section-margin,.skin-skyBlue .section-margin{padding:70px 0}.obt-base .main-header-margin,.skin-BubleGum .main-header-margin,.skin-Camarone .main-header-margin,.skin-Cascade .main-header-margin,.skin-Coral .main-header-margin,.skin-Heliotrope .main-header-margin,.skin-JungleGreen .main-header-margin,.skin-Lima .main-header-margin,.skin-MilanoRed .main-header-margin,.skin-Patina .main-header-margin,.skin-pelorous .main-header-margin,.skin-Puce .main-header-margin,.skin-SchoolBusYellow .main-header-margin,.skin-simplifystack .main-header-margin,.skin-skyBlue .main-header-margin{margin-bottom:50px}.obt-base .navbar-brand-btn,.skin-BubleGum .navbar-brand-btn,.skin-Camarone .navbar-brand-btn,.skin-Cascade .navbar-brand-btn,.skin-Coral .navbar-brand-btn,.skin-Heliotrope .navbar-brand-btn,.skin-JungleGreen .navbar-brand-btn,.skin-Lima .navbar-brand-btn,.skin-MilanoRed .navbar-brand-btn,.skin-Patina .navbar-brand-btn,.skin-pelorous .navbar-brand-btn,.skin-Puce .navbar-brand-btn,.skin-SchoolBusYellow .navbar-brand-btn,.skin-simplifystack .navbar-brand-btn,.skin-skyBlue .navbar-brand-btn{margin-left:15px}.obt-base .nav>li>a:focus,.skin-BubleGum .nav>li>a:focus,.skin-Camarone .nav>li>a:focus,.skin-Cascade .nav>li>a:focus,.skin-Coral .nav>li>a:focus,.skin-Heliotrope .nav>li>a:focus,.skin-JungleGreen .nav>li>a:focus,.skin-Lima .nav>li>a:focus,.skin-MilanoRed .nav>li>a:focus,.skin-Patina .nav>li>a:focus,.skin-pelorous .nav>li>a:focus,.skin-Puce .nav>li>a:focus,.skin-SchoolBusYellow .nav>li>a:focus,.skin-simplifystack .nav>li>a:focus,.skin-skyBlue .nav>li>a:focus{color:inherit;background:inherit}.obt-base .text-box-dark,.skin-BubleGum .text-box-dark,.skin-Camarone .text-box-dark,.skin-Cascade .text-box-dark,.skin-Coral .text-box-dark,.skin-Heliotrope .text-box-dark,.skin-JungleGreen .text-box-dark,.skin-Lima .text-box-dark,.skin-MilanoRed .text-box-dark,.skin-Patina .text-box-dark,.skin-pelorous .text-box-dark,.skin-Puce .text-box-dark,.skin-SchoolBusYellow .text-box-dark,.skin-simplifystack .text-box-dark,.skin-skyBlue .text-box-dark{background:rgba(0,0,0,.7);padding:8px}.obt-base .text-box-white,.skin-BubleGum .text-box-white,.skin-Camarone .text-box-white,.skin-Cascade .text-box-white,.skin-Coral .text-box-white,.skin-Heliotrope .text-box-white,.skin-JungleGreen .text-box-white,.skin-Lima .text-box-white,.skin-MilanoRed .text-box-white,.skin-Patina .text-box-white,.skin-pelorous .text-box-white,.skin-Puce .text-box-white,.skin-SchoolBusYellow .text-box-white,.skin-simplifystack .text-box-white,.skin-skyBlue .text-box-white{background:hsla(0,0%,100%,.7);padding:8px}.obt-base .text-blur-box,.skin-BubleGum .text-blur-box,.skin-Camarone .text-blur-box,.skin-Cascade .text-blur-box,.skin-Coral .text-blur-box,.skin-Heliotrope .text-blur-box,.skin-JungleGreen .text-blur-box,.skin-Lima .text-blur-box,.skin-MilanoRed .text-blur-box,.skin-Patina .text-blur-box,.skin-pelorous .text-blur-box,.skin-Puce .text-blur-box,.skin-SchoolBusYellow .text-blur-box,.skin-simplifystack .text-blur-box,.skin-skyBlue .text-blur-box{background:inherit;background-attachment:inherit}.obt-base .text-blur-box:before,.skin-BubleGum .text-blur-box:before,.skin-Camarone .text-blur-box:before,.skin-Cascade .text-blur-box:before,.skin-Coral .text-blur-box:before,.skin-Heliotrope .text-blur-box:before,.skin-JungleGreen .text-blur-box:before,.skin-Lima .text-blur-box:before,.skin-MilanoRed .text-blur-box:before,.skin-Patina .text-blur-box:before,.skin-pelorous .text-blur-box:before,.skin-Puce .text-blur-box:before,.skin-SchoolBusYellow .text-blur-box:before,.skin-simplifystack .text-blur-box:before,.skin-skyBlue .text-blur-box:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background:inherit;background-attachment:fixed;-webkit-filter:blur(10px);filter:blur(10px)}.obt-base .img-blur,.obt-base .text-blur-box>*,.skin-BubleGum .img-blur,.skin-BubleGum .text-blur-box>*,.skin-Camarone .img-blur,.skin-Camarone .text-blur-box>*,.skin-Cascade .img-blur,.skin-Cascade .text-blur-box>*,.skin-Coral .img-blur,.skin-Coral .text-blur-box>*,.skin-Heliotrope .img-blur,.skin-Heliotrope .text-blur-box>*,.skin-JungleGreen .img-blur,.skin-JungleGreen .text-blur-box>*,.skin-Lima .img-blur,.skin-Lima .text-blur-box>*,.skin-MilanoRed .img-blur,.skin-MilanoRed .text-blur-box>*,.skin-Patina .img-blur,.skin-Patina .text-blur-box>*,.skin-pelorous .img-blur,.skin-pelorous .text-blur-box>*,.skin-Puce .img-blur,.skin-Puce .text-blur-box>*,.skin-SchoolBusYellow .img-blur,.skin-SchoolBusYellow .text-blur-box>*,.skin-simplifystack .img-blur,.skin-simplifystack .text-blur-box>*,.skin-skyBlue .img-blur,.skin-skyBlue .text-blur-box>*{position:relative}.obt-base .img-blur:before,.skin-BubleGum .img-blur:before,.skin-Camarone .img-blur:before,.skin-Cascade .img-blur:before,.skin-Coral .img-blur:before,.skin-Heliotrope .img-blur:before,.skin-JungleGreen .img-blur:before,.skin-Lima .img-blur:before,.skin-MilanoRed .img-blur:before,.skin-Patina .img-blur:before,.skin-pelorous .img-blur:before,.skin-Puce .img-blur:before,.skin-SchoolBusYellow .img-blur:before,.skin-simplifystack .img-blur:before,.skin-skyBlue .img-blur:before{z-index:0;content:\"\";width:100%;display:block;height:100%;position:absolute;background:linear-gradient(rgba(0,0,0,.3),rgba(0,0,0,.3))}.obt-base .angular-google-map-container,.skin-BubleGum .angular-google-map-container,.skin-Camarone .angular-google-map-container,.skin-Cascade .angular-google-map-container,.skin-Coral .angular-google-map-container,.skin-Heliotrope .angular-google-map-container,.skin-JungleGreen .angular-google-map-container,.skin-Lima .angular-google-map-container,.skin-MilanoRed .angular-google-map-container,.skin-Patina .angular-google-map-container,.skin-pelorous .angular-google-map-container,.skin-Puce .angular-google-map-container,.skin-SchoolBusYellow .angular-google-map-container,.skin-simplifystack .angular-google-map-container,.skin-skyBlue .angular-google-map-container{height:400px}.obt-base .small-map .angular-google-map-container,.skin-BubleGum .small-map .angular-google-map-container,.skin-Camarone .small-map .angular-google-map-container,.skin-Cascade .small-map .angular-google-map-container,.skin-Coral .small-map .angular-google-map-container,.skin-Heliotrope .small-map .angular-google-map-container,.skin-JungleGreen .small-map .angular-google-map-container,.skin-Lima .small-map .angular-google-map-container,.skin-MilanoRed .small-map .angular-google-map-container,.skin-Patina .small-map .angular-google-map-container,.skin-pelorous .small-map .angular-google-map-container,.skin-Puce .small-map .angular-google-map-container,.skin-SchoolBusYellow .small-map .angular-google-map-container,.skin-simplifystack .small-map .angular-google-map-container,.skin-skyBlue .small-map .angular-google-map-container{height:300px}@media (min-width:768px){.obt-base .navbar>.container-fluid .navbar-brand,.obt-base .navbar>.container .navbar-brand,.skin-BubleGum .navbar>.container-fluid .navbar-brand,.skin-BubleGum .navbar>.container .navbar-brand,.skin-Camarone .navbar>.container-fluid .navbar-brand,.skin-Camarone .navbar>.container .navbar-brand,.skin-Cascade .navbar>.container-fluid .navbar-brand,.skin-Cascade .navbar>.container .navbar-brand,.skin-Coral .navbar>.container-fluid .navbar-brand,.skin-Coral .navbar>.container .navbar-brand,.skin-Heliotrope .navbar>.container-fluid .navbar-brand,.skin-Heliotrope .navbar>.container .navbar-brand,.skin-JungleGreen .navbar>.container-fluid .navbar-brand,.skin-JungleGreen .navbar>.container .navbar-brand,.skin-Lima .navbar>.container-fluid .navbar-brand,.skin-Lima .navbar>.container .navbar-brand,.skin-MilanoRed .navbar>.container-fluid .navbar-brand,.skin-MilanoRed .navbar>.container .navbar-brand,.skin-Patina .navbar>.container-fluid .navbar-brand,.skin-Patina .navbar>.container .navbar-brand,.skin-pelorous .navbar>.container-fluid .navbar-brand,.skin-pelorous .navbar>.container .navbar-brand,.skin-Puce .navbar>.container-fluid .navbar-brand,.skin-Puce .navbar>.container .navbar-brand,.skin-SchoolBusYellow .navbar>.container-fluid .navbar-brand,.skin-SchoolBusYellow .navbar>.container .navbar-brand,.skin-simplifystack .navbar>.container-fluid .navbar-brand,.skin-simplifystack .navbar>.container .navbar-brand,.skin-skyBlue .navbar>.container-fluid .navbar-brand,.skin-skyBlue .navbar>.container .navbar-brand{margin-left:0}}.skin-simplifystack .bg-light{background-color:#fff;color:#312f38}.skin-simplifystack .bg-light .btn-link,.skin-simplifystack .bg-light a{color:#312f38}.skin-simplifystack .bg-medium{background-color:#e9e9e9;color:#312f38}.skin-simplifystack .bg-medium .btn-link,.skin-simplifystack .bg-medium a{color:#312f38}.skin-simplifystack .bg-medium2{background-color:#5a5960;color:#fff}.skin-simplifystack .bg-medium2 .btn-link,.skin-simplifystack .bg-medium2 a{color:#fff}.skin-simplifystack .bg-dark{background-color:#312f38;color:#e9e9e9}.skin-simplifystack .bg-dark .btn-link,.skin-simplifystack .bg-dark a{color:#e9e9e9}.skin-simplifystack .bg-success{background-color:#red;color:#white}.skin-simplifystack .bg-success .btn-link,.skin-simplifystack .bg-success a{color:#white}.skin-simplifystack .bg-info{background-color:#5a5960;color:#fff}.skin-simplifystack .bg-info .btn-link,.skin-simplifystack .bg-info a{color:#fff}.skin-simplifystack .panel-variable{border-color:#312f38}.skin-simplifystack .panel-variable>.panel-heading{color:#fff;background-color:#312f38;border-color:#312f38}.skin-simplifystack .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#312f38}.skin-simplifystack .panel-variable>.panel-heading .badge{color:#312f38;background-color:#fff}.skin-simplifystack .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#312f38}.skin-simplifystack .box-variable{border-color:#312f38}.skin-simplifystack .box-variable>.box-header{color:#fff;background-color:#312f38;border-color:#312f38}.skin-simplifystack .box-variable>.box-header+.box-body{border-top-color:#312f38}.skin-simplifystack .box-variable>.box-footer+.panel-body{border-bottom-color:#312f38}.skin-simplifystack .primary{color:#pink}.skin-simplifystack .primary-strong{color:#a05a2c}.skin-simplifystack .primary-light{color:#c2bcdb}.skin-simplifystack .main-header .navbar{background-color:#312f38;border-color:#5a5960;color:#fff}.skin-simplifystack .main-header .dropdown-menu{border-color:#c5c5c5}.skin-simplifystack .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#d6d6d6}.skin-simplifystack .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#c5c5c5}.skin-simplifystack .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#black;background-color:#d6d6d6}.skin-simplifystack .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#d6d6d6}.skin-simplifystack .main-header .navbar-right a{color:#fff}.skin-simplifystack .main-header .nav>li>a:hover,.skin-simplifystack .main-header .navbar-right a :hover{color:#black;background-color:#d6d6d6}@media (max-width:991px){.skin-simplifystack .main-header .navbar-right a{color:#fff}.skin-simplifystack .main-header .navbar-right a :hover{color:#black;background-color:#d6d6d6}}@media (min-width:768px){.skin-simplifystack .main-header .navbar-right a{color:#fff}.skin-simplifystack .main-header .navbar-right a :hover{color:#black;background-color:#d6d6d6}}.skin-simplifystack .content{background-color:#e9e9e9}.skin-simplifystack .content a{color:#fff}.skin-simplifystack .main-footer{background-color:#312f38;color:#fff;border-top:1px solid #312f38}.skin-simplifystack .calendar a{color:#black}.skin-simplifystack obt-filter-form select{background-color:#7b7a80}.skin-simplifystack obt-filter-form .form-control{color:#fff}.skin-simplifystack .calendar-section{background-color:#fff}.skin-simplifystack obt-calendar .fc-toolbar h2{color:#black}.skin-simplifystack obt-calendar .fc-today{background-color:#e9e9e9}.skin-simplifystack obt-calendar .fc-button{background:#d6d6d6;background-image:none;color:#black;border-color:#bdbdbd;border-bottom-color:#bdbdbd}.skin-simplifystack obt-calendar .fc-button.hover,.skin-simplifystack obt-calendar .fc-button:active,.skin-simplifystack obt-calendar .fc-button:hover{background-color:#f0f0f0}.skin-simplifystack .tooltip-inner{background-color:#d6d6d6;color:#black}.skin-simplifystack .tooltip.top .tooltip-arrow{border-top-color:#d6d6d6}.skin-simplifystack .tooltip.right .tooltip-arrow{border-right-color:#d6d6d6}.skin-simplifystack .tooltip.bottom .tooltip-arrow{border-bottom-color:#d6d6d6}.skin-simplifystack .tooltip.left .tooltip-arrow{border-left-color:#d6d6d6}.skin-simplifystack hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-simplifystack .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-simplifystack .btn-warning-advisor :active,.skin-simplifystack .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-simplifystack .btn-secondary-outline,.skin-simplifystack .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-simplifystack .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-skyBlue .bg-light{background-color:#fff;color:#253542}.skin-skyBlue .bg-light .btn-link,.skin-skyBlue .bg-light a{color:#253542}.skin-skyBlue .bg-medium{background-color:#ecf6fd;color:#253542}.skin-skyBlue .bg-medium .btn-link,.skin-skyBlue .bg-medium a{color:#253542}.skin-skyBlue .bg-medium2{background-color:#3a5268;color:#fff}.skin-skyBlue .bg-medium2 .btn-link,.skin-skyBlue .bg-medium2 a{color:#fff}.skin-skyBlue .bg-dark{background-color:#253542;color:#ecf6fd}.skin-skyBlue .bg-dark .btn-link,.skin-skyBlue .bg-dark a{color:#ecf6fd}.skin-skyBlue .bg-success{background-color:#red;color:#white}.skin-skyBlue .bg-success .btn-link,.skin-skyBlue .bg-success a{color:#white}.skin-skyBlue .bg-info{background-color:#3a5268;color:#fff}.skin-skyBlue .bg-info .btn-link,.skin-skyBlue .bg-info a{color:#fff}.skin-skyBlue .panel-variable{border-color:#253542}.skin-skyBlue .panel-variable>.panel-heading{color:#fff;background-color:#253542;border-color:#253542}.skin-skyBlue .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#253542}.skin-skyBlue .panel-variable>.panel-heading .badge{color:#253542;background-color:#fff}.skin-skyBlue .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#253542}.skin-skyBlue .box-variable{border-color:#253542}.skin-skyBlue .box-variable>.box-header{color:#fff;background-color:#253542;border-color:#253542}.skin-skyBlue .box-variable>.box-header+.box-body{border-top-color:#253542}.skin-skyBlue .box-variable>.box-footer+.panel-body{border-bottom-color:#253542}.skin-skyBlue .primary{color:#pink}.skin-skyBlue .primary-strong{color:#a05a2c}.skin-skyBlue .primary-light{color:#c2bcdb}.skin-skyBlue .main-header .navbar{background-color:#253542;border-color:#3a5268;color:#fff}.skin-skyBlue .main-header .dropdown-menu{border-color:#a5d2fd}.skin-skyBlue .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#d1e8fd}.skin-skyBlue .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#a5d2fd}.skin-skyBlue .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#d1e8fd}.skin-skyBlue .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#d1e8fd}.skin-skyBlue .main-header .navbar-right a{color:#fff}.skin-skyBlue .main-header .nav>li>a:hover,.skin-skyBlue .main-header .navbar-right a :hover{color:#000;background-color:#d1e8fd}@media (max-width:991px){.skin-skyBlue .main-header .navbar-right a{color:#fff}.skin-skyBlue .main-header .navbar-right a :hover{color:#000;background-color:#d1e8fd}}@media (min-width:768px){.skin-skyBlue .main-header .navbar-right a{color:#fff}.skin-skyBlue .main-header .navbar-right a :hover{color:#000;background-color:#d1e8fd}}.skin-skyBlue .content{background-color:#ecf6fd}.skin-skyBlue .content a{color:#fff}.skin-skyBlue .main-footer{background-color:#253542;color:#fff;border-top:1px solid #253542}.skin-skyBlue .calendar a{color:#000}.skin-skyBlue obt-filter-form select{background-color:#5b7fa2}.skin-skyBlue obt-filter-form .form-control{color:#fff}.skin-skyBlue .calendar-section{background-color:#fff}.skin-skyBlue obt-calendar .fc-toolbar h2{color:#000}.skin-skyBlue obt-calendar .fc-today{background-color:#ecf6fd}.skin-skyBlue obt-calendar .fc-button{background:#d1e8fd;background-image:none;color:#000;border-color:#a0d0fb;border-bottom-color:#a0d0fb}.skin-skyBlue obt-calendar .fc-button.hover,.skin-skyBlue obt-calendar .fc-button:active,.skin-skyBlue obt-calendar .fc-button:hover{background-color:#fff}.skin-skyBlue .tooltip-inner{background-color:#d1e8fd;color:#000}.skin-skyBlue .tooltip.top .tooltip-arrow{border-top-color:#d1e8fd}.skin-skyBlue .tooltip.right .tooltip-arrow{border-right-color:#d1e8fd}.skin-skyBlue .tooltip.bottom .tooltip-arrow{border-bottom-color:#d1e8fd}.skin-skyBlue .tooltip.left .tooltip-arrow{border-left-color:#d1e8fd}.skin-skyBlue hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-skyBlue .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-skyBlue .btn-warning-advisor :active,.skin-skyBlue .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-skyBlue .btn-secondary-outline,.skin-skyBlue .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-skyBlue .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-pelorous .bg-light{background-color:#fff;color:#174a55}.skin-pelorous .bg-light .btn-link,.skin-pelorous .bg-light a{color:#174a55}.skin-pelorous .bg-medium{background-color:#dcedf0;color:#174a55}.skin-pelorous .bg-medium .btn-link,.skin-pelorous .bg-medium a{color:#174a55}.skin-pelorous .bg-medium2{background-color:#1d5d6a;color:#fff}.skin-pelorous .bg-medium2 .btn-link,.skin-pelorous .bg-medium2 a{color:#fff}.skin-pelorous .bg-dark{background-color:#174a55;color:#dcedf0}.skin-pelorous .bg-dark .btn-link,.skin-pelorous .bg-dark a{color:#dcedf0}.skin-pelorous .bg-success{background-color:#red;color:#white}.skin-pelorous .bg-success .btn-link,.skin-pelorous .bg-success a{color:#white}.skin-pelorous .bg-info{background-color:#1d5d6a;color:#fff}.skin-pelorous .bg-info .btn-link,.skin-pelorous .bg-info a{color:#fff}.skin-pelorous .panel-variable{border-color:#174a55}.skin-pelorous .panel-variable>.panel-heading{color:#fff;background-color:#174a55;border-color:#174a55}.skin-pelorous .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#174a55}.skin-pelorous .panel-variable>.panel-heading .badge{color:#174a55;background-color:#fff}.skin-pelorous .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#174a55}.skin-pelorous .box-variable{border-color:#174a55}.skin-pelorous .box-variable>.box-header{color:#fff;background-color:#174a55;border-color:#174a55}.skin-pelorous .box-variable>.box-header+.box-body{border-top-color:#174a55}.skin-pelorous .box-variable>.box-footer+.panel-body{border-bottom-color:#174a55}.skin-pelorous .primary{color:#pink}.skin-pelorous .primary-strong{color:#a05a2c}.skin-pelorous .primary-light{color:#c2bcdb}.skin-pelorous .main-header .navbar{background-color:#174a55;border-color:#1d5d6a;color:#fff}.skin-pelorous .main-header .dropdown-menu{border-color:#79b9c6}.skin-pelorous .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#a9d2da}.skin-pelorous .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#79b9c6}.skin-pelorous .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#a9d2da}.skin-pelorous .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#a9d2da}.skin-pelorous .main-header .navbar-right a{color:#fff}.skin-pelorous .main-header .nav>li>a:hover,.skin-pelorous .main-header .navbar-right a :hover{color:#000;background-color:#a9d2da}@media (max-width:991px){.skin-pelorous .main-header .navbar-right a{color:#fff}.skin-pelorous .main-header .navbar-right a :hover{color:#000;background-color:#a9d2da}}@media (min-width:768px){.skin-pelorous .main-header .navbar-right a{color:#fff}.skin-pelorous .main-header .navbar-right a :hover{color:#000;background-color:#a9d2da}}.skin-pelorous .content{background-color:#dcedf0}.skin-pelorous .content a{color:#fff}.skin-pelorous .main-footer{background-color:#174a55;color:#fff;border-top:1px solid #174a55}.skin-pelorous .calendar a{color:#000}.skin-pelorous obt-filter-form select{background-color:#247485}.skin-pelorous obt-filter-form .form-control{color:#fff}.skin-pelorous .calendar-section{background-color:#fff}.skin-pelorous obt-calendar .fc-toolbar h2{color:#000}.skin-pelorous obt-calendar .fc-today{background-color:#dcedf0}.skin-pelorous obt-calendar .fc-button{background:#a9d2da;background-image:none;color:#000;border-color:#85bfcb;border-bottom-color:#85bfcb}.skin-pelorous obt-calendar .fc-button.hover,.skin-pelorous obt-calendar .fc-button:active,.skin-pelorous obt-calendar .fc-button:hover{background-color:#cde5e9}.skin-pelorous .tooltip-inner{background-color:#a9d2da;color:#000}.skin-pelorous .tooltip.top .tooltip-arrow{border-top-color:#a9d2da}.skin-pelorous .tooltip.right .tooltip-arrow{border-right-color:#a9d2da}.skin-pelorous .tooltip.bottom .tooltip-arrow{border-bottom-color:#a9d2da}.skin-pelorous .tooltip.left .tooltip-arrow{border-left-color:#a9d2da}.skin-pelorous hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-pelorous .btn-warning-advisor{background-color:#c45842;border-color:#c45842;color:#fff}.skin-pelorous .btn-warning-advisor :active,.skin-pelorous .btn-warning-advisor :hover{background-color:#9d4635;border-color:#9d4635;color:#fff}.skin-pelorous .btn-secondary-outline,.skin-pelorous .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-pelorous .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-BubleGum .bg-light{background-color:#fff;color:#4d0932}.skin-BubleGum .bg-light .btn-link,.skin-BubleGum .bg-light a{color:#4d0932}.skin-BubleGum .bg-medium{background-color:#f8e7f2;color:#4d0932}.skin-BubleGum .bg-medium .btn-link,.skin-BubleGum .bg-medium a{color:#4d0932}.skin-BubleGum .bg-medium2{background-color:#9a1264;color:#fff}.skin-BubleGum .bg-medium2 .btn-link,.skin-BubleGum .bg-medium2 a{color:#fff}.skin-BubleGum .bg-dark{background-color:#4d0932;color:#f8e7f2}.skin-BubleGum .bg-dark .btn-link,.skin-BubleGum .bg-dark a{color:#f8e7f2}.skin-BubleGum .bg-success{background-color:#red;color:#white}.skin-BubleGum .bg-success .btn-link,.skin-BubleGum .bg-success a{color:#white}.skin-BubleGum .bg-info{background-color:#9a1264;color:#fff}.skin-BubleGum .bg-info .btn-link,.skin-BubleGum .bg-info a{color:#fff}.skin-BubleGum .panel-variable{border-color:#4d0932}.skin-BubleGum .panel-variable>.panel-heading{color:#fff;background-color:#4d0932;border-color:#4d0932}.skin-BubleGum .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#4d0932}.skin-BubleGum .panel-variable>.panel-heading .badge{color:#4d0932;background-color:#fff}.skin-BubleGum .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#4d0932}.skin-BubleGum .box-variable{border-color:#4d0932}.skin-BubleGum .box-variable>.box-header{color:#fff;background-color:#4d0932;border-color:#4d0932}.skin-BubleGum .box-variable>.box-header+.box-body{border-top-color:#4d0932}.skin-BubleGum .box-variable>.box-footer+.panel-body{border-bottom-color:#4d0932}.skin-BubleGum .primary{color:#pink}.skin-BubleGum .primary-strong{color:#a05a2c}.skin-BubleGum .primary-light{color:#c2bcdb}.skin-BubleGum .main-header .navbar{background-color:#4d0932;border-color:#9a1264;color:#fff}.skin-BubleGum .main-header .dropdown-menu{border-color:#e08bbe}.skin-BubleGum .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#ecb9d8}.skin-BubleGum .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#e08bbe}.skin-BubleGum .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#ecb9d8}.skin-BubleGum .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#ecb9d8}.skin-BubleGum .main-header .navbar-right a{color:#fff}.skin-BubleGum .main-header .nav>li>a:hover,.skin-BubleGum .main-header .navbar-right a :hover{color:#000;background-color:#ecb9d8}@media (max-width:991px){.skin-BubleGum .main-header .navbar-right a{color:#fff}.skin-BubleGum .main-header .navbar-right a :hover{color:#000;background-color:#ecb9d8}}@media (min-width:768px){.skin-BubleGum .main-header .navbar-right a{color:#fff}.skin-BubleGum .main-header .navbar-right a :hover{color:#000;background-color:#ecb9d8}}.skin-BubleGum .content{background-color:#f8e7f2}.skin-BubleGum .content a{color:#fff}.skin-BubleGum .main-footer{background-color:#4d0932;color:#fff;border-top:1px solid #4d0932}.skin-BubleGum .calendar a{color:#000}.skin-BubleGum obt-filter-form select{background-color:#c1177e}.skin-BubleGum obt-filter-form .form-control{color:#fff}.skin-BubleGum .calendar-section{background-color:#fff}.skin-BubleGum obt-calendar .fc-toolbar h2{color:#000}.skin-BubleGum obt-calendar .fc-today{background-color:#f8e7f2}.skin-BubleGum obt-calendar .fc-button{background:#ecb9d8;background-image:none;color:#000;border-color:#e191c2;border-bottom-color:#e191c2}.skin-BubleGum obt-calendar .fc-button.hover,.skin-BubleGum obt-calendar .fc-button:active,.skin-BubleGum obt-calendar .fc-button:hover{background-color:#f7e1ee}.skin-BubleGum .tooltip-inner{background-color:#ecb9d8;color:#000}.skin-BubleGum .tooltip.top .tooltip-arrow{border-top-color:#ecb9d8}.skin-BubleGum .tooltip.right .tooltip-arrow{border-right-color:#ecb9d8}.skin-BubleGum .tooltip.bottom .tooltip-arrow{border-bottom-color:#ecb9d8}.skin-BubleGum .tooltip.left .tooltip-arrow{border-left-color:#ecb9d8}.skin-BubleGum hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-BubleGum .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-BubleGum .btn-warning-advisor :active,.skin-BubleGum .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-BubleGum .btn-secondary-outline,.skin-BubleGum .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-BubleGum .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-Lima .bg-light{background-color:#fff;color:#0f3902}.skin-Lima .bg-light .btn-link,.skin-Lima .bg-light a{color:#0f3902}.skin-Lima .bg-medium{background-color:#d6f2cd;color:#0f3902}.skin-Lima .bg-medium .btn-link,.skin-Lima .bg-medium a{color:#0f3902}.skin-Lima .bg-medium2{background-color:#1e7205;color:#fff}.skin-Lima .bg-medium2 .btn-link,.skin-Lima .bg-medium2 a{color:#fff}.skin-Lima .bg-dark{background-color:#0f3902;color:#d6f2cd}.skin-Lima .bg-dark .btn-link,.skin-Lima .bg-dark a{color:#d6f2cd}.skin-Lima .bg-success{background-color:#red;color:#white}.skin-Lima .bg-success .btn-link,.skin-Lima .bg-success a{color:#white}.skin-Lima .bg-info{background-color:#1e7205;color:#fff}.skin-Lima .bg-info .btn-link,.skin-Lima .bg-info a{color:#fff}.skin-Lima .panel-variable{border-color:#0f3902}.skin-Lima .panel-variable>.panel-heading{color:#fff;background-color:#0f3902;border-color:#0f3902}.skin-Lima .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#0f3902}.skin-Lima .panel-variable>.panel-heading .badge{color:#0f3902;background-color:#fff}.skin-Lima .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#0f3902}.skin-Lima .box-variable{border-color:#0f3902}.skin-Lima .box-variable>.box-header{color:#fff;background-color:#0f3902;border-color:#0f3902}.skin-Lima .box-variable>.box-header+.box-body{border-top-color:#0f3902}.skin-Lima .box-variable>.box-footer+.panel-body{border-bottom-color:#0f3902}.skin-Lima .primary{color:#pink}.skin-Lima .primary-strong{color:#a05a2c}.skin-Lima .primary-light{color:#c2bcdb}.skin-Lima .main-header .navbar{background-color:#0f3902;border-color:#1e7205;color:#fff}.skin-Lima .main-header .dropdown-menu{border-color:#84d86b}.skin-Lima .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#ade59c}.skin-Lima .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#84d86b}.skin-Lima .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#ade59c}.skin-Lima .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#ade59c}.skin-Lima .main-header .navbar-right a{color:#fff}.skin-Lima .main-header .nav>li>a:hover,.skin-Lima .main-header .navbar-right a :hover{color:#000;background-color:#ade59c}@media (max-width:991px){.skin-Lima .main-header .navbar-right a{color:#fff}.skin-Lima .main-header .navbar-right a :hover{color:#000;background-color:#ade59c}}@media (min-width:768px){.skin-Lima .main-header .navbar-right a{color:#fff}.skin-Lima .main-header .navbar-right a :hover{color:#000;background-color:#ade59c}}.skin-Lima .content{background-color:#d6f2cd}.skin-Lima .content a{color:#fff}.skin-Lima .main-footer{background-color:#0f3902;color:#fff;border-top:1px solid #0f3902}.skin-Lima .calendar a{color:#000}.skin-Lima obt-filter-form select{background-color:#289807}.skin-Lima obt-filter-form .form-control{color:#fff}.skin-Lima .calendar-section{background-color:#fff}.skin-Lima obt-calendar .fc-toolbar h2{color:#000}.skin-Lima obt-calendar .fc-today{background-color:#d6f2cd}.skin-Lima obt-calendar .fc-button{background:#ade59c;background-image:none;color:#000;border-color:#8cda74;border-bottom-color:#8cda74}.skin-Lima obt-calendar .fc-button.hover,.skin-Lima obt-calendar .fc-button:active,.skin-Lima obt-calendar .fc-button:hover{background-color:#cef0c4}.skin-Lima .tooltip-inner{background-color:#ade59c;color:#000}.skin-Lima .tooltip.top .tooltip-arrow{border-top-color:#ade59c}.skin-Lima .tooltip.right .tooltip-arrow{border-right-color:#ade59c}.skin-Lima .tooltip.bottom .tooltip-arrow{border-bottom-color:#ade59c}.skin-Lima .tooltip.left .tooltip-arrow{border-left-color:#ade59c}.skin-Lima hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-Lima .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-Lima .btn-warning-advisor :active,.skin-Lima .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-Lima .btn-secondary-outline,.skin-Lima .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-Lima .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-Camarone .bg-light{background-color:#fff;color:#00481c}.skin-Camarone .bg-light .btn-link,.skin-Camarone .bg-light a{color:#00481c}.skin-Camarone .bg-medium{background-color:#e5eee9;color:#00481c}.skin-Camarone .bg-medium .btn-link,.skin-Camarone .bg-medium a{color:#00481c}.skin-Camarone .bg-medium2{background-color:#005b24;color:#fff}.skin-Camarone .bg-medium2 .btn-link,.skin-Camarone .bg-medium2 a{color:#fff}.skin-Camarone .bg-dark{background-color:#00481c;color:#e5eee9}.skin-Camarone .bg-dark .btn-link,.skin-Camarone .bg-dark a{color:#e5eee9}.skin-Camarone .bg-success{background-color:#red;color:#white}.skin-Camarone .bg-success .btn-link,.skin-Camarone .bg-success a{color:#white}.skin-Camarone .bg-info{background-color:#005b24;color:#fff}.skin-Camarone .bg-info .btn-link,.skin-Camarone .bg-info a{color:#fff}.skin-Camarone .panel-variable{border-color:#00481c}.skin-Camarone .panel-variable>.panel-heading{color:#fff;background-color:#00481c;border-color:#00481c}.skin-Camarone .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#00481c}.skin-Camarone .panel-variable>.panel-heading .badge{color:#00481c;background-color:#fff}.skin-Camarone .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#00481c}.skin-Camarone .box-variable{border-color:#00481c}.skin-Camarone .box-variable>.box-header{color:#fff;background-color:#00481c;border-color:#00481c}.skin-Camarone .box-variable>.box-header+.box-body{border-top-color:#00481c}.skin-Camarone .box-variable>.box-footer+.panel-body{border-bottom-color:#00481c}.skin-Camarone .primary{color:#pink}.skin-Camarone .primary-strong{color:#a05a2c}.skin-Camarone .primary-light{color:#c2bcdb}.skin-Camarone .main-header .navbar{background-color:#00481c;border-color:#005b24;color:#fff}.skin-Camarone .main-header .dropdown-menu{border-color:#7fad91}.skin-Camarone .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#b2cdbd}.skin-Camarone .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#7fad91}.skin-Camarone .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#b2cdbd}.skin-Camarone .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#b2cdbd}.skin-Camarone .main-header .navbar-right a{color:#fff}.skin-Camarone .main-header .nav>li>a:hover,.skin-Camarone .main-header .navbar-right a :hover{color:#000;background-color:#b2cdbd}@media (max-width:991px){.skin-Camarone .main-header .navbar-right a{color:#fff}.skin-Camarone .main-header .navbar-right a :hover{color:#000;background-color:#b2cdbd}}@media (min-width:768px){.skin-Camarone .main-header .navbar-right a{color:#fff}.skin-Camarone .main-header .navbar-right a :hover{color:#000;background-color:#b2cdbd}}.skin-Camarone .content{background-color:#e5eee9}.skin-Camarone .content a{color:#fff}.skin-Camarone .main-footer{background-color:#00481c;color:#fff;border-top:1px solid #00481c}.skin-Camarone .calendar a{color:#000}.skin-Camarone obt-filter-form select{background-color:#196b39}.skin-Camarone obt-filter-form .form-control{color:#fff}.skin-Camarone .calendar-section{background-color:#fff}.skin-Camarone obt-calendar .fc-toolbar h2{color:#000}.skin-Camarone obt-calendar .fc-today{background-color:#e5eee9}.skin-Camarone obt-calendar .fc-button{background:#b2cdbd;background-image:none;color:#000;border-color:#93b9a2;border-bottom-color:#93b9a2}.skin-Camarone obt-calendar .fc-button.hover,.skin-Camarone obt-calendar .fc-button:active,.skin-Camarone obt-calendar .fc-button:hover{background-color:#d1e1d8}.skin-Camarone .tooltip-inner{background-color:#b2cdbd;color:#000}.skin-Camarone .tooltip.top .tooltip-arrow{border-top-color:#b2cdbd}.skin-Camarone .tooltip.right .tooltip-arrow{border-right-color:#b2cdbd}.skin-Camarone .tooltip.bottom .tooltip-arrow{border-bottom-color:#b2cdbd}.skin-Camarone .tooltip.left .tooltip-arrow{border-left-color:#b2cdbd}.skin-Camarone hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-Camarone .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-Camarone .btn-warning-advisor :active,.skin-Camarone .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-Camarone .btn-secondary-outline,.skin-Camarone .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-Camarone .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-SchoolBusYellow .bg-light{background-color:#fff;color:#4b4200}.skin-SchoolBusYellow .bg-light .btn-link,.skin-SchoolBusYellow .bg-light a{color:#4b4200}.skin-SchoolBusYellow .bg-medium{background-color:#fef8cc;color:#4b4200}.skin-SchoolBusYellow .bg-medium .btn-link,.skin-SchoolBusYellow .bg-medium a{color:#4b4200}.skin-SchoolBusYellow .bg-medium2{background-color:#968400;color:#fff}.skin-SchoolBusYellow .bg-medium2 .btn-link,.skin-SchoolBusYellow .bg-medium2 a{color:#fff}.skin-SchoolBusYellow .bg-dark{background-color:#4b4200;color:#fef8cc}.skin-SchoolBusYellow .bg-dark .btn-link,.skin-SchoolBusYellow .bg-dark a{color:#fef8cc}.skin-SchoolBusYellow .bg-success{background-color:#red;color:#white}.skin-SchoolBusYellow .bg-success .btn-link,.skin-SchoolBusYellow .bg-success a{color:#white}.skin-SchoolBusYellow .bg-info{background-color:#968400;color:#fff}.skin-SchoolBusYellow .bg-info .btn-link,.skin-SchoolBusYellow .bg-info a{color:#fff}.skin-SchoolBusYellow .panel-variable{border-color:#4b4200}.skin-SchoolBusYellow .panel-variable>.panel-heading{color:#fff;background-color:#4b4200;border-color:#4b4200}.skin-SchoolBusYellow .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#4b4200}.skin-SchoolBusYellow .panel-variable>.panel-heading .badge{color:#4b4200;background-color:#fff}.skin-SchoolBusYellow .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#4b4200}.skin-SchoolBusYellow .box-variable{border-color:#4b4200}.skin-SchoolBusYellow .box-variable>.box-header{color:#fff;background-color:#4b4200;border-color:#4b4200}.skin-SchoolBusYellow .box-variable>.box-header+.box-body{border-top-color:#4b4200}.skin-SchoolBusYellow .box-variable>.box-footer+.panel-body{border-bottom-color:#4b4200}.skin-SchoolBusYellow .primary{color:#pink}.skin-SchoolBusYellow .primary-strong{color:#a05a2c}.skin-SchoolBusYellow .primary-light{color:#c2bcdb}.skin-SchoolBusYellow .main-header .navbar{background-color:#4b4200;border-color:#968400;color:#fff}.skin-SchoolBusYellow .main-header .dropdown-menu{border-color:#fcea66}.skin-SchoolBusYellow .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#fdf199}.skin-SchoolBusYellow .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#fcea66}.skin-SchoolBusYellow .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#fdf199}.skin-SchoolBusYellow .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#fdf199}.skin-SchoolBusYellow .main-header .navbar-right a{color:#fff}.skin-SchoolBusYellow .main-header .nav>li>a:hover,.skin-SchoolBusYellow .main-header .navbar-right a :hover{color:#000;background-color:#fdf199}@media (max-width:991px){.skin-SchoolBusYellow .main-header .navbar-right a{color:#fff}.skin-SchoolBusYellow .main-header .navbar-right a :hover{color:#000;background-color:#fdf199}}@media (min-width:768px){.skin-SchoolBusYellow .main-header .navbar-right a{color:#fff}.skin-SchoolBusYellow .main-header .navbar-right a :hover{color:#000;background-color:#fdf199}}.skin-SchoolBusYellow .content{background-color:#fef8cc}.skin-SchoolBusYellow .content a{color:#fff}.skin-SchoolBusYellow .main-footer{background-color:#4b4200;color:#fff;border-top:1px solid #4b4200}.skin-SchoolBusYellow .calendar a{color:#000}.skin-SchoolBusYellow obt-filter-form select{background-color:#e1c600}.skin-SchoolBusYellow obt-filter-form .form-control{color:#fff}.skin-SchoolBusYellow .calendar-section{background-color:#fff}.skin-SchoolBusYellow obt-calendar .fc-toolbar h2{color:#000}.skin-SchoolBusYellow obt-calendar .fc-today{background-color:#fef8cc}.skin-SchoolBusYellow obt-calendar .fc-button{background:#fdf199;background-image:none;color:#000;border-color:#fcea67;border-bottom-color:#fcea67}.skin-SchoolBusYellow obt-calendar .fc-button.hover,.skin-SchoolBusYellow obt-calendar .fc-button:active,.skin-SchoolBusYellow obt-calendar .fc-button:hover{background-color:#fef8cb}.skin-SchoolBusYellow .tooltip-inner{background-color:#fdf199;color:#000}.skin-SchoolBusYellow .tooltip.top .tooltip-arrow{border-top-color:#fdf199}.skin-SchoolBusYellow .tooltip.right .tooltip-arrow{border-right-color:#fdf199}.skin-SchoolBusYellow .tooltip.bottom .tooltip-arrow{border-bottom-color:#fdf199}.skin-SchoolBusYellow .tooltip.left .tooltip-arrow{border-left-color:#fdf199}.skin-SchoolBusYellow hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-SchoolBusYellow .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-SchoolBusYellow .btn-warning-advisor :active,.skin-SchoolBusYellow .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-SchoolBusYellow .btn-secondary-outline,.skin-SchoolBusYellow .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-SchoolBusYellow .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-Heliotrope .bg-light{background-color:#fff;color:#50246c}.skin-Heliotrope .bg-light .btn-link,.skin-Heliotrope .bg-light a{color:#50246c}.skin-Heliotrope .bg-medium{background-color:#ecdaf7;color:#50246c}.skin-Heliotrope .bg-medium .btn-link,.skin-Heliotrope .bg-medium a{color:#50246c}.skin-Heliotrope .bg-medium2{background-color:#703397;color:#fff}.skin-Heliotrope .bg-medium2 .btn-link,.skin-Heliotrope .bg-medium2 a{color:#fff}.skin-Heliotrope .bg-dark{background-color:#50246c;color:#ecdaf7}.skin-Heliotrope .bg-dark .btn-link,.skin-Heliotrope .bg-dark a{color:#ecdaf7}.skin-Heliotrope .bg-success{background-color:#red;color:#white}.skin-Heliotrope .bg-success .btn-link,.skin-Heliotrope .bg-success a{color:#white}.skin-Heliotrope .bg-info{background-color:#703397;color:#fff}.skin-Heliotrope .bg-info .btn-link,.skin-Heliotrope .bg-info a{color:#fff}.skin-Heliotrope .panel-variable{border-color:#50246c}.skin-Heliotrope .panel-variable>.panel-heading{color:#fff;background-color:#50246c;border-color:#50246c}.skin-Heliotrope .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#50246c}.skin-Heliotrope .panel-variable>.panel-heading .badge{color:#50246c;background-color:#fff}.skin-Heliotrope .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#50246c}.skin-Heliotrope .box-variable{border-color:#50246c}.skin-Heliotrope .box-variable>.box-header{color:#fff;background-color:#50246c;border-color:#50246c}.skin-Heliotrope .box-variable>.box-header+.box-body{border-top-color:#50246c}.skin-Heliotrope .box-variable>.box-footer+.panel-body{border-bottom-color:#50246c}.skin-Heliotrope .primary{color:#pink}.skin-Heliotrope .primary-strong{color:#a05a2c}.skin-Heliotrope .primary-light{color:#c2bcdb}.skin-Heliotrope .main-header .navbar{background-color:#50246c;border-color:#703397;color:#fff}.skin-Heliotrope .main-header .dropdown-menu{border-color:#bd7fe3}.skin-Heliotrope .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#d9b6ef}.skin-Heliotrope .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#bd7fe3}.skin-Heliotrope .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#d9b6ef}.skin-Heliotrope .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#d9b6ef}.skin-Heliotrope .main-header .navbar-right a{color:#fff}.skin-Heliotrope .main-header .nav>li>a:hover,.skin-Heliotrope .main-header .navbar-right a :hover{color:#000;background-color:#d9b6ef}@media (max-width:991px){.skin-Heliotrope .main-header .navbar-right a{color:#fff}.skin-Heliotrope .main-header .navbar-right a :hover{color:#000;background-color:#d9b6ef}}@media (min-width:768px){.skin-Heliotrope .main-header .navbar-right a{color:#fff}.skin-Heliotrope .main-header .navbar-right a :hover{color:#000;background-color:#d9b6ef}}.skin-Heliotrope .content{background-color:#ecdaf7}.skin-Heliotrope .content a{color:#fff}.skin-Heliotrope .main-footer{background-color:#50246c;color:#fff;border-top:1px solid #50246c}.skin-Heliotrope .calendar a{color:#000}.skin-Heliotrope obt-filter-form select{background-color:#9041c2}.skin-Heliotrope obt-filter-form .form-control{color:#fff}.skin-Heliotrope .calendar-section{background-color:#fff}.skin-Heliotrope obt-calendar .fc-toolbar h2{color:#000}.skin-Heliotrope obt-calendar .fc-today{background-color:#ecdaf7}.skin-Heliotrope obt-calendar .fc-button{background:#d9b6ef;background-image:none;color:#000;border-color:#c38ce6;border-bottom-color:#c38ce6}.skin-Heliotrope obt-calendar .fc-button.hover,.skin-Heliotrope obt-calendar .fc-button:active,.skin-Heliotrope obt-calendar .fc-button:hover{background-color:#efe0f8}.skin-Heliotrope .tooltip-inner{background-color:#d9b6ef;color:#000}.skin-Heliotrope .tooltip.top .tooltip-arrow{border-top-color:#d9b6ef}.skin-Heliotrope .tooltip.right .tooltip-arrow{border-right-color:#d9b6ef}.skin-Heliotrope .tooltip.bottom .tooltip-arrow{border-bottom-color:#d9b6ef}.skin-Heliotrope .tooltip.left .tooltip-arrow{border-left-color:#d9b6ef}.skin-Heliotrope hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-Heliotrope .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-Heliotrope .btn-warning-advisor :active,.skin-Heliotrope .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-Heliotrope .btn-secondary-outline,.skin-Heliotrope .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-Heliotrope .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-Cascade .bg-light{background-color:#fff;color:#475658}.skin-Cascade .bg-light .btn-link,.skin-Cascade .bg-light a{color:#475658}.skin-Cascade .bg-medium{background-color:#e8eeef;color:#475658}.skin-Cascade .bg-medium .btn-link,.skin-Cascade .bg-medium a{color:#475658}.skin-Cascade .bg-medium2{background-color:#72898c;color:#fff}.skin-Cascade .bg-medium2 .btn-link,.skin-Cascade .bg-medium2 a{color:#fff}.skin-Cascade .bg-dark{background-color:#475658;color:#e8eeef}.skin-Cascade .bg-dark .btn-link,.skin-Cascade .bg-dark a{color:#e8eeef}.skin-Cascade .bg-success{background-color:#red;color:#white}.skin-Cascade .bg-success .btn-link,.skin-Cascade .bg-success a{color:#white}.skin-Cascade .bg-info{background-color:#72898c;color:#fff}.skin-Cascade .bg-info .btn-link,.skin-Cascade .bg-info a{color:#fff}.skin-Cascade .panel-variable{border-color:#475658}.skin-Cascade .panel-variable>.panel-heading{color:#fff;background-color:#475658;border-color:#475658}.skin-Cascade .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#475658}.skin-Cascade .panel-variable>.panel-heading .badge{color:#475658;background-color:#fff}.skin-Cascade .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#475658}.skin-Cascade .box-variable{border-color:#475658}.skin-Cascade .box-variable>.box-header{color:#fff;background-color:#475658;border-color:#475658}.skin-Cascade .box-variable>.box-header+.box-body{border-top-color:#475658}.skin-Cascade .box-variable>.box-footer+.panel-body{border-bottom-color:#475658}.skin-Cascade .primary{color:#pink}.skin-Cascade .primary-strong{color:#a05a2c}.skin-Cascade .primary-light{color:#c2bcdb}.skin-Cascade .main-header .navbar{background-color:#475658;border-color:#72898c;color:#fff}.skin-Cascade .main-header .dropdown-menu{border-color:#bbcdcf}.skin-Cascade .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#d2dddf}.skin-Cascade .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#bbcdcf}.skin-Cascade .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#d2dddf}.skin-Cascade .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#d2dddf}.skin-Cascade .main-header .navbar-right a{color:#fff}.skin-Cascade .main-header .nav>li>a:hover,.skin-Cascade .main-header .navbar-right a :hover{color:#000;background-color:#d2dddf}@media (max-width:991px){.skin-Cascade .main-header .navbar-right a{color:#fff}.skin-Cascade .main-header .navbar-right a :hover{color:#000;background-color:#d2dddf}}@media (min-width:768px){.skin-Cascade .main-header .navbar-right a{color:#fff}.skin-Cascade .main-header .navbar-right a :hover{color:#000;background-color:#d2dddf}}.skin-Cascade .content{background-color:#e8eeef}.skin-Cascade .content a{color:#fff}.skin-Cascade .main-footer{background-color:#475658;color:#fff;border-top:1px solid #475658}.skin-Cascade .calendar a{color:#000}.skin-Cascade obt-filter-form select{background-color:#8facb0}.skin-Cascade obt-filter-form .form-control{color:#fff}.skin-Cascade .calendar-section{background-color:#fff}.skin-Cascade obt-calendar .fc-toolbar h2{color:#000}.skin-Cascade obt-calendar .fc-today{background-color:#e8eeef}.skin-Cascade obt-calendar .fc-button{background:#d2dddf;background-image:none;color:#000;border-color:#b4c6ca;border-bottom-color:#b4c6ca}.skin-Cascade obt-calendar .fc-button.hover,.skin-Cascade obt-calendar .fc-button:active,.skin-Cascade obt-calendar .fc-button:hover{background-color:#f0f4f4}.skin-Cascade .tooltip-inner{background-color:#d2dddf;color:#000}.skin-Cascade .tooltip.top .tooltip-arrow{border-top-color:#d2dddf}.skin-Cascade .tooltip.right .tooltip-arrow{border-right-color:#d2dddf}.skin-Cascade .tooltip.bottom .tooltip-arrow{border-bottom-color:#d2dddf}.skin-Cascade .tooltip.left .tooltip-arrow{border-left-color:#d2dddf}.skin-Cascade hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-Cascade .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-Cascade .btn-warning-advisor :active,.skin-Cascade .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-Cascade .btn-secondary-outline,.skin-Cascade .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-Cascade .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-Coral .bg-light{background-color:#fff;color:#7f4423}.skin-Coral .bg-light .btn-link,.skin-Coral .bg-light a{color:#7f4423}.skin-Coral .bg-medium{background-color:#ffe7da;color:#7f4423}.skin-Coral .bg-medium .btn-link,.skin-Coral .bg-medium a{color:#7f4423}.skin-Coral .bg-medium2{background-color:#b25f31;color:#fff}.skin-Coral .bg-medium2 .btn-link,.skin-Coral .bg-medium2 a{color:#fff}.skin-Coral .bg-dark{background-color:#7f4423;color:#ffe7da}.skin-Coral .bg-dark .btn-link,.skin-Coral .bg-dark a{color:#ffe7da}.skin-Coral .bg-success{background-color:#red;color:#white}.skin-Coral .bg-success .btn-link,.skin-Coral .bg-success a{color:#white}.skin-Coral .bg-info{background-color:#b25f31;color:#fff}.skin-Coral .bg-info .btn-link,.skin-Coral .bg-info a{color:#fff}.skin-Coral .panel-variable{border-color:#7f4423}.skin-Coral .panel-variable>.panel-heading{color:#fff;background-color:#7f4423;border-color:#7f4423}.skin-Coral .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#7f4423}.skin-Coral .panel-variable>.panel-heading .badge{color:#7f4423;background-color:#fff}.skin-Coral .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#7f4423}.skin-Coral .box-variable{border-color:#7f4423}.skin-Coral .box-variable>.box-header{color:#fff;background-color:#7f4423;border-color:#7f4423}.skin-Coral .box-variable>.box-header+.box-body{border-top-color:#7f4423}.skin-Coral .box-variable>.box-footer+.panel-body{border-bottom-color:#7f4423}.skin-Coral .primary{color:#pink}.skin-Coral .primary-strong{color:#a05a2c}.skin-Coral .primary-light{color:#c2bcdb}.skin-Coral .main-header .navbar{background-color:#7f4423;border-color:#b25f31;color:#fff}.skin-Coral .main-header .dropdown-menu{border-color:#ffb790}.skin-Coral .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#ffcfb5}.skin-Coral .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#ffb790}.skin-Coral .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#ffcfb5}.skin-Coral .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#ffcfb5}.skin-Coral .main-header .navbar-right a{color:#fff}.skin-Coral .main-header .nav>li>a:hover,.skin-Coral .main-header .navbar-right a :hover{color:#000;background-color:#ffcfb5}@media (max-width:991px){.skin-Coral .main-header .navbar-right a{color:#fff}.skin-Coral .main-header .navbar-right a :hover{color:#000;background-color:#ffcfb5}}@media (min-width:768px){.skin-Coral .main-header .navbar-right a{color:#fff}.skin-Coral .main-header .navbar-right a :hover{color:#000;background-color:#ffcfb5}}.skin-Coral .content{background-color:#ffe7da}.skin-Coral .content a{color:#fff}.skin-Coral .main-footer{background-color:#7f4423;color:#fff;border-top:1px solid #7f4423}.skin-Coral .calendar a{color:#000}.skin-Coral obt-filter-form select{background-color:#e57a3f}.skin-Coral obt-filter-form .form-control{color:#fff}.skin-Coral .calendar-section{background-color:#fff}.skin-Coral obt-calendar .fc-toolbar h2{color:#000}.skin-Coral obt-calendar .fc-today{background-color:#ffe7da}.skin-Coral obt-calendar .fc-button{background:#ffcfb5;background-image:none;color:#000;border-color:#ffae82;border-bottom-color:#ffae82}.skin-Coral obt-calendar .fc-button.hover,.skin-Coral obt-calendar .fc-button:active,.skin-Coral obt-calendar .fc-button:hover{background-color:#fff0e8}.skin-Coral .tooltip-inner{background-color:#ffcfb5;color:#000}.skin-Coral .tooltip.top .tooltip-arrow{border-top-color:#ffcfb5}.skin-Coral .tooltip.right .tooltip-arrow{border-right-color:#ffcfb5}.skin-Coral .tooltip.bottom .tooltip-arrow{border-bottom-color:#ffcfb5}.skin-Coral .tooltip.left .tooltip-arrow{border-left-color:#ffcfb5}.skin-Coral hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-Coral .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-Coral .btn-warning-advisor :active,.skin-Coral .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-Coral .btn-secondary-outline,.skin-Coral .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-Coral .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-Patina .bg-light{background-color:#fff;color:#3f6053}.skin-Patina .bg-light .btn-link,.skin-Patina .bg-light a{color:#3f6053}.skin-Patina .bg-medium{background-color:#e1ece7;color:#3f6053}.skin-Patina .bg-medium .btn-link,.skin-Patina .bg-medium a{color:#3f6053}.skin-Patina .bg-medium2{background-color:#54806f;color:#fff}.skin-Patina .bg-medium2 .btn-link,.skin-Patina .bg-medium2 a{color:#fff}.skin-Patina .bg-dark{background-color:#3f6053;color:#e1ece7}.skin-Patina .bg-dark .btn-link,.skin-Patina .bg-dark a{color:#e1ece7}.skin-Patina .bg-success{background-color:#red;color:#white}.skin-Patina .bg-success .btn-link,.skin-Patina .bg-success a{color:#white}.skin-Patina .bg-info{background-color:#54806f;color:#fff}.skin-Patina .bg-info .btn-link,.skin-Patina .bg-info a{color:#fff}.skin-Patina .panel-variable{border-color:#3f6053}.skin-Patina .panel-variable>.panel-heading{color:#fff;background-color:#3f6053;border-color:#3f6053}.skin-Patina .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#3f6053}.skin-Patina .panel-variable>.panel-heading .badge{color:#3f6053;background-color:#fff}.skin-Patina .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#3f6053}.skin-Patina .box-variable{border-color:#3f6053}.skin-Patina .box-variable>.box-header{color:#fff;background-color:#3f6053;border-color:#3f6053}.skin-Patina .box-variable>.box-header+.box-body{border-top-color:#3f6053}.skin-Patina .box-variable>.box-footer+.panel-body{border-bottom-color:#3f6053}.skin-Patina .primary{color:#pink}.skin-Patina .primary-strong{color:#a05a2c}.skin-Patina .primary-light{color:#c2bcdb}.skin-Patina .main-header .navbar{background-color:#3f6053;border-color:#54806f;color:#fff}.skin-Patina .main-header .dropdown-menu{border-color:#a5c6b9}.skin-Patina .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#c3d9d0}.skin-Patina .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#a5c6b9}.skin-Patina .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#c3d9d0}.skin-Patina .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#c3d9d0}.skin-Patina .main-header .navbar-right a{color:#fff}.skin-Patina .main-header .nav>li>a:hover,.skin-Patina .main-header .navbar-right a :hover{color:#000;background-color:#c3d9d0}@media (max-width:991px){.skin-Patina .main-header .navbar-right a{color:#fff}.skin-Patina .main-header .navbar-right a :hover{color:#000;background-color:#c3d9d0}}@media (min-width:768px){.skin-Patina .main-header .navbar-right a{color:#fff}.skin-Patina .main-header .navbar-right a :hover{color:#000;background-color:#c3d9d0}}.skin-Patina .content{background-color:#e1ece7}.skin-Patina .content a{color:#fff}.skin-Patina .main-footer{background-color:#3f6053;color:#fff;border-top:1px solid #3f6053}.skin-Patina .calendar a{color:#000}.skin-Patina obt-filter-form select{background-color:#6aa18b}.skin-Patina obt-filter-form .form-control{color:#fff}.skin-Patina .calendar-section{background-color:#fff}.skin-Patina obt-calendar .fc-toolbar h2{color:#000}.skin-Patina obt-calendar .fc-today{background-color:#e1ece7}.skin-Patina obt-calendar .fc-button{background:#c3d9d0;background-image:none;color:#000;border-color:#a4c5b8;border-bottom-color:#a4c5b8}.skin-Patina obt-calendar .fc-button.hover,.skin-Patina obt-calendar .fc-button:active,.skin-Patina obt-calendar .fc-button:hover{background-color:#e2ede8}.skin-Patina .tooltip-inner{background-color:#c3d9d0;color:#000}.skin-Patina .tooltip.top .tooltip-arrow{border-top-color:#c3d9d0}.skin-Patina .tooltip.right .tooltip-arrow{border-right-color:#c3d9d0}.skin-Patina .tooltip.bottom .tooltip-arrow{border-bottom-color:#c3d9d0}.skin-Patina .tooltip.left .tooltip-arrow{border-left-color:#c3d9d0}.skin-Patina hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-Patina .btn-warning-advisor{background-color:#c87137;border-color:#c87137;color:#fff}.skin-Patina .btn-warning-advisor :active,.skin-Patina .btn-warning-advisor :hover{background-color:#a05a2c;border-color:#a05a2c;color:#fff}.skin-Patina .btn-secondary-outline,.skin-Patina .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-Patina .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-Puce .bg-light{background-color:#fff;color:#684349}.skin-Puce .bg-light .btn-link,.skin-Puce .bg-light a{color:#684349}.skin-Puce .bg-medium{background-color:#f5e6e9;color:#684349}.skin-Puce .bg-medium .btn-link,.skin-Puce .bg-medium a{color:#684349}.skin-Puce .bg-medium2{background-color:#a66b74;color:#fff}.skin-Puce .bg-medium2 .btn-link,.skin-Puce .bg-medium2 a{color:#fff}.skin-Puce .bg-dark{background-color:#684349;color:#f5e6e9}.skin-Puce .bg-dark .btn-link,.skin-Puce .bg-dark a{color:#f5e6e9}.skin-Puce .bg-success{background-color:#red;color:#white}.skin-Puce .bg-success .btn-link,.skin-Puce .bg-success a{color:#white}.skin-Puce .bg-info{background-color:#a66b74;color:#fff}.skin-Puce .bg-info .btn-link,.skin-Puce .bg-info a{color:#fff}.skin-Puce .panel-variable{border-color:#684349}.skin-Puce .panel-variable>.panel-heading{color:#fff;background-color:#684349;border-color:#684349}.skin-Puce .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#684349}.skin-Puce .panel-variable>.panel-heading .badge{color:#684349;background-color:#fff}.skin-Puce .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#684349}.skin-Puce .box-variable{border-color:#684349}.skin-Puce .box-variable>.box-header{color:#fff;background-color:#684349;border-color:#684349}.skin-Puce .box-variable>.box-header+.box-body{border-top-color:#684349}.skin-Puce .box-variable>.box-footer+.panel-body{border-bottom-color:#684349}.skin-Puce .primary{color:#pink}.skin-Puce .primary-strong{color:#a05a2c}.skin-Puce .primary-light{color:#c2bcdb}.skin-Puce .main-header .navbar{background-color:#684349;border-color:#a66b74;color:#fff}.skin-Puce .main-header .dropdown-menu{border-color:#e2b6bd}.skin-Puce .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#ecced3}.skin-Puce .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#e2b6bd}.skin-Puce .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#ecced3}.skin-Puce .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#ecced3}.skin-Puce .main-header .navbar-right a{color:#fff}.skin-Puce .main-header .nav>li>a:hover,.skin-Puce .main-header .navbar-right a :hover{color:#000;background-color:#ecced3}@media (max-width:991px){.skin-Puce .main-header .navbar-right a{color:#fff}.skin-Puce .main-header .navbar-right a :hover{color:#000;background-color:#ecced3}}@media (min-width:768px){.skin-Puce .main-header .navbar-right a{color:#fff}.skin-Puce .main-header .navbar-right a :hover{color:#000;background-color:#ecced3}}.skin-Puce .content{background-color:#f5e6e9}.skin-Puce .content a{color:#fff}.skin-Puce .main-footer{background-color:#684349;color:#fff;border-top:1px solid #684349}.skin-Puce .calendar a{color:#000}.skin-Puce obt-filter-form select{background-color:#d08692}.skin-Puce obt-filter-form .form-control{color:#fff}.skin-Puce .calendar-section{background-color:#fff}.skin-Puce obt-calendar .fc-toolbar h2{color:#000}.skin-Puce obt-calendar .fc-today{background-color:#f5e6e9}.skin-Puce obt-calendar .fc-button{background:#ecced3;background-image:none;color:#000;border-color:#dea9b2;border-bottom-color:#dea9b2}.skin-Puce obt-calendar .fc-button.hover,.skin-Puce obt-calendar .fc-button:active,.skin-Puce obt-calendar .fc-button:hover{background-color:#faf3f4}.skin-Puce .tooltip-inner{background-color:#ecced3;color:#000}.skin-Puce .tooltip.top .tooltip-arrow{border-top-color:#ecced3}.skin-Puce .tooltip.right .tooltip-arrow{border-right-color:#ecced3}.skin-Puce .tooltip.bottom .tooltip-arrow{border-bottom-color:#ecced3}.skin-Puce .tooltip.left .tooltip-arrow{border-left-color:#ecced3}.skin-Puce hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-Puce .btn-warning-advisor{background-color:#8592d1;border-color:#8592d1;color:#fff}.skin-Puce .btn-warning-advisor :active,.skin-Puce .btn-warning-advisor :hover{background-color:#5d6692;border-color:#5d6692;color:#fff}.skin-Puce .btn-secondary-outline,.skin-Puce .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-Puce .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-MilanoRed .bg-light{background-color:#fff;color:#6a1300}.skin-MilanoRed .bg-light .btn-link,.skin-MilanoRed .bg-light a{color:#6a1300}.skin-MilanoRed .bg-medium{background-color:#f7e8e5;color:#6a1300}.skin-MilanoRed .bg-medium .btn-link,.skin-MilanoRed .bg-medium a{color:#6a1300}.skin-MilanoRed .bg-medium2{background-color:#a01c00;color:#fff}.skin-MilanoRed .bg-medium2 .btn-link,.skin-MilanoRed .bg-medium2 a{color:#fff}.skin-MilanoRed .bg-dark{background-color:#6a1300;color:#f7e8e5}.skin-MilanoRed .bg-dark .btn-link,.skin-MilanoRed .bg-dark a{color:#f7e8e5}.skin-MilanoRed .bg-success{background-color:#red;color:#white}.skin-MilanoRed .bg-success .btn-link,.skin-MilanoRed .bg-success a{color:#white}.skin-MilanoRed .bg-info{background-color:#a01c00;color:#fff}.skin-MilanoRed .bg-info .btn-link,.skin-MilanoRed .bg-info a{color:#fff}.skin-MilanoRed .panel-variable{border-color:#6a1300}.skin-MilanoRed .panel-variable>.panel-heading{color:#fff;background-color:#6a1300;border-color:#6a1300}.skin-MilanoRed .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#6a1300}.skin-MilanoRed .panel-variable>.panel-heading .badge{color:#6a1300;background-color:#fff}.skin-MilanoRed .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#6a1300}.skin-MilanoRed .box-variable{border-color:#6a1300}.skin-MilanoRed .box-variable>.box-header{color:#fff;background-color:#6a1300;border-color:#6a1300}.skin-MilanoRed .box-variable>.box-header+.box-body{border-top-color:#6a1300}.skin-MilanoRed .box-variable>.box-footer+.panel-body{border-bottom-color:#6a1300}.skin-MilanoRed .primary{color:#pink}.skin-MilanoRed .primary-strong{color:#a05a2c}.skin-MilanoRed .primary-light{color:#c2bcdb}.skin-MilanoRed .main-header .navbar{background-color:#6a1300;border-color:#a01c00;color:#fff}.skin-MilanoRed .main-header .dropdown-menu{border-color:#d88f7f}.skin-MilanoRed .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#e7bcb2}.skin-MilanoRed .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#d88f7f}.skin-MilanoRed .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#e7bcb2}.skin-MilanoRed .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#e7bcb2}.skin-MilanoRed .main-header .navbar-right a{color:#fff}.skin-MilanoRed .main-header .nav>li>a:hover,.skin-MilanoRed .main-header .navbar-right a :hover{color:#000;background-color:#e7bcb2}@media (max-width:991px){.skin-MilanoRed .main-header .navbar-right a{color:#fff}.skin-MilanoRed .main-header .navbar-right a :hover{color:#000;background-color:#e7bcb2}}@media (min-width:768px){.skin-MilanoRed .main-header .navbar-right a{color:#fff}.skin-MilanoRed .main-header .navbar-right a :hover{color:#000;background-color:#e7bcb2}}.skin-MilanoRed .content{background-color:#f7e8e5}.skin-MilanoRed .content a{color:#fff}.skin-MilanoRed .main-footer{background-color:#6a1300;color:#fff;border-top:1px solid #6a1300}.skin-MilanoRed .calendar a{color:#000}.skin-MilanoRed obt-filter-form select{background-color:#b93619}.skin-MilanoRed obt-filter-form .form-control{color:#fff}.skin-MilanoRed .calendar-section{background-color:#fff}.skin-MilanoRed obt-calendar .fc-toolbar h2{color:#000}.skin-MilanoRed obt-calendar .fc-today{background-color:#f7e8e5}.skin-MilanoRed obt-calendar .fc-button{background:#e7bcb2;background-image:none;color:#000;border-color:#db9a8b;border-bottom-color:#db9a8b}.skin-MilanoRed obt-calendar .fc-button.hover,.skin-MilanoRed obt-calendar .fc-button:active,.skin-MilanoRed obt-calendar .fc-button:hover{background-color:#f3ded9}.skin-MilanoRed .tooltip-inner{background-color:#e7bcb2;color:#000}.skin-MilanoRed .tooltip.top .tooltip-arrow{border-top-color:#e7bcb2}.skin-MilanoRed .tooltip.right .tooltip-arrow{border-right-color:#e7bcb2}.skin-MilanoRed .tooltip.bottom .tooltip-arrow{border-bottom-color:#e7bcb2}.skin-MilanoRed .tooltip.left .tooltip-arrow{border-left-color:#e7bcb2}.skin-MilanoRed hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-MilanoRed .btn-warning-advisor{background-color:#0091b2;border-color:#0091b2;color:#fff}.skin-MilanoRed .btn-warning-advisor :active,.skin-MilanoRed .btn-warning-advisor :hover{background-color:#00748e;border-color:#00748e;color:#fff}.skin-MilanoRed .btn-secondary-outline,.skin-MilanoRed .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-MilanoRed .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}.skin-JungleGreen .bg-light{background-color:#fff;color:#135b3a}.skin-JungleGreen .bg-light .btn-link,.skin-JungleGreen .bg-light a{color:#135b3a}.skin-JungleGreen .bg-medium{background-color:#d3f0e3;color:#135b3a}.skin-JungleGreen .bg-medium .btn-link,.skin-JungleGreen .bg-medium a{color:#135b3a}.skin-JungleGreen .bg-medium2{background-color:#1f915d;color:#fff}.skin-JungleGreen .bg-medium2 .btn-link,.skin-JungleGreen .bg-medium2 a{color:#fff}.skin-JungleGreen .bg-dark{background-color:#135b3a;color:#d3f0e3}.skin-JungleGreen .bg-dark .btn-link,.skin-JungleGreen .bg-dark a{color:#d3f0e3}.skin-JungleGreen .bg-success{background-color:#red;color:#white}.skin-JungleGreen .bg-success .btn-link,.skin-JungleGreen .bg-success a{color:#white}.skin-JungleGreen .bg-info{background-color:#1f915d;color:#fff}.skin-JungleGreen .bg-info .btn-link,.skin-JungleGreen .bg-info a{color:#fff}.skin-JungleGreen .panel-variable{border-color:#135b3a}.skin-JungleGreen .panel-variable>.panel-heading{color:#fff;background-color:#135b3a;border-color:#135b3a}.skin-JungleGreen .panel-variable>.panel-heading+.panel-collapse>.panel-body{border-top-color:#135b3a}.skin-JungleGreen .panel-variable>.panel-heading .badge{color:#135b3a;background-color:#fff}.skin-JungleGreen .panel-variable>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#135b3a}.skin-JungleGreen .box-variable{border-color:#135b3a}.skin-JungleGreen .box-variable>.box-header{color:#fff;background-color:#135b3a;border-color:#135b3a}.skin-JungleGreen .box-variable>.box-header+.box-body{border-top-color:#135b3a}.skin-JungleGreen .box-variable>.box-footer+.panel-body{border-bottom-color:#135b3a}.skin-JungleGreen .primary{color:#pink}.skin-JungleGreen .primary-strong{color:#a05a2c}.skin-JungleGreen .primary-light{color:#c2bcdb}.skin-JungleGreen .main-header .navbar{background-color:#135b3a;border-color:#1f915d;color:#fff}.skin-JungleGreen .main-header .dropdown-menu{border-color:#7dd3ac}.skin-JungleGreen .main-header .navbar-nav>.tasks-menu>.dropdown-menu{background:#a8e1c7}.skin-JungleGreen .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a{border-bottom-color:#7dd3ac}.skin-JungleGreen .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li.menu>li>a :hover{color:#000;background-color:#a8e1c7}.skin-JungleGreen .main-header .navbar-nav>.tasks-menu>.dropdown-menu>li .menu>li>a:hover{background-color:#a8e1c7}.skin-JungleGreen .main-header .navbar-right a{color:#fff}.skin-JungleGreen .main-header .nav>li>a:hover,.skin-JungleGreen .main-header .navbar-right a :hover{color:#000;background-color:#a8e1c7}@media (max-width:991px){.skin-JungleGreen .main-header .navbar-right a{color:#fff}.skin-JungleGreen .main-header .navbar-right a :hover{color:#000;background-color:#a8e1c7}}@media (min-width:768px){.skin-JungleGreen .main-header .navbar-right a{color:#fff}.skin-JungleGreen .main-header .navbar-right a :hover{color:#000;background-color:#a8e1c7}}.skin-JungleGreen .content{background-color:#d3f0e3}.skin-JungleGreen .content a{color:#fff}.skin-JungleGreen .main-footer{background-color:#135b3a;color:#fff;border-top:1px solid #135b3a}.skin-JungleGreen .calendar a{color:#000}.skin-JungleGreen obt-filter-form select{background-color:#27b675}.skin-JungleGreen obt-filter-form .form-control{color:#fff}.skin-JungleGreen .calendar-section{background-color:#fff}.skin-JungleGreen obt-calendar .fc-toolbar h2{color:#000}.skin-JungleGreen obt-calendar .fc-today{background-color:#d3f0e3}.skin-JungleGreen obt-calendar .fc-button{background:#a8e1c7;background-image:none;color:#000;border-color:#82d4af;border-bottom-color:#82d4af}.skin-JungleGreen obt-calendar .fc-button.hover,.skin-JungleGreen obt-calendar .fc-button:active,.skin-JungleGreen obt-calendar .fc-button:hover{background-color:#ceeedf}.skin-JungleGreen .tooltip-inner{background-color:#a8e1c7;color:#000}.skin-JungleGreen .tooltip.top .tooltip-arrow{border-top-color:#a8e1c7}.skin-JungleGreen .tooltip.right .tooltip-arrow{border-right-color:#a8e1c7}.skin-JungleGreen .tooltip.bottom .tooltip-arrow{border-bottom-color:#a8e1c7}.skin-JungleGreen .tooltip.left .tooltip-arrow{border-left-color:#a8e1c7}.skin-JungleGreen hr.hrTooltip{border-top:1px solid #000;background-color:#000}.skin-JungleGreen .btn-warning-advisor{background-color:#b52666;border-color:#b52666;color:#fff}.skin-JungleGreen .btn-warning-advisor :active,.skin-JungleGreen .btn-warning-advisor :hover{background-color:#901e51;border-color:#901e51;color:#fff}.skin-JungleGreen .btn-secondary-outline,.skin-JungleGreen .btn-secondary-outline:focus{color:#fff;background-image:none;background-color:transparent;border-color:#fff;margin-left:5px;margin-right:5px}.skin-JungleGreen .btn-secondary-outline:hover{background-color:hsla(0,0%,100%,.5);border-color:transparent;margin-left:5px;margin-right:5px}", ""]);

	// exports


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	//blocks requie.js
	__webpack_require__(81);
	__webpack_require__(82);

	__webpack_require__(83);
	__webpack_require__(84);
	__webpack_require__(85);

	__webpack_require__(86);
	__webpack_require__(87);
	__webpack_require__(88);
	__webpack_require__(89);
	__webpack_require__(90);
	__webpack_require__(91);

	__webpack_require__(93);
	__webpack_require__(94);

	__webpack_require__(95);
	__webpack_require__(96);
	__webpack_require__(97);
	__webpack_require__(98);


/***/ },
/* 81 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular.module('blocks.logger', []);
	})();


/***/ },
/* 82 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('blocks.logger')
	        .factory('logger', logger);

	    logger.$inject = ['$log', 'toastr'];

	    /* @ngInject */
	    function logger($log, toastr) {
	        var service = {
	            showToasts: true,

	            error   : error,
	            info    : info,
	            success : success,
	            warning : warning,

	            // straight to console; bypass toastr
	            log     : $log.log
	        };

	        return service;
	        /////////////////////

	        function error(message, data, title) {
	            toastr.error(message, title);
	            $log.error('Error: ' + message, data);
	        }

	        function info(message, data, title) {
	//            toastr.info(message, title);
	            $log.info('Info: ' + message, data);
	        }

	        function success(message, data, title) {
	            toastr.success(message, title);
	            $log.info('Success: ' + message, data);
	        }

	        function warning(message, data, title) {
	            toastr.warning(message, title);
	            $log.warn('Warning: ' + message, data);
	        }
	    }
	}());


/***/ },
/* 83 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular.module('blocks.exception', ['blocks.logger']);
	})();


/***/ },
/* 84 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('blocks.exception')
	        .factory('exception', exception);

	    exception.$inject = ['logger'];

	    /* @ngInject */
	    function exception(logger) {
	        var service = {
	            catcher: catcher
	        };
	        return service;

	        function catcher(message) {
	            return function(reason) {
	                logger.error(message, reason);
	            };
	        }
	    }
	})();


/***/ },
/* 85 */
/***/ function(module, exports) {

	// Include in index.html so that app level exceptions are handled.
	// Exclude from testRunner.html which should run exactly what it wants to run
	(function() {
	    'use strict';

	    angular
	        .module('blocks.exception')
	        .provider('exceptionHandler', exceptionHandlerProvider)
	        .config(config);

	    /**
	     * Must configure the exception handling
	     * @return {[type]}
	     */
	    function exceptionHandlerProvider() {
	        /* jshint validthis:true */
	        this.config = {
	            appErrorPrefix: undefined
	        };

	        this.configure = function (appErrorPrefix) {
	            this.config.appErrorPrefix = appErrorPrefix;
	        };

	        this.$get = function() {
	            return {config: this.config};
	        };
	    }

	    config.$inject = ['$provide'];

	    /**
	     * Configure by setting an optional string value for appErrorPrefix.
	     * Accessible via config.appErrorPrefix (via config value).
	     * @param  {[type]} $provide
	     * @return {[type]}
	     * @ngInject
	     */
	    function config($provide) {
	        $provide.decorator('$exceptionHandler', extendExceptionHandler);
	    }

	    extendExceptionHandler.$inject = ['$delegate', 'exceptionHandler', 'logger'];

	    /**
	     * Extend the $exceptionHandler service to also display a toast.
	     * @param  {Object} $delegate
	     * @param  {Object} exceptionHandler
	     * @param  {Object} logger
	     * @return {Function} the decorated $exceptionHandler service
	     */
	    function extendExceptionHandler($delegate, exceptionHandler, logger) {
	        return function(exception, cause) {
	            var appErrorPrefix = exceptionHandler.config.appErrorPrefix || '';
	            var errorData = {exception: exception, cause: cause};
	            exception.message = appErrorPrefix + exception.message;
	            $delegate(exception, cause);
	            /**
	             * Could add the error to a service's collection,
	             * add errors to $rootScope, log errors to remote web server,
	             * or log locally. Or throw hard. It is entirely up to you.
	             * throw exception;
	             *
	             * @example
	             *     throw { message: 'error message we added' };
	             */
	            logger.error(exception.message, errorData);
	        };
	    }
	})();


/***/ },
/* 86 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular.module('blocks.modal', ['blocks.logger']);
	})();

/***/ },
/* 87 */
/***/ function(module, exports) {

	(function () {
	    "use strict";
	    angular
	        .module('blocks.modal')
	        .directive('obtModalPopup', obtModalPopup)
	        .directive('obtModalPopupChoice', obtModalPopupChoice);

	    function obtModalPopup() {
	        return {
	            restrict : 'E',
	            require: '?^obtModalPopups', /*optional*/
	            scope : {
	                name : '=?',
	                title: '@?',
	                templateUrl:'@',
	                templateController: '@',
	                openModalPromise: '=?',
	                modalModel : '=?'
	            },
	            controller: ctrlFn ,
	            link : linkFn
	        };
	    }

	    function obtModalPopupChoice() {
	        return {
	            restrict : 'E',
	            require: '^obtModalPopup', /*required*/
	            scope : {
	                templateConditionName:'@?',
	                templateConditionValue:'@?',
	                templateConditionFn:'&?', // it have the hightest priority
	                templateUrl:'@',
	                templateController: '@?'
	            },
	            link : linkChoiceFn
	        };
	    }

	    //---------------------------------------------------------------------
	    //controller and link for modal

	    /*@ngInject*/
	    function ctrlFn ($scope, logger, obtModalService) {

	        var modalChoices = [];

	        $scope.name = {
	            open : openModal
	        };

	        $scope.openModalPromise = openModal;

	        this.addModalChoice = addModalChoice;

	        function addModalChoice(choice){
	            modalChoices.push(choice);
	        }

	        function openModal(model, success, fail){
	            var settings = getModalSettings(model, success, fail);
	            return obtModalService.openModal(settings).result.then(modalClosed);
	        }

	        function modalClosed(data){
	            if (data) {
	                if (data.error === 0) {
	                    logger.success( data.message);
	                }
	                else if (data.error === 2) {
	                    logger.error(data.message, data);
	                }
	                else {
	                    logger.error("error raised during process");
	                }
	            }
	        }

	        function getModalSettings(model, success, fail){
	            // set default value
	            var templateUrl = $scope.templateUrl;
	            var templateController = $scope.templateController;

	            //check if a choice is valid
	            if (modalChoices && model) {
	                var firstMatchingChoice = modalChoices.filter(function(item){
	                    return item && item.templateConditionName != null ? String(model[item.templateConditionName]) == item.templateConditionValue : false;
	                }).shift();

	                console.log(firstMatchingChoice);

	                if(firstMatchingChoice){
	                    templateUrl = firstMatchingChoice.templateUrl ? firstMatchingChoice.templateUrl : templateUrl;
	                    templateController = firstMatchingChoice.templateController ? firstMatchingChoice.templateController : templateController;
	                }
	            }

	            var settings = {
	                templateUrl:templateUrl,
	                controller:templateController
	            };

	            $scope.usedModalModel = ! angular.isUndefined(model) ? model : $scope.modalModel;
	            settings.resolve = settings.resolve ? settings.resolve : {};
	            settings.resolve.modalModel = getSelectedModalModel;

	            settings.callbackSuccess = success || callbackSuccess;
	            settings.callbackFailed = fail || success || callbackFailed;
	            return settings;
	        }

	        function getSelectedModalModel(){
	            return $scope.usedModalModel;
	        }

	        function callbackSuccess (selectedItem) {
	            $scope.selected = selectedItem;
	        }

	        function callbackFailed () {
	        }
	    }
	    ctrlFn.$inject = ["$scope", "logger", "obtModalService"];

	    function linkFn(scope, element, attributes, modalsController){
	        if (modalsController) {
	            modalsController.addModalOption({
	                title: attributes.title,
	                openModalPromise: scope.openModalPromise
	            });
	        }
	    }

	    //----------------------------------------------------------------------
	    //controller and link for modal choice

	    function linkChoiceFn(scope, element, attributes, modalController){
	        if (modalController) {
	            modalController.addModalChoice({
	                templateConditionName: scope.templateConditionName,
	                templateConditionValue: scope.templateConditionValue,
	                templateUrl: scope.templateUrl,
	                templateController : scope.templateController
	            });
	        }
	    }
	})();

/***/ },
/* 88 */
/***/ function(module, exports) {

	(function () {

	    "use strict";

	    angular
	        .module('blocks.modal')
	        .service('obtModalService', obtModalService);

	        obtModalService.$inject=['$rootScope','$uibModal','$state'];
	    /*@ngInject*/
	    function obtModalService($rootScope, $uibModal, $state){
	        return {
	            openModal:openModal
	        };

	        function openModal(args){
	            args.callbackSuccess = args.callbackSuccess ? args.callbackSuccess :  angular.noop;
	            args.callbackFailed = args.callbackFailed ? args.callbackFailed: angular.noop;
	            args.size = args.size ? args.size : '';/* '' vs 'sm' vs 'lg'*/
	            args.notLinkedToState = args.notLinkedToState ?  args.notLinkedToState : false;
	            args.backdrop = (typeof args.backdrop === 'boolean' ?  args.backdrop : true);
	            args.windowClass = args.windowClass ?  args.windowClass : 'right fade';

	            var modalInstance = $uibModal.open(args);

	            modalInstance.result.then(args.callbackSuccess,args.callbackFailed);
	            if(! args.notLinkedToState){
	                registerExistStateEvent(modalInstance);
	            }
	            return modalInstance;
	        }

	        function registerExistStateEvent(modalInstance){
	            /* register to find when the current state is leaved */
	            var currentState = $state.current.name ;/* returns the current*/
	            var listener = $rootScope.$on('$stateChangeStart',
	                function(event, toState, toParams, fromState, fromParams){
	                    if(fromState.name === currentState){
	                        /*close modal*/
	                        modalInstance.dismiss('State leaved');
	                        listener();
	                    }
	                });
	        }
	    }
	})();


/***/ },
/* 89 */
/***/ function(module, exports) {

	(function () {
	    'use strict';
	    angular
	        .module('blocks.modal')
	        .controller('modalsController', modalsController);

	    modalsController.$inject = ['$uibModalInstance','modalModel','modalSettings'];
	    /*@ngInject*/
	    function modalsController($uibModalInstance, modalModel, modalSettings) {
	        var vm = this;
	        vm.options = modalSettings.options;
	        vm.title = modalSettings.title;

	        vm.ok = function () {
	            $uibModalInstance.close({message:'test'});
	        };

	        vm.cancel = function () {
	            $uibModalInstance.dismiss('cancel');
	        };


	        vm.selectOption = function (position) {
	            $uibModalInstance.dismiss('open new modal');
	            vm.options[position].openModalPromise(modalModel, modalSettings.closeCallback);
	        };
	    }
	})();


/***/ },
/* 90 */
/***/ function(module, exports) {

	(function () {
	    "use strict";

	    angular
	        .module('blocks.modal')
	        .directive('obtModalPopups', obtModalPopups);

	    /*@ngInject*/
	    function obtModalPopups() {
	        return {
	            restrict: 'E',
	            scope: {
	                openModalPromise: '=',
	                title: '@'
	            },
	            controller: obtModalPopupsCtrl
	        }
	    }

	    obtModalPopupsCtrl.$inject=['$scope', 'obtModalService'];
	    /*@ngInject*/
	    function obtModalPopupsCtrl ($scope, obtModalService) {
	        var vm = this;
	        $scope.openModalPromise = openModal;
	        vm.addModalOption = addModalOption;
	        var modalOptions = null;

	        function addModalOption (option) {
	            if (option) {
	                if (!modalOptions) {
	                    modalOptions = [];
	                }
	                modalOptions.push(option);
	            }
	        }

	        function openModal(calEvent, closeCallback) {
	            var settings = getModalSettings(calEvent, closeCallback);
	            return obtModalService.openModal(settings).result;
	        }

	        function getModalSettings(calEvent, closeCallback){
	            var settings = {
	                templateUrl: 'app/blocks/modal/obt-modals.directive.html',
	                controller:'modalsController',
	                controllerAs: 'vmModalPopups'
	            };

	            settings.resolve = settings.resolve ? settings.resolve : {};
	            settings.resolve.modalModel = function(){return calEvent};
	            settings.resolve.modalSettings = function(){
	                return {
	                    closeCallback: closeCallback,
	                    options:modalOptions,
	                    title:$scope.title
	                }};

	//                    settings.callbackSuccess = callbackSuccess;
	            settings.callbackFailed = callbackFailed;

	            return settings;
	        }
	        function callbackSuccess (selectedItem) {}
	        function callbackFailed () {
	//                    toaster.pop('error', "Error", "error raised during process");
	        }
	    }
	})();

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 06/02/15.
	 */
	(function () {
	    'use strict';
	    angular
	        .module('blocks.modal')
	        .directive('obtModalWrapper', obtModalWrapper);

	    /* @ngInject */
	    function obtModalWrapper() {
	        return {
	            restrict: 'E',
	            transclude: true,
	            template: __webpack_require__(92) ,
	            scope: {
	                modalTitle: '@',
	                trackEvent: '@?',
	                trackCategory: '@?',
	                trackLabel: '@?'
	            }
	        }
	    }
	})();

/***/ },
/* 92 */
/***/ function(module, exports) {

	module.exports = "<div class=modal-content><div class=modal-header ng-switch=\"trackEvent || '_undefined_'\"><button ng-switch-default analytics-on=click analytics-event={{trackEvent}} analytics-category={{trackCategory}} analytics-label={{trackLabel}} type=button class=close data-dismiss=modal ng-click=\"$parent.$parent.$dismiss('close button clicked')\"><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button> <button ng-switch-when=_undefined_ type=button class=close data-dismiss=modal ng-click=\"$parent.$parent.$dismiss('close button clicked')\"><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button><h3 ng-if=modalTitle class=modal-title ng-bind-html=modalTitle></h3></div><div class=modal-body ng-transclude></div><div class=modal-footer></div></div>";

/***/ },
/* 93 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular.module('blocks.router', [
	        'ui.router',
	        'blocks.logger'
	    ]);
	})();


/***/ },
/* 94 */
/***/ function(module, exports) {

	/* Help configure the state-base ui.router */
	(function() {
	    'use strict';

	    angular
	        .module('blocks.router')
	        .provider('routerHelper', routerHelperProvider);

	    routerHelperProvider.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];
	    /* @ngInject */
	    function routerHelperProvider($locationProvider, $stateProvider, $urlRouterProvider) {
	        /* jshint validthis:true */
	        var config = {
	            docTitle: undefined,
	            resolveAlways: {},
	            parent:'layout'
	        };

	        $locationProvider.html5Mode(true);

	        this.configure = function(cfg) {
	            angular.extend(config, cfg);
	        };

	        this.$get = RouterHelper;
	        RouterHelper.$inject = ['$location', '$rootScope', '$state', 'logger'];
	        /* @ngInject */
	        function RouterHelper($location, $rootScope, $state, logger) {
	            var handlingStateChangeError = false;
	            var hasOtherwise = false;
	            var stateCounts = {
	                errors: 0,
	                changes: 0
	            };

	            var service = {
	                configureStates: configureStates,
	                getStates: getStates,
	                stateCounts: stateCounts
	            };

	            init();

	            return service;

	            ///////////////

	            function configureStates(states, otherwisePath) {
	                states.forEach(function(state) {
	                    state.config.resolve =
	                        angular.extend(state.config.resolve || {}, config.resolveAlways);
	                    if(state.state !== config.parent){
	                        state.config.parent = state.config.parent ? state.config.parent : config.parent;
	                    }
	                    $stateProvider.state(state.state, state.config);
	                });
	                if (otherwisePath && !hasOtherwise) {
	                    hasOtherwise = true;
	                    $urlRouterProvider.otherwise(otherwisePath);
	                }
	            }

	            function handleRoutingErrors() {
	                // Route cancellation:
	                // On routing error, go to the dashboard.
	                // Provide an exit clause if it tries to do it twice.
	                $rootScope.$on('$stateChangeError',
	                    function(event, toState, toParams, fromState, fromParams, error) {
	                        if (handlingStateChangeError) {
	                            return;
	                        }
	                        stateCounts.errors++;
	                        handlingStateChangeError = true;
	                        var destination = (toState &&
	                            (toState.title || toState.name || toState.loadedTemplateUrl)) ||
	                            'unknown target';
	                        var msg = 'Error routing to ' + destination + '. ' +
	                            (error.data || '') + '. <br/>' + (error.statusText || '') +
	                            ': ' + (error.status || '');
	                        logger.warning(msg, {'fromState':fromState,'toState':toState});
	                        $location.path('/');
	                    }
	                );
	            }

	            function init() {
	                handleRoutingErrors();
	                updateDocTitle();
	            }

	            function getStates() { return $state.get(); }

	            function updateDocTitle() {
	                $rootScope.$on('$stateChangeSuccess',
	                    function(event, toState, toParams, fromState, fromParams) {
	                        stateCounts.changes++;
	                        handlingStateChangeError = false;
	                        var title = config.docTitle ; // + ' ' + (toState.title || '');
	                        $rootScope.title = title; // data bind to <title>
	                    }
	                );
	            }
	        }
	    }
	})();


/***/ },
/* 95 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular.module('blocks.storage', ['blocks.logger', 'ngStorage']);
	})();


/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 12/03/15.
	 */
	(function () {
	    'use strict';
	    angular
	        .module('blocks.storage')
	        .factory('reminderServices', reminderServices);

	    /*@ngInject*/
	    function reminderServices($localStorage){
	        initStorage(); //run the init function
	        return  {
	            add: add,
	            get: get,
	            clear: clear
	        };

	        function initStorage(){
	            if (!$localStorage.obtRememberMe) {
	                $localStorage.obtRememberMe = {};
	            }
	        }

	        function add(data) {
	            $localStorage.obtRememberMe = data;
	        }

	        function get(){
	            return $localStorage.obtRememberMe;
	        }

	        function clear(){
	            $localStorage.obtRememberMe = {};
	        }
	    }
	    reminderServices.$inject = ["$localStorage"];
	})();


/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 12/03/15.
	 */
	(function () {
	    'use strict';
	    angular
	        .module('blocks.storage')
	        .factory('sessionServices', sessionServices);

	    /*@ngInject*/
	    function sessionServices(config, obtStorage, logger){
	        var currentSession;
	        return  {
	            setSession:setSession,
	            getSession: getSession,
	            removeSession: removeSession,

	            setArgs : setArgs,
	            getArgs : getArgs
	        };
	        function setSession(data){
	            if(data){
	                data.language = data.language || config.language; //set a default language for every new session
	                obtStorage.removeSession(data.cId);
	                obtStorage.addSession(data);
	                currentSession = data;
	            }else{
	                logger.warning('setSession function received an empty object');
	            }
	        }

	        function getSession(cId){
	            if(!angular.isUndefined(cId)
	                && (!currentSession || currentSession.cId !== cId)){ //we search in the local storage
	                currentSession = obtStorage.findSession(cId);
	            }
	            return currentSession; //is cid is empty or CID = the current session, elsse we search it inside the local storage
	        }

	        function removeSession(cId){
	            if(!angular.isUndefined(cId)){
	                obtStorage.removeSession(cId);
	                if(currentSession && currentSession.cId === cId){
	                    currentSession = null;
	                }
	            }else if(currentSession){ //remove the current sessoin
	                obtStorage.removeSession(currentSession.cId);
	                currentSession = null;
	            }
	        }

	        function getArgs(arg){
	            return arg && currentSession ? currentSession[arg] :null;
	        }

	        function setArgs(name, value, createSessionIfMissing) {
	            if(! currentSession && createSessionIfMissing && name){
	                currentSession = {};
	            }
	            if(currentSession && name){
	                currentSession[name] = value;
	                setSession(currentSession);
	            }
	        }
	    }
	    sessionServices.$inject = ["config", "obtStorage", "logger"];
	})();


/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 28/11/14.
	 */
	(function(){
	    "use strict";
	    angular
	        .module('blocks.storage')
	        .factory('obtStorage', obtStorage);

	    /*@ngInject*/
	    function obtStorage($sessionStorage, $state, config, _, logger){
	        return ({
	            findSession: findSession,
	            removeSession: removeSession,
	            addSession: addSession
	        });

	        function addSession(session) {
	            if (!$sessionStorage.obtSessions) {
	                $sessionStorage.obtSessions = [];
	            }
	            $sessionStorage.obtSessions.push(session);
	        }

	        function findSessionBycId(cId, removeSelected) {
	            if (angular.isUndefined(cId)) {
	                return null;
	            }
	            if (angular.isUndefined(removeSelected)) {
	                removeSelected = false;
	            }

	            /*return -1 if not found*/
	            var uiToUse = $state.current && $state.current.obtVid && $state.current.obtPage ?
	                          $state.current.obtVid +''+ $state.current.obtPage : config.ui;
	            var itemIndex = _.findIndex($sessionStorage.obtSessions, function(session) {
	                return session.cId === cId && session.ui === uiToUse;
	            });

	            if (itemIndex >= 0) {
	                return removeSelected ? $sessionStorage.obtSessions.splice(itemIndex, 1)
	                                    : $sessionStorage.obtSessions[itemIndex];
	            }
	            return null;
	        }

	        function findSession(cId){
	            return findSessionBycId(cId, false);
	        }

	        function removeSession(cId){
	            while (findSessionBycId(cId, true)){
	                logger.log('session' + cId + ': removed');
	            }
	        }
	    }
	    obtStorage.$inject = ["$sessionStorage", "$state", "config", "_", "logger"];
	})();



/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	//angular = require('angular');
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(100);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);


/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 8/1/15.
	 */
	(function() {
	    'use strict';

	    angular
	        .module('app.core')
	        .factory('obtSocket', obtSocket );

	    obtSocket.$inject = ['socketFactory'];
	    /* @ngInject */
	    function obtSocket(socketFactory) {
	        var instance = null;
	        var instance_server_url = null;
	        var ioSocket = null;
	        var default_server_url = 'https://dev.martinblouin.com:8080';

	        //SOURCE: https://github.com/btford/angular-socket-io/issues/69
	        //source ; http://stackoverflow.com/questions/16518153/get-connection-status-on-socket-io-client
	        return {
	            connected:function(){
	                //if(ioSocket){
	                //    console.log('>>>>>>>>>>', ioSocket );
	                //}

	                if(ioSocket){
	                    return ioSocket.connected;
	                }
	                return false;
	            },
	            getSocket : function(server, port){
	                //var url = 'https://dev.martinblouin.com:8080';
	                try{
	                    if(server){
	                        var new_instance_server_url = port? server + ':' + port : server;
	                        if(instance && instance_server_url == new_instance_server_url){
	                            return instance; // the optimze and retunn the same socket instance.
	                        }else{
	                            instance_server_url = new_instance_server_url;
	                        }
	                    }else if(!instance_server_url){
	                        instance_server_url = default_server_url;
	                    }

	                    var options = {
	                        'reconnection delay': 1000,
	                        'reconnection limit': 1000,
	                        'max reconnection attempts': 'Infinity'
	                    };

	                    ioSocket = io.connect(instance_server_url, options);
	                    instance = socketFactory({ioSocket:ioSocket});
	                    return instance;

	                }catch(err){
	                    return null;
	                }
	            }
	        };
	    }
	})();


/***/ },
/* 101 */
/***/ function(module, exports) {

	(function () {
	        'use strict';

	        angular
	            .module('app.core', [
	                    'oc.lazyLoad',
	                    'ngAnimate', 'ngSanitize', 'ngResource', /*Angular*/
	                    'pascalprecht.translate',/*Translation*/
	                    'reCAPTCHA',
	                    'ngAutodisable',
	                    'uiGmapgoogle-maps',/*Map*/
	                    'mgo-angular-wizard', /*wizard*/

	                    'btford.socket-io',

	                    'formly',
	                    'formlyBootstrap',

	                    'angulartics', 'angulartics.google.analytics','angulartics.piwik',

	                    'validator',
	                    'builder', 'builder.components',

	                    'bootstrapLightbox',
	                    'angular-loading-bar',

	                    'ui.router', 'ui.calendar', 'ngplus', 'ui.bootstrap', 'ui.scrollfix', /*UI boostrap*/
	                    'blocks.exception', 'blocks.logger', 'blocks.router', 'blocks.storage', 'blocks.modal' /*obt  Bocks*/
	            ]);
	})();


/***/ },
/* 102 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.core')
	        .factory('bootstrap.dialog', modalDialog);

	    modalDialog.$inject = ['$uibModal', '$templateCache'];

	    /* @ngInject */
	    function modalDialog($uibModal, $templateCache) {
	        var service = {
	            deleteDialog: deleteDialog,
	            confirmationDialog: confirmationDialog
	        };

	        $templateCache.put('modalDialog.tpl.html',
	                '<div>' +
	                '    <div class="modal-header">' +
	                '        <button type="button" class="close" data-dismiss="modal" ' +
	                '            aria-hidden="true" data-ng-click="cancel()">&times;</button>' +
	                '        <h3>{{title}}</h3>' +
	                '    </div>' +
	                '    <div class="modal-body">' +
	                '        <p>{{message}}</p>' +
	                '    </div>' +
	                '    <div class="modal-footer">' +
	                '        <button class="btn btn-primary" data-ng-click="ok()">{{okText}}</button>' +
	                '        <button class="btn btn-info" data-ng-click="cancel()">{{cancelText}}</button>' +
	                '    </div>' +
	                '</div>');

	        return service;

	        function deleteDialog(itemName) {
	            var title = 'Confirm Delete';
	            itemName = itemName || 'item';
	            var msg = 'Delete ' + itemName + '?';

	            return confirmationDialog(title, msg);
	        }

	        function confirmationDialog(title, msg, okText, cancelText) {

	            var modalOptions = {
	                templateUrl: 'modalDialog.tpl.html',
	                controller: ModalInstance,
	                keyboard: true,
	                resolve: {
	                    options: function () {
	                        return {
	                            title: title,
	                            message: msg,
	                            okText: okText,
	                            cancelText: cancelText
	                        };
	                    }
	                }
	            };

	            return $uibModal.open(modalOptions).result;
	        }
	    }

	    ModalInstance.$inject = ['$scope', '$uibModalInstance', 'options'];

	    /* @ngInject */
	    function ModalInstance($scope, $uibModalInstance, options) {
	        $scope.title = options.title || 'Title';
	        $scope.message = options.message || '';
	        $scope.okText = options.okText || 'OK';
	        $scope.cancelText = options.cancelText || 'Cancel';
	        $scope.ok = function () {
	            $uibModalInstance.close('ok');
	        };
	        $scope.cancel = function () {
	            $uibModalInstance.dismiss('cancel');
	        };
	    }
	})();


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	    'use strict';

	    var core = angular.module('app.core');

	    var config = {
	        appErrorPrefix: '[obtAdvisor Error] ',
	        appTitle: 'TherapistBooking',
	        calendarDisabledImage:'image/calendarDisabledImage.png',
	        appServiceBaseUrl: '.',
	        language:'fr',
	        ui:'21'
	    };
	    core.value('config', config);

	    core.config(toastrConfig);
	    toastrConfig.$inject = ['toastr'];
	    /* @ngInject */
	    function toastrConfig(toastr) {
	        toastr.options.timeOut = 4000;
	        toastr.options.positionClass = 'toast-bottom-right';
	    }

	    core.config(reCAPTCHA);
	    reCAPTCHA.$inject = ['reCAPTCHAProvider'];
	    function reCAPTCHA(reCAPTCHAProvider) {
	        // required: please use your own key :)
	        reCAPTCHAProvider.setPublicKey('6Lexr_USAAAAADBE6Z3osj77aI8VH1AR_zeZPRHe');

	        // optional: gets passed into the Recaptcha.create call
	        reCAPTCHAProvider.setOptions({
	            theme:"custom",
	            custom_theme_widget:"recaptcha_widget"
	        });
	    }
	    core.config(["vcRecaptchaServiceProvider", function(vcRecaptchaServiceProvider){
	  vcRecaptchaServiceProvider.setDefaults({
	    key: '6LflOkIUAAAAAHywKymkFP3qML2h5Z0TH5axVJ8S'

	  });
	}]);
	    core.config(mapConfig);
	    mapConfig.$inject = ['uiGmapGoogleMapApiProvider'];
	    /* @ngInject */
	    function mapConfig (uiGmapGoogleMapApiProvider) {
	        uiGmapGoogleMapApiProvider.configure({
	//            key: 'AIzaSyC1M07ycLC7xzr9_f5iN-f1DkLIS6kiajc',
	            key: 'AIzaSyBAZj6rZNYvt6O7EsTipxGrl8_xSUmaTZI',  ///maleye key
	            v: '3',
	            libraries: 'weather,geometry,visualization'
	        });
	    }


	    core.config(translateConfig);
	    /*@ngInject*/
	    function translateConfig($translateProvider) {
	        $translateProvider.preferredLanguage('fr');
	        $translateProvider.useStaticFilesLoader({
	            prefix: './locales/',
	            suffix: '.json'
	        })
	    }
	    translateConfig.$inject = ["$translateProvider"];

	    core.config(configure);
	    configure.$inject = ['$logProvider', 'routerHelperProvider', 'exceptionHandlerProvider'];
	    function configure($logProvider, routerHelperProvider, exceptionHandlerProvider) {
	        if ($logProvider.debugEnabled) {
	            $logProvider.debugEnabled(true);
	        }
	        exceptionHandlerProvider.configure(config.appErrorPrefix);
	        routerHelperProvider.configure({docTitle: config.appTitle });
	    }

	    core.run(['$templateCache', function($templateCache) {
	        //ADD THE TEMPLATE INSIDE THE $TEMPLATECACHE
	        $templateCache.put("lightbox.html",  __webpack_require__(104));
	        // NG INCLUDE
	        $templateCache.put("app/layout/header/header-advisor.html",  __webpack_require__(105));
	        $templateCache.put("app/layout/subFooter.html",  __webpack_require__(106));
	        $templateCache.put("app/layout/header/header-association.html",  __webpack_require__(107));
	        $templateCache.put("app/booking/booking-cascade-options.html",  __webpack_require__(108));
	        $templateCache.put("app/layout/header/header-clinic.html",  __webpack_require__(109));
	        $templateCache.put("app/layout/header/header-clinicTherapist.html",  __webpack_require__(110));
	        $templateCache.put("app/layout/header/header-404.html",  __webpack_require__(111));
	        $templateCache.put("app/layout/header/header-dynamic.html",  __webpack_require__(112));
	        $templateCache.put("app/layout/sidebar.html",  __webpack_require__(113));
	        $templateCache.put("app/layout/header.html",  __webpack_require__(114));
	        $templateCache.put("app/layoutV2/sidebar.html",  __webpack_require__(115));
	        $templateCache.put("app/layout/footer.html",  __webpack_require__(116));
	        $templateCache.put("app/layoutV2/header.html",  __webpack_require__(117));
	        $templateCache.put("app/layoutV2/content.html",  __webpack_require__(118));
	        $templateCache.put("app/layoutV2/footer.html",  __webpack_require__(119));
	        $templateCache.put("app/layout/header/header-therapist.html",  __webpack_require__(120));

	        // TEMPLATE-URL
	        $templateCache.put("app/booking/add.html",  __webpack_require__(121));
	        $templateCache.put("app/login/signIn.html",  __webpack_require__(122));
	        $templateCache.put("app/therapist/filter-tpl.html",  __webpack_require__(123));
	        $templateCache.put("app/booking/requestBooking.html",  __webpack_require__(124));
	        $templateCache.put("app/booking/addToWaitingList.html",  __webpack_require__(125));
	        $templateCache.put("app/resellers/reports/resellerBookingReport.filter.html",  __webpack_require__(126));
	        $templateCache.put("app/booking/buttonRequestBooking.html",  __webpack_require__(127));

	        $templateCache.put("app/blocks/modal/obt-modalWrapper.directive.html",  __webpack_require__(92));

	        $templateCache.put("app/widgets/profileCard/obt-ProfileCard.html",  __webpack_require__(128));
	        $templateCache.put("app/widgets/profileCard/obt-ProfileCard-map.html",  __webpack_require__(129));

	        $templateCache.put("app/widgets/map/obt-map-window.tpl.html",  __webpack_require__(130));

	        $templateCache.put("app/widgets/obtSection/obtSection.html",  __webpack_require__(131));
	        $templateCache.put("app/widgets/obtSection/type_1.html",  __webpack_require__(132));
	        $templateCache.put("app/widgets/obtSection/type_2.html",  __webpack_require__(133));
	        $templateCache.put("app/widgets/obtSection/type_3.html",  __webpack_require__(134));
	        $templateCache.put("app/widgets/obtSection/type_4.html",  __webpack_require__(135));
	        $templateCache.put("app/widgets/obtSection/type_5.html",  __webpack_require__(136));
	        $templateCache.put("app/widgets/obtSection/type_6.html",  __webpack_require__(137));
	        $templateCache.put("app/widgets/obtSection/type_7.html",  __webpack_require__(138));
	        $templateCache.put("app/widgets/obtSection/type_8.html",  __webpack_require__(139));
	        $templateCache.put("app/widgets/obtSection/type_9.html",  __webpack_require__(140));
	        $templateCache.put("app/widgets/obtSection/type_100.html",  __webpack_require__(141));
	        $templateCache.put("app/widgets/obtSection/type_101.html",  __webpack_require__(142));
	        $templateCache.put("app/widgets/obtSection/type_103.html",  __webpack_require__(143));
	        $templateCache.put("app/widgets/obtSection/type_106.html",  __webpack_require__(144));
	        $templateCache.put("app/widgets/obtMenu.html",  __webpack_require__(145));

	        $templateCache.put("template/ngCart/addtocart.html",  __webpack_require__(146));
	        $templateCache.put("template/ngCart/checkout.html",  __webpack_require__(147));
	        $templateCache.put("template/ngCart/cart.html",  __webpack_require__(148));
	        $templateCache.put("template/ngCart/summary.html",  __webpack_require__(149));

	        // templateUrl



	          $templateCache.put("app/login/updateSectionDirective/updateSectionDirective.html",  __webpack_require__(150));

	    }]);

	    core.run(['$anchorScroll', function($anchorScroll) {
	        $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	    }]);

	    core.run(["$window", "$rootScope", "RouterTransitionService", "$translate", "config", "$anchorScroll", "dataservice", "$state", function($window, $rootScope, RouterTransitionService, $translate, config, $anchorScroll,dataservice,$state){
	        //$window.moment.locale('en-my-settings', {
	        //    // customizations.
	        //    'longDateFormat' : {'lly': "ddd, MMMM D"}
	        //});

	        // debug - ui router //
	        $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams){
	            //if(toParams.language != fromState.language){
	            //  console.debug('UPDATE LANGUAGE from ', fromState.language, ' to ', toParams.language);
	            //  $translate.use(toParams.language); //update the selected labguage if required
	            //  config.language = toParams.language;
	            //}
	            RouterTransitionService.stateChangeStart(toState, toParams, fromState, fromParams);
	           // console.log('$stateChangeStart to '+toState.name+'- fired when the transition begins. toState,toParams : \n',toState, JSON.stringify(toParams));

	        });

	        $rootScope.$on('$stateChangeError',function(event, toState, toParams, fromState, fromParams){
	            RouterTransitionService.stateChangeError(toState, toParams, fromState, fromParams);
	            console.log('$stateChangeError - fired when an error occurs during transition.');
	            console.log(arguments);
	        });

	        $rootScope.$on('$stateChangeSuccess',function(event, toState, toParams, fromState, fromParams){
	            RouterTransitionService.stateChangeSuccess(toState, toParams, fromState, fromParams);
	            console.log('$stateChangeSuccess to '+toState.name+'- fired once the state transition is complete.');
	            if(!$state.includes('therapistClinic.service')){
	                    dataservice.therapist.getTherapist(toParams.cId, toParams.tId).then(function(data){
	                      console.log(data,'not service');
	                    dataservice.page.setNavBarTitle(data.navBarTitle);
	                    dataservice.page.setMenu(data.navBarMenu);
	                    dataservice.page.setPageSection(data.pageSections);
	                 });
	            }
	            else{
	              dataservice.dynamic.getServiceContent(toParams.sId, toParams.cId).then(function(data){
	                console.log(data,'my params');
	              dataservice.page.setPageSection(data.features);
	              });
	        
	            }
	            $anchorScroll();
	        });

	        $rootScope.$on('$viewContentLoaded',function(event){
	            RouterTransitionService.viewContentLoaded();
	            console.log('$viewContentLoaded - fired after dom rendered',event);
	        });

	        $rootScope.$on('$stateNotFound',function(event, unfoundState, fromState, fromParams){
	            RouterTransitionService.stateNotFound(unfoundState, fromState, fromParams);
	            console.log('$stateNotFound '+unfoundState.to+'  - fired when a state cannot be found by its name.');
	            console.log(unfoundState, fromState, fromParams);
	        });
	    }]);
	})();


/***/ },
/* 104 */
/***/ function(module, exports) {

	module.exports = "<div class=modal-body style=\"height: auto\" ng-swipe-left=Lightbox.nextImage() ng-swipe-right=Lightbox.prevImage()><div class=lightbox-nav><button class=close aria-hidden=true ng-click=$dismiss()>×</button><div class=btn-group ng-if=\"Lightbox.images.length > 1\"><a class=\"btn btn-xs btn-default\" ng-click=Lightbox.prevImage()><i class=\"fa fa-arrow-left\" aria-hidden=true></i></a> <a ng-href={{Lightbox.imageUrl}} target=_blank class=\"btn btn-xs btn-default\" title=\"Open in new tab\">{{'LIGHTBOX_OPEN_IN_NEW_TAB'| translate }}</a> <a class=\"btn btn-xs btn-default\" ng-click=Lightbox.nextImage()><i class=\"fa fa-arrow-right\" aria-hidden=true></i></a></div></div><div class=lightbox-image-container><div class=lightbox-image-caption><span>{{Lightbox.imageCaption}}</span></div><img ng-if=!Lightbox.isVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}}><div ng-if=Lightbox.isVideo(Lightbox.image) class=\"embed-responsive embed-responsive-16by9\"><video ng-if=!Lightbox.isSharedVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}} controls autoplay></video><embed-video ng-if=Lightbox.isSharedVideo(Lightbox.image) lightbox-src={{Lightbox.imageUrl}} ng-href={{Lightbox.imageUrl}} iframe-id=lightbox-video class=embed-responsive-item><a ng-href={{Lightbox.imageUrl}}>Watch video</a></embed-video></div></div><div class=lightbox-image-container style=\"background-color: white; margin: 1em -15px -10px\"><h4 ng-if=\"Lightbox.image.title && Lightbox.image.titleDisplayImage\">{{Lightbox.image.title}}</h4><p ng-if=\"Lightbox.image.description && Lightbox.image.DescriptionDisplayImage\" ng-bind-html=Lightbox.image.description></p></div></div>";

/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-static-top\"><div class=container><div class=navbar-header><a ng-if=navBarTitle href=\"\" class=navbar-brand ng-bind-html=\"navBarTitle ? navBarTitle : ''\"></a> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><form class=\"navbar-form navbar-right\" role=search><select name=therapist class=form-control ng-model=vm.filters.worktypeId ng-change=vm.updateTherapistsList() ng-options=\"item.KEY as item.VALUE for item in vm.options.worktypes\"><option value>- {{'OPT_SELECT_WORKTYPE'|translate}} -</select></form><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav navbar-right\"><li obt-language></li></ul></div></div></nav>";

/***/ },
/* 106 */
/***/ function(module, exports) {

	module.exports = "<div class=bg-info><div class=container><div class=row><div ng-if=vm.footerData.location class=\"col-md-12 text-center\"><h4 ng-if=vm.footerData.location.companyName>{{vm.footerData.location.companyName}}</h4><ul class=list-inline ng-if=vm.footerData.location.address><li><i class=\"fa fa-map-marker\"></i> {{ vm.footerData.location.address + \", \" + vm.footerData.location.city + \", \" + vm.footerData.location.state + \", \" + vm.footerData.location.postalCode}}</li></ul><ul class=list-inline><li ng-if=vm.footerData.location.www><a target=_blank ng-href=//{{vm.footerData.location.www}}><i class=\"fa fa-cloud\"></i> {{ vm.footerData.location.www}}</a></li><li ng-if=vm.footerData.location.email><a ng-href=mailto:{{vm.footerData.location.email}}><i class=\"fa fa-envelope\"></i> {{ vm.footerData.location.email}}</a></li><li ng-if=vm.footerData.location.phone><i class=\"fa fa-phone\"></i>{{ vm.footerData.location.phone}}</li><li ng-if=vm.footerData.location.fax><i class=\"fa fa-print\"></i> {{ vm.footerData.location.fax}}</li></ul></div><hr ng-if=\"vm.footerData.location && vm.footerData.receptionist\"><div class=col-md-12 ng-if=vm.footerData.receptionist><ul class=list-inline><li><obt-online-receptionist phone-number={{vm.footerData.receptionist}} is-online={{vm.footerData.receptionistOnline}}></obt-online-receptionist></li></ul></div><hr ng-if=\"(vm.footerData.location || vm.footerData.receptionist) && vm.footerData.followUs\"></div><div class=row ng-if=vm.footerData.followUs><div class=\"col-md-12 text-center\" ng-class=\"{'paddingTop_15' : !vm.footerData.followUs.followUsTitle}\"><h3 ng-if=vm.footerData.followUs.followUsTitle>{{vm.footerData.followUs.followUsTitle}}</h3><ul class=list-inline ng-if=vm.footerData.followUs style=\"color: white\"><li ng-if=vm.footerData.followUs.facebook><a class=\"btn btn-link\" target=_blank ng-href={{vm.footerData.followUs.facebook}}><i class=\"fa fa-facebook fa-3x\"></i></a></li><li ng-if=vm.footerData.followUs.twitter><a class=\"btn btn-link\" target=_blank ng-href={{vm.footerData.followUs.twitter}}><i class=\"fa fa-twitter fa-3x\"></i></a></li><li ng-if=vm.footerData.followUs.googlePlus><a class=\"btn btn-link\" target=_blank ng-href={{vm.footerData.followUs.googlePlus}} rel=publisher><i class=\"fa fa-google-plus fa-3x\"></i></a></li><li ng-if=vm.footerData.followUs.instagram><a class=\"btn btn-link\" target=_blank ng-href={{vm.footerData.followUs.instagram}} rel=publisher><i class=\"fa fa-instagram fa-3x\"></i></a></li></ul></div></div></div></div>";

/***/ },
/* 107 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-static-top\"><div class=container><div class=navbar-header><a ng-if=navBarTitle class=navbar-brand ui-sref=association({cId:vm.cId}) ng-bind-html=\"navBarTitle ? navBarTitle : ''\"></a> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav navbar-right\"><li obt-language></li></ul></div></div></nav>";

/***/ },
/* 108 */
/***/ function(module, exports) {

	module.exports = "<fieldset selects-cascade cascade-options=vmModal.cascadeOptions cascade-order=vmModal.cascadeOrder><div ng-hide=vmModal.cascadeStatus.location.hidden class=form-group><select-cascade name=location key-to-name-options=vmModal.options.locations status=vmModal.cascadeStatus.location ng-model=vmModal.modalModel.locationId placeholder=\"- {{ 'PLEASE_CHOOSE_A_LOCATION' | translate }} -\" is-required=true></select-cascade></div><div ng-hide=vmModal.cascadeStatus.therapist.hidden class=form-group><select-cascade name=therapist key-to-name-options=vmModal.options.therapists status=vmModal.cascadeStatus.therapist ng-model=vmModal.modalModel.therapistId placeholder=\"- {{ 'PLEASE_CHOOSE_A_THERAPIST' | translate }} -\" is-required=true></select-cascade></div><div ng-hide=vmModal.cascadeStatus.worktype.hidden class=form-group><select-cascade name=worktype key-to-name-options=vmModal.options.worktypes status=vmModal.cascadeStatus.worktype ng-model=vmModal.modalModel.workTypeId placeholder=\"- {{ 'PLEASE_CHOOSE_A_WORKTYPE' | translate }} -\" is-required=true></select-cascade></div></fieldset>";

/***/ },
/* 109 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-default navbar-static-top navbar-fixed-top\"><div class=container><div class=navbar-header><a ng-if=navBarLogo class=navbar-brand style=\"padding: 0px 0px\" ui-sref=clinic({cId:vm.cId}) ui-sref-opts=\"{reload: true}\"><span ng-if=navBarLogo><img ng-src={{navBarLogo}} height=50px alt=logo></span></a> <a ng-if=navBarTitle class=navbar-brand style=\"padding: 0px 0px\" ui-sref=clinic({cId:vm.cId})><h3 class=navbar-text ng-bind-html=\"navBarTitle ? navBarTitle : ''\"></h3></a> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav navbar-right\"><li><a ui-sref=clinic({cId:vm.cId}) ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-home fa-lg\"></i></a></li><obt-login ng-if=navBarShowSignIn></obt-login><li ng-if=\"vm.footerData.showBookNow && !isCalendarDisabled\"><button href ng-click=\"vmApp.gotoAnchor('Calendar')\" class=\"btn btn-secondary-outline warning-outline\">{{'BOOK_NOW'|translate}}</button></li><li obt-language></li><obt-menu ng-if=navBarMenu data=navBarMenu></obt-menu><obt-menu-xs ng-if=navBarMenu data=navBarMenu></obt-menu-xs></ul></div></div></nav>";

/***/ },
/* 110 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-default navbar-static-top navbar-fixed-top\"><div class=container><div class=navbar-header><a ng-if=navBarLogo class=navbar-brand style=\"padding: 0px 0px\" ui-sref=\"therapist({cId:vm.cId, tId:vm.tId})\" ui-sref-opts=\"{reload: true}\"><span ng-if=navBarLogo><img ng-src={{navBarLogo}} height=50px alt=logo></span></a> <a ng-if=navBarTitle class=navbar-brand style=\"padding: 0px 0px\" ui-sref=\"therapist({cId:vm.cId, tId:vm.tId})\"><h3 class=navbar-text ng-bind-html=\"navBarTitle ? navBarTitle : ''\"></h3></a> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav navbar-right\"><li><a ui-sref=\"therapist({cId:vm.cId, tId:vm.tId})\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-home fa-lg\"></i></a></li><obt-login ng-if=navBarShowSignIn></obt-login><li ng-if=\"vm.footerData.showBookNow && !isCalendarDisabled\"><a href ng-click=\"vmApp.gotoAnchor('Calendar')\" class=\"btn btn-secondary-outline warning-outline\">{{'BOOK_NOW'|translate}}</a></li><li obt-language></li><obt-menu ng-if=navBarMenu data=navBarMenu></obt-menu><obt-menu-xs ng-if=navBarMenu data=navBarMenu></obt-menu-xs></ul></div></div></nav>";

/***/ },
/* 111 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-static-top\"><div class=container><div class=navbar-header><a ng-if=navBarTitle class=navbar-brand href=\"\" ng-bind-html=\"navBarTitle ? navBarTitle : ''\"></a> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav navbar-right\"><li obt-language></li></ul></div></div></nav>";

/***/ },
/* 112 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-static-top\"><div class=container><div class=navbar-header><a ng-if=navBarTitle class=navbar-brand href=\"\" ng-bind-html=\"navBarTitle ? navBarTitle : ''\"></a> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav navbar-right\"><li obt-language></li><li ng-if=vm.headerData.home><a ng-href={{vm.headerData.home}}><i class=\"fa fa-home fa-lg\"></i></a></li></ul></div></div></nav>";

/***/ },
/* 113 */
/***/ function(module, exports) {

	module.exports = "<div ng-controller=\"SidebarController as vm\"><ht-sidebar when-done-animating=vm.sidebarReady()><div class=sidebar-filler></div><div class=sidebar-dropdown><a href=#>Menu</a></div><div class=sidebar-inner><div class=sidebar-widget></div><ul class=navi><li class=\"nlightblue fade-selection-animation\" ng-class=vm.isCurrent(r) ng-repeat=\"r in vm.navRoutes\"><a ui-sref={{r.name}} ng-bind-html=r.settings.content></a></li></ul></div></ht-sidebar></div>";

/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-static-top\"><div class=container><div class=navbar-header><a ui-sref=\"association({cId:'cpoq'})\" class=navbar-brand><b>Advisor</b>OBT</a> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav navbar-right\"><li obt-language cid={{vm.cId}} tid={{vm.tId}}></li><li obt-login></li></ul></div></div></nav>";

/***/ },
/* 115 */
/***/ function(module, exports) {

	module.exports = "<section class=sidebar><ul class=sidebar-menu><li class=header>MAIN NAVIGATION</li><li><a ui-sref-active=active ui-sref=dashboard><i class=\"fa fa-dashboard\"></i>{{'DASHBOARD' | translate}}</a></li></ul></section>";

/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports = "<div class=container-fluid><div class=row><div class=\"col-xs-12 col-sm-9 vcenter\"><p class=hidden-xs ng-bind-html=vmShell.footer.LeftText></p><p class=\"text-center visible-xs-block\" ng-bind-html=vmShell.footer.LeftText></p></div><div class=\"col-xs-12 col-sm-3 vcenter\"><div ng-if=\"vmShell.footer.brandLogo.href && vmShell.footer.brandLogo.image\"><p class=\"text-right hidden-xs\"><a ng-if=vmShell.footer.brandLogo.isAbsolute class=nav-link href={{vmShell.footer.brandLogo.href}}><img height=30px ng-src={{vmShell.footer.brandLogo.image}} alt=\"Brand logo\"></a> <a ng-if=!vmShell.footer.brandLogo.isAbsolute class=nav-link ui-sref={{vmShell.footer.brandLogo.href}}><img height=30px g-src={{vmShell.footer.brandLogo.image}} alt=\"Brand logo\"></a></p><p class=\"text-center visible-xs-block\"><a ng-if=vmShell.footer.brandLogo.isAbsolute class=nav-link href={{vmShell.footer.brandLogo.href}}><img height=30px ng-src={{vmShell.footer.brandLogo.image}} alt=\"Brand logo\"></a> <a ng-if=!vmShell.footer.brandLogo.isAbsolute class=nav-link ui-sref={{vmShell.footer.brandLogo.href}}><img height=30px ng-src={{vmShell.footer.brandLogo.image}} alt=\"Brand logo\"></a></p></div><div ng-if=\"!vmShell.footer.brandLogo.href && vmShell.footer.brandLogo.image\"><p class=\"text-right hidden-xs\"><img height=30px ng-src={{vmShell.footer.brandLogo.image}} alt=\"Brand logo\"></p><p class=\"text-center visible-xs-block\"><img height=30px ng-src={{vmShell.footer.brandLogo.image}} alt=\"Brand logo\"></p></div></div></div></div>";

/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-static-top\"><div class=container-fluid><div class=navbar-header><a ui-sref=association class=navbar-brand><b>Admin</b>LTE</a> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav\"><li class=active><a href=#>Link <span class=sr-only>(current)</span></a></li><li><a href=#>Link</a></li><li class=dropdown><a href=# class=dropdown-toggle data-toggle=dropdown>Dropdown <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=#>Action</a></li><li><a href=#>Another action</a></li><li><a href=#>Something else here</a></li><li class=divider></li><li><a href=#>Separated link</a></li><li class=divider></li><li><a href=#>One more separated link</a></li></ul></li></ul><form class=\"navbar-form navbar-left\" role=search><div class=form-group><input class=form-control id=navbar-search-input placeholder=Search></div></form><ul class=\"nav navbar-nav navbar-right\"><li><a href=#>Link</a></li><li class=dropdown><a href=# class=dropdown-toggle data-toggle=dropdown>Dropdown <span class=caret></span></a><ul class=dropdown-menu role=menu><li><a href=#>Action</a></li><li><a href=#>Another action</a></li><li><a href=#>Something else here</a></li><li class=divider></li><li><a href=#>Separated link</a></li></ul></li></ul></div></div></nav>";

/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports = "<div class=container-fluid ui-view></div>";

/***/ },
/* 119 */
/***/ function(module, exports) {

	module.exports = "<div class=container-fluid><div class=row><div class=\"col-xs-12 col-sm-9\"><p><strong>Copyright © 2014-2015 <a href=\"\">OBT Team</a>.</strong> <span class=visible-xs-inline><br></span>All rights reserved.</p></div><div class=\"col-xs-12 col-sm-3\"><p class=\"text-right hidden-xs\"><b>Version</b> 2.0</p><p class=\"text-center visible-xs-block\"><b>Version</b> 2.0</p></div></div></div>";

/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-static-top navbar-fixed-top\"><div class=container><div class=navbar-header><a ng-if=logoLink class=navbar-brand style=\"padding: 5px 0px\" ui-sref=\"therapistClinic({cId:vm.cId, tId:vm.tId})\" ui-sref-opts=\"{reload: true}\"><span ng-if=logoLink><img ng-src={{logoLink}} height=40px alt=logo></span></a> <a ng-if=navBarTitle class=\"navbar-brand hidden-xs\" ui-sref=\"therapistClinic({cId:vm.cId, tId:vm.tId})\" ui-sref-opts=\"{reload: true}\" ng-bind-html=\"navBarTitle ? navBarTitle : ''\"></a> <button ng-if=\"vm.footerData.showBookNow && !isCalendarDisabled\" ng-click=\"vmApp.gotoAnchor('Calendar')\" class=\"navbar-brand-btn navbar-btn btn btn-warning-advisor visible-xs-inline\">{{'BOOK_NOW'|translate}}</button> <button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#navbar-collapse><i class=\"fa fa-bars\"></i></button></div><div class=\"collapse navbar-collapse\" id=navbar-collapse><ul class=\"nav navbar-nav navbar-right\"><li ng-if=!vm.ngCart.isEmpty()><ngcart-summary></ngcart-summary></li><obt-login ng-if=navBarShowSignIn></obt-login><li class=hidden-xs ng-if=\"vm.footerData.showBookNow && !isCalendarDisabled\"><button ng-click=\"vmApp.gotoAnchor('Calendar')\" class=\"navbar-btn btn btn-warning-advisor\">{{'BOOK_NOW'|translate}}</button></li><li><a ui-sref=\"therapistClinic({cId:vm.cId, tId:vm.tId})\" ui-sref-opts=\"{reload: true}\"><i class=\"fa fa-home fa-lg\"></i></a></li><li obt-language cid={{vm.cId}} tid={{vm.tId}}></li><obt-menu ng-if=navBarMenu data=navBarMenu></obt-menu><li class=visible-xs-block ng-repeat=\"menu in navBarMenu | orderBy:'order'\" ng-switch=menu.type><a ng-switch-when=1 href=javascript:void(0) ng-click=vmApp.gotoAnchor(menu.data.link)>{{menu.data.name}}</a> <a ng-switch-when=2 href=javascript:void(0) ui-sref={{menu.data.link}}>{{menu.data.name}}\\n</a> <a ng-switch-when=3 href={{menu.data.link}}>{{menu.data.name}}\\n</a></li></ul></div></div></nav>";

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = "<obt-modal-wrapper modal-title={{vmModal.modalModel.description}} track-event=close track-category=booking track-label=\"{{ vmModal.modalModel.description }} - {{vmModal.data.cEmail}} - {{vmModal.modalModel.start | momentFormat }}\"><div class=\"alert alert-danger\" ng-if=vmModal.alert><p class=text-center>{{vmModal.alert}}</p></div><p>{{'WHEN'|translate}} : {{vmModal.getBookingTime()}}<br><span ng-if=vmModal.modalModel.details ng-bind-html=vmModal.modalModel.details></span></p><hr><form accept-charset=UTF-8 role=form name=bookingForm ng-submit=vmModal.applyBooking() ng-autodisable-class=spinner ng-autodisable><span ng-include=\"'app/booking/booking-cascade-options.html'\"></span><fieldset ng-if=vmModal.isQuickBooking><div class=form-group><input class=form-control placeholder=\"{{ 'FIRST_NAME' | translate }}\" name=fName ng-model=vmModal.data.fName> <span ng-show=\"bookingForm.fName.$invalid && !bookingForm.fName.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'LAST_NAME' | translate }}\" name=lName ng-model=vmModal.data.lName> <span ng-show=\"bookingForm.lName.$invalid && !bookingForm.lName.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'EMAIL' | translate }}\" name=email type=email ng-model=vmModal.data.cEmail> <span ng-show=\"bookingForm.email.$invalid && !bookingForm.email.$pristine\" class=help-block>{{'VALID_EMAIL_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'PHONE' | translate }}\" name=phone type=tel ng-model=vmModal.data.phone> <span ng-show=\"bookingForm.phone.$invalid && !bookingForm.phone.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'ref_name' | translate }}\" name=refName ng-model=vmModal.data.refName> <span ng-show=\"bookingForm.refName.$invalid && !bookingForm.refName.$pristine\" class=help-block>{{'REF_NAME_REQUIRED'| translate}}</span></div></fieldset><div class=form-group><textarea class=form-control rows=3 placeholder=\"{{ 'COMMENT' | translate }}\" name=comment ng-model=vmModal.data.comment></textarea></div><fieldset ng-if=vmModal.isQuickBooking><div class=form-group><div vc-recaptcha theme=\"'light'\" key=vmModal.key ng-model=vmModal.data.captcha on-create=vmModal.setWidgetId(widgetId) on-success=vmModal.setResponse(response) on-expire=vmModal.cbExpiration()></div></div></fieldset><div class=form-group><button type=submit class=\"oldBoy btn btn-lg btn-success-advisor btn-block\" ng-disabled=\"bookingForm.$invalid || vmModal.isLoading\" analytics-on=click analytics-event=click analytics-category=booking analytics-label=\"{{ vmModal.modalModel.description }} - {{vmModal.data.cEmail}} - {{vmModal.modalModel.start | momentFormat }}\" analytics-email={{vmModal.data.cEmail}} analytics-time=\"{{vmModal.modalModel.start | momentFormat }}\">{{'BOOK'| translate }}</button></div></form></obt-modal-wrapper>";

/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = "<obt-modal-wrapper modal-title=\"{{ (vmLogin.forgetPassword ? 'RESET_PASSWORD' : 'SIGN_IN')  | translate }}\"><div class=\"alert alert-danger\" ng-show=vmLogin.alert><p class=text-center>{{vmLogin.alert}}</p></div><form ng-hide=vmLogin.forgetPassword accept-charset=UTF-8 role=form name=loginForm ng-submit=vmLogin.signIn() novalidate><fieldset><div class=form-group><input id=login_email class=form-control placeholder=\"{{ 'EMAIL_OR_TEL' | translate }}\" name=email ng-model=vmLogin.login.email required> <span ng-show=\"loginForm.email.$invalid && !loginForm.email.$pristine\" class=help-block>{{ 'VALID_EMAIL_OR_VALID_TEL_REQUIRED' | translate }}</span></div><div class=form-group><input id=login_password class=form-control placeholder=\"{{ 'PASSWORD' | translate }}\" name=password type=password ng-model=vmLogin.login.password ng-minlength=3 required> <span ng-show=loginForm.password.$error.minlength class=help-block>{{ 'REQUIRED_PASSWORD_TOO_SHORT' | translate }}</span></div><div ng-if=\"vmLogin.fName === true\" class=form-group><input id=login_email class=form-control placeholder=\"{{ 'FIRST_NAME' | translate }}\" name=fName ng-model=vmLogin.login.fName required></div><div ng-if=\"vmLogin.isCPhone === true\" class=form-group><input ng-model=vmLogin.login.isCellPhone id=isCellPhone type=checkbox name=isCellPhone> {{'IS_CELL_PHONE'|translate}}</div><div class=row><div class=col-xs-6><div class=input-group><div class=checkbox><label><input ng-model=vmLogin.login.remember id=login_remember_me type=checkbox name=remember> {{'REMEMBER_ME'|translate}}</label></div></div></div><div class=col-xs-6><input class=\"btn btn-success-advisor btn-block\" type=submit id=login_btn_sign_in_ value=\"{{ 'SIGN_IN' | translate }}\" ng-disabled=loginForm.$invalid></div></div></fieldset></form><form ng-show=vmLogin.forgetPassword accept-charset=UTF-8 role=form name=forgetPasswordForm ng-submit=vmLogin.forgetPasswordFunction() novalidate><fieldset><div class=form-group><input id=login_forget_pwd_email class=form-control placeholder=\"{{ 'EMAIL_OR_TEL' | translate }}\" name=email ng-model=vmLogin.sendPassword.email required> <span ng-show=\"forgetPasswordForm.email.$invalid && !forgetPasswordForm.email.$pristine\" class=help-block>{{ 'VALID_EMAIL_OR_VALID_TEL_REQUIRED' | translate }}</span></div><div ng-if=\"vmLogin.fName === true\" class=form-group><input id=login_email class=form-control placeholder=\"{{ 'FIRST_NAME' | translate }}\" name=fName ng-model=vmLogin.sendPassword.fName required></div><div ng-if=\"vmLogin.isCPhone === true\" class=form-group><input ng-model=vmLogin.sendPassword.isCellPhone id=isCellPhone type=checkbox name=isCellPhone> {{'IS_CELL_PHONE'|translate}}</div><input class=\"btn btn-success-advisor btn-block\" type=submit id=login_btn_send_new_pwd value=\"{{ 'SEND_NEW_PASSWORD' | translate }}\" ng-disabled=forgetPasswordForm.$invalid></fieldset></form><a href=\"\" ng-click=vmLogin.forgetPasswordActive()>{{ (vmLogin.forgetPassword ? 'SIGN_IN' : 'FORGET_PASSWORD') | translate }}</a></obt-modal-wrapper>";

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports = "<form class=form-inline role=form name=filterForm ng-submit=submitFilter() ng-autodisable><div class=form-group><label for=worktype>{{'ADV_CALENDAR_FILTER'|translate}}</label><select name=worktype class=form-control ng-model=selectedfilters.workTypeId ng-selected=\"selectedfilters.workTypeId = selectedfilters.workTypeId ||  options.worktypes_default\" ng-options=\"item.KEY as item.VALUE for item in options.worktypes\" ng-change=submitFilter()><option value>- {{'OPT_SELECT_AVD_CAL_SERVICE'|translate}} -</select></div></form>";

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports = "<obt-modal-wrapper modal-title={{vmModal.modalModel.description}} track-event=close track-category=booking track-label=\"{{ vmModal.modalModel.description }} - {{vmModal.data.cEmail}} - {{vmModal.modalModel.start | momentFormat }}\"><div class=\"alert alert-danger\" ng-if=vmModal.alert><p class=text-center>{{vmModal.alert}}</p></div><p ng-if=\"vmModal.modalModel.start && vmModal.modalModel.end\">{{'WHEN'|translate}} : {{vmModal.getBookingTime()}}</p><p ng-if=vmModal.modalModel.details ng-bind-html=vmModal.modalModel.details></p><hr><form accept-charset=UTF-8 role=form name=bookingForm ng-submit=vmModal.requestBooking() ng-autodisable-class=spinner ng-autodisable><span ng-include=\"'app/booking/booking-cascade-options.html'\"></span><fieldset ng-if=vmModal.isQuickBooking><div class=form-group><input class=form-control placeholder=\"{{ 'FIRST_NAME' | translate }}\" name=fName ng-model=vmModal.data.fName> <span ng-show=\"bookingForm.fName.$invalid && !bookingForm.fName.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'LAST_NAME' | translate }}\" name=lName ng-model=vmModal.data.lName> <span ng-show=\"bookingForm.lName.$invalid && !bookingForm.lName.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'EMAIL' | translate }}\" name=email type=email ng-model=vmModal.data.cEmail> <span ng-show=\"bookingForm.email.$invalid && !bookingForm.email.$pristine\" class=help-block>{{'VALID_EMAIL_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'PHONE' | translate }}\" name=phone type=tel ng-model=vmModal.data.phone> <span ng-show=\"bookingForm.phone.$invalid && !bookingForm.phone.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'ref_name' | translate }}\" name=refName ng-model=vmModal.data.refName> <span ng-show=\"bookingForm.refName.$invalid && !bookingForm.refName.$pristine\" class=help-block>{{'REF_NAME_REQUIRED'| translate}}</span></div></fieldset><div class=form-group><textarea class=form-control rows=3 placeholder=\"{{ 'COMMENT' | translate }}\" name=comment ng-model=vmModal.data.comment></textarea></div><fieldset ng-if=vmModal.isQuickBooking><div class=text-center style=margin-left:20px><div vc-recaptcha theme=\"'light'\" key=vmModal.key ng-model=vmModal.data.captcha on-create=vmModal.setWidgetId(widgetId) on-success=vmModal.setResponse(response) on-expire=vmModal.cbExpiration()></div></div></fieldset><div class=form-group><button type=submit class=\"oldBoy btn btn-lg btn-success-advisor btn-block\" ng-disabled=\"bookingForm.$invalid || vmModal.isLoading\" analytics-on=click analytics-event=click analytics-category=booking analytics-label=\"{{ vmModal.modalModel.description }} - {{vmModal.data.cEmail}} - {{vmModal.modalModel.start | momentFormat }}\" analytics-email={{vmModal.data.cEmail}} analytics-time=\"{{vmModal.modalModel.start | momentFormat }}\">{{'BOOK'| translate }}</button></div></form></obt-modal-wrapper>";

/***/ },
/* 125 */
/***/ function(module, exports) {

	module.exports = "<obt-modal-wrapper modal-title={{vmModal.modalModel.description}} track-event=close track-category=booking track-label=\"{{ vmModal.modalModel.description }} - {{vmModal.data.cEmail}} - {{vmModal.modalModel.start | momentFormat }}\"><div class=\"alert alert-danger\" ng-if=vmModal.alert><p class=text-center>{{vmModal.alert}}</p></div><p>{{'WHEN'|translate}} : {{vmModal.getBookingTime()}}<br><span ng-if=vmModal.modalModel.details ng-bind-html=vmModal.modalModel.details></span></p><hr><form accept-charset=UTF-8 role=form name=bookingForm ng-submit=vmModal.addToWaitingList() ng-autodisable-class=spinner ng-autodisable><span ng-include=\"'app/booking/booking-cascade-options.html'\"></span><fieldset ng-if=vmModal.isQuickBooking><div class=form-group><input class=form-control placeholder=\"{{ 'FIRST_NAME' | translate }}\" name=fName ng-model=vmModal.data.fName> <span ng-show=\"bookingForm.fName.$invalid && !bookingForm.fName.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'LAST_NAME' | translate }}\" name=lName ng-model=vmModal.data.lName> <span ng-show=\"bookingForm.lName.$invalid && !bookingForm.lName.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'EMAIL' | translate }}\" name=email type=email ng-model=vmModal.data.cEmail> <span ng-show=\"bookingForm.email.$invalid && !bookingForm.email.$pristine\" class=help-block>{{'VALID_EMAIL_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'PHONE' | translate }}\" name=phone type=tel ng-model=vmModal.data.phone> <span ng-show=\"bookingForm.phone.$invalid && !bookingForm.phone.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'ref_name' | translate }}\" name=refName ng-model=vmModal.data.refName> <span ng-show=\"bookingForm.refName.$invalid && !bookingForm.refName.$pristine\" class=help-block>{{'REF_NAME_REQUIRED'| translate}}</span></div></fieldset><div class=form-group><textarea class=form-control rows=3 placeholder=\"{{ 'COMMENT' | translate }}\" name=comment ng-model=vmModal.data.comment></textarea></div><fieldset ng-if=vmModal.isQuickBooking><div class=form-group><div vc-recaptcha theme=\"'light'\" key=vmModal.key ng-model=vmModal.data.captcha on-create=vmModal.setWidgetId(widgetId) on-success=vmModal.setResponse(response) on-expire=vmModal.cbExpiration()></div></div></fieldset><div class=form-group><button type=submit class=\"oldBoy btn btn-lg btn-success-advisor btn-block\" ng-disabled=\"bookingForm.$invalid || vmModal.isLoading\" analytics-on=click analytics-event=click analytics-category=booking analytics-label=\"{{ vmModal.modalModel.description }} - {{vmModal.data.cEmail}} - {{vmModal.modalModel.start | momentFormat }}\" analytics-email={{vmModal.data.cEmail}} analytics-time=\"{{vmModal.modalModel.start | momentFormat }}\">{{'REQUEST'| translate }}</button></div></form></obt-modal-wrapper>";

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports = "<form class=form role=form name=filterForm ng-submit=submitFilter()><div class=row><div class=\"form-group col-sm-12\"><label class=control-label>{{'THERAPIST'|translate}}</label><select name=therapist class=form-control ng-model=selectedfilters.tId ng-options=\"therapist.KEY as therapist.VALUE for therapist in comboData.therapists\"><option value>- {{'OPT_SELECT_THERAPIST'|translate}} -</select></div><div class=\"form-group col-sm-2\"><label class=control-label>{{'DEFINED_FILTER'|translate}}</label><br><div class=btn-group><button type=button class=\"btn btn-danger\" ng-click=\"filterVm.dayRange(selectedfilters, 0)\">{{'TODAY'|translate}}</button> <button type=button class=\"btn btn-danger dropdown-toggle\" data-toggle=dropdown aria-expanded=false><span class=caret></span> <span class=sr-only>Toggle Dropdown</span></button><ul class=dropdown-menu role=menu><li><a href=\"\" ng-click=\"filterVm.dayRange(selectedfilters, -1)\">{{'YESTERDAY'|translate}}</a></li><li><a href=\"\" ng-click=\"filterVm.dayRange(selectedfilters, 1)\">{{'TOMORROW'|translate}}</a></li><li><a href=\"\" ng-click=\"filterVm.dayRange(selectedfilters, -7)\">{{'LAST_7_DAYS'|translate}}</a></li><li><a href=\"\" ng-click=\"filterVm.dayRange(selectedfilters, 7)\">{{'NEXT_7_DAYS'|translate}}</a></li><li><a href=\"\" ng-click=\"filterVm.monthRange(selectedfilters, -1)\">{{'LAST_MONTH'|translate}}</a></li><li><a href=\"\" ng-click=\"filterVm.monthRange(selectedfilters, 0)\">{{'THIS_MONTH'|translate}}</a></li></ul></div></div><div class=\"form-group col-sm-5\"><label class=control-label>{{'FROM'|translate}}</label><custom-datepicker ng-model=selectedfilters.start></custom-datepicker></div><div class=\"form-group col-sm-5\"><label class=control-label>{{'TO'|translate}}</label><custom-datepicker ng-model=selectedfilters.end></custom-datepicker></div><div class=\"form-group col-sm-12\"><button type=submit class=\"btn btn-block btn-success-advisor\"><i class=\"fa fa-search\"></i> {{'FILTER'|translate}}</button></div></div></form>";

/***/ },
/* 127 */
/***/ function(module, exports) {

	module.exports = "<obt-modal-wrapper modal-title={{vmModal.modalModel.title}} track-event=close track-category=booking track-label=\"{{ vmModal.modalModel.description }} - {{vmModal.data.cEmail}} - {{vmModal.modalModel.start | momentFormat }}\"><div class=\"alert alert-danger\" ng-if=vmModal.alert><p class=text-center>{{vmModal.alert}}</p></div><p ng-if=vmModal.modalModel.details ng-bind-html=vmModal.modalModel.details></p><hr ng-if=\"vmModal.modalModel.details\"><form accept-charset=UTF-8 role=form name=bookingForm ng-submit=vmModal.requestBooking() ng-autodisable-class=spinner ng-autodisable><span ng-include=\"'app/booking/booking-cascade-options.html'\"></span><div class=\"form-group row\"><div style=border:1px ng-class=\"vmModal.modalModel.askTime ? 'col-xs-8' : 'col-xs-12' \" style=\"margin-top: 35px\" ng-if=vmModal.modalModel.askDate><custom-datepicker ng-model=vmModal.modalModel.start options={minDate:vmModal.data.today}></custom-datepicker></div><div style=border:1px ng-class=\"vmModal.modalModel.askDate ? 'col-xs-4' : 'col-xs-12' \" ng-if=vmModal.modalModel.askTime><input class=form-control name=from type=time ng-model=vmModal.data.startTime></div></div><div class=form-group ng-if=vmModal.modalModel.askNumber><input class=form-control placeholder=\"{{ 'NUMBER_OF_PEOPLE' | translate }}\" name=numberOfPeople type=number ng-model=vmModal.modalModel.numberOfPeople></div><fieldset ng-if=vmModal.isQuickBooking><div class=form-group><input class=form-control placeholder=\"{{ 'FIRST_NAME' | translate }}\" name=fName ng-model=vmModal.data.fName> <span ng-show=\"bookingForm.fName.$invalid && !bookingForm.fName.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'LAST_NAME' | translate }}\" name=lName ng-model=vmModal.data.lName> <span ng-show=\"bookingForm.lName.$invalid && !bookingForm.lName.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'EMAIL' | translate }}\" name=email type=email ng-model=vmModal.data.cEmail> <span ng-show=\"bookingForm.email.$invalid && !bookingForm.email.$pristine\" class=help-block>{{'VALID_EMAIL_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'PHONE' | translate }}\" name=phone type=tel ng-model=vmModal.data.phone> <span ng-show=\"bookingForm.phone.$invalid && !bookingForm.phone.$pristine\" class=help-block>{{'FIELD_REQUIRED'| translate}}</span></div><div class=form-group><input class=form-control placeholder=\"{{ 'ref_name' | translate }}\" name=refName ng-model=vmModal.data.refName> <span ng-show=\"bookingForm.refName.$invalid && !bookingForm.refName.$pristine\" class=help-block>{{'REF_NAME_REQUIRED'| translate}}</span></div></fieldset><div class=form-group><textarea class=form-control rows=3 placeholder=\"{{ 'COMMENT' | translate }}\" name=comment ng-model=vmModal.data.comment></textarea></div><fieldset ng-if=vmModal.isQuickBooking><div class=text-center style=margin-left:20px><div vc-recaptcha theme=\"'light'\" key=vmModal.key ng-model=vmModal.data.captcha on-create=vmModal.setWidgetId(widgetId) on-success=vmModal.setResponse(response) on-expire=vmModal.cbExpiration()></div></div></fieldset><div class=form-group><button type=submit class=\"oldBoy btn btn-lg btn-success-advisor btn-block\" ng-disabled=\"bookingForm.$invalid || vmModal.isLoading\" analytics-on=click analytics-event=click analytics-category=booking analytics-label=\"{{ vmModal.modalModel.description }} - {{vmModal.data.cEmail}} - {{vmModal.modalModel.start | momentFormat }}\" analytics-email={{vmModal.data.cEmail}} analytics-time=\"{{vmModal.modalModel.start | momentFormat }}\">{{'BOOK'| translate }}</button></div></form></obt-modal-wrapper>";

/***/ },
/* 128 */
/***/ function(module, exports) {

	module.exports = "<div class=thudmbnail ng-switch=vmProfile.profile.isDescriptionValid><a ng-switch-when=true ui-sref=\"{{vmProfile.profile.cType === 't' ? 'therapistClinic' : 'therapist'}}({tId:vmProfile.profile.therapistId})\"><img ng-src=\"{{vmProfile.profile.avatar !== null ? vmProfile.profile.avatar : 'img/avatar.jpg'}}\" obt-error-image=\"'img/avatar.jpg'\" alt=Avatar class=\"img-rounded img-responsive center-block\"></a> <img ng-switch-default ng-src=\"{{vmProfile.profile.avatar !== null ? vmProfile.profile.avatar : 'img/avatar.jpg'}}\" obt-error-image=\"'img/avatar.jpg'\" alt=Avatar class=\"img-rounded img-responsive center-block\"><div class=caption><h3 class=text-center>{{ vmProfile.profile.fName + ' ' + vmProfile.profile.lName}}<br><small>{{vmProfile.profile.sufix}}</small><br><small><ul class=list-inline><li ng-repeat-start=\"wTitle in vmProfile.profile.wTitles\">{{wTitle}}</li><li ng-repeat-end ng-if=!$last>|</li></ul></small><ul><li ng-if=vmProfile.profile.www><a ng-href=\"{{vmProfile.profile.https ? 'https' :'http'}}://{{vmProfile.profile.www}}\" class=\"btn btn-link\">{{vmProfile.profile.www}}</a></li><li ng-if=!!vmProfile.profile.email><a href=mailto:{{vmProfile.profile.email}}><small>{{vmProfile.profile.email}}</small></a></li><li ng-if=!!vmProfile.profile.cPhone><small>{{vmProfile.profile.cPhone}}</small></li></ul></h3></div></div>";

/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=\"col-sm-3 col-xs-12 text-center\"><img ng-src=\"{{vmProfile.profile.avatar ? vmProfile.profile.avatar : 'img/avatar.jpg'}}\" obt-error-image=\"'img/avatar.jpg'\" alt=Avatar width=115 class=\"img-thumbnails img-responsive center-block\"><div ng-if=vmProfile.profile.isRankingEnabled><ul class=\"list-inline text-center\" style=\"margin-top: 10px\"><li ng-repeat=\"rank in vmProfile.profile.ranking track by $index\"><a href=\"\"><span ng-if=\"rank == 4\" class=\"glyphicon glyphicon-star\"></span> <span ng-if=\"rank == 0\" class=\"glyphicon glyphicon-star-empty\"></span></a></li></ul></div><button style=\"margin-top: 10px\" ng-if=vmProfile.showBookNowButton() class=\"btn btn-warning-advisor btn-xs\" ui-sref=\"{{vmProfile.profile.cType === 't' ? 'therapistClinic' : 'therapist'}}({cId:vmProfile.profile.cId, tId:vmProfile.profile.tId})\">{{'VIEW_PROFILE'|translate}}</button></div><div class=\"col-sm-6 col-xs-12\"><div class=media><div class=media-left><a href=#><img ng-src=\"{{'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=' + vmProfile.location.mapId + '|'+ (vmProfile.location.color ? vmProfile.location.color : 'FF776B' ) + '|000000'}}\" alt=\"marker\"></a></div><div class=media-body><h3 class=\"media-heading media-heading-no-padding\">{{ vmProfile.profile.fName + \" \" + vmProfile.profile.lName}} <small style=white-space:nowrap>{{vmProfile.profile.sufix}}</small></h3><ul class=list-inline><li><span ng-repeat=\"wTitle in vmProfile.profile.wTitles\"><span ng-if=!$first>|</span> {{wTitle}}</span></li></ul></div></div><div class=\"hidden-xs hidden-sm well\"><ul class=list-inline ng-if=vmProfile.profile.skills><li ng-repeat=\"skill in vmProfile.profile.skills\">&#149; <span>{{skill}}</span></li></ul></div><address ng-if=vmProfile.location><span ng-if=vmProfile.location.address>{{vmProfile.location.address}}<br></span> <span ng-if=\"vmProfile.location.city || vmProfile.location.state || vmProfile.location.postalCode \">{{vmProfile.location.city}}, {{vmProfile.location.state}}, {{vmProfile.location.postalCode}}<br></span> <span ng-if=vmProfile.location.email><a href=mailto:{{vmProfile.location.email}}>{{vmProfile.location.email}}</a><br></span> {{vmProfile.location.phone}}</address></div><div class=\"col-sm-3 col-xs-12\" ng-if=vmProfile.showBookNowButton()><obt-calendar ng-if=!!!vmProfile.profile.calendar.isCalendarDisabled calendar-data-promise=\"vmProfile.calendar.getData(start, end)\" event-click-promise=\"showSingleBookingForm(vmProfile.addCIdTId(calEvent), closeCallback)\" calendar-profile=vmProfile.calendar.profile language={{vmProfile.language}} calendar-name=\"{{'map_' + vmProfile.profile.cId + '_' + vmProfile.profile.tId + '_' + vmProfile.profile.lId }}\" show-weekend=true></obt-calendar><obt-modal-popup title=\"Add a booking for a client\" open-modal-promise=showSingleBookingForm template-url=app/booking/add.html template-controller=\"BookingController as vmModal\"></obt-modal-popup></div></div>";

/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = "<div class=row style=\"border: 1px solid grey; padding: 3px; background-color: white; color: black\"><div ng-if=parameter.avatar class=\"col-md-4 col-xs-12\"><img ng-src={{parameter.avatar}} alt=avatar style=\"max-height: 120px; padding-right: 5px\" class=\"center-block img-responsive\"></div><div class=col-xs-12 ng-class=\"parameter.avatar ? 'col-md-8' : 'col-md-12'\"><address><span ng-if=parameter.companyName><strong>{{parameter.companyName}}</strong><br></span> <span ng-if=parameter.address>{{parameter.address}}<br></span> <span ng-if=parameter.postalCode>{{parameter.postalCode}}<br></span> <span ng-if=parameter.phone>{{parameter.phone}}</span></address></div></div>";

/***/ },
/* 131 */
/***/ function(module, exports) {

	module.exports = "<div class=fullHeight><div class=\"container container-sm-height\" ng-if=vm.data.features ng-repeat=\"service in vm.data.features | orderBy:'order'\" id=anchor{{service.anchor}} ng-switch=service.type><div class=row-sm-height ng-switch-when=1 ng-switch=$odd><div class=\"container container-sm-height\" style=\"width: 100%\"><div class=\"row row-sm-height\" ng-switch-when=false><div class=\"col-xs-12 visible-xs\"><div class=\"square-box center-block\"><img class=\"square-content img-responsive\" ng-class=\"{ 'img-circle':!service.data.shape}\" ng-src={{service.data.avatar}}></div></div><div class=\"col-sm-9 col-sm-height col-middle col-xs-12\"><h2 class=featurette-headingdd>{{service.data.name}} <span ng-if=!!service.data.subName class=text-muted>{{service.data.subName}}</span></h2><p class=text-justify ng-bind-html=service.data.description></p></div><div class=\"col-sm-3 col-sm-height col-middle hidden-xs\"><div class=\"square-box center-block\"><img class=\"square-content img-responsive\" ng-class=\"{ 'img-circle':!service.data.shape }\" ng-src={{service.data.avatar}}></div></div></div><div class=\"row row-sm-height\" ng-switch-when=true><div class=\"col-sm-3 col-sm-height col-middle col-xs-12\"><div class=\"square-box center-block\"><img class=\"square-content img-responsive\" ng-class=\"{ 'img-circle':!service.data.shape}\" ng-src={{service.data.avatar}}></div></div><div class=\"col-sm-9 col-sm-height col-middle col-xs-12\"><h2 class=featurette-headingdd>{{service.data.name}} <span ng-if=!!service.data.subName class=text-muted>{{service.data.subName}}</span></h2><p class=text-justify ng-bind-html=service.data.description></p></div></div></div></div><div class=row ng-switch-when=2><div class=col-sm-12><h2 class=featurette-headingddd>{{service.data.name}} <span ng-if=!!service.data.subName class=text-muted>{{service.data.subName}}</span></h2><ul><li ng-repeat=\"description in service.data.description\" ng-bind-html=description></li></ul></div></div><div class=row ng-switch-default><div class=col-sm-12><obt-section data=service.data type={{service.type}} anchor={{service.anchor}} pagesectionid={{service.pageSectionId}} pageid={{service.pageId}}></obt-section></div></div></div></div>";

/***/ },
/* 132 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=\"row is-table-row\" style=\"width: 100%\"><div ng-class=\"{'col-md-6 col-md-push-6':vm.data.middle_large && vm.data.avatar_on_right ,'col-md-6' :vm.data.middle_large && !vm.data.avatar_on_right,'col-md-3  col-md-push-9':!vm.data.middle_large && !vm.data.avatar_on_right }\"><div class=\"square-box center-block\"><img ng-if=\"!vm.data.bgVideo || vm.data.bgVideo === null || vm.data.bgVideo === undefined || vm.data.bgVideo === '' \" class=\"square-content img-responsive\" ng-class=\"{ 'img-circle':!vm.data.shape}\" ng-src={{vm.data.avatar}}><div ng-if=\"vm.data.bgVideo && vm.data.bgVideo !== null && vm.data.bgVideo !== undefined || vm.data.bgVideo !== '' \" class=\"square-content img-responsive\" style=height:auto><div ng-if=\"!vm.data.bgVideo.includes('youtube.com') && (!vm.data.bgVideo.includes('vimeo.com'))\"><video width=100% height=auto><source ng-src={{vm.data.bgVideo}}><source ng-src={{vm.data.bgVideo}} type=video/webm><source ng-src={{vm.data.bgVideo}} type=video/ogg><source ng-src={{vm.data.bgVideo}} type=video/mp4><source ng-src={{vm.data.bgVideo}} type=video/3gp></video></div><div ng-if=\"vm.data.bgVideo.includes('youtube.com') || (vm.data.bgVideo.includes('vimeo.com'))\"><iframe width=100% height=auto ng-src={{vm.trustSrc(vm.data.bgVideo)}} frameborder=0 allowfullscreen></iframe></div></div></div></div><div ng-class=\"{'col-md-6 col-md-pull-6':vm.data.middle_large && vm.data.avatar_on_right ,'col-md-6' :vm.data.middle_large && !vm.data.avatar_on_right,'col-md-9  col-md-pull-3':!vm.data.middle_large && !vm.data.avatar_on_right }\"><h2>{{vm.data.name}} <span ng-if=!!vm.data.subName class=text-muted>{{vm.data.subName}}</span></h2><p class=text-justify ng-bind-html=vm.data.description></p></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 133 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row><div class=col-sm-12><h2 ng-if=vm.data.name>{{vm.data.name}} <span ng-if=!!vm.data.subName class=text-muted>{{vm.data.subName}}</span></h2><ul ng-if=vm.data.description><li ng-repeat=\"description in vm.data.description\" ng-bind-html=description></li></ul></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 134 */
/***/ function(module, exports) {

	module.exports = "<div ng-cloak><div ng-if=vm.data.bgVideo><div ng-if=\"vm.desktop && !vm.mobile  \"><div ng-if=\"!embded.calOnly && !embded.noDetail\"><div ng-if=\"!vm.data.bgVideo.includes('youtube.com') && (!vm.data.bgVideo.includes('vimeo.com'))\"><video width=100% height=100% autoplay loop poster=vm.data.bgImg><source ng-src={{vm.data.bgVideo}} type=video/mp4></video></div><div ng-if=\"vm.data.bgVideo.includes('youtube.com') || (vm.data.bgVideo.includes('vimeo.com'))\"><iframe width=100% height=700px ng-src={{vm.trustSrc(vm.data.bgVideo)}} frameborder=0 allowfullscreen></iframe></div></div></div><div ng-if=\"!vm.desktop && vm.mobile \"><div ng-if=\"!embded.calOnly && !embded.noDetail\" ng-class=\"{'parallax img-blur' : vm.data.fullBlurBox , 'parallax' : !vm.data.fullBlurBox }\" ng-style=\"vm.data.bgImg && {'background-image':'url(' + vm.data.bgImg + ')', 'background-color':vm.data.bgColor}\"><div class=parallax__center ng-class=\"vm.data.box == null ? '' : vm.data.box == true ? 'text-box-white' : 'text-box-dark' \"><h1 ng-bind-html=vm.data.name></h1><h2 ng-bind-html=vm.data.subName></h2><p ng-bind-html=vm.data.description></p></div></div></div></div><div ng-if=!vm.data.bgVideo><div ng-if=\"!embded.calOnly && !embded.noDetail\" ng-class=\"{'parallax img-blur' : vm.data.fullBlurBox , 'parallax' : !vm.data.fullBlurBox }\" ng-style=\"vm.data.bgImg && {'background-image':'url(' + vm.data.bgImg + ')', 'background-color':vm.data.bgColor}\"><div class=parallax__center ng-class=\"vm.data.box == null ? '' : vm.data.box == true ? 'text-box-white' : 'text-box-dark' \"><h1 ng-bind-html=vm.data.name></h1><h2 ng-bind-html=vm.data.subName></h2><p ng-bind-html=vm.data.description></p></div></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = "<uib-carousel active=vm.data.active interval=vm.data.myInterval no-wrap=vm.data.noWrapSlides><uib-slide ng-repeat=\"slide in vm.data.gallery track by $index\" index=$index><div class=\"fill center-vertically container\" ng-class=\"{'img-blur' : vm.data.fullBlurBox , '' : !vm.data.fullBlurBox }\" ng-style=\"slide.bgImg && {'background-image':'url(' + slide.bgImg + ')', 'min-height':(vm.data.minHeight  || 100) + 'vh','background-color':slide.bgColor}\"><div class=container><div class=row><div class=col-xs-12 ng-class=\"slide.box == null ? '' : slide.box == true ? 'text-box-white' : 'text-box-dark' \"><h1 ng-if=vm.data.displayTitle ng-bind-html=slide.title></h1><p ng-if=vm.data.displayDescription ng-bind-html=slide.description></p></div></div></div></div></uib-slide></uib-carousel><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 136 */
/***/ function(module, exports) {

	module.exports = "<div ng-if=!embded.calOnly ng-class=\"{'parallax-5 center-vertically img-blur' : vm.data.fullBlurBox , 'parallax-5 center-vertically ' : !vm.data.fullBlurBox }\" style=\"width: 100%\" ng-style=\"{'background-image':'url(' + vm.data.bgImg + ')', 'background-color':vm.data.bgColor ,'min-height' : (vm.data.minHeight || 100) + 'vh' }\"><div class=text-center><div class=row ng-if=\"vm.data.name || vm.data.subName || vm.data.description\"><div class=\"col-md-6 col-md-offset-3 col-xs-12 text-center\" ng-class=\"vm.data.box == null ? '' : vm.data.box == true ? 'text-box-white' : 'text-box-dark' \"><h2 ng-if=vm.data.name ng-bind-html=vm.data.name ng-class=vm.data.extra_css.name.class ng-style=\"vm.data.extra_css.name.color && { 'color':vm.data.extra_css.name.color }\"></h2><h3 ng-if=vm.data.subName ng-bind-html=vm.data.subName ng-class=vm.data.extra_css.subName.class ng-style=\"vm.data.extra_css.subName.color && { 'color':vm.data.extra_css.subName.color }\"></h3><hr ng-if=vm.data.hr></div></div><div class=row><div class=col-xs-12 ng-if=vm.data.description ng-class=\"vm.data.box == null ? '' : vm.data.box == true ? 'text-box-white' : 'text-box-dark' \"><p ng-bind-html=vm.data.description ng-class=vm.data.extra_css.description.class ng-style=\"vm.data.extra_css.description.color && { 'color':vm.data.extra_css.description.color }\"></p></div><div class=col-xs-12 ng-if=vm.data.bookNow><div class=text-center><button class=\"btn btn-warning-advisor\" ng-click=vm.btnBooking(vm.data.bookNow)>{{vm.data.bookNow.title}}</button><obt-modal-popup title=\"Add a booking for a client\" open-modal-promise=vm.btnBooking template-url=app/booking/buttonRequestBooking.html template-controller=\"BookingController as vmModal\"></obt-modal-popup></div></div></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 137 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row ng-if=\"vm.data.name || vm.data.subName || vm.data.description\"><div class=\"col-md-6 col-md-offset-3 col-xs-12 text-center\"><h2 ng-if=vm.data.name ng-bind-html=vm.data.name></h2><h3 ng-if=vm.data.subName ng-bind-html=vm.data.subName></h3><hr ng-if=vm.data.hr></div></div><div class=row ng-if=vm.data.description><div class=col-xs-12><p ng-bind-html=vm.data.description></p></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row ng-if=\"vm.data.name || vm.data.subName || vm.data.description\"><div class=\"col-md-6 col-md-offset-3 col-xs-12 text-center\"><h2 ng-if=vm.data.name ng-bind-html=vm.data.name ng-class=vm.data.extra_css.name.class ng-style=\"vm.data.extra_css.name.color && { 'color':vm.data.extra_css.name.color }\"></h2><h3 ng-if=vm.data.subName ng-bind-html=vm.data.subName ng-class=vm.data.extra_css.subName.class ng-style=\"vm.data.extra_css.subName.color && { 'color':vm.data.extra_css.subName.color }\"></h3><hr ng-if=vm.data.hr></div></div><div class=row><div class=col-xs-12><p ng-if=vm.data.description ng-bind-html=vm.data.description ng-class=vm.data.extra_css.description.class ng-style=\"vm.data.extra_css.description.color && { 'color':vm.data.extra_css.description.color }\"></p></div></div><div ng-if=vm.data.carousel><div ng-if=vm.desktop class=row><data-owl-carousel class=owl-carousel data-options=\"{navigation: true, pagination: true, rewindNav : false, items:vm.data.gallery_item_per_row}\"><div owl-carousel-item=\"\" ng-repeat=\"item in vm.data.gallery\" class=item><a ng-click=vm.openlightBoxCarousel(vm.data.gallery,$index)><img ng-src={{item.thumbUrl}} alt=\"{{item.name}} service\" class=\"img-thumbnail img-crop-square __disable__service-icon-140pxCercle .img-responsive\"></a><h3 class=text-center>{{ item.title }}</h3><p class=text-center ng-bind-html=item.title>{{ item.description }}</p></div></data-owl-carousel></div><div ng-if=vm.mobile class=row><data-owl-carousel class=owl-carousel data-options=\"{navigation: true, pagination: true, rewindNav : false, items:1}\"><div owl-carousel-item=\"\" ng-repeat=\"item in vm.data.gallery\" class=item><a ng-click=vm.openlightBoxCarousel(vm.data.gallery,$index)><img ng-src={{item.thumbUrl}} alt=\"{{item.name}} service\" class=\"img-thumbnail img-crop-square __disable__service-icon-140pxCercle .img-responsive\"></a><h3 class=text-center>{{ item.title }}</h3><p class=text-center ng-bind-html=item.title>{{ item.description }}</p></div></data-owl-carousel></div></div><div ng-if=!vm.data.carousel><div ng-if=vm.mobile class=row><table border=0 class=\"table table-condensed\"><tr ng-repeat=\"items in vm.galtype7Mobile\"><td ng-repeat=\"service in items\" ng-class=\"vm.data.gallery_item_per_row ? 'col-md-'+ (12 / vm.data.gallery_item_per_row)+' col-sm-'+ (12 / vm.data.gallery_item_per_row)+' col-xs-'+ (12 / vm.data.gallery_item_per_row) : 'col-md-4 col-sm-4 col-xs-4'\"><div class=service-item><a ng-if=\"service.thumbUrl \" ng-click=vm.openLightboxModal(service,vm.anchor)><img ng-src={{service.thumbUrl}} alt=\"{{service.name}} service\" class=\"img-thumbnail img-crop-square __disable__service-icon-140pxCercle .img-responsive\"></a><h4 class=text-center ng-if=\"service.title && vm.data.titleDisplayThumb\">{{service.title}}</h4><p class=text-center ng-if=\"service.description && vm.data.DescriptionDisplayThumb\" ng-bind-html=service.description></p></div></table></div><div ng-if=vm.desktop class=row><table border=0 class=\"table table-condensed\"><tr ng-repeat=\"items in vm.galtype7\"><td ng-repeat=\"service in items\" ng-class=\"vm.data.gallery_item_per_row ? 'col-md-'+ (12 / vm.data.gallery_item_per_row)+' col-sm-'+ (12 / vm.data.gallery_item_per_row)+' col-xs-'+ (12 / vm.data.gallery_item_per_row) : 'col-md-4 col-sm-4 col-xs-4'\"><div class=service-item><a ng-class=\"{'thumbnail' : vm.data.formImg, '' : !vm.data.formImg}\" ng-if=\"service.thumbUrl \" ng-click=vm.openLightboxModal(service,vm.anchor)><img ng-src={{service.thumbUrl}} alt=\"{{service.name}} service\" class=\"img-thumbnail img-crop-square __disable__service-icon-140pxCercle .img-responsive\"></a><h4 class=text-center ng-if=\"service.title && vm.data.titleDisplayThumb\">{{service.title}}</h4><p class=text-center ng-if=\"service.description && vm.data.DescriptionDisplayThumb\" ng-bind-html=service.description></p></div></table></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 139 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row ng-if=\"vm.data.name || vm.data.subName\" style=\"margin-bottom: 35px\"><div class=\"col-md-6 col-md-offset-3 col-xs-12 text-center\"><h2 ng-if=vm.data.name ng-bind-html=vm.data.name></h2><h3 ng-if=vm.data.subName ng-bind-html=vm.data.subName></h3><hr ng-if=vm.data.hr></div></div><div class=row><ul class=list-unstyled><li class=\"text-center col-xs-12\" ng-class=\"{'col-md-6': vm.data.gallery.length == 2, 'col-md-4': vm.data.gallery.length == 3, 'col-md-3': vm.data.gallery.length >= 4, 'col-sm-6': vm.data.gallery.length >= 3, }\" ng-repeat=\"service in vm.data.gallery | orderBy:'order'\"><div class=service-item ng-switch=!!service.url><a class=whiteLink ng-switch-when=true ui-sref-opts={reload:true} ui-sref={{service.url}}(service.pageId)><span ng-if=\"service.avatar !== undefined\" ng-switch=!!service.avatar><span ng-switch-when=false><i class=\"service-icon glyphicon glyphicon-leaf\"></i></span> <span ng-switch-default><img ng-src={{service.avatar}} alt=\"{{service.title}} service\" class=img-thumbnail ng-class=\"{'service-icon-140pxRounded':service.avatarShape == 1, 'service-icon-140pxCercle': (!service.avatarShape || service.avatarShape == 0)}\"></span></span><h4>{{service.title}}</h4><p ng-bind-html=service.description></p></a> <span ng-switch-when=false><span ng-if=\"service.avatar !== undefined\" ng-switch=!!service.avatar><span ng-switch-when=false><i class=\"service-icon glyphicon glyphicon-leaf\"></i></span> <span ng-switch-default><img ng-src={{service.avatar}} alt=\"{{service.title}} service\" class=img-thumbnail ng-class=\"{'service-icon-140pxRounded':service.avatarShape == 1, 'service-icon-140pxCercle':(!service.avatarShape || service.avatarShape == 0)}\"></span></span><h4>{{service.title}}</h4><p ng-bind-html=service.description></p></span></div></li></ul></div><div class=row><div class=col-xs-12><p ng-if=vm.data.description ng-bind-html=vm.data.description></p></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 140 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row ng-if=\"vm.data.name || vm.data.subName || vm.data.description\"><div class=\"col-md-6 col-md-offset-3 col-xs-12 text-center\"><h2 ng-if=vm.data.name ng-bind-html=vm.data.name ng-class=vm.data.extra_css.name.class ng-style=\"vm.data.extra_css.name.color && { 'color':vm.data.extra_css.name.color }\"></h2><h3 ng-if=vm.data.subName ng-bind-html=vm.data.subName ng-class=vm.data.extra_css.subName.class ng-style=\"vm.data.extra_css.subName.color && { 'color':vm.data.extra_css.subName.color }\"></h3><hr ng-if=vm.data.hr></div></div><div class=row><div class=col-xs-12><p ng-if=vm.data.description ng-bind-html=vm.data.description ng-class=vm.data.extra_css.description.class ng-style=\"vm.data.extra_css.description.color && { 'color':vm.data.extra_css.description.color }\"></p></div></div><div ng-if=vm.mobile class=row><table border=0 class=\"table table-condensed\"><tr ng-repeat=\"items in vm.galtype9Mobile\"><td ng-repeat=\"service in items\" ng-style=\"{ 'width' : (100 / vm.data.gallery_item_per_row) }\"><div class=service-item><a ng-if=\"service.thumbUrl && service.url\" ng-click=vm.openLightboxModal(service,vm.anchor)><img ng-src={{service.thumbUrl}} alt=\"{{service.name}} service\" class=\"img-thumbnail img-crop-square __disable__service-icon-140pxCercle .img-responsive\"></a><h4 class=text-center ng-if=\"service.title && vm.data.titleDisplayThumb\">{{service.title}}</h4><p class=text-center ng-if=\"service.description && vm.data.DescriptionDisplayThumb\" ng-bind-html=service.description></p><p class=text-center ng-if=service.addToCart.price>{{service.addToCart.price}} {{service.addToCart.currency}}</p><ngcart-addtocart class=text-center ng-if=service.addToCart id={{vm.getIdItem(service,vm.anchor)}} data=service.addToCart name={{service.addToCart.name}} price={{service.addToCart.price}} quantity={{service.addToCart.quantity}} quantity-max={{service.addToCart.quantityMax}} quantity-min={{service.addToCart.quantityMin}}>{{\"ADD_TO_CART\" | translate}}</ngcart-addtocart></div></table></div><div ng-if=vm.desktop class=row><table border=0 class=\"table table-condensed\"><tr ng-repeat=\"items in vm.galtype9\"><td ng-repeat=\"service in items\" ng-style=\"{ 'width' : (100 / vm.data.gallery_item_per_row) }\"><div class=service-item><a ng-if=\"service.thumbUrl && service.url\" ng-class=\"{'thumbnail' : vm.data.formImg, '' : !vm.data.formImg}\" ng-click=vm.openLightboxModal(service,vm.anchor)><img ng-src={{service.thumbUrl}} alt=\"{{service.name}} service\" class=\"img-thumbnail img-crop-square __disable__service-icon-140pxCercle .img-responsive\"></a><h4 class=text-center ng-if=\"service.title && vm.data.titleDisplayThumb\">{{service.title}}</h4><p class=text-center ng-if=\"service.description && vm.data.DescriptionDisplayThumb\" ng-bind-html=service.description></p><p class=text-center ng-if=service.addToCart.price>{{service.addToCart.price}} {{service.addToCart.currency}}</p><ngcart-addtocart class=text-center ng-if=service.addToCart id={{vm.getIdItem(service,vm.anchor)}} data=service.addToCart name={{service.addToCart.name}} price={{service.addToCart.price}} quantity={{service.addToCart.quantity}} quantity-max={{service.addToCart.quantityMax}} quantity-min={{service.addToCart.quantityMin}}>{{\"ADD_TO_CART\" | translate}}</ngcart-addtocart></div></table></div><div class=row ng-if=\"vm.data.bookNow && vm.data.bookNow.cId && !vm.ngCart.isEmpty()\"><div class=col-xs-12><ngcart-cart></ngcart-cart></div></div><div class=row ng-if=\"vm.data.bookNow && vm.data.bookNow.cId\"><div class=col-xs-12><div class=text-center><button class=\"btn btn-default\" ng-disabled=vm.ngCart.isEmpty() ng-click=\"vm.btnBooking(vm.angular.extend({}, vm.data.bookNow, {'cart': vm.getCartDirective()}))\">{{vm.data.bookNow.title}}</button><obt-modal-popup title=\"Add a booking for a client\" open-modal-promise=vm.btnBooking template-url=app/booking/buttonRequestBooking.html template-controller=\"BookingController as vmModal\"></obt-modal-popup></div></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row ng-if=\"vm.data.name || vm.data.subName || vm.data.description\"><div class=\"col-md-4 col-md-offset-4 col-xs-12 text-center\"><h2 ng-if=vm.data.name ng-bind-html=vm.data.name></h2><h3 ng-if=vm.data.subName ng-bind-html=vm.data.subName></h3><hr ng-if=vm.data.hr></div></div><div class=row><div class=\"col-md-3 text-center\" ng-class=\"{'col-md-push-9':vm.data.avatar_on_right}\"><div class=thudmbnail><img ng-src=\"{{vm.data.avatar !== null ? vm.data.avatar : 'img/avatar.jpg'}}\" obt-error-image=\"'img/avatar.jpg'\" alt=Avatar class=\"img-responsive center-block\" ng-class=\"{'img-rounded':vm.data.avatarShape == 1, 'img-circle':vm.data.avatarShape == 0}\"><div class=caption><h3 class=text-center>{{ vm.data.fName + ' ' + vm.data.lName}}<br><small>{{vm.data.sufix}}</small><br><small><ul class=list-inline><li ng-repeat-start=\"wTitle in vm.data.wTitles\">{{wTitle}}</li><li ng-repeat-end ng-if=!$last>|</li></ul></small> <span ng-if=vm.data.www><a ng-href=\"{{vm.data.https ? 'https' :'http'}}://{{vm.data.www}}\" class=\"btn btn-link\">{{vm.data.www}}</a></span></h3></div></div></div><div class=col-md-9 ng-class=\"{'col-md-pull-3':vm.data.avatar_on_right}\" ng-bind-html=vm.data.description></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 142 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row ng-if=\"vm.data.name || vm.data.subName\" style=\"margin-bottom: 35px\"><div class=\"col-md-6 col-md-offset-3 col-xs-12 text-center\"><h2 ng-if=vm.data.name ng-bind-html=vm.data.name></h2><h3 ng-if=vm.data.subName ng-bind-html=vm.data.subName></h3><hr ng-if=vm.data.hr></div></div><div class=row><ul class=list-unstyled><li class=\"text-center col-xs-12\" ng-class=\"{'col-md-6': vm.data.services.length == 2, 'col-md-4': vm.data.services.length == 3, 'col-md-3': vm.data.services.length >= 4, 'col-sm-6': vm.data.services.length >= 3, }\" ng-repeat=\"service in vm.data.services | orderBy:'order'\"><div class=service-item ng-switch=!!service.url><a class=whiteLink ng-switch-when=true ui-sref-opts={reload:true} ui-sref={{service.url}}(service.pageId)><span ng-if=\"service.avatar !== undefined\" ng-switch=!!service.avatar><span ng-switch-when=false><i class=\"service-icon glyphicon glyphicon-leaf\"></i></span> <span ng-switch-default><img ng-src={{service.avatar}} alt=\"{{service.name}} service\" class=img-thumbnail ng-class=\"{'service-icon-140pxRounded':service.avatarShape == 1, 'service-icon-140pxCercle': (!service.avatarShape || service.avatarShape == 0)}\"></span></span><h4>{{service.name}}</h4><p ng-bind-html=service.synopsis></p></a> <span ng-switch-when=false><span ng-if=\"service.avatar !== undefined\" ng-switch=!!service.avatar><span ng-switch-when=false><i class=\"service-icon glyphicon glyphicon-leaf\"></i></span> <span ng-switch-default><img ng-src={{service.avatar}} alt=\"{{service.name}} service\" class=img-thumbnail ng-class=\"{'service-icon-140pxRounded':service.avatarShape == 1, 'service-icon-140pxCercle':(!service.avatarShape || service.avatarShape == 0)}\"></span></span><h4>{{service.name}}</h4><p ng-bind-html=service.synopsis></p></span></div></li></ul></div><div class=row><div class=col-xs-12><p ng-if=vm.data.description ng-bind-html=vm.data.description></p></div></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 143 */
/***/ function(module, exports) {

	module.exports = "";

/***/ },
/* 144 */
/***/ function(module, exports) {

	module.exports = "<div class=container><div class=row ng-if=vm.data.title><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 text-center\"><h2 ng-bind-html=vm.data.title></h2><hr></div></div><div class=row><ul class=list-unstyled><li ng-repeat-start=\"service in vm.data.services\" class=\"text-center col-xs-12\" ng-class=\"[\n                 (vm.data.gallery_item_per_row ? 'col-md-'+ (12 / vm.data.gallery_item_per_row) : ''),\n                 (vm.data.gallery_item_per_row ? 'col-sm-'+ (12 / (vm.data.gallery_item_per_row/2)) : ''),\n                 {\n                   'col-md-12': !vm.data.gallery_item_per_row && vm.data.services.length == 1,\n                   'col-md-6':  !vm.data.gallery_item_per_row && vm.data.services.length == 2,\n                   'col-md-4':  !vm.data.gallery_item_per_row && vm.data.services.length >= 3,\n                   'col-sm-6':  !vm.data.gallery_item_per_row && vm.data.services.length >= 4\n                 }\n                 ]\"><div class=service-item><a ng-if=\"service.thumbUrl && service.url\" ng-click=vm.openLightboxModal($index)><img ng-src={{service.thumbUrl}} alt=\"{{service.name}} service\" class=\"img-thumbnail __disable__service-icon-140pxCercle\"></a><h4>{{service.title}}</h4><p ng-bind-html=service.description></p></div></li><span ng-repeat-end><li ng-if=\"vm.data.gallery_item_per_row && vm.data.services.length >= 4 && ($index + 1) % vm.data.gallery_item_per_row == 0\" class=\"clearfix visible-md-block\"></li><li ng-if=\"vm.data.gallery_item_per_row && vm.data.services.length >= 4 && ($index + 1) % (vm.data.gallery_item_per_row/2) == 0\" class=\"clearfix visible-sm-block\"></li><li ng-if=\"!vm.data.gallery_item_per_row && vm.data.services.length >= 4 && ($index + 1) % 3 == 0\" class=\"clearfix visible-md-block\"></li><li ng-if=\"!vm.data.gallery_item_per_row && vm.data.services.length >= 4 && ($index + 1) % 2 == 0\" class=\"clearfix visible-sm-block\"></li></span></ul></div></div><obt-update-section-directive ng-if=vm.getConnectedState() data=vm.data page-id={{vm.pageId}} page-section-id={{vm.pageSectionId}} type={{vm.type}} anchor={{vm.anchor}}></obt-update-section-directive>";

/***/ },
/* 145 */
/***/ function(module, exports) {

	module.exports = "<li class=visible-xs-block ng-repeat=\"menu in vmMenu.data | orderBy:'order'\" ng-switch=menu.type><a ng-switch-when=1 href=javascript:void(0) ng-click=vmMenu.test(menu.data.link)>{{menu.data.name}}</a> <a ng-switch-when=2 href=javascript:void(0) ui-sref={{menu.data.link}}>{{menu.data.name}}\\n</a> <a ng-switch-when=3 href={{menu.data.link}}>{{menu.data.name}}\\n</a></li>";

/***/ },
/* 146 */
/***/ function(module, exports) {

	module.exports = "<div><div ng-hide=\"attrs.id && price\"><button class=\"btn btn-xs btn-default\" ng-disabled=true ng-transclude></button></div><div ng-show=\"attrs.id && price\"><div ng-switch=!!inCart()><div ng-switch-default><span ng-show=\"quantityMax && quantityMax > 1\"><select name=quantity id=quantity ng-model=q ng-options=\" v for v in qtyOpt\" style=\"color: initial\"></select></span> <button class=\"btn btn-xs btn-default\" ng-click=\"ngCart.addItem(id, name, price, q, data)\" ng-transclude></button></div><div><button style=\"white-space: normal\" ng-switch-when=true class=\"btn btn-xs btn-danger hidden-xs hidden-sm\" ng-click=ngCart.removeItemById(id)>{{'REMOVE_ITEM_SELECTED' | translate }} ({{ngCart.getItemById(id).getQuantity()}})</button> <button ng-switch-when=true class=\"btn btn-xs btn-danger hidden-md hidden-lg\" ng-click=ngCart.removeItemById(id)><span class=\"glyphicon glyphicon-remove\" aria-hidden=true></span> ({{ngCart.getItemById(id).getQuantity()}})</button></div></div></div></div>";

/***/ },
/* 147 */
/***/ function(module, exports) {

	module.exports = "<div><div ng-if=\"service=='http' || service == 'log'\"><button class=\"btn btn-primary\" ng-click=checkout() ng-disabled=!ngCart.getTotalItems() ng-transclude>Checkout</button></div><div ng-if=\"service=='paypal'\"><form action=https://www.paypal.com/cgi-bin/webscr method=post target=_top ng-show=ngCart.getTotalItems()><input type=hidden name=cmd value=_xclick> <input type=hidden name=business value=\"{{ settings.paypal.business }}\"> <input type=hidden name=lc value=CA> <input type=hidden name=item_name value=\"{{ settings.paypal.item_name }}\"> <input type=hidden name=item_number value=\"{{ settings.paypal.item_number }}\"> <input type=hidden name=amount value=\"{{ ngCart.getSubTotal()}}\"> <input type=hidden name=currency_code value=\"{{ settings.paypal.currency_code }}\"> <input type=hidden name=button_subtype value=services> <input type=hidden name=no_note value=0> <input type=hidden name=tax_rate value=\"{{ ngCart.getTaxRate()}}\"> <input type=hidden name=shipping value=\"{{ ngCart.getShipping()}}\"> <input type=hidden name=bn value=PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest> <input type=image src=https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif border=0 name=submit alt=\"PayPal - The safer, easier way to pay online!\"> <img alt=\"\" border=0 src=https://www.paypalobjects.com/en_US/i/scr/pixel.gif width=1 height=1></form></div></div>";

/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = "<div><div class=\"alert alert-warning\" role=alert ng-show=\"ngCart.getTotalItems() === 0\">{{'YOUR_CART_IS_EMPTY' | translate}}</div><div class=\"table-responsive col-lg-12\" ng-show=\"ngCart.getTotalItems() > 0 && (curr = ngCart.getCart().items[0].getData() && ngCart.getCart().items[0].getData().currency) ? true : false\"><table class=\"table table-striped-nope ngCart cart\"><thead><tr><th><th><th>{{'CART_QUANTITY'| translate}}<th>{{'CART_AMOUNT'| translate}}<th>{{'CART_TOTAL'| translate}}<tfoot><tr ng-show=ngCart.getTax()><td><td><td><td>{{ 'CART_TAX' | translate}} ({{ ngCart.getTaxRate() }}%):<td>{{ ngCart.getTax() }} {{ curr }}<tr ng-show=ngCart.getShipping()><td><td><td><td>{{'CART_SHIPPING'| translate}}:<td>{{ ngCart.getShipping() }} {{ curr }}<tr><td><td><td><td>{{'CART_TOTAL'| translate}}:<td>{{ ngCart.totalCost() }} {{ curr }}<tbody><tr ng-repeat=\"item in ngCart.getCart().items track by $index\"><td><span ng-click=ngCart.removeItemById(item.getId()) class=\"glyphicon glyphicon-remove\"></span><td>{{ item.getName() }}<td>{{ item.getQuantity() | number }}<td>{{ item.getPrice() }} {{ curr }}<td>{{ item.getTotal() }} {{ curr }}</table></div></div>";

/***/ },
/* 149 */
/***/ function(module, exports) {

	module.exports = "<div class=row><div class=col-md-6>{{ ngCart.getTotalItems() }}<ng-pluralize count=ngCart.getTotalItems() when=\"{1: 'item', 'other':'items'}\"></ng-pluralize><br>{{ ngCart.totalCost()}} {{ ngCart.getCart().items && ngCart.getCart().items[0].getData() && ngCart.getCart().items[0].getData().currency }}</div></div>";

/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports = "<div><div ng-style=\"{'margin-top': (type === '3' || type === '4' || type === '5' ) ? '-35px' : '40px'}\" style=right:0;z-index:5;position:absolute><button style=background:inherit class=btn ng-click=showSectionForm(getData())><i class=\"fa fa-pencil-square-o\"></i></button><obt-modal-popup title=\"Add a booking for a client\" open-modal-promise=showSectionForm template-url=./../../app/login/updateSectionForms/type_1.html template-controller=\"updateSectionController \"></obt-modal-popup></div></div>";

/***/ },
/* 151 */
/***/ function(module, exports) {

	/* global toastr:false, moment:false */
	(function() {
	    'use strict';

	    angular
	        .module('app.core')
	        .constant('toastr', toastr)
	        .constant('moment', moment)
	        .constant('_', _);
	})();


/***/ },
/* 152 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('app.core')
	        .factory('emitService', emitService);
	    /*USE: emitService('order:created', {data});*/
	    emitService.$inject = ['$rootScope'];
	    /* @ngInject */
	    function emitService($rootScope) {
	        return function() { $rootScope.$emit.apply($rootScope, arguments); }
	    }
	})();

/***/ },
/* 153 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('app.core')
	        //.run(socketRunService)
	        .factory('queryservice', queryservice);

	    ///*@ngInject*/
	    //function socketRunService(obtSocket, queryservice){
	    //    if(obtSocket){
	    //        obtSocket.on('disconnect', reconnectSocket);
	    //    }
	    //
	    //    function reconnectSocket(value) { //OK
	    //        value = angular.fromJson(value);
	    //        queryservice.setResponseServer(value)
	    //    }
	    //}

	    /* @ngInject */
	    function queryservice($http, $state, $stateParams, $q, exception, logger, config, emitService,
	                          sessionServices, obtSocket, $window, $timeout, RouterTransitionService) {
	        var isPrimed = false;
	        var primePromise;
	        var msgId = 0;
	        var callbackList = {};
	        var base = config.appServiceBaseUrl;

	        var is_protocal_configured = false;
	        var is_protocal_error = false;
	        var protocol_config = null;
	        var socket_instance = null;

	        var service = {
	            callServer: callServer,
	            ready: ready,
	            getFormOptions:getFormOptions,
	            findOptionNamePerId: findOptionNamePerId,
	            findOptionIdPerName: findOptionIdPerName,
	            findOptionCidPerId :findOptionCidPerId,
	            setEvnArgs :setEvnArgs,
	            setResponseServer: unWrapProtocol
	        };

	        return service;


	        function findCurrentState(){
	            var state =  RouterTransitionService.getState();
	            if(state && state.name == 'stateChangeStart' && state.toState){
	                return state.toState;
	            }else{
	                return $state.current;
	            }
	        }
	        function prime() {
	            // This function can only be called once.
	            if (primePromise) {
	                return primePromise;
	            }

	            primePromise = $q.when(true).then(success);
	            return primePromise;

	            function success() {
	                isPrimed = true;
	                logger.info('Primed data');
	            }
	        }

	        function ready(nextPromises) {
	            var readyPromise = primePromise || prime();

	            return readyPromise
	                .then(function() { return $q.all(nextPromises); })
	                .catch(exception.catcher('"ready" function failed'));
	        }

	        function protocolWrapper_socket(myFctName, myArgs) {
	            var currentState = findCurrentState();
	            var currentSession = sessionServices.getSession() || {};
	            var baseUrl = currentState.data && currentState.data.home ? $state.href(currentState.data.home, $stateParams) : '';

	            var session  = {
	                cId: (myArgs && myArgs.cId ? myArgs.cId : $stateParams.cId),
	                tId:$stateParams.tId,
	                language:$stateParams.language,
	                ui: currentState.obtVid && currentState.obtPage ?  currentState.obtVid +''+ currentState.obtPage : null,
	                uId:currentSession.uId,
	                piwikId:protocol_config && protocol_config.piwikId ? protocol_config.piwikId : null,
	                sessionId:currentSession.sessionId};
	            return {
	                ui: session.ui || config.ui,
	                version: protocol_config && protocol_config.version ? protocol_config.version : 'obt0.1b1',
	                uiOrigin: 'simpleFactory',
	                sessionId: session.sessionId || null,
	                piwikId: session.piwikId || null,
	                retQueue: 'php',
	                language: session && session.language ? session.language : config.language,
	                transactionArray:[
	                    {
	                        commandId:'0',
	                        transactionType:"1",
	                        cId: session ? session.cId : null,
	                        operation:1,
	                        operationType:myFctName,
	                        dataType:"3",
	                        body:angular.toJson({
	                            language: session && session.language ? session.language : config.language, //default value : fr
	                            baseUrl:baseUrl,
	                            ui: session.ui || config.ui,
	                            cId: session ? session.cId : null,
	                            uId: session ? session.uId : null,
	                            fctArgsJson: myArgs,
	                            php:
	                            {
	                                sessionId: session.sessionId || null,
	                                piwikId: session.piwikId || null,
	                                SERVER_HTTP_HOST: protocol_config && protocol_config.httpHost ? protocol_config.httpHost : "HOST_NOT_SET",
	                                SERVER_REMOTE_ADDR: "192.168.10.1",
	                                language: session && session.language ? session.language : config.language,
	                                obtVersion:"/mblouin/obt-dashboard/public_html"
	                            },
	                            sessionId: session.sessionId || null,
	                            piwikId: session.piwikId || null,
	                        }),
	                        error:'0'
	                    }
	                ],
	                error:'0'
	            };
	        }

	        function protocolWrapper(myFctName, myArgs) {
	            var currentState = findCurrentState();
	            var currentSession = sessionServices.getSession() || {};
	            var baseUrl = currentState.data && currentState.data.home ? $state.href(currentState.data.home, $stateParams) : '';
	            var session  = {
	                cId: (myArgs && myArgs.cId ? myArgs.cId : $stateParams.cId),
	                tId:$stateParams.tId,
	                language:$stateParams.language,
	                ui: currentState.obtVid && currentState.obtPage ?  currentState.obtVid +''+ currentState.obtPage : null,
	                uId:currentSession.uId,
	                sessionId:currentSession.sessionId,
	                piwikId:protocol_config && protocol_config.piwikId ? protocol_config.piwikId : null,
	            };
	            return {
	                operation: 'python',
	                pOperation: 1,
	                fctName: myFctName,
	                fctArgsJson: myArgs,
	                language: session && session.language ? session.language : config.language, //default value : fr
	                origin: 'simpleFactory',
	                baseUrl:baseUrl,
	                ui: session.ui || config.ui,
	                cId: session.cId || null,
	                uId: session.uId || null,
	                sessionId: session.sessionId || null,
	                piwikId: session.piwikId || null
	            };
	        }
	        function unWrapProtocol(protocol){
	            if(protocol.data){
	                protocol = protocol.data;
	            }
	            if (protocol.id !== null) {
	                var deferred = getStoredCallBack(protocol.id);
	                if (deferred) {
	                    var data = protocol.transactionArray ? functionCallSanity(protocol.transactionArray[0]) : null;
	                    if (data !== null) {
	                        if (data.body.http === 'login') { //&&  ! data.body.sessionId){
	                            deferred.reject("TIMEOUT, please re-log!");
	                            handleTimeOut(data.body);
	                        } else {
	                            if(data.body.error === 1){
	                                logger.error(data.body.body);
	                                deferred.reject(data.body.body);
	                            }else{
	                                deferred.resolve(data.body);
	                            }
	                        }
	                    } else {
	                        if (protocol.transactionArray && protocol.transactionArray[0]
	                            && protocol.transactionArray[0].body.indexOf("Error obt#48") > -1){
	                            $window.location.href = './';
	                        }
	                        logger.error("OBT - Protocol Error - empty data!");
	                        deferred.reject("OBT - Protocol Error - empty data!");
	                        //$window.location.href = './';
	                    }
	                }
	            }
	//            return protocol.transactionArray ? functionCallSanity(protocol.transactionArray[0]) : null;
	        }

	        function functionCallSanity(protocol) {
	            if (protocol) {
	                if (protocol.error === 0) {
	                    return {body: protocol.body, dataType: protocol.dataType};
	//                  if ($scope.appState == null || !isReloginAsked(functionProtocol)) { //Check If a relogin is asked
	//                  } else { //else, a relogin is asked, we must stop the current process and show the relogin dialog..
	//                      //NOTE we don't return a value for this case.
	//                      lauchReloginProcess();
	//                  }
	                } else {
	                    //TODO send error msg to server
	                    exception.catcher('"response" received an error flag');
	                    return null;
	                }
	            }
	            return null;
	        }

	        function storeCallback(obtCallback) {
	            var id = msgId++;
	            callbackList[id] = obtCallback;
	            return id;
	        }

	        function getStoredCallBack(id) { /*callbackList.splice(id,1)*/
	            var value = callbackList[id];
	            if (value !== null) {
	                delete callbackList[id];
	            }
	            return value;
	        }

	        function handleTimeOut(data) {
	            exception.catcher('Timeout, please relogin');
	            emitService('obt:TimeOut', data);//emit a message the msg
	        }
	        function sendRequest(myFctName, myArgs){
	            var deferred = $q.defer();
	            var msgId = storeCallback(deferred);  //Store teh Callback

	            if('obtUiHelper.getUiConfig'!= myFctName && !is_protocal_configured){
	                get_config_protocol()
	                    .then(init_socket)
	                    .then(function(){
	                        sendCallServer(msgId, myFctName, myArgs);
	                    });
	            }else{
	                sendCallServer(msgId, myFctName, myArgs);
	            }

	            return deferred.promise;

	//            var protocol = {};
	//            if(obtSocket){
	//                protocol = protocolWrapper_socket(myFctName, myArgs); //create the socket protocol
	//                protocol['id'] = msgId;
	//                obtSocket.emit('fctCall', protocol);
	//            }else{
	//                protocol = protocolWrapper(myFctName, myArgs); //create the protocol
	//                protocol.id = msgId;
	//
	//                $http.post(base + '/php/bridge.php', protocol )
	//                    .then(unWrapProtocol)
	//                    .catch(function(message) {
	//                        var deferred = getStoredCallBack(message.id);
	//                        if (deferred) {
	//                            deferred.reject(message);
	//                        }
	//                        exception.catcher('XHR Failed for ' + myFctName )(message);
	////                    $location.url('/');
	//                    });
	//            }
	        }
	        function sendCallServer(msgId, myFctName, myArgs){
	            // if(myFctName == "obtAdvHelper.getFooterInfo"){
	            //   var state =  RouterTransitionService.getState();
	            //   console.debug({
	            //     func: 'obtAdvHelper.getFooterInfo',
	            //       state_name : state.name,
	            //       toState : state.toState,
	            //     toStateParams : state.toState.params,
	            //       currentState : findCurrentState(),
	            //       currentSession : sessionServices.getSession() || {},
	            //
	            //     language:[$stateParams.language, $state.current.params, $state.current]
	            //   });
	            // }

	            var protocol = {};

	            if(is_protocal_configured && socket_instance && obtSocket.connected()){ // Socket need to be confidured before any call
	                protocol = protocolWrapper_socket(myFctName, myArgs); //create the protocol
	                protocol['id'] = msgId;
	                socket_instance.emit('fctCall', protocol);
	            }else{
	                protocol = protocolWrapper(myFctName, myArgs); //create the protocol
	                protocol['id'] = msgId;
	                //getQueryRessources.save(protocol, callServer_success, callServer_error);

	                $http.post(base + '/php/bridge.php', protocol )
	                    .then(unWrapProtocol)
	                    .catch(function(message) {
	                        var deferred = getStoredCallBack(message.id);
	                        if (deferred) {
	                            deferred.reject(message);
	                        }
	                        exception.catcher('XHR Failed for ' + myFctName )(message);
	//                    $location.url('/');
	                    });
	            }
	        }

	        function callServer_success(value){
	            unWrapProtocol(value);
	        }
	        function get_config_protocol(){
	            return callServer('obtUiHelper.getUiConfig', {})
	                .then(function(info){
	                    is_protocal_configured = true;
	                    protocol_config = info;
	                    console.log(info,'my infos');
	                    return info;
	                });
	        }

	        function init_socket(protocol_config){
	            socket_instance = obtSocket.getSocket(protocol_config.nodeJsHost , protocol_config.nodeJsPort );
	            if(socket_instance){
	                socket_instance.on('connect_error',
	                    function(error_msg) {
	                        console.info('#ERROR CONNECT SOCKET');

	                        // console.log('-----------------------------------------');
	                        // console.log('--------------  ERROR CONNECT SOCKET-----');
	                        // console.log('-----------------------------------------');
	                        //socket_instance.disconnect();
	                        //socket_instance.connect();
	                        //socket_instance = null;
	                        //is_protocal_error = true;
	                });
	                //socket_instance.on('disconnect',
	                //    function(error_msg) {
	                //        console.log('-----------------------------------------');
	                //        console.log('--------------  RECONECT SOCKET ---------');
	                //        console.log('-----------------------------------------');
	                //
	                //        socket_instance.connect();
	                //        //socket_instance = null;
	                //        is_protocal_error = false;
	                //});
	                socket_instance.on('data', socket_callServer_success);

	                //$timeout(function(){
	                //    console.log('-----------------------------------------');
	                //    console.log('---------  TEST DISCONNECT SOCKET -------');
	                //    console.log('-----------------------------------------');
	                //
	                //    socket_instance.disconnect();
	                //
	                //}, 15000);
	            }
	        }
	        function socket_callServer_success(value){
	            value = angular.fromJson(value);
	            callServer_success(value)
	        }
	        function callServer(myFctName, myArgs){
	            return sendRequest(myFctName, myArgs)
	        }


	        function getFormOptions(cbIdList, cId, tId, passthrough) {
	            var args = {
	                cId: cId || sessionServices.getArgs('cId'),
	                language: sessionServices.getArgs('language')
	            };

	            args.passthrough = passthrough || {};
	            args.passthrough.tId = tId || sessionServices.getArgs('tId');

	            if (cbIdList) {
	                args['cbIdList'] = cbIdList;
	            }

	            if (tId) {
	                args['tId'] = tId;
	            }
	            return callServer("obtUiHelper.getComboxBoxUpdate", args, null)
	                .then(function (response) {

	                    console.log(response , 'my response de getFormOPtions');
	                    var options = [];

	                    if (response && response.updateComboBox) {
	                       _.each(response.updateComboBox, function (item) {
	                           options[item.NAME] = item.COMBOVALUE;

	                           //setDefault
	                           _.each(item.COMBOVALUE, function findDefaultID(subItem){
	                               if(subItem.ISDEFAULT){
	                                   options[item.NAME + '_default'] = subItem.KEY;
	                               }
	                           });

	                       });
	                    }
	                    return options;
	                });
	        }

	        function findOptionIdPerName(nameToSearch, options, keyName, fieldName){
	            //if(idToSearch){
	            if(!keyName){ keyName = 'KEY'}
	            if(!fieldName){fieldName = 'VALUE';}
	            var fieldsToSearch = {};
	            fieldsToSearch[keyName] = nameToSearch;
	            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
	            //}else{
	            //    return null;
	            //}
	        }
	        function findOptionNamePerId(idToSearch, options, keyName, fieldName){
	            //if(idToSearch){
	            if(!keyName){ keyName = 'KEY'}
	            if(!fieldName){fieldName = 'VALUE';}
	            var fieldsToSearch = {};
	            fieldsToSearch[keyName] = idToSearch;
	            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
	            //}else{
	            //    return null;
	            //}
	        }
	        function findOptionCidPerId(idToSearch, options, keyName, fieldName){
	            //if(idToSearch){
	            if(!keyName){ keyName = 'KEY'}
	            if(!fieldName){fieldName = 'CID';}
	            var fieldsToSearch = {};
	            fieldsToSearch[keyName] = idToSearch;
	            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
	            //}else{
	            //    return null;
	            //}
	        }
	        function setEvnArgs(args, cId, tId) {
	            var currentSession = sessionServices.getSession();
	            if (!args) {
	                args = {};
	            }
	            if(currentSession){
	                args['cId'] = cId || currentSession.cId;

	                args['tId'] = tId || args.tId || currentSession.tId;
	            }
	        }

	    }
	    queryservice.$inject = ["$http", "$state", "$stateParams", "$q", "exception", "logger", "config", "emitService", "sessionServices", "obtSocket", "$window", "$timeout", "RouterTransitionService"];
	})();


/***/ },
/* 154 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('app.core')
	        .run(appRun);

	    /* @ngInject */
	    function appRun(routerHelper, config) {
	        var otherwise = '/'+config.language; //+'/404';
	        //var otherwise = '/'+config.language +'/oracle';
	        routerHelper.configureStates(getStates(), otherwise);
	    }
	    appRun.$inject = ["routerHelper", "config"];
	    function getStates() { return []; }
	    //
	    //function getStates() {
	    //    return [
	    //        {
	    //            state: '404',
	    //            config: {
	    //                url: '/404',
	    //                templateUrl: 'app/core/404.html',
	    //                title: '404'
	    //            }
	    //        }
	    //    ]
	    //}
	})();


/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 07/05/15.
	 */

	(function (app) {

	    "use strict";

	    app.factory('ObtBaseFactory',ObtBaseFactory);
	    app.service("obtBaseService", obtBaseService);

	    /*@ngInject*/
	    function obtBaseService (queryservice ) {
	        return {
	            getItems : getItems,
	            updateItem : updateItem,
	            addItem : addItem,
	            deleteItem:deleteItem
	        };

	        function callServer(args, functionName){
	            queryservice.setEvnArgs(args);
	            return queryservice.callServer(functionName, args, null);
	        }
	        function getItems(args){
	            args = args || {};
	            args.format=1;
	            return callServer(args, "obtStatementsHelper.getAccountSummary");
	        }
	        function addItem (data){
	            return callServer(data, "obtStatementsHelper.add");
	        }
	        function updateItem (data){
	            return callServer(data, "obtStatementsHelper.update");
	        }
	        function deleteItem (key){
	            var args = {tId:key};
	            return callServer(args, "obtStatementsHelper.delete");
	        }
	    }
	    obtBaseService.$inject = ["queryservice"];
	    /*@ngInject*/
	    function ObtBaseFactory(obtBaseService, $log){
	        var factory = function(args, data, service){
	            this.infos = data || null;
	            this.args = args || {};
	            this.service = service || obtBaseService || null;

	            this.infosField = null;
	            this.infosDetailsField = null;  //Disabled if null
	            this.errorField = 'error';
	            this.errorMsgField = 'body';
	        };

	        factory.prototype.setData = setData;
	        factory.prototype.setArgs =setArgs;
	        factory.prototype.getArgs = getArgs;
	        factory.prototype.getArg = getArg;
	        factory.prototype.getData = getData;
	        factory.prototype.updateItem = updateItem;
	        factory.prototype.deleteItem = deleteItem;
	        factory.prototype.addItem = addItem;
	        factory.prototype.reload =reload;
	        factory.prototype.isError = isError;
	        factory.prototype.getError = getError;
	        factory.prototype.isErrorInResponse = isErrorInResponse;
	        factory.prototype.transformData = transformData;
	        return factory;

	        function setData(data){
	            //data[0].seoKeywords = [];
	            this.infos = this.transformData(data);

	        }
	        function setArgs(args){
	            this.args = args;
	        }
	        function getArgs(){
	            return this.args ? this.args : {};
	        }
	        function getArg(name){
	            return this.args && this.args[name] ? this.args[name] : null;
	        }
	        function getData(){
	            if(this.isError()){
	                return null;
	            }
	            return this.infos && this.infosField ? this.infos[this.infosField] : this.infos;
	        }

	        function reload(){
	            console.log('reload called');
	            if(this.service){
	                var factoryInstance = this;
	                return this.service.getItems(this.getArgs()).then(
	                    function (response) {
	                        factoryInstance.setData(response);
	                        console.log('model reloaded');
	                    });
	            }}

	        function addItem(item){
	            $log.debug('add item');
	            var factoryInstance = this;
	            return this.service.addItem(item)
	                .then(function (response) {
	                    console.log('add done');
	                    return response;
	                }).finally(function (){
	                    return factoryInstance.reload();
	                });
	        }

	        function updateItem(item, stopReloadIfError){
	            stopReloadIfError = stopReloadIfError ? true : false;

	            $log.debug('update item');
	            var factoryInstance = this;
	            return this.service.updateItem(item || this.infos)
	                .then(function (response) {
	                    console.log('update done');
	                    if(stopReloadIfError){
	                        stopReloadIfError = factoryInstance.isErrorInResponse(response);
	                    }
	                    return response;
	                }).finally(function (){
	                    if(!stopReloadIfError){
	                        return factoryInstance.reload();
	                    }
	                });
	        }

	        function deleteItem(itemId){
	            $log.debug('delete item');
	            var factoryInstance = this;
	            return this.service.deleteItem(itemId)
	                .then(function (response) {
	                    console.log('delete done');
	                    return response;
	                }).finally(function (){
	                    return factoryInstance.reload();
	                });
	        }

	        function isErrorInResponse(response){
	            return response && response.error && response.error == 1;
	        }
	        function isError(){
	            return this.infos && this.infos[this.errorField] == 1 ? true : false ;
	        }
	        function getError(){
	            return this.infos && this.isError() ? this.infos[this.errorMsgField] : "";
	        }
	        function transformData(data){
	            angular.forEach(data.rows, function(item){
	                if(item.fTime){
	                    item.fTime = moment(item.fTime);
	                }
	                if(item.lTime){
	                    item.lTime = moment(item.lTime);
	                }
	                if(item.tTime){
	                    item.tTime = moment(item.tTime);
	                }
	                if(item.opDate){
	                    item.opDate = moment(item.opDate);
	                }
	                if(item.insDate){
	                    item.insDate = moment(item.insDate);
	                }
	                if(item.createdOn){
	                    item.createdOn = moment(item.createdOn);
	                }
	            });
	            return data;
	        }
	    }
	    ObtBaseFactory.$inject = ["obtBaseService", "$log"];
	})(angular.module('app.core'));


/***/ },
/* 156 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('app.core')
	        .factory('RouterTransitionService', RouterTransitionService);
	    /*USE: emitService('order:created', {data});*/
	    RouterTransitionService.$inject = ['$rootScope'];
	    /* @ngInject */
	    function RouterTransitionService() {

	        /** NAME:
	         * $stateChangeStart
	         * $stateChangeError
	         * $stateChangeSuccess
	         * $viewContentLoaded
	         * $stateNotFound
	         */
	        var state = {
	            name            : null,
	            toState         : null,
	            toParams        : null,
	            fromState       : null,
	            fromParams      : null,
	            unfoundState    : null,
	        };

	        return {
	            getState: getState,
	            stateChangeStart: stateChangeStart,
	            stateChangeError: stateChangeError,
	            stateChangeSuccess: stateChangeSuccess,
	            viewContentLoaded: viewContentLoaded,
	            stateNotFound: stateNotFound
	        }
	        function clear(){
	            state.name         = null;
	            state.toState      = null;
	            state.toParams     = null;
	            state.fromState    = null;
	            state.fromParams   = null;
	            state.unfoundState = null;
	        }
	        function getState(){return state; }

	        function stateChangeStart(toState, toParams, fromState, fromParams){
	            clear();
	            state.name         = 'stateChangeStart';
	            state.toState      = toState;
	            state.toParams     = toParams;
	            state.fromState    = fromState;
	            state.fromParams   = fromParams;
	        }
	        function stateChangeError(toState, toParams, fromState, fromParams){
	            clear();
	            state.name         = 'stateChangeError';
	            state.toState      = toState;
	            state.toParams     = toParams;
	            state.fromState    = fromState;
	            state.fromParams   = fromParams;
	        }
	        function stateChangeSuccess(toState, toParams, fromState, fromParams){
	            clear();
	            state.name         = 'stateChangeSuccess';
	            state.toState      = toState;
	            state.toParams     = toParams;
	            state.fromState    = fromState;
	            state.fromParams   = fromParams;
	        }
	        function viewContentLoaded(){
	            clear();
	            state.name         = 'viewContentLoaded';
	        }
	        function stateNotFound(unfoundState, fromState, fromParams){
	            clear();
	            state.name         = 'stateNotFound';
	            state.fromState    = fromState;
	            state.fromParams   = fromParams;
	            state.unfoundState = unfoundState;
	        }
	    }
	})();

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(163);
	__webpack_require__(164);
	__webpack_require__(165);
	__webpack_require__(158);
	__webpack_require__(166);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(169);
	__webpack_require__(170);
	__webpack_require__(171);


/***/ },
/* 158 */
/***/ function(module, exports) {

	(function (app) {
	    'use strict';

	    app.factory('dynamicServices', dynamicServices);

	    /*@ngInject*/
	    function dynamicServices(queryservice, $q){
	        return  {
	            getContent:getDynamicContent,
	            getServiceContent:getServiceContent
	        };

	        function getDynamicContent(kId, cId) {
	            if(kId){
	                var args = {kId:kId, cId : cId};
	                var fctName= "obtAdvHelper.getContentsInfo";
	                return queryservice.callServer(fctName,args);
	            }else{
	                return $q.when({});
	            }
	        }

	        function getServiceContent(sId, cId) {
	            if(sId){
	                var args = {sId:sId, cId : cId};
	                var fctName= "obtAdvHelper.getServicesInfo";
	                return queryservice.callServer(fctName,args);
	            }else{
	                return $q.when({});
	            }
	        }
	    }
	    dynamicServices.$inject = ["queryservice", "$q"];
	})(angular.module('app.data'));


/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 02/03/15.
	 */
	(function () {
	    'use strict';

	    angular
	        .module('app.data', ['app.core']);
	})();


/***/ },
/* 160 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 02/03/15.
	 */
	/**
	 * Created by pmnia on 02/03/15.
	 */
	(function (app) {
	    'use strict';

	    app.factory('advisorServices', advisorServices);
	    /*@ngInject*/
	    function advisorServices(queryservice){
	        return  {
	            getAdvisor:getAdvisor,
	            getTherapists: getTherapists
	        };

	        function getAdvisor(cId, wq, lq) {
	            if(cId){
	                var fctArgsJson= {cId:cId, wq:wq, lq:lq};
	                var fctName= "obtAdvHelper.getClinicInfo";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }
	        }

	        function getTherapists(cId, wq, lq){
	            if(cId){
	                var fctArgsJson= {cId:cId, wq:wq, lq:lq};
	                var fctName= "obtAdvHelper.getTherapistsInfoByLocations";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }
	        }
	    }
	    advisorServices.$inject = ["queryservice"];
	})(angular.module('app.data'));


/***/ },
/* 161 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 02/03/15.
	 */
	/**
	 * Created by pmnia on 02/03/15.
	 */
	(function (app) {
	    'use strict';

	    app.factory('associationServices', associationServices);
	    /*@ngInject*/
	    function associationServices(queryservice){
	        return  {
	            getAssociation:getAssociation,
	            getTherapists: getTherapists
	        };

	        function getAssociation(cId) {
	            if(cId){
	                var fctArgsJson= {cId:cId};
	                var fctName= "obtAdvHelper.getClinicInfo";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }
	        }

	        function getTherapists(cId){
	            if(cId){
	                var fctArgsJson= {cId:cId};
	                var fctName= "obtAdvHelper.getTherapistsInfoByLocations";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }
	        }
	    }
	    associationServices.$inject = ["queryservice"];
	})(angular.module('app.data'));


/***/ },
/* 162 */
/***/ function(module, exports) {

	(function (app) {
	    'use strict';

	    app.factory('bookingServices', bookingServices);
	    /*@ngInject*/
	    function bookingServices(queryservice, $q){
	        return  {
	            addBooking:addBooking,
	            requestBooking:requestBooking,
	            addToWaitingList:addToWaitingList
	        };

	        function addBooking(fctArgsJson, cId) {
	            if(fctArgsJson && cId){
	                fctArgsJson.cId = cId;
	                var fctName= "obtCalHelper.addBooking";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }else{
	                return $q.when({});
	            }
	        }

	        function addToWaitingList(fctArgsJson, cId) {
	            if(fctArgsJson && cId){
	                fctArgsJson.cId = cId;
	                var fctName= "obtCalHelper.addToWaitingList";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }else{
	                return $q.when({});
	            }
	        }

	        function requestBooking(fctArgsJson, cId) {
	            if(fctArgsJson && cId){
	                fctArgsJson.cId = cId;
	                var fctName= "obtCalHelper.requestBooking";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }else{
	                return $q.when({});
	            }
	        }
	    }
	    bookingServices.$inject = ["queryservice", "$q"];
	})(angular.module('app.data'));


/***/ },
/* 163 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 02/03/15.
	 */
	/**
	 * Created by pmnia on 02/03/15.
	 */
	(function (app) {
	    'use strict';

	    app.factory('calendarServices', calendarServices);
	    /*@ngInject*/
	    function calendarServices(queryservice, $q){
	        return  {
	            getProfile:getProfile,
	            getData:getData
	        };

	        function getProfile(cId, tId) {
	            if(cId){
	                var fctArgsJson= {cId:cId};
	                if(tId){
	                    fctArgsJson.tId = tId;
	                }

	                var fctName= "obtAdvHelper.getTherapistsInfo"; //
	                return queryservice.callServer(fctName,fctArgsJson)
	                    .then(findCalendarProfile);
	            }
	        }

	        function findCalendarProfile(data){
	            if(data && data.error === 0){
	                return data[0].calendar;
	            }else{
	                return data;
	            }
	        }

	        function getData(start, end, cId, tId, filters) {
	            if(cId){
	                var fctArgsJson = filters || {};
	                fctArgsJson.start = start;
	                fctArgsJson.end = end;
	                fctArgsJson.cId = cId;

	                if(tId){
	                    fctArgsJson.tId = tId;
	                }
	                var fctName= "obtCalHelper.getCalendarData";
	                return queryservice.callServer(fctName,fctArgsJson)
	                    .then(function (result){
	                        return result &&  result.data ? result.data : result;
	                    });
	            }else{
	                return $q.when([]);
	            }
	        }
	    }
	    calendarServices.$inject = ["queryservice", "$q"];
	})(angular.module('app.data'));


/***/ },
/* 164 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 02/03/15.
	 */
	/**
	 * Created by pmnia on 02/03/15.
	 */
	(function (app) {
	    'use strict';

	    app.factory('clinicServices', clinicServices);
	    /*@ngInject*/
	    function clinicServices(queryservice){
	        return  {
	            getClinic:getClinic,
	            getTherapists: getTherapists
	        };

	        function getClinic(cId) {
	            if(cId){
	                var fctArgsJson= {cId:cId};
	                var fctName= "obtAdvHelper.getClinicInfo";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }
	        }

	        function getTherapists(cId){
	            console.log('clinicService')
	            if(cId){
	                var fctArgsJson= {cId:cId};
	                var fctName= "obtAdvHelper.getTherapistsInfo";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }
	        }
	    }
	    clinicServices.$inject = ["queryservice"];
	})(angular.module('app.data'));


/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 02/03/15.
	 */
	(function () {
	    'use strict';
	    angular
	        .module('app.data')
	        .factory('dataservice', dataService);

	    /*@ngInject*/
	    function dataService(queryservice, associationServices, clinicServices,
	                         calendarServices, therapistServices,preferenceServices
	                        ,bookingServices, loginServices, formServices
	                    , dynamicServices, pageServices, advisorServices, oracleServices){
	        return  {
	            queryService : queryservice,
	            association : associationServices,
	            clinic : clinicServices,
	            therapist : therapistServices,
	            calendar : calendarServices,
	            preference : preferenceServices,
	            booking : bookingServices,
	            login : loginServices,
	            form : formServices,
	            dynamic : dynamicServices,
	            page : pageServices,
	            advisor : advisorServices,
	            oracle : oracleServices
	        };
	    }
	    dataService.$inject = ["queryservice", "associationServices", "clinicServices", "calendarServices", "therapistServices", "preferenceServices", "bookingServices", "loginServices", "formServices", "dynamicServices", "pageServices", "advisorServices", "oracleServices"];
	})();


/***/ },
/* 166 */
/***/ function(module, exports) {

	(function (app) {
	    'use strict';

	    app.factory('formServices', formServices);

	    /*@ngInject*/
	    function formServices(queryservice, _){
	        return  {
	            getOptions:getOptions,
	            getOptionsFrom:getOptionsFrom,
	            unwrapOptions:unwrapOptions,
	            findOptionNamePerId:findOptionNamePerId,
	            findOptionNamePerCODE :findOptionNamePerCODE
	        };

	        function getOptions(cbIdList, passthrough, args) {
	            //if(cbIdList){
	                var fctArgsJson = args || {};
	                fctArgsJson.cbIdList = cbIdList;
	                //if(passthrough){fctArgsJson.passthrough =  angular.extend({}, passthrough, fctArgsJson.passthrough);
	                fctArgsJson.passthrough = passthrough;
	                //}
	                var fctName= "obtUiHelper.getComboxBoxUpdate";
	                return queryservice.callServer(fctName,fctArgsJson).then(unwrapOptions);
	            //}
	        }

	        function findOptionNamePerId(idToSearch, options, keyName, fieldName){
	            if(!keyName){ keyName = 'KEY'}
	            if(!fieldName){fieldName = 'VALUE';}

	            var fieldsToSearch = {};
	            fieldsToSearch[keyName] = idToSearch;
	            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
	        }
	        function findOptionNamePerCODE(code,options){
	         var keyName = 'CODE'
	         var fieldName = 'KEY';

	            var fieldsToSearch = {};
	            fieldsToSearch[keyName] = code;
	            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
	        }

	        function unwrapOptions(response){
	            var options = {};

	            if (response && response.updateComboBox) {
	                _.each(response.updateComboBox, function (item) {
	                    if(item.COMBOVALUE instanceof Array){
	                        item.COMBOVALUE.map(function(item){
	                            var parsedString =  parseInt(item.KEY, 10);
	                            if( ! isNaN(parsedString)){
	                                item.KEY = parsedString ;
	                            }
	                            return item;
	                        });
	                    }
	                    options[item.NAME] = item.COMBOVALUE;

	                    //setDefault
	                    _.each(item.COMBOVALUE, function findDefaultID(subItem){
	                        if(subItem.ISDEFAULT){
	                            options[item.NAME + '_default'] = subItem.KEY;
	                        }
	                    });

	                });
	            }
	            return options;
	        }

	        function getOptionsFrom(data, name ){
	            return _.result(_.find(data, {NAME:name}), 'COMBOVALUE');
	        }
	    }
	    formServices.$inject = ["queryservice", "_"];
	})(angular.module('app.data'));


/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 12/03/15.
	 */
	(function () {
	    'use strict';
	    angular
	        .module('app.data')
	        .run(restoreSession)
	        .factory('loginServices', loginServices);


	    restoreSession.$inject=['$rootScope', '$stateParams','loginServices'];
	    /*@ngInject*/
	    function restoreSession($rootScope, $stateParams, loginServices) {
	        loginServices.loadSession($stateParams.cId, loginServices);

	        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                if (toParams.cId !== fromParams.cId) { // CID have change
	                    loginServices.loadSession(toParams.cId, loginServices);
	                }
	            }
	        );

	        $rootScope.$on('obt:TimeOut', function (event, data) {
	            loginServices.removeSession(data.cId, loginServices);
	        });
	    }


	    loginServices.$inject = ['queryservice', 'exception', 'sessionServices'];
	    /*@ngInject*/
	    function loginServices(queryservice, exception, sessionServices){


	        var status={};
	        return  {
	            status:status,
	            signIn: signIn,
	            signOut: signOut,
	            loadSession:loadSession,
	            removeSession:removeSession,
	            changePassword:changePassword,
	            sendPassword:sendPassword
	        };

	        function signIn(items, cId) {
	            var fctArgsJson={};
	            if(items.fName){
	                fctArgsJson.fName = items.fName;
	            }
	            if(items.fName){
	                fctArgsJson.isCellPhone = items.isCellPhone;
	            }
	            fctArgsJson.email = items.email;
	            fctArgsJson.password = items.password;
	            fctArgsJson.cId = cId;
	            fctArgsJson.loginToUi = 1;
	            var fctName= "obtLoginHelper.login";
	            var instance = this;
	            return queryservice.callServer(fctName,fctArgsJson)
	                .then(function(data){
	                   console.log(data);
	                  if(data && (data.isCPhone === true || data.fName === true) ){

	                    return data;
	                 }
	                 else{

	                     if(data && data.error === 0){
	                         if (data.sessionId ) {
	                             saveSession(data, instance);
	                             return data;
	                         } else {
	                             return {isLogged: false, body: data.body, error : 1};
	                         }
	                     }else {
	                         return {isLogged: false, body: data.body, error : 1};
	                     }
	                 }

	                });
	        }
	        function loadSession(cId, instance){
	            instance.status = sessionServices.getSession(cId);
	        }
	        function saveSession(data, instance){
	            sessionServices.setSession(data);
	            if(data && instance){
	                instance.status = data;
	                instance.status.isLogged = true;
	            }
	        }
	        function removeSession(cId, instance){
	            sessionServices.removeSession(cId, true);
	            instance.status = null;
	        }
	        function signOut(sessionId, cId){
	            if(!sessionId && this.status && this.status.sessionId){
	                sessionId = this.status.sessionId;
	                cId = this.status.cId;
	            }
	            if(!sessionId){
	                return;
	            }
	            var fctArgsJson={};
	            fctArgsJson.cId = cId;
	            fctArgsJson.sessionId = sessionId;
	            var fctName= "obtLoginHelper.logout";
	            var instance = this;
	            return queryservice.callServer(fctName,fctArgsJson)
	                .then(function(response){
	                    removeSession(cId, instance);
	                    return response;
	                })
	                .catch(function (){
	                    removeSession(cId, instance);
	                    exception.catcher('"sign out" function failed')
	                    });
	        }
	        function changePassword(currentPwd, newPwd, uId, cId){
	            var args = {};
	            args.currentPassword = currentPwd;
	            args.newPassword = newPwd;
	            args.uId = uId;
	            args.cId = cId;
	            return queryservice.callServer("obtLoginHelper.updatePassword", args, null);
	        }

	        function sendPassword(cId, args){
	            args = args || {};
	            args.cId = cId;
	            return queryservice.callServer("obtLoginHelper.sendPassword", args, null);
	        }
	    }
	})();


/***/ },
/* 168 */
/***/ function(module, exports) {

	(function (app) {
	    'use strict';

	    app.factory('pageServices', pageServices);

	    /*@ngInject*/
	    function pageServices(queryservice, $q, $rootScope){
	        $rootScope.embded = {};
	        return  {
	            getFooterContent:getFooterContent,
	            setTitle:setTitle,
	            setLogoLink : setLogoLink,
	            setNavBarTitle:setNavBarTitle,
	            setTitles: setTitles,
	            setFavicon:setFavicon,
	            setNavBarLogo:setNavBarLogo,
	            setEmbded: setEmbded,
	            setMenu: setMenu,
	            setIsCalendarDisabled: setIsCalendarDisabled,
	            setNavBarShowSignIn: setNavBarShowSignIn,
	            setPageSection: setPageSection
	        };

	        function setTitles(title, navBarTitle, favicon ){
	            console.log(title, navBarTitle, favicon,'ici please');
	            setTitle(title);
	            setNavBarTitle(navBarTitle);
	            setFavicon(favicon);
	        }
	        function setLogoLink(logoLink){
	          $rootScope.logoLink = logoLink;
	        }
	        function setPageSection(pageSection){
	            console.log(pageSection,'ici please');
	            $rootScope.pageSection = pageSection;
	        }
	        function getPageSection(){

	          return  $rootScope.pageSection;
	        }

	        function setMenu(navBarMenu){
	            console.debug('navBarMenu',navBarMenu);
	            $rootScope.navBarMenu = navBarMenu;
	        }

	        function setNavBarLogo(navBarLogo){
	            $rootScope.navBarLogo = navBarLogo;
	        }
	        function setTitle(title){
	            $rootScope.title = title;
	        }
	        function setNavBarTitle(title){
	           // console.log(title,'ici please');
	            $rootScope.navBarTitle = title;
	        }
	        function setNavBarShowSignIn(navBarShowSignIn){
	            $rootScope.navBarShowSignIn = navBarShowSignIn;
	        }

	        function setIsCalendarDisabled(isCalendarDisabled){
	            $rootScope.isCalendarDisabled = isCalendarDisabled;
	        }

	        function setFavicon(favicon){
	            $rootScope.favicon = favicon;
	        }

	        function setEmbded(mode){
	            $rootScope.embded = $rootScope.embded || {};
	            $rootScope.embded.calOnly = mode === 'calOnly';
	            $rootScope.embded.noDetail = mode === 'noDetail' ||  mode === 'calOnly';
	            $rootScope.embded.noHeader = mode  ? true  : false;
	        }

	        function getFooterContent(cId, tId) {
	            if(cId){
	                var args = {cId : cId, tId:tId};
	                var fctName= "obtAdvHelper.getFooterInfo";
	                return queryservice.callServer(fctName,args);
	            }else{
	                return $q.when({});
	            }
	        }
	    }
	    pageServices.$inject = ["queryservice", "$q", "$rootScope"];
	})(angular.module('app.data'));


/***/ },
/* 169 */
/***/ function(module, exports) {

	(function (app) {
	    'use strict';

	    app.factory('preferenceServices', preferenceServices);

	    /*@ngInject*/
	    function preferenceServices(queryservice){
	        return  {
	            getHistory:getHistory
	        };

	        function getHistory(cId, uId) {
	            if(cId && uId){
	                var fctArgsJson= {cId:cId, uId:uId};
	                var fctName= "obtUiHelper.getCustomerHistory";
	                return queryservice.callServer(fctName,fctArgsJson);
	            }
	        }
	    }
	    preferenceServices.$inject = ["queryservice"];
	})(angular.module('app.data'));


/***/ },
/* 170 */
/***/ function(module, exports) {

	(function (app) {
	    'use strict';

	    app.factory('therapistServices', therapistServices);

	    /*@ngInject*/
	    function therapistServices(queryservice){
	        return  {
	            getTherapist:getTherapist
	        };

	        function getTherapist(cId, tId) {
	            console.log('getTherapist' , cId, tId);
	            // if(cId && tId){
	                var fctArgsJson= {cId:cId, tId:tId};
	                var fctName= "obtAdvHelper.getTherapistsInfo";
	                return queryservice.callServer(fctName,fctArgsJson)
	                    .then(getFirstFromArray)
	                    //.catch(function(){console.log('momo')}).finally(function(){console.log('hoho')});
	            // }
	        }

	        function getFirstFromArray(data){
	            console.debug('getTherapist -- getFirstFromArray' , JSON.stringify(data));
	            return data ? data[0] : {};
	        }
	    }
	    therapistServices.$inject = ["queryservice"];
	})(angular.module('app.data'));


/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 11/11/15.
	 */
	(function (app) {
	    'use strict';

	    app.factory('oracleServices', oracleServices);

	    /*@ngInject*/
	    function oracleServices(queryservice, $q){
	        return  {
	            domainArgs:null,
	            getFallbackPage:getFallbackPage
	        };

	        function getFallbackPage(data) {

	                var args = angular.extend({}, data);
	                var fctName= "obtAdvHelper.getFallbackInfo";
	                return queryservice.callServer(fctName,args);
	            //if(false){}else{
	            //    var deferral = $q.defer();
	            //    deferral.resolve({page:'therapistClinic', args:{cId:'mblouin6', tId:1}});
	            //    return deferral.promise;
	            //}
	        }
	    }
	    oracleServices.$inject = ["queryservice", "$q"];
	})(angular.module('app.data'));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(173);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(194);
	__webpack_require__(195);
	__webpack_require__(196);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	(function(){

	    'use strict';
	    angular
	        .module('app.widgets')
	        .directive('customDatepicker', function () {
	            return {
	                restrict: 'EA',
	                scope:{
	                    myDate: '=ngModel',
	                    notRequired : '@?',
	                    options : '=?',
	                    name : '@'
	                },
	                template: __webpack_require__(174),
	                link : function (scope, element, attrs, ngModelCtrl) {
	                    if(scope.myDate && typeof scope.myDate == 'moment'){
	                        scope.myDate = scope.myDate.toDate();
	                    }
	                    scope.notRequired = scope.notRequired ? false : true;
	                    scope.open = function($event) {
	                        $event.preventDefault();
	                        $event.stopPropagation();
	                        scope.opened = true;
	                    };

	                    scope.datepickerOptions = angular.extend({},{'show-button-bar': false, 'show-weeks':false}, scope.options);
	                }
	            };
	        });
	})();


/***/ },
/* 174 */
/***/ function(module, exports) {

	module.exports = "<div class=\"form-group has-feedback\"><input class=\"form-control custom-datepicker\" name={{name}} ng-model=myDate ng-click=\"opened = true\" uib-datepicker-popup=dd/MM/yyyy is-open=opened show-button-bar=false shortcut-propagation=true datepicker-options=datepickerOptions ng-required=\"{{required}}\"> <span class=\"glyphicon glyphicon-calendar form-control-feedback\"></span></div>";

/***/ },
/* 175 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular.module('app.widgets', ['matchMedia', 'ngCart','angularModalService','ui.tinymce','uiSwitch','lr.upload','ui.carousel']);
	})();


/***/ },
/* 176 */
/***/ function(module, exports) {

	/**
	 * Created by LENOVO T440 on 27/09/2017.
	 */

	/******/ (function(modules) { // webpackBootstrap
	    /******/ 	// The module cache
	    /******/ 	var installedModules = {};
	    /******/
	    /******/ 	// The require function
	    /******/ 	function __webpack_require__(moduleId) {
	        /******/
	        /******/ 		// Check if module is in cache
	        /******/ 		if(installedModules[moduleId])
	        /******/ 			return installedModules[moduleId].exports;
	        /******/
	        /******/ 		// Create a new module (and put it into the cache)
	        /******/ 		var module = installedModules[moduleId] = {
	            /******/ 			exports: {},
	            /******/ 			id: moduleId,
	            /******/ 			loaded: false
	            /******/ 		};
	        /******/
	        /******/ 		// Execute the module function
	        /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	        /******/
	        /******/ 		// Flag the module as loaded
	        /******/ 		module.loaded = true;
	        /******/
	        /******/ 		// Return the exports of the module
	        /******/ 		return module.exports;
	        /******/ 	}
	    /******/
	    /******/
	    /******/ 	// expose the modules object (__webpack_modules__)
	    /******/ 	__webpack_require__.m = modules;
	    /******/
	    /******/ 	// expose the module cache
	    /******/ 	__webpack_require__.c = installedModules;
	    /******/
	    /******/ 	// __webpack_public_path__
	    /******/ 	__webpack_require__.p = "";
	    /******/
	    /******/ 	// Load entry module and return exports
	    /******/ 	return __webpack_require__(0);
	    /******/ })
	/************************************************************************/
	/******/ ([
	    /* 0 */
	    /***/ function(module, exports) {

	        'use strict';

	        var _module = angular.module('angularModalService', []);

	        _module.factory('ModalService', ['$animate', '$document', '$compile', '$controller', '$http', '$rootScope', '$q', '$templateRequest', '$timeout', function ($animate, $document, $compile, $controller, $http, $rootScope, $q, $templateRequest, $timeout) {

	            function ModalService() {

	                var self = this;

	                //  Track open modals.
	                self.openModals = [];

	                //  Returns a promise which gets the template, either
	                //  from the template parameter or via a request to the
	                //  template url parameter.
	                var getTemplate = function getTemplate(template, templateUrl) {
	                    var deferred = $q.defer();
	                    if (template) {
	                        deferred.resolve(template);
	                    } else if (templateUrl) {
	                        $templateRequest(templateUrl, true).then(function (template) {
	                            deferred.resolve(template);
	                        }, function (error) {
	                            deferred.reject(error);
	                        });
	                    } else {
	                        deferred.reject("No template or templateUrl has been specified.");
	                    }
	                    return deferred.promise;
	                };

	                //  Adds an element to the DOM as the last child of its container
	                //  like append, but uses $animate to handle animations. Returns a
	                //  promise that is resolved once all animation is complete.
	                var appendChild = function appendChild(parent, child) {
	                    var children = parent.children();
	                    if (children.length > 0) {
	                        return $animate.enter(child, parent, children[children.length - 1]);
	                    }
	                    return $animate.enter(child, parent);
	                };

	                //  Close all modals, providing the given result to the close promise.
	                self.closeModals = function (result, delay) {
	                    while (self.openModals.length) {
	                        self.openModals[0].close(result, delay);
	                        self.openModals.splice(0, 1);
	                    }
	                };

	                self.showModal = function (options) {

	                    //  Get the body of the document, we'll add the modal to this.
	                    var body = angular.element($document[0].body);

	                    //  Create a deferred we'll resolve when the modal is ready.
	                    var deferred = $q.defer();

	                    //  Validate the input parameters.
	                    var controllerName = options.controller;
	                    if (!controllerName) {
	                        deferred.reject("No controller has been specified.");
	                        return deferred.promise;
	                    }

	                    //  Get the actual html of the template.
	                    getTemplate(options.template, options.templateUrl).then(function (template) {

	                        //  The main modal object we will build.
	                        var modal = {};

	                        //  Create a new scope for the modal.
	                        var modalScope = (options.scope || $rootScope).$new();
	                        var rootScopeOnClose = $rootScope.$on('$locationChangeSuccess', cleanUpClose);

	                        //  Create the inputs object to the controller - this will include
	                        //  the scope, as well as all inputs provided.
	                        //  We will also create a deferred that is resolved with a provided
	                        //  close function. The controller can then call 'close(result)'.
	                        //  The controller can also provide a delay for closing - this is
	                        //  helpful if there are closing animations which must finish first.
	                        var closeDeferred = $q.defer();
	                        var closedDeferred = $q.defer();
	                        var inputs = {
	                            $scope: modalScope,
	                            close: function close(result, delay) {
	                                //  If we have a pre-close function, call it.
	                                if (typeof options.preClose === 'function') options.preClose(modal, result, delay);

	                                if (delay === undefined || delay === null) delay = 0;
	                                $timeout(function () {

	                                    cleanUpClose(result);
	                                }, delay);
	                            }
	                        };

	                        //  If we have provided any inputs, pass them to the controller.
	                        if (options.inputs) angular.extend(inputs, options.inputs);

	                        //  Compile then link the template element, building the actual element.
	                        //  Set the $element on the inputs so that it can be injected if required.
	                        var linkFn = $compile(template);
	                        var modalElement = linkFn(modalScope);
	                        inputs.$element = modalElement;

	                        //  Create the controller, explicitly specifying the scope to use.
	                        var controllerObjBefore = modalScope[options.controllerAs];
	                        var modalController = $controller(options.controller, inputs, false, options.controllerAs);

	                        if (options.controllerAs && controllerObjBefore) {
	                            angular.extend(modalController, controllerObjBefore);
	                        }

	                        //  Then, append the modal to the dom.
	                        if (options.appendElement) {
	                            // append to custom append element
	                            appendChild(options.appendElement, modalElement);
	                        } else {
	                            // append to body when no custom append element is specified
	                            appendChild(body, modalElement);
	                        }

	                        // Finally, append any custom classes to the body
	                        if (options.bodyClass) {
	                            body[0].classList.add(options.bodyClass);
	                        }

	                        //  Populate the modal object...
	                        modal.controller = modalController;
	                        modal.scope = modalScope;
	                        modal.element = modalElement;
	                        modal.close = closeDeferred.promise;
	                        modal.closed = closedDeferred.promise;

	                        //  ...which is passed to the caller via the promise.
	                        deferred.resolve(modal);

	                        //  We can track this modal in our open modals.
	                        self.openModals.push({ modal: modal, close: inputs.close });

	                        function cleanUpClose(result) {

	                            //  Resolve the 'close' promise.
	                            closeDeferred.resolve(result);

	                            //  Remove the custom class from the body
	                            if (options.bodyClass) {
	                                body[0].classList.remove(options.bodyClass);
	                            }

	                            //  Let angular remove the element and wait for animations to finish.
	                            $animate.leave(modalElement).then(function () {
	                                //  Resolve the 'closed' promise.
	                                closedDeferred.resolve(result);

	                                //  We can now clean up the scope
	                                modalScope.$destroy();

	                                //  Remove the modal from the set of open modals.
	                                for (var i = 0; i < self.openModals.length; i++) {
	                                    if (self.openModals[i].modal === modal) {
	                                        self.openModals.splice(i, 1);
	                                        break;
	                                    }
	                                }

	                                //  Unless we null out all of these objects we seem to suffer
	                                //  from memory leaks, if anyone can explain why then I'd
	                                //  be very interested to know.
	                                inputs.close = null;
	                                deferred = null;
	                                closeDeferred = null;
	                                modal = null;
	                                inputs = null;
	                                modalElement = null;
	                                modalScope = null;
	                            });

	                            // remove event watcher
	                            rootScopeOnClose && rootScopeOnClose();
	                        }
	                    }).then(null, function (error) {
	                        // 'catch' doesn't work in IE8.
	                        deferred.reject(error);
	                    });

	                    return deferred.promise;
	                };
	            }

	            return new ModalService();
	        }]);

	        /***/ }
	    /******/ ]);
	//# sourceMappingURL=angular-modal-service.js.map


/***/ },
/* 177 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 27/03/15.
	 */

	//source:https://github.com/angular-ui/bootstrap/issues/2828
	(function () {
	    'use strict';
	    angular
	        .module('app.widgets')
	        .config(['$uibTooltipProvider', function($uibTooltipProvider) {
	            $uibTooltipProvider.options({animation: false});
	        }])
	        // .config(['$tooltipProvider', function($tooltipProvider) {
	        //     $tooltipProvider.options({animation: false});
	        // }])
	        // Bootstrap UI fixes after upgrading to Angular 1.3
	        .directive('tooltipHtmlUnsafe', function() {
	            return {
	                restrict: 'EA',
	                link: function(scope, element, attrs) {
	                    attrs.tooltipPlacement = attrs.tooltipPlacement || 'top';
	                    attrs.tooltipAnimation = attrs.tooltipAnimation || true;
	                    attrs.tooltipPopupDelay = attrs.tooltipPopupDelay || 0;
	                    attrs.tooltipTrigger = attrs.tooltipTrigger || 'mouseenter';
	                    attrs.tooltipAppendToBody = attrs.tooltipAppendToBody || false;
	                }
	            }
	        })

	        .directive('popover', function() {
	            return {
	                restrict: 'EA',
	                link: function(scope, element, attrs) {
	                    attrs.popoverPlacement = attrs.popoverPlacement || 'top';
	                    attrs.popoverAnimation = attrs.popoverAnimation || true;
	                    attrs.popoverPopupDelay = attrs.popoverPopupDelay || 0;
	                    attrs.popoverTrigger = attrs.popoverTrigger || 'mouseenter';
	                    attrs.popoverAppendToBody = attrs.popoverAppendToBody || false;
	                }
	            }
	        })

	})();


/***/ },
/* 178 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.widgets')
	        .directive('obtProfileCard', obtProfileCard);


	    function obtProfileCard () {
	        var directive = {
	            restrict: 'E',
	            templateUrl: getTemplateURL,
	            scope : {
	                profile:'=',
	                location : '=?',
	                calendarFilters : '=?'
	            },
	            bindToController:true,
	            controller: obtProfileCardCtrl,
	            controllerAs:'vmProfile'
	        };
	        return directive;
	    }
	    function getTemplateURL (elem, attr){
	        return attr.profileTemplate ? attr.profileTemplate : 'app/widgets/profileCard/obt-ProfileCard.html';
	    }

	    obtProfileCardCtrl.$inject=['dataservice'];
	    /*@NgInject*/
	    function obtProfileCardCtrl(dataservice){
	        var vm = this;
	        vm.showBookNowButton = showBookNowButton;
	        vm.cId = vm.profile.cId || vm.id;
	        vm.tId = vm.profile.tId;
	        vm.addCIdTId = addCIdTId;
	        vm.calendar = {profile : {viewHeight: 200, hideToday:true, hideTitle:true,
	            viewBasic: true, viewTreeDay:false, viewWeek: false,
	            hideEventTitle:true,
	            viewDay: false, viewMonth: false, defaultView:'basicThreeDays'}
	            , getData : getCalendarData};

	        function addCIdTId(data){
	            if(data){
	                data.cId = vm.cId;
	                data.tId = vm.tId;
	            }
	            return data;
	        }
	        function getCalendarData(start, end){
	            var filters = angular.extend({}, vm.calendarFilters,{lId:vm.profile.lId});
	            return dataservice.calendar.getData(start,end, vm.cId, vm.tId,filters)
	                .then(function (data) {
	                    return {data: data,timezone: null};
	                });
	        }
	        function showBookNowButton(){
	            return vm.profile && vm.profile.cType && vm.profile.cId;
	        }
	    }
	    //function link(scope, element, attrs) {}
	})();


/***/ },
/* 179 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.widgets')
	        .directive('obtMatch', obtMatch);

	    function obtMatch () {
	        return {
	            require: 'ngModel',
	            restrict: 'A',
	            scope: {
	                match: '=obtMatch'
	            },
	            link: link
	        };
	    }

	    function link(scope, elem, attrs, ctrl) {
	        scope.$watch(function() {
	            return (ctrl.$pristine && angular.isUndefined(ctrl.$modelValue)) || scope.match === ctrl.$modelValue;
	        }, function(currentValue) {
	            ctrl.$setValidity('match', currentValue);
	        });
	    }
	})();


/***/ },
/* 180 */
/***/ function(module, exports) {

	(function () {
	    'use strict';
	    angular
	        .module('app.widgets')
	        .directive('obtErrorImage', obtErrorImage);


	    function obtErrorImage () {
	        return {
	            link: function(scope, element, attrs) {
	                element.bind('error', function() {
	                    if (attrs.src != attrs.errSrc) {
	                        attrs.$set('src', attrs.errSrc);
	                    }
	                });
	            }
	        }
	    }
	})();


/***/ },
/* 181 */
/***/ function(module, exports) {

	(function () {
	    'use strict';
	    angular
	        .module('app.widgets')
	        .factory('calendarService', calendarService);

	    /* @ngInject */
	    function calendarService() {
	        return{
	            moveDateTimeZone:moveDateTimeZone
	        };

	        function moveDateTimeZone(timezone, date) {
	            if (timezone) {
	                date.zone(timezone, true);
	            }
	            return date;
	        }
	    }
	})();

/***/ },
/* 182 */
/***/ function(module, exports) {

	(function () {
	    'use strict';
	    angular
	        .module('app.widgets')
	        .directive('obtCalendar', obtCalendar);

	    /* @ngInject */
	    function obtCalendar () {
	        return {
	            restrict: 'E', //E = element, A = attribute, C = class, M = comment
	            scope: {
	                //@ reads the attribute value, = provides two-way binding, & works with functions
	                showWeekend: '@',
	//                timezone:'@?',
	                calendarName : '@?',
	                language:'@?',
	                calendarFilter: '=?',
	                createEvent: '&?',
	                resizeEvent: '&?',
	                removeEvent: '&?',
	                dragEvent: '&?',
	                calendarProfile:'=?',
	                syncCalendar: '=?', //list of calendar name
	                name: '=?', //expose API

	                eventClickPromise: '&?',
	                renderEventFunction: '&?',
	                calendarDataPromise: '&?'
	            }, link: function (scope, element, attrs) { //DOM manipulation
	                (attrs.showWeekend === 'true' ? scope.showWeekend = true : scope.showWeekend = false);
	                (attrs.createEvent ? scope.canCreateEvent = true : scope.canCreateEvent = false);
	                (attrs.resizeEvent ? scope.canResizeEvent = true : scope.canResizeEvent = false);
	                (attrs.dragEvent ? scope.canDragEvent = true : scope.canDragEvent = false);
	                (attrs.removeEvent ? scope.canRemoveEvent = true : scope.canRemoveEvent = false);
	                (attrs.renderEventFunction ? scope.useCustomRender = true : scope.useCustomRender = false);
	                (attrs.eventClickPromise ? scope.canClickEvent = true : scope.canClickEvent = false);
	                (attrs.calendarDataPromise ? scope.canLoadData = true : scope.canLoadData = false);

	                scope.calendarName = scope.calendarName ? scope.calendarName : 'calendar';
	                    //watch the filter : function(){return scope.calendarFilter},
	                scope.$watch('calendarFilter',
	                    function (newValue, oldValue) {
	                        scope.applyFilters(newValue);
	                    }, true);
	                scope.setupCalendar();
	            },
	            template:"<div class=\'calendar\' ng-model=\'eventSources\' ui-calendar=\'uiConfig.calendar\' calendar=\'{{calendarName}}\'\n     ng-style=\"(isCalendarDisabled) ? {\'background\': \'url(\' + disabledCalImg + \') no-repeat center center\', \'background-size\': \'contain\' } : {}\"\n     ng-class=\"{ \'calendar_disabled calendar_loading_bg\' : isCalendarLoadingData, calendar_disabled : isCalendarDisabled }\"></div>",

	            controller: /*@ngInject*/["$scope", "$window", "calendarService", "$compile", "logger", "$timeout", "config", "uiCalendarConfig", "$sce", "$analytics", function ($scope, $window, calendarService, $compile, logger, $timeout, config, uiCalendarConfig, $sce, $analytics) {
	                $scope.eventSources = [];
	                $scope.calScrollTime = $scope.calScrollTime || '10:00:00';
	                $scope.applyFilters = function (filters) {
	                    if (filters) {
	                        refetchCalendar();
	                    }
	                };

	                function syncCalendarFct(calendarAPI) {
	                    if(calendarAPI){
	                        calendarAPI.refetchCalendar();
	                    }
	                }

	                function syncAllCalendarFct() {
	                    if ($scope.syncCalendar) {
	                        if (angular.isArray($scope.syncCalendar)) {
	                            for (var i = 0, size = $scope.syncCalendar.length; i < size; i++) {
	                                syncCalendarFct($scope.syncCalendar[i]);
	                            }
	                        } else if (angular.isObject($scope.syncCalendar)) {
	                            syncCalendarFct($scope.syncCalendar);
	                        }
	                    }
	                }

	                function refetchAndSync() {
	                    refetchCalendar();
	                    syncAllCalendarFct();
	                }

	                function eventMouseoverFn(event, jsEvent, view ){
	                    $analytics.eventTrack('hover', {  category: 'calendar', label: event.title });
	                }

	                //CLICK EVENT//
	                //-----------------------------------
	                $scope.selectedEvent = false;
	                function onEventClick(calEvent) {
	                    $analytics.eventTrack('click', {  category: 'calendar', label: calEvent.title });
	                    if(calEvent.editable){}
	                    if ($scope.canClickEvent && $scope.eventClickPromise && ( angular.isUndefined(calEvent.editable) || calEvent.editable == true)) {
	                        $scope.eventClickPromise({calEvent: calEvent, closeCallback: refetchAndSync});
	                    }
	                }

	                function onEventDrop(event, delta, revertFunc, jsEvent, ui, view) {
	                    event.start = calendarService.moveDateTimeZone($scope.timezone, event.start);
	                    $scope.dragEvent({calEvent: event, closeCallback: refetchAndSync}); //refetchCalendar
	                }

	                function onEventResize(event, delta, revertFunc, jsEvent, ui, view) {
	                    event.end = calendarService.moveDateTimeZone($scope.timezone, event.end);
	                    $scope.resizeEvent({calEvent: event, closeCallback: refetchAndSync});
	                }

	                $scope.onRemoveEvent = function (eventId, eventType) {
	                    if ($scope.removeEvent && eventId) {
	//                        find the event
	                        var calEvent = findEventById(eventId);
	                        if (calEvent) {
	                            var result = _.find(calEvent, {'type': eventType });
	                            if (result) {
	                                $scope.removeEvent({calEvent: result, closeCallback: refetchAndSync}); //refetchCalendar});
	                            }
	                        }
	                    }
	                };

	                //renderEvent fonction call//
	                function addTootipOption(event, element, description) {
	                    var popRawContent = angular.element('<div class="btn-group" role="group" aria-label="options group">\n    <button type="button" class="btn btn-default"><span class="glyphicon glyphicon-thumbs-up" aria-hidden="true"></span></button>\n    <button type="button" class="btn btn-default"><span class="glyphicon glyphicon-thumbs-down" aria-hidden="true"></span></button>\n</div>\n<div class="btn-group" role="group" aria-label="Close group">\n    <button type="button" class="btn btn-default" ng-click="onRemoveEvent()"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></button>\n</div>');

	                    $scope.$apply(function () {
	                        var popContent = $compile(popRawContent)($scope);
	                        element.attr("tabindex", event.id);
	                        var popoverData = {
	                            placement: 'top',
	                            html: true,
	                            content: description, // popContent,
	                            trigger: 'hover focus',
	                            delay: {show: 0, hide: 3000}
	                        };
	                        if (description) {
	                            popoverData.title = description;
	                        }
	                        element.popover(popoverData);
	                    });

	                    $(document).on('show.bs.popover', function () {
	                        $('.popover').not(this).popover('hide');
	                    });
	                }

	                /**
	                 *
	                 * @param event
	                 * @param element
	                 * @param functionName the function name to associate with the event
	                 * @returns {*}
	                 */
	                function addCloseEventBtn(event, element, functionName) {

	                    //add close button
	                    var closeButtonRaw = '<button type="button" ng-click="' + functionName + '(' + event.id + ',' + event.type + ')" obt-stop-event class="close"><span aria-hidden="true" style="font-size: 22px">&times;</span><span class="sr-only">Close</span></button>';
	                    var closeButton = angular.element(closeButtonRaw);
	                    $compile(closeButton)($scope);
	//                    element.find('.fc-title').append(closeButton);
	                    element.find('.fc-time').append(closeButton);
	                    return closeButton;
	                }

	                function customEventRender(event, element) {

	                    if ($scope.canRemoveEvent && event.isDeletable) {
	                        addCloseEventBtn(event, element, 'onRemoveEvent');
	                    }
	                    if ($scope.useCustomRender && $scope.renderEventFunction) {
	                        $scope.renderEventFunction({event: event, element: element});
	//                        addTootipOption(event, element);
	                    } else {
	                        if(!('ontouchstart' in $window))
	                        {
	                            var tooltip = event.description || event.title || null;
	                            tooltip += event.details ?  '<hr class="hrTooltip"><p class="text-left ">' + event.details + '</p>': '';
	                            element.tooltip({title:tooltip,container: "body", html:true});
	                        }
	//                        var trustedHtml = $sce.trustAsHtml(tooltip);
	//                        var trustedHtmld = $compile(tooltip)($scope);
	//                        element.attr('tooltip-html-unsafe', tooltip );
	//                        element.replaceWith($compile(element)($scope));
	//                        element.attr("data-title", tooltip);
	//                        element.tooltip({container: "body", html:true});
	//                        element.attr('tooltip-html-unsafe', '{{"tooltip"}}');
	//                       addTootipOption(event, element, tooltip);
	                    }
	                }

	                // I load the "remote" data from the server.
	                function renderCalendar() {
	                    if (uiCalendarConfig.calendars[$scope.calendarName]) {
	                        $timeout(function render(){
	                            console.log('render calendar called');
	                            uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('render');
	                        }, 0);
	                    }
	                }
	                function refetchCalendar() {
	                    if (uiCalendarConfig.calendars[$scope.calendarName]) {
	                        uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('unselect');
	                        uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('refetchEvents');
	                    }
	                }

	                $scope.name = {refetchCalendar: refetchCalendar, renderCalendar:renderCalendar};

	                function createEventClick(date, endDate) {
	                    if ($scope.canCreateEvent && $scope.createEvent) {
	                        var newEvent = {};
	//                        newEvent.title = 'test';
	                        newEvent.start = date;
	                        if ($scope.timezone) { //set time zone
	                            calendarService.moveDateTimeZone($scope.timezone, newEvent.start);
	                        }

	                        if (endDate) {
	                            newEvent.end = endDate;
	                            if ($scope.timezone) { //set time zone
	                                calendarService.moveDateTimeZone($scope.timezone, newEvent.end);
	                            }
	                        } else {
	                            newEvent.end = angular.copy(newEvent.start);
	                            newEvent.end.add(30, 'minutes');
	                        }

	                        if($scope.calendarFilter ){
	                            newEvent.therapistId = $scope.calendarFilter.therapistId;
	                        }

	                        //create a new event pass it to the custum function
	                        $scope.createEvent({calEvent: newEvent, closeCallback: refetchAndSync});
	                    }
	                }

	                function setBusinessHour(data){
	                    uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('businessHours ', data.businessHours);
	                }
	                function setdefaultDate(startDate) {
	                    uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('gotoDate', startDate);
	                }

	                function changeCalendarView(viewName) {
	                    if (viewName) {
	                        uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('changeView', viewName);
	                    }
	                }

	                function findEventById(eventId) {
	                    if (eventId) {
	                        return getEvents(eventId);
	                    }
	                }

	                function getEvents(eventId) {
	                    if (eventId) {
	                        return uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('clientEvents', eventId);
	                    } else {
	                        return uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('clientEvents'); //return all events
	                    }
	                }

	                $scope.setupCalendar = function getProfileAndSetupCalendar(){
	                    if($scope.calendarProfile){
	                        setupCalendar($scope.calendarProfile);
	                    }else{
	                        setupCalendar();
	                    }
	                };

	                function replaceEvents(newEventList) {
	                    //clear event
	                    uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('removeEvents');
	                    //add new events
	                    for (var i = 0; i < newEventList.length; i++) {
	                        uiCalendarConfig.calendars[$scope.calendarName].fullCalendar('renderEvent', newEventList[i]);
	                    }
	                }

	                function setupCalendar(profile) {
	                    profile = profile || {};

	                    console.log('--------- calendar profile ------------');
	                    console.log(profile);

	                    profile.showWeekend = profile.showWeekend || false;
	                    profile.viewBasic = profile.viewBasic || profile.viewBasic !== false;
	                    profile.scrollTime = profile.scrollTime || '10:00:00';
	                    profile.viewHeight = profile.height || profile.viewHeight || 300;
	                    profile.viewMonth = profile.viewMonth || false;
	                    profile.viewWeek = profile.viewWeek || false;
	                    profile.viewTreeDay = profile.viewTreeDay || false;
	                    profile.viewDay = profile.viewDay || false;
	                    profile.timeFormat =  profile.timeFormat || 'H:mm';
	                    profile.businessHours = profile.businessHours ||  {};
	                    profile.isCalendarDisabled = profile.isCalendarDisabled || false;  //define if the calendar is disabled for this session

	                    $scope.isCalendarDisabled = profile.isCalendarDisabled;
	                    $scope.isCalendarLoadingData = false;
	                    $scope.disabledCalImg = profile.disabledCalImg || config.calendarDisabledImage;

	                    var dayView = profile.viewBasic ? 'basicDay': 'agendaDay';
	                    var weekView = profile.viewBasic ? 'basicWeek': 'agendaWeek';
	//                    var rightMenu =  weekView + ',' +dayView;
	                    var rightMenu = "";
	                    rightMenu = profile.viewDay ? dayView + ',' + rightMenu: rightMenu;
	                    rightMenu = profile.viewTreeDay ? 'basicThreeDays,' + rightMenu: rightMenu;
	                    rightMenu = profile.viewWeek ? weekView +',' + rightMenu: rightMenu;
	                    rightMenu = profile.viewMonth ? 'month,'+ rightMenu : rightMenu;

	                    profile.defaultView = profile.viewName || profile.defaultView  ||  weekView;

	                    var header = {
	                        left: 'prev,next',
	                        right: profile.headerRight || rightMenu
	                    };
	                    if(!profile.hideToday){
	                        header.left +=' today';
	                    }
	                    if(!profile.hideTitle){
	                        header.center = 'title'
	                    }


	                    $scope.uiConfig = {
	                        calendar: {
	                            columnFormat:'ddd D MMM',
	                            timezone:false,
	                            timeFormat:profile.timeFormat,
	                            height: profile.viewHeight,
	                            editable: false,
	                            weekends: profile.defaultView == 'basicThreeDays' || profile.viewTreeDay ? true : profile.showWeekend,
	                            defaultView: profile.defaultView,
	                            scrollTime: profile.scrollTime,
	                            header: header,
	                            eventLimit: true, // allow "more" link when too many events
	                            handleWindowResize: true,
	                            windowResize: function(view) {
	                                if(profile.viewMonth && profile.viewWeek && profile.viewTreeDay && profile.viewDay ){
	                                    if ($window.innerWidth < 514) {
	                                        changeCalendarView(dayView);
	                                    } else {
	                                        changeCalendarView(weekView);
	                                    }
	                                }

	                            },
	                            businessHours: profile.businessHours,

	                            views: {
	                                basicThreeDays: {
	                                    type: 'basicDay', /*basicWeek*/
	                                    duration: { days: 3 },
	                                    buttonText: '3 days'
	//                                    start: $.fullCalendar.moment(startSemester)
	//                                    end: $.fullCalendar.moment(endSemester),
	//                                    intervalStart: $.fullCalendar.moment(startSemester),
	//                                    intervalEnd: $.fullCalendar.moment(endSemester),
	                                }
	                            },

	                            selectable: $scope.canCreateEvent,
	                            selectHelper: $scope.canCreateEvent,
	                            unselectAuto:true,
	                            select: function (start, end) {
	                                createEventClick(start, end);
	                            },
	                            eventStartEditable: $scope.canDragEvent, //drag
	                            eventDurationEditable: $scope.canResizeEvent, //resize
	                            lang: $scope.language || config.language,
	                            allDayDefault: false, //events can be display on the agenda view
	                            eventClick: function (calEvent, jsEvent, view) {
	                                onEventClick(calEvent);
	                            },
	                            eventMouseover : function (event, jsEvent, view ) {
	                                eventMouseoverFn(event, jsEvent, view);
	                            },
	                            eventRender: function (event, element) {
	                                customEventRender(event, element);
	                            },
	                            eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
	                                onEventDrop(event, delta, revertFunc, jsEvent, ui, view);
	                            },
	                            eventResize: function (event, delta, revertFunc, jsEvent, ui, view) {
	                                onEventResize(event, delta, revertFunc, jsEvent, ui, view);
	                            },
	//                            eventSources: [{
	                                events: function (start, end, timezone, callback) {
	                                    if (!profile.isCalendarDisabled  && $scope.canLoadData && $scope.calendarDataPromise) {
	                                        $scope.isCalendarLoadingData = true;
	                                        var promise = $scope.calendarDataPromise({start: start, end: end});
	                                        promise.then(function (calData) {
	                                            var profile = null,
	                                                events = [],
	                                                timezone;

	                                            timezone = calData.timezone;
	                                            if(calData.data && calData.data.profile){
	                                                profile = calData.data.profile;
	                                                events = calData.data.data;
	                                            }else{
	                                                events = calData.data;
	                                            }
	                                            if (events && events[0]) {
	                                                $scope.calendarDataToLoad = events;
	                                                //if(events[0].start < end){
	                                                    setdefaultDate(events[0].start);
	                                                //}
	                                            }
	                                            if(profile){
	                                                setBusinessHour(profile);
	                                            }
	                                            if(events){
	                                                callback(events);
	                                            }
	                                            $scope.timezone = timezone;
	                                            $scope.isCalendarLoadingData = false;
	                                        }, function (data) {
	                                            if (data && angular.isString(data.body)) {
	                                                if (data.error != 0) {
	                                                    logger.error(data.body);
	                                                }
	                                            }
	                                            $scope.isCalendarLoadingData = false;
	                                        });
	                                    }
	                                }
	//                            }]
	                        }
	                    };
	                }
	            }]
	        }
	    }})();


/***/ },
/* 183 */
/***/ function(module, exports) {

	(function () {
	    'use strict';
	    angular
	        .module('app.widgets')
	        .directive('affixTarget', affixTarget)
	        .directive('affixContainer', affixContainer)
	        .directive('affixTop', affixTop)
	        .directive('affixBottom', affixBottom);



	    function affixTarget(){
	        return {
	            restrict : 'A',
	            require: '?^affixContainer', /*optional*/
	            link : function linkFn(scope, element, attrs, affixContainerCtrl){
	                affixContainerCtrl.setTarget(element);
	            }
	        }
	    }

	    /*@ngInject*/
	    function affixContainerCtrl(){
	        var vm = this;
	        vm.top=null;
	        vm.bottom=null;
	        vm.target = null;

	        vm.getOffset= getOffset;
	        vm.setTop = setTop;
	        vm.setBottom = setBottom;
	        vm.setTarget = setTarget;

	        function setTarget(target){
	            vm.target = target;
	        }
	        function getOffset(windowHeight){
	            var top = vm.top ? vm.top.offset().top : null;
	            var containerSize = vm.bottom ? vm.bottom.outerHeight(true) : null;
	            var bottom = windowHeight - top - containerSize;

	            if(top && vm.affixMargin && vm.affixMargin.top){
	                top -= vm.affixMargin.top;
	                console.log('-50 pon top', vm.affixMargin.top )
	            }
	            if(bottom && vm.affixMargin && vm.affixMargin.bottom){
	                bottom += vm.affixMargin.bottom;
	            }
	            return {
	                top:top - 50,
	                bottom: bottom
	            };
	        }
	        function setTop(data){
	            vm.top = data;
	        }
	        function setBottom(data){
	            vm.bottom = data;
	        }
	    }
	    function affixContainer($timeout, $window, $document){
	        return {
	            restrict : 'A',
	            controller:affixContainerCtrl,
	            link:affixContainerLink
	//            require: '?^obtModalPopups' /*optional*/
	        };

	        function affixContainerLink(scope,elem,attr,ctrl){
	            scope.vm.affixMargin = {top     : attr.affixMarginTop || 0,
	                                    bottom  : attr.affixMarginBottom || 0};

	            if(!ctrl.target){
	                return;
	            }
	            var listener  = scope.$on(attr.dataLoadedEvent ? attr.dataLoadedEvent : 'dataloaded', function () {
	                $timeout(function () { // You might need this timeout to be sure its run after DOM render.
	                    setAffix(ctrl);
	                    angular.element($window).bind('resize', function() {
	                        setAffix(ctrl);
	                    });
	                    listener(); //kill it
	                }, 0, false);
	            });
	        }

	        function setAffix(ctrl){
	            var target = ctrl.target;
	            target.width(target.width()); //set the width
	            target.affix({
	                offset: ctrl.getOffset($document[0].body.offsetHeight)
	            });
	        }
	    }
	    affixContainer.$inject = ["$timeout", "$window", "$document"];
	    function affixTop(){
	        return {
	            restrict : 'A',
	            require: '?^affixContainer', /*optional*/
	            link : function linkFn(scope, element, attrs, affixContainerCtrl){
	                if(affixContainerCtrl){
	                    affixContainerCtrl.setTop(element);
	                }

	//                offset.top =  attrs.offsetTop || element.offset().top;
	            }
	        }
	    }
	    function affixBottom(){
	        return {
	            restrict : 'A',
	            require: '?^affixContainer', /*optional*/
	            link : function linkFn(scope, element, attrs, affixContainerCtrl){
	                if(affixContainerCtrl){
	                    affixContainerCtrl.setBottom(element);
	                }
	//                offset.bottom =  attrs.offsetBottom || outerHeight(true);
	            }
	        }
	    }
	})();



/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	    'use strict';

	    angular
	        .module('app.widgets')
	        .directive('htWidgetHeader', htWidgetHeader);


	    function htWidgetHeader() {
	        //Usage:
	        //<div ht-widget-header title="vm.map.title"></div>
	        // Creates:
	        // <div ht-widget-header=""
	        //      title="Movie"
	        //      allow-collapse="true" </div>
	        var directive = {
	            scope: {
	                'title': '@',
	                'subtitle': '@',
	                'rightText': '@',
	                'allowCollapse': '@'
	            },
	            template: __webpack_require__(185),
	            restrict: 'EA'
	        };
	        return directive;
	    }
	})();


/***/ },
/* 185 */
/***/ function(module, exports) {

	module.exports = "<div class=widget-head><div class=\"page-title pull-left\">{{title}}</div><small class=page-title-subtle ng-show=subtitle>({{subtitle}})</small><div class=\"widget-icons pull-right\"></div><small class=\"pull-right page-title-subtle\" ng-show=rightText>{{rightText}}</small><div class=clearfix></div></div>";

/***/ },
/* 186 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.widgets')
	        .directive('htImgPerson', htImgPerson);

	    htImgPerson.$inject = ['config'];
	    /* @ngInject */
	    function htImgPerson (config) {
	        //Usage:
	        //<img ht-img-person="{{person.imageSource}}"/>
	        var basePath = config.imageBasePath;
	        var unknownImage = config.unknownPersonImageSource;
	        var directive = {
	            link: link,
	            restrict: 'A'
	        };
	        return directive;

	        function link(scope, element, attrs) {
	            attrs.$observe('htImgPerson', function (value) {
	                value = basePath + (value || unknownImage);
	                attrs.$set('src', value);
	            });
	        }
	    }
	})();


/***/ },
/* 187 */
/***/ function(module, exports) {

	(function () {
	    'use strict';
	    angular
	        .module('app.widgets')
	        .controller('InfoController', ["$scope", "$log", function ($scope, $log) {
	            $scope.templateValue = 'hello from the template itself';
	            $scope.clickedButtonInWindow = function () {
	                var msg = 'clicked a window in the template!';
	                $log.info(msg);
	                alert(msg);
	            }
	        }])
	        .directive('obtMap', obtMap);

	    //win info design : http://en.marnoto.com/2014/09/5-formas-de-personalizar-infowindow.html

	    //OLD VERSION // template:"<ui-gmap-google-map center=\'map.center\' zoom=\'map.zoom\' draggable=\"true\" options=\"map.options\">\n    <ui-gmap-markers models=\"map.markers\" idKey=\"\'id\'\" coords=\"\'self\'\" icon=\"\'icon\'\" fit=\"map.markers.length > 0\" events=\"map.markersEvents\">\n        <ui-gmap-windows options=\"\'windowOptions\'\">\n            <div class=\"row\" style=\'border: 1px solid grey; padding: 3px; background-color: white; color: black;\'>\n                <div ng-if=\"avatar\" class=\"col-md-4 col-xs-12\">\n                    <img ng-src=\"{{avatar}}\" obt-error-image=\'img/avatar.jpg\' alt=\"avatar\" class=\"center-block img-responsive\"/>\n                </div>\n                <div class=\"col-xs-12\" ng-class=\"avatar ? \'col-md-8\' : \'col-md-12\'\">\n                    <address ng-non-bindable>\n                        <span ng-if=\'companyName\'><strong>{{companyName}}</strong><br></span>\n                        <span ng-if=\'address\'>{{address}}<br></span>\n                        <span ng-if=\'postalCode\'>{{postalCode}}<br></span>\n                        <span ng-if=\'phone\'>{{phone}}</span>\n                    </address>\n                </div>\n            </div>\n        </ui-gmap-windows>\n    </ui-gmap-markers>\n</ui-gmap-google-map>",

	    // NEW VERSION //template:"<!--obt-error-image=\'img/avatar.jpg\'-->\n<ui-gmap-google-map center=\'map.center\' zoom=\'map.zoom\' draggable=\"true\" options=\"map.options\">\n    <ui-gmap-markers models=\"map.markers\" idKey=\"\'id\'\" coords=\"\'self\'\" icon=\"\'icon\'\" fit=\"map.markers.length > 0\" events=\"map.markersEvents\">\n        <ui-gmap-windows options=\"\'windowOptions\'\">\n            \n            <div class=\"info-window\" ng-non-bindable>\n                <h3 ng-if=\'companyName\'>{{companyName}}</h3>\n                <div class=\"info-content\">\n                    <img  ng-if=\'avatar\' ng-src=\"{{avatar}}\" alt=\"avatar\" class=\"info-content-img\"/>\n                    <p ng-if=\'address\'>{{address}}</p>\n                    <p ng-if=\'postalCode\'>{{postalCode}}</p>\n                    <p ng-if=\'phone\'>{{phone}}</p>\n                </div>\n            </div>\n            \n        </ui-gmap-windows>\n    </ui-gmap-markers>\n</ui-gmap-google-map>",

	    //version URL: template:"<ui-gmap-google-map center=\'map.center\' zoom=\'map.zoom\' draggable=\"true\" options=\"map.options\">\n    <ui-gmap-markers models=\"map.markers\" idKey=\"\'id\'\" coords=\"\'self\'\" icon=\"\'icon\'\" fit=\"map.markers.length > 0\" events=\"map.markersEvents\">\n        <ui-gmap-windows options=\"\'windowOptions\'\" templateUrl=\"\'app/widgets/map/obt-map-window.tpl.html\'\" templateParameter=\"\'{avatar: avatar, companyName:companyName, address:address, postalCode:postalCode, phone:phone }\'\">\n        </ui-gmap-windows>\n    </ui-gmap-markers>\n</ui-gmap-google-map>",

	    // try // template:"<ui-gmap-google-map center=\'map.center\' zoom=\'map.zoom\' draggable=\"true\" options=\"map.options\">\n    <ui-gmap-markers models=\"map.markers\" idKey=\"\'id\'\" coords=\"\'self\'\" icon=\"\'icon\'\" fit=\"map.markers.length > 0\" events=\"map.markersEvents\">\n        <ui-gmap-windows options=\"\'windowOptions\'\">\n            <div class=\"row\" style=\'border: 1px solid grey; padding: 3px; background-color: white; color: black;\'>\n               \n                <div ng-if=\"avatar\" class=\"col-md-4 col-xs-12\">\n                    jrllod\n                    <div ng-non-bindable>\n                        <img src=\"{{avatar}}\" alt=\"avatar\" class=\"center-block img-responsive\"/>\n                        -===========--\n                    </div>\n                    <img ng-non-bindable src=\"{{avatar}}\" alt=\"avatar\" class=\"center-block img-responsive\"/>\n                    \n                </div>\n                <div class=\"col-xs-12\" ng-class=\"avatar ? \'col-md-8\' : \'col-md-12\'\">\n                    <address>\n                        \n                        <strong>{{companyName}} CCCCCCC </strong><br>\n                        \n                        <span ng-if=\'companyName\'>\n                            <span ng-non-bindable>\n                                <strong>{{companyName}}</strong><br>\n                            </span>\n                        </span>\n                        <span ng-if=\'address\'>\n                            <span ng-non-bindable>{{address}}<br></span>\n                        </span>\n                        <span ng-if=\'postalCode\'>\n                            <span ng-non-bindable>{{postalCode}}<br></span>\n                        </span>\n                        <span ng-if=\'phone\'>\n                            <span ng-non-bindable>{{phone}}</span>\n                        </span>\n                    </address>\n                </div>\n            </div>\n        </ui-gmap-windows>\n    </ui-gmap-markers>\n</ui-gmap-google-map>",
	    //recent but not working // template:"<ui-gmap-google-map center=\'map.center\' zoom=\'map.zoom\' draggable=\"true\" options=\"map.options\">\n    <ui-gmap-markers models=\"map.markers\" idKey=\"\'id\'\" coords=\"\'self\'\" icon=\"\'icon\'\" fit=\"map.markers.length > 0\" events=\"map.markersEvents\">\n        <ui-gmap-windows options=\"\'windowOptions\'\">\n            <div class=\"row\" style=\'border: 1px solid grey; padding: 3px; background-color: white; color: black;\'>\n                <div ng-switch=\'avatar == null\'>\n                    <div ng-switch-when=\"true\"> true  <span ng-non-bindable>{{avatar}}</span> </div>\n                    <div ng-switch-when=\"false\"> false <span ng-non-bindable>{{avatar}}</span> </div>\n                </div>\n                \n                \n                \n                <div ng-if=\"avatar\" class=\"col-md-4 col-xs-12\" ng-non-bindable>\n                    <img src=\"{{avatar}}\" obt-error-image=\'img/avatar.jpg\' class=\"center-block img-responsive\"  style=\"height: 100px;\" />\n                </div>\n                <div class=\"col-md-8 col-xs-12\" ng-class=\"avatar ? \'col-md-8\' : \'col-md-12\'\">\n                    <address ng-non-bindable>\n                        <span ng-if=\'companyName\'><strong>{{companyName}}</strong><br></span>\n                        <span ng-if=\'address\'>{{address}}<br></span>\n                        <span ng-if=\'postalCode\'>{{postalCode}}<br></span>\n                        <span ng-if=\'phone\'>{{phone}}</span>\n                    </address>\n                </div>\n            </div>\n        </ui-gmap-windows>\n    </ui-gmap-markers>\n</ui-gmap-google-map>",
	    //do not know : template:"<ui-gmap-google-map center=\'map.center\' zoom=\'map.zoom\' draggable=\"true\" options=\"map.options\">\n    <ui-gmap-markers models=\"map.markers\" idKey=\"\'id\'\" coords=\"\'self\'\" icon=\"\'icon\'\" fit=\"map.markers.length > 0\" events=\"map.markersEvents\">\n        <ui-gmap-windows options=\"\'windowOptions\'\" templateUrl=\"\'obt-map-window.tpl.html\'\" templateParameter=\"\'{avatar: 123 }\'\">\n        </ui-gmap-windows>\n    </ui-gmap-markers>\n</ui-gmap-google-map>",

	//    obtMap.$inject = [];
	    /* @ngInject */
	    function obtMap () {
	        return {
	            scope:{
	                map:"=?",
	                markers:"=?",
	                name:"=?"
	            },
	            template:"<ui-gmap-google-map center=\'map.center\' zoom=\'map.zoom\' draggable=\"true\" options=\"map.options\">\n    <ui-gmap-markers models=\"map.markers\" idKey=\"\'id\'\" coords=\"\'self\'\" icon=\"\'icon\'\" fit=\"map.markers.length > 0\" events=\"map.markersEvents\"></ui-gmap-markers>\n    <ui-gmap-window ng-cloak\n                    show=\"map.window.show\"\n                    coords=\"map.window.model\"\n                    templateUrl=\"map.window.templateURL\"\n                    templateParameter=\"map.window.model\"\n                    options=\"map.window.options\">\n        </ui-gmap-window>\n    \n</ui-gmap-google-map>",
	            restrict : "E",
	//            ,link: obtMapLink
	            controller:obtMapController
	        };

	    }

	    /*@ngInject*/
	    function obtMapController($scope, uiGmapIsReady, $timeout){
	        $scope.map = $scope.map ? $scope.map : { center: { latitude: 45, longitude: -73 }, options:{scrollwheel: false}, zoom: 8, markers:[]};
	        console.log('map',$scope.map);

	        $scope.map.window = {
	            marker: {},
	            show: false,
	            templateURL: 'app/widgets/map/obt-map-window.tpl.html',
	            closeClick: function(){
	                $scope.map.window.show = false;
	            },
	            options:{boxClass: "infobox", disableAutoPan:true, maxWidth:400, enableCloseButton:false, closeBoxURL: ""}
	            // options: {
	            //     pixelOffset: {
	            //         width: 0,
	            //         height: -24
	            //     }
	            // }
	        };

	        $scope.name = {setMarkers:setMarkers, toggleMarker : toggleMarker};
	        // events="{'click':toggleMarkerAnimation}"
	        $scope.mapInstance = null;
	        $scope.map.markersEvents = {
	            mouseover: function (marker, eventName, model, args) {
	                // model.show = true;
	                $scope.map.window.model = model;
	                $scope.map.window.show = true;
	            },
	            mouseout: function (marker, eventName, model, args) {
	                // model.show = false;
	                // vm.map.window.model = model;
	                $scope.map.window.show = false;
	            }
	        };
	        //$scope.toggleMarkerAnimation = toggleBounce;

	        uiGmapIsReady.promise(1).then(function(instances) {
	          instances.forEach(function(inst) {
	            $scope.mapInstance = inst.map;
	            if($scope.markers){
	              setMarkers($scope.markers);
	            }
	          });
	        });

	        function toggleBounce(marker) {
	            if (!marker){
	                return;
	            }
	            if (marker.getAnimation() != null) {
	                marker.setAnimation(null);
	            } else {
	                marker.setAnimation(google.maps.Animation.BOUNCE);
	            }
	        }

	        function toggleMarker(){
	            if($scope.map.markers){
	                var marker = $scope.map.markers[0];
	                if(!marker.options){
	                    marker.options = {};
	                }
	                marker.options.animation  = google.maps.Animation.BOUNCE;

	            }
	        }

	        function setMarkers(data){
	            console.log('setMarker', data);
	            var markersLength = data ? data.length : 0;
	            if(markersLength){
	                $scope.map.markers = [];
	                $scope.map.center = {
	                    latitude:  data[0].latitude,
	                    longitude: data[0].longitude
	                };


	                $timeout(function(){
	                  $scope.map.zoom = markersLength < 2 ? 15 : 8;
	                  console.log('setMarker zoom', $scope.map.zoom);
	                });

	                var location = {};
	                $scope.map.markers =  data || [];
	                for (var i = 0; i < markersLength; i++) {
	                    location = data[i];
	                    location.show = false;
	//                        location.animation =  google.maps.Animation.BOUNCE;
	//                        location.avatar = location.avatar ? location.avatar : location.therapists[0].avatar;
	                    location.icon = 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=' + (location.mapId ? location.mapId : i)   + '|'+(location.color ? location.color : 'FF776B' ) + '|000000';
	                    location.windowOptions = {boxClass: "infobox", disableAutoPan:true, maxWidth:400, enableCloseButton:false, closeBoxURL: ""};
	                }
	            }
	        }
	    }
	    obtMapController.$inject = ["$scope", "uiGmapIsReady", "$timeout"];//obtMapController

	})();


/***/ },
/* 188 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 8/22/15.
	 */


	(function(){
	    angular.module('app.widgets')
	        .run(configHrefDirective)
	        .service('hrefLangService', hrefLangService)
	        .directive('obtHrefLang',obtHrefLang);

	    /*@ngInject*/
	    function hrefLangService(){
	        var links = {};
	        var vm = this;
	        vm.setLinks = setLinks;
	        vm.getLinks = getLinks;
	        return vm;

	        function getLinks(){
	            return links;
	        }
	        function setLinks(newLinks){
	            if(newLinks){
	                links = newLinks;
	            }
	        }
	    }
	    /*@ngInject*/
	    function configHrefDirective($rootScope, $state, hrefLangService){
	        $rootScope.$on('$stateChangeSuccess',
	            function(event, toState, toParams, fromState, fromParams){
	                //var current_location = window.location;
	                // window.location.hash
	                var hrefLangs = {};
	                var langs = ['fr','en'];
	                var params = angular.extend({}, toParams);

	                var lang;
	                var absoluteLink;

	                for(var i=0; i< langs.length; i++){
	                    lang = langs[i];
	                    params.language = lang;
	                    absoluteLink = $state.href(toState, params, {absolute: true});
	                    //var link ='<link rel="alternate" hreflang="' +
	                    //    lang +'" href="'+ absoluteLink + '"/>';
	                    hrefLangs[lang] = absoluteLink;
	                }
	                hrefLangService.setLinks(hrefLangs);
	            });
	    }
	    configHrefDirective.$inject = ["$rootScope", "$state", "hrefLangService"];
	    function obtHrefLang(){
	        return {
	            restrict:'EA',
	            replace:true,
	            scope:{},
	            template: '<link ng-repeat="(key, url) in vm.hrefLangService.getLinks()" rel="alternate" hreflang="{{key}}" href="{{ url }}" />',
	            controller: /*@ngInject*/["hrefLangService", function(hrefLangService){
	                var vm = this;
	                vm.hrefLangService = hrefLangService;
	            }],
	            controllerAs:'vm'
	        };

	    }

	})();


/***/ },
/* 189 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 8/29/15.
	 */
	(function(app){
	    angular
	        .module('app.widgets')
	        .filter('momentFormat',momentFormatFilter);
	    function momentFormatFilter(){
	        return function(input) {
	            input = input || '';
	            if(moment.isMoment(input)){
	                return input.format('DD-MM-YYYY, HH:mm');
	            }else{
	                return input;
	            }
	        };
	    }
	})();


/***/ },
/* 190 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 8/30/15.
	 */
	(function () {
	    'use strict';

	    angular
	        .module('app.widgets')
	        .directive('obtFilterForm', function () {
	            return {
	                restrict: 'E',
	                //templateUrl: function(elem, attr){
	                //    return attr.templateUrl;
	                //},
	                template: '<div ng-include="templateUrl"></div>',
	                scope: {
	                    templateUrl: '@',
	                    filtersResult: '=',
	                    comboData : '=?',
	                    name : '=?',
	                    filterVm : '=?',
	                    filterCallback : '&?'
	                },
	                controller: /*ngInject*/["$scope", "queryservice", "dataservice", "$timeout", function ($scope, queryservice, dataservice, $timeout) {
	                    var cbIdList = $scope.comboData;
	                    $scope.options = [];
	                    $scope.selectedfilters = angular.extend({}, $scope.filtersResult);
	                    $scope.name = {filter:{}};
	                    $scope.submitFilter = submitFilter;
	                    $scope.rangeFn = {
	                        dayRange : dayRange,
	                        weekRange: weekRange,
	                        monthRange: monthRange,
	                        yearRange: yearRange,
	                        openDatePicker : openDatePicker
	                    };

	                    if(cbIdList && cbIdList.options){
	                        getOptionData();
	                    }

	                    function getOptionData() {
	                        //queryservice.getFormOptions
	                        //combobox list ID and Passthrough
	                        return dataservice.form.getOptions(cbIdList.options, cbIdList.args).then(
	                            function success(result){
	                                $scope.options = result;
	                            }
	                            ,function fail(response){
	                                //toaster.pop('error', 'Error', response.body ? response.body : response);
	                                $scope.options = [];
	                            }
	                        );
	                    }
	                    function submitFilter() {
	                        $scope.filtersResult = angular.copy($scope.selectedfilters); // $scope.selectedfilters && $scope.selectedfilters.length > 0 ? angular.copy($scope.selectedfilters) : null;
	                        $scope.name.filter = $scope.filtersResult;

	                        $timeout(function(){
	                            if($scope.filterCallback){
	                                $scope.filterCallback();
	                            }
	                        });

	                    }
	                    function dayRange (data, range, startingPoint){
	                        if (angular.isUndefined(range) || !angular.isNumber(range)){
	                            range = 0;
	                        }
	                        if(angular.isObject(data)) {
	                            data.start = new Date();
	                            data.end = new Date();
	                            if(startingPoint && startingPoint !== 0){
	                                data.start = data.start.setDate(data.start.getDate() + startingPoint);
	                                data.end = data.end.setDate(data.end.getDate() + startingPoint);
	                            }
	                            if(range !== 0){
	                                range > 0 ?
	                                    data.end.setDate(data.end.getDate() + range)
	                                    : data.start.setDate(data.start.getDate() + range);
	                            }
	                        }
	                    }
	                    function weekRange (data, range){
	                        genericStartEndOfDate(data, range, 'week');
	                    }
	                    function monthRange (data, range){
	                        genericStartEndOfDate(data, range, 'month');
	                    }
	                    function yearRange (data, range){
	                        genericStartEndOfDate(data, range, 'year');
	                    }
	                    function genericStartEndOfDate(data, range, timeLeap) {
	                        //valid choice: year, month, week, day
	                        timeLeap = timeLeap || 'week';
	                        if (angular.isUndefined(range) || !angular.isNumber(range)){
	                            range = 0;
	                        }
	                        if(angular.isObject(data)) {
	                            var month_selected_start = moment().add(range, timeLeap);
	                            var month_selected_end= month_selected_start.clone();
	                            data.start = month_selected_start.startOf(timeLeap).toDate();
	                            data.end = month_selected_end.endOf(timeLeap).toDate();
	                        }
	                    }
	                    function openDatePicker($event, values, name) {
	                        $event.preventDefault();
	                        $event.stopPropagation();
	                        values[name] = true;
	                    }

	                }]
	            };
	        });
	})();


/***/ },
/* 191 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 10/31/15.
	 */
	(function(){
	    angular.module('app.widgets')
	        .directive('obtSection', obtSection);

	    function obtSection(){
	        return {
	            priority: 50,
	            restrict:'E',
	            scope:{
	                pageSectionId:'@?',
	                pageId:'@?',
	                data:'=?data',
	                type:'@?',
	                templateUrl:'@?',
	                anchor:'@?'
	            },
	            bindToController:true,
	            controllerAs:'vm',
	            template:'<div ng-class="vm.data.css" ng-include="vm.getContentUrl()" id="anchor{{vm.anchor}}"></div>',
	            controller:/*@ngInject*/["screenSize", "Lightbox", "ngCart", "$sce", "sessionServices", "$rootScope", "Carousel", function(screenSize, Lightbox, ngCart,$sce,sessionServices,$rootScope,Carousel){
	                var vm = this;
	                active();
	                vm.getConnectedState= getConnectedState;
	                vm.getContentUrl = getContentUrl;
	                vm.getIdItem = getIdItem;
	                vm.ngCart = ngCart;
	                vm.items = [] ;
	                vm.galtype9 = [] ;
	                vm.galtype7 = [] ;
	                vm.galtype9Mobile = [];
	                vm.galtype7Mobile = [];
	                vm.desktop = screenSize.is('md, lg');
	                vm.mobile = screenSize.is('xs, sm');
	                vm.angular =  angular;
	                vm.getCartDirective = function (){
	                   var data = {};
	                    data.items = [] ;
	                    data.items = vm.ngCart.getCart().items ;
	                    data.shipping = vm.ngCart.getCart().shipping;
	                    data.tax = vm.ngCart.getCart().tax ;
	                    data.taxRate= vm.ngCart.getCart().taxRate ;
	                    data.totalCost = vm.ngCart.totalCost();
	                    data.SubTotal=  vm.ngCart.getSubTotal();
	                    return data ;
	                }
	                // Using dynamic method `on`, which will set the variables initially and then update the variable on window resize
	    vm.desktop = screenSize.on('md, lg', function(match){
	        vm.desktop = match;
	    });
	    vm.mobile = screenSize.on('xs, sm', function(match){
	        vm.mobile = match;
	       })




	                vm.trustSrc = function(src) {
	                    src = src+'?rel=0&autoplay=1&version=3&loop=1&controls=0&modestbranding=1&showinfo=0';
	                    if(src.includes('vimeo')){
	                        src = src+'&byline=0&portrait=0&background=1' ;
	                    }
	                    return $sce.trustAsResourceUrl(src);
	                }


	                function active(){

	                    if(vm.type && vm.type === '7'){
	                        if(vm.data.gallery && Array.isArray(vm.data.gallery)){
	                            vm.data.gallery = vm.data.gallery.map(function (item) {
	                                item.titleDisplayImage = vm.data.TitleDisplayImage;
	                                item.DescriptionDisplayImage = vm.data.DescriptionDisplayImage;
	                                return item;
	                            });
	                        }

	                    }
	                }

	                function getConnectedState(){
	                   return sessionServices.getArgs('isLogged');

	                }
	                vm.openlightBoxCarousel = function (data,index){
	                  console.log(data,index)

	                    Lightbox.openModal(data,index);

	                }
	    vm.openLightboxModal = function (arg,anchor){
	                var tampon = [] ;
	                var items = $rootScope.pageSection ;
	                      angular.forEach(items , function (value){
	                                if(value.anchor === anchor){
	                                      if(value.data.gallery && value.data.gallery.length){
	                                        console.log( vm.data.TitleDisplayImage);
	                                        console.log(vm.data.DescriptionDisplayImage);
	                                         tampon = value.data.gallery ;
	                                             angular.forEach(tampon,function (values,key){
	                                                values.titleDisplayImage = vm.data.TitleDisplayImage;
	                                                values.DescriptionDisplayImage = vm.data.DescriptionDisplayImage;
	                                                    if(values.thumbUrl === arg.thumbUrl && values.title === arg.title){
	                                                      
	                                                         console.log(tampon,'mon tampon');                                                      
	                                                        Lightbox.openModal(tampon, key);
	                                                       }
	                                             })

	                                       }
	                                }

	                     })
	    }


	       function getIdItem (arg,anchor){
	            var id = '' ;
	         if(vm.type && vm.type === '9'){
	           var items = $rootScope.pageSection ;
	                      angular.forEach(items , function (value){
	                           if(value.anchor === anchor){
	                                if(value.data.gallery && value.data.gallery.length){
	                                    tampon = value.data.gallery ;
	                                    angular.forEach(tampon,function (values,key){
	                                        if(values.thumbUrl === arg.thumbUrl && values.title === arg.title){
	                                           id =(key+1).toString();
	                                           id = 'item'+id;
	                                          }
	                                   })

	                                }
	                          }

	                  })
	         }



	                   return id ;
	           }
	           vm.takeNumber = function (data){
	             if(typeof (data)  === 'string'){

	               data = parseInt(data) ;

	           }
	   return data ;
	         }

	                function getContentUrl(){
	                    if ( typeof vm.templateUrl == 'undefined' ) {
	                        if (typeof  vm.type == 'undefined'){

	                            return 'app/widgets/obtSection/obtSection.html';
	                        }else{
	                            var type = parseInt(vm.type, 10);
	                           return 'app/widgets/obtSection/type_'+ type +'.html'

	                        }
	                    } else {
	                        return vm.templateUrl;
	                    }
	                }

	          

	             
	         

	               

	                if(vm.type === '9'){
	                  // vm.desktop = screenSize.is('md, lg');
	                  // vm.mobile = screenSize.is('xs, sm');

	                     var tamponTabMobile =[];
	                     var items = vm.data.gallery.slice(0);
	                     var itemsMobile = items.slice(0);
	                     console.log(items,itemsMobile,vm.data.gallery);
	                     while(itemsMobile.length){
	                         var item = itemsMobile.slice(0,1);
	                         itemsMobile.splice(0,1);
	                         tamponTabMobile.push(item) ;
	                     }

	                     vm.galtype9Mobile = tamponTabMobile;

	                     var tamponTab =[];
	                     var nbCol =  parseInt(vm.data.gallery_item_per_row);
	                  //   var items = vm.data.gallery;
	                     while(items.length){
	                         var item = items.slice(0,nbCol);
	                         items.splice(0,nbCol);
	                         tamponTab.push(item) ;
	                     }

	                     vm.galtype9 = tamponTab;



	                }


	                if(vm.type === '7'){
	                 
	                    var tamponTab7 =[];
	                    var tamponTab7Mobile =[];
	                    var nbCol7 =  parseInt(vm.data.gallery_item_per_row);
	                    var items = vm.data.gallery.slice(0);
	                    var itemsMobile = items.slice(0);
	                    while(items.length)
	                    {
	                        var item = items.slice(0,nbCol7);
	                        items.splice(0,nbCol7);
	                        tamponTab7.push(item) ;
	                    }
	                    vm.galtype7 = tamponTab7;
	                    while(itemsMobile.length)
	                    {
	                        var item = itemsMobile.slice(0,1);
	                        itemsMobile.splice(0,1);
	                        tamponTab7Mobile.push(item) ;
	                    }
	                    vm.galtype7Mobile = tamponTab7Mobile;
	                   
	                }

	            }]
	        };
	       
	    }
	})();


/***/ },
/* 192 */
/***/ function(module, exports) {

	(function () {
	    'use strict';
	    angular
	        .module('app.widgets')
	        .directive('selectsCascade', selectsCascade)
	        .directive('selectCascade', selectCascade);


	    function selectsCascade(){
	        return {
	            restrict:'A',
	            scope:{
	                options:'=?',
	                keyToNameOptions:'=?',
	                cascadeOptions:'=',
	                cascadeOrder:'='
	            },
	            controller: selectsCascadeCtrl,
	            controllerAs:'vm',
	            bindToController:true,
	            link: function (scope) {
	                scope.vm.initState();
	            }
	        };

	        /*@ngInject*/
	        function selectsCascadeCtrl(){
	            var vm = this;
	            vm.registeredSelects = {}; // contain the list of select to register
	            vm.registerSelect = registerSelect;
	            //vm.setSubOption = setSubOption;
	            vm.state = {};
	            vm.initState = initState;
	            vm.setSelectedKey = setSelectedKey;

	            function registerSelect(name, controller){
	                if(name && controller){
	                    if (! vm.registeredSelects) {
	                        vm.registeredSelects = {};
	                    }
	                    vm.registeredSelects[name] = controller;
	                }
	            }

	            function setSelectedKey(cascadeName, keyValue){
	                //set key
	                setStateCurrentKey(cascadeName, keyValue);
	                updateState();
	            }

	            function initState(){
	                //vm.cascadeOrder
	                //vm.cascadeOptions

	                //set the first cascade data
	                vm.state = vm.state || {};
	                if(angular.isArray(vm.cascadeOrder)){

	                    vm.cascadeOrder.forEach(function(itemName){


	                        vm.registeredSelects[itemName].setHidden(false);
	                        vm.state[itemName]={name:itemName, options:[], selected:vm.registeredSelects[itemName].bindModel, cascade:null}
	                    });

	                    //var firstCascadeName = vm.cascadeOrder[0];
	                    //if(firstCascadeName){
	                    //    cascade_set_option(firstCascadeName,cascadeOptions);
	                    //    vm.state[firstCascadeName].options = vm.cascadeOptions;
	                    //}
	                }

	                updateState();
	            }

	            function cascade_set_option(cascadeName, cascadeOptions){

	                vm.registeredSelects[cascadeName].setOptions(cascadeOptions);
	            }

	            function state_reducer(cascadeOptions, cascadeName){
	                //set option and check if selected key is valid for a state

	                //var demo = [{value:1, options:[{value:10, options:[]}, {value:11, options:[]} ]}];

	                //set the options for a given State
	                cascade_set_option(cascadeName, cascadeOptions);

	                // find if current value is valid
	                var isSelectedKeyValid = null;
	                if(angular.isArray(cascadeOptions)){
	                    isSelectedKeyValid = _.find(cascadeOptions, function(item){
	                        return item.value == vm.state[cascadeName].selected;
	                    });
	                }

	                //set current selected value to null if we can't find the value:
	                if (! isSelectedKeyValid){ //reset current key value if not valid
	                    vm.state[cascadeName].selected = null;
	                    return null;
	                }else{
	                    var currentKey = vm.state[cascadeName].selected;
	                    //return new options  for next nested cascade
	                    return isSelectedKeyValid.options || null;
	                }
	            }

	            /**
	             * update the state
	             */
	            function updateState(){
	                if(angular.isArray(vm.cascadeOrder)){
	                    vm.cascadeOrder.reduce(state_reducer, vm.cascadeOptions);
	                }
	            }


	            //for (var i=0,  size=vm.keyToNameOptions[vm.name].length; i < size; i++) {
	            //    var element = vm.keyToNameOptions[vm.name][i];
	            //    if( element.KEY  == vm.bindModel){
	            //        vm.e =element;
	            //        return element.onSelect.items;
	            //    }
	            //}

	            /**
	             * find the cascade state and set his current key an
	             * @param cascadeName
	             * @param keyValue
	             */
	            function setStateCurrentKey(cascadeName, keyValue){
	                vm.state[cascadeName].selected = keyValue;
	            }
	        }
	    }

	    function selectCascade(){
	        return {
	            restrict:'E',
	            scope:{
	                name:'@',
	                keyToNameOptions:'=?',
	                bindModel:'=ngModel',
	                status:'=?',
	                placeholder:'@?'
	            },
	            controller:selectCascadeCtrl,
	            controllerAs:'vm',
	            bindToController:true,
	            link: selectCascadeLinkFn,
	            require:'^selectsCascade',
	            template:'<select class="form-control"\n        id="vm.name"\n        ng-hide="vm.status.hidden"\n        ng-disabled="!vm.options"\n        ng-model="vm.bindModel"\n        ng-change="vm.onChange()"\n        ng-selected = "vm.bindModel = vm.bindModel ||  vm.default_option"\n        ng-options="option.value as vm.getOptionByKey(option.value) for option in vm.options"\n        ng-required="vm.isRequired">\n    <option value="" ng-if="vm.placeholder">{{vm.placeholder}}</option>\n</select>'
	        };

	        /*@ngInject*/
	        function selectCascadeCtrl(){
	            var vm = this;
	            vm.status = vm.status || {hidden: true};
	            vm.selected = {};
	            vm.masterController = null;
	            vm.options = null;
	            vm.setMasterController = setMasterController;
	            vm.setOptions = setOptions;
	            vm.setHidden = setHidden;
	            vm.onChange = onChange;
	            vm.getOptionByKey = getOptionByKey;

	            updateStatus();

	            function setHidden(isHidden){
	                vm.status.hidden = isHidden;
	            }
	            function setOptions(options){
	                updateStatus();
	                vm.options = options;
	            }

	            function setMasterController(masterCtrl){
	                vm.masterController = masterCtrl;
	            }

	            function onChange(){
	                updateStatus();
	                //getOptionByKey();
	                if(vm.masterController){
	                    vm.masterController.setSelectedKey(vm.name, vm.bindModel);
	                }
	            }
	            function getOptionByKey(keyForValueToFind){
	                if(angular.isArray(vm.keyToNameOptions)){
	                    var result = _.find(vm.keyToNameOptions, function(item){
	                        return item.KEY == keyForValueToFind;
	                    });
	                    return result && result.VALUE ? result.VALUE : keyForValueToFind;
	                }
	                return keyForValueToFind;
	            }

	            function updateStatus(){
	                //update the status
	                vm.status.enabled = (angular.isArray(vm.options) && vm.options.length > 0)
	                || (angular.isObject(vm.options) && Object.keys(vm.options).length > 0 ? true : false);
	            }
	        }

	        function selectCascadeLinkFn(scope, element,attributes, selectsCascadeController){
	            if(selectsCascadeController){
	      
	                selectsCascadeController.registerSelect(scope.vm.name, scope.vm);
	                scope.vm.setMasterController(selectsCascadeController);
	            }
	        }
	    }

	})();


/***/ },
/* 193 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.widgets')
	        .directive('obtOnlineReceptionist', obtOnlineReceptionist);

	    function obtOnlineReceptionist () {
	        return {
	            restrict: 'E',
	            template:"<span ng-if=\'phoneNumber\' ng-switch=\'isOnline || \"false\"\'>    \n    <button ng-switch-when=\'true\' class=\'btn btn-xs btn-success-advisor\'>\n        {{ phoneNumber }} <img  ng-src=\'img/headset.svg\' width=\'18px\'  height=\'18px\' alt=\'headset\' /> {{ \'ONLINE\'|translate }}\n    </button>\n    <span ng-switch-default>{{phoneNumber}}</span>\n</span>",
	            scope: {
	                phoneNumber: '@',
	                isOnline: '@?'
	            }
	        };
	    }
	})();


/***/ },
/* 194 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.widgets')
	        .directive('obtMenu', obtMenu)
	        .directive('obtMenuXs', obtMenuXs);

	    function obtMenu () {
	        return  {
	            controller:menuController,
	            controllerAs:'vmMenu',
	            scope:{
	                data:'='
	            },
	            bindToController:true,
	            replace:true,
	            template:'<li class="hidden-xs dropdown tasks-menu">\n    <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">\n        <i class="fa fa-bars"></i>\n    </a>\n    <ul class="dropdown-menu">\n        <li>\n            <ul class="menu" style="max-height: 600px;">\n                <li ng-repeat="menu in vmMenu.data | orderBy:\'order\'" ng-switch="menu.type">\n                    \n                    <a ng-switch-when="1" href="javascript:void(0)" ng-click="vmMenu.gotoAnchor(menu.data.link)">\n                        <!--anchor-->\n                        <h3>{{menu.data.name}}</h3>\n                    </a>\n                    <a ng-switch-when="2" href="javascript:void(0)" ui-sref="{{menu.data.link}}">\n                        <!--internal link-->\n                        <h3>{{menu.data.name}}</h3>\n                    </a>\n                    <a ng-switch-when="3" href="{{menu.data.link}}">\n                        <!--external link-->\n                        <h3>{{menu.data.name}}</h3>\n                    </a>\n                </li>\n            </ul>\n        </li>\n    </ul>\n</li>      ',
	          restrict: 'AE'
	        };
	    }

	    function obtMenuXs () {
	        return  {
	            controller:menuController,
	            controllerAs:'vmMenu',
	            scope:{
	                data:'='
	            },
	            bindToController:true,
	            replace:true,
	            templateUrl:'app/widgets/obtMenu.html',
	            // template:'<li class="visible-xs-block" ng-repeat="menu in vmMenu.data | orderBy:\'order\'" ng-switch="menu.type">\n    \n    <a ng-switch-when="1" href="javascript:void(0)" ng-click="vmMenu.gotoAnchor(menu.data.link)">\n        <!--anchor-->\n        {{menu.data.name}}\n    </a>\n    <a ng-switch-when="2" href="javascript:void(0)" ui-sref="{{menu.data.link}}">\n        <!--internal link-->\n        {{menu.data.name}}\n    </a>\n    <a ng-switch-when="3" href="{{menu.data.link}}">\n        <!--external link-->\n        {{menu.data.name}}\n    </a>\n</li>',
	            restrict: 'AE'
	        };
	    }


	    /*@ngInject*/
	    function menuController($stateParams, config, $location, $anchorScroll){

	       console.log('la c bon');
	        var vm = this;
	        vm.data = vm.data;
	        vm.selectedMenuId = $stateParams.menu || config.menu;//obtSession.get('menu');
	        vm.gotoAnchor = gotoAnchor;
	        vm.test = function(data){
	          console.log(data);
	        }
	        active(); //fill the combobox

	        // function goTo (key){
	        //     console.debug('Go to : ' , key);
	        // }
	        function gotoAnchor(x) {
	            var newHash = 'anchor' + x;
	            if ($location.hash() !== newHash) {
	                // set the $location.hash to `newHash` and
	                // $anchorScroll will automatically scroll to it
	                $location.hash('anchor' + x);
	            } else {
	                // call $anchorScroll() explicitly,
	                // since $location.hash hasn't changed
	                $anchorScroll();
	            }
	        }

	        function active(){
	            var args = {cId:vm.cid || null, tId:vm.tid || null };
	            // menuServices.getMenusPromise(args)
	            //     .then(function(result){
	            //             vm.data = result;
	            //         }
	            //     );
	        }
	    }
	    menuController.$inject = ["$stateParams", "config", "$location", "$anchorScroll"];
	})();


/***/ },
/* 195 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 14/05/2017.
	 */


	(function(){
	    angular.module('app.widgets')
	        .directive('obtBookingButton',obtBookingButton);


	    function obtBookingButton(){
	        return {
	            restrict:'A',
	            bindToController:true,
	            scope:{
	                // maxItem:'@',
	                model:'=?',
	                closeCallback:'&?'
	            },
	            template: '<form class="form-inline">\n    <span ng-show="vm.range" class="form-group booking-button-quantity">\n        <select class="form-control" name="quantity" id="quantity" ng-model="q" ng-options=" v for v in vm.range">\n        <option value="">- Quantity -</option>\n        </select>\n    </span>\n    <button type="submit" class="btn btn-sm btn-default" ng-click="vm.bookItem(q)" ng-transclude>{{vm.title | translate}}</button>\n\n    <obt-modal-popup\n            title=\'Add a booking for a client\'\n            open-modal-promise=\'vm.showSingleBookingForm\'\n            template-url=\'app/booking/add.html\'\n            template-controller=\'BookingController as vmModal\'>\n        <obt-modal-popup-choice\n                template-condition-name="allDayType"\n                template-condition-value="onRequest"\n                template-url=\'app/booking/requestBooking.html\'\n                template-controller=\'BookingController as vmModal\'>\n        </obt-modal-popup-choice>\n        <obt-modal-popup-choice\n                template-condition-name="allDayType"\n                template-condition-value="NA"\n                template-url=\'app/booking/addToWaitingList.html\'\n                template-controller=\'BookingController as vmModal\'>\n        </obt-modal-popup-choice>\n    </obt-modal-popup>\n</form>',
	            link: function(scope, element, attrs, $ctrl) {

	                element.on('click', function(e) {
	                    e.stopPropagation(); //stop event from bubbling up to document object
	                    $ctrl.bookItem();
	                });

	            },
	            controller: /*@ngInject*/["obtModalService", function(obtModalService){
	                var vm = this;

	                // vm.range = [];
	                // vm.title = 'BOOK_NOW';
	                // vm.maxItem = parseInt(vm.maxItem);
	                // for(i=1; i <= vm.maxItem; i++){
	                //     vm.range.push(i)
	                // }
	                // console.log('directive to debyg', $scope.maxItem, vm.maxItem, vm.range  );

	                vm.bookItem = function(quantity){
	                    var model = angular.extend(
	                        {
	                            'allDay' : true,
	                            'allDayType' : "onRequest",
	                            'title' : "Reqest Appointment",
	                            'description' : "Réservation en ligne"
	                        },
	                        vm.model);

	                    vm.showSingleBookingForm(model, vm.closeCallback);
	                }

	                vm.showSingleBookingForm = function (model, closeCallback){
	                    var settings = getModalSettings(model);
	                    return obtModalService.openModal(settings).result.then(modalClosed);
	                    console.log('TESY', model)
	                }

	                function getModalSettings(calEvent, closeCallback){
	                    var settings = {
	                        templateUrl: 'app/blocks/modal/obt-modals.directive.html',
	                        controller:'modalsController',
	                        controllerAs: 'vmModalPopups'
	                    };

	                    settings.resolve = settings.resolve ? settings.resolve : {};
	                    settings.resolve.modalModel = function(){return calEvent};
	                    settings.resolve.modalSettings = function(){
	                        return {
	                            closeCallback: closeCallback,
	                            options:modalOptions,
	                            title:$scope.title
	                        }};

	//                    settings.callbackSuccess = callbackSuccess;
	                    settings.callbackFailed = callbackFailed;

	                    return settings;
	                }

	                function getModalSettings(model, success, fail){
	                    // set default value
	                    var templateUrl = vm.templateUrl || 'app/booking/requestBooking.html';
	                    var templateController = vm.templateController || 'BookingController as vmModal';

	                    // //check if a choice is valid
	                    // if (modalChoices && model) {
	                    //     var firstMatchingChoice = modalChoices.filter(function(item){
	                    //         return item && item.templateConditionName != null ? String(model[item.templateConditionName]) == item.templateConditionValue : false;
	                    //     }).shift();
	                    //
	                    //     console.log(firstMatchingChoice);
	                    //
	                    //     if(firstMatchingChoice){
	                    //         templateUrl = firstMatchingChoice.templateUrl ? firstMatchingChoice.templateUrl : templateUrl;
	                    //         templateController = firstMatchingChoice.templateController ? firstMatchingChoice.templateController : templateController;
	                    //     }
	                    // }

	                    var settings = {
	                        templateUrl:templateUrl,
	                        controller:templateController
	                    };

	                    vm.usedModalModel = ! angular.isUndefined(model) ? model : vm.modalModel;
	                    settings.resolve = settings.resolve ? settings.resolve : {};
	                    settings.resolve.modalModel = getSelectedModalModel;

	                    settings.callbackSuccess = success || callbackSuccess;
	                    settings.callbackFailed = fail || success || callbackFailed;
	                    return settings;
	                }
	            }],
	            controllerAs:'vm'
	        };

	    }


	})();


/***/ },
/* 196 */
/***/ function(module, exports) {

	/**
	 * Binds a TinyMCE widget to <textarea> elements.
	 */
	angular.module('ui.tinymce', [])
	  .value('uiTinymceConfig', {})
	  .directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', 'uiTinymceService', function($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig, uiTinymceService) {
	    uiTinymceConfig = uiTinymceConfig || {};

	    if (uiTinymceConfig.baseUrl) {
	      tinymce.baseURL = uiTinymceConfig.baseUrl;
	    }

	    return {
	      require: ['ngModel', '^?form'],
	      priority: 599,
	      link: function(scope, element, attrs, ctrls) {
	        if (!$window.tinymce) {
	          return;
	        }

	        var ngModel = ctrls[0],
	          form = ctrls[1] || null;

	        var expression, options = {
	          debounce: true
	        }, tinyInstance,
	          updateView = function(editor) {
	            var content = editor.getContent({format: options.format}).trim();
	            content = $sce.trustAsHtml(content);

	            ngModel.$setViewValue(content);
	            if (!$rootScope.$$phase) {
	              scope.$digest();
	            }
	          };

	        function toggleDisable(disabled) {
	          if (disabled) {
	            ensureInstance();

	            if (tinyInstance) {
	              tinyInstance.getBody().setAttribute('contenteditable', false);
	            }
	          } else {
	            ensureInstance();

	            if (tinyInstance && !tinyInstance.settings.readonly && tinyInstance.getDoc()) {
	              tinyInstance.getBody().setAttribute('contenteditable', true);
	            }
	          }
	        }

	        // fetch a unique ID from the service
	        var uniqueId = uiTinymceService.getUniqueId();
	        attrs.$set('id', uniqueId);

	        expression = {};

	        angular.extend(expression, scope.$eval(attrs.uiTinymce));

	        //Debounce update and save action
	        var debouncedUpdate = (function(debouncedUpdateDelay) {
	          var debouncedUpdateTimer;
	          return function(ed) {
		        $timeout.cancel(debouncedUpdateTimer);
		         debouncedUpdateTimer = $timeout(function() {
	              return (function(ed) {
	                if (ed.isDirty()) {
	                  ed.save();
	                  updateView(ed);
	                }
	              })(ed);
	            }, debouncedUpdateDelay);
	          };
	        })(400);

	        var setupOptions = {
	          // Update model when calling setContent
	          // (such as from the source editor popup)
	          setup: function(ed) {
	            ed.on('init', function() {
	              ngModel.$render();
	              ngModel.$setPristine();
	                ngModel.$setUntouched();
	              if (form) {
	                form.$setPristine();
	              }
	            });

	            // Update model when:
	            // - a button has been clicked [ExecCommand]
	            // - the editor content has been modified [change]
	            // - the node has changed [NodeChange]
	            // - an object has been resized (table, image) [ObjectResized]
	            ed.on('ExecCommand change NodeChange ObjectResized', function() {
	              if (!options.debounce) {
	                ed.save();
	                updateView(ed);
	              	return;
	              }
	              debouncedUpdate(ed);
	            });

	            ed.on('blur', function() {
	              element[0].blur();
	              ngModel.$setTouched();
	              if (!$rootScope.$$phase) {
	                scope.$digest();
	              }
	            });

	            ed.on('remove', function() {
	              element.remove();
	            });

	            if (uiTinymceConfig.setup) {
	              uiTinymceConfig.setup(ed, {
	                updateView: updateView
	              });
	            }

	            if (expression.setup) {
	              expression.setup(ed, {
	                updateView: updateView
	              });
	            }
	          },
	          format: expression.format || 'html',
	          selector: '#' + attrs.id
	        };
	        // extend options with initial uiTinymceConfig and
	        // options from directive attribute value
	        angular.extend(options, uiTinymceConfig, expression, setupOptions);
	        // Wrapped in $timeout due to $tinymce:refresh implementation, requires
	        // element to be present in DOM before instantiating editor when
	        // re-rendering directive
	        $timeout(function() {
	          if (options.baseURL){
	            tinymce.baseURL = options.baseURL;
	          }
	          var maybeInitPromise = tinymce.init(options);
	          if(maybeInitPromise && typeof maybeInitPromise.then === 'function') {
	            maybeInitPromise.then(function() {
	              toggleDisable(scope.$eval(attrs.ngDisabled));
	            });
	          } else {
	            toggleDisable(scope.$eval(attrs.ngDisabled));
	          }
	        });

	        ngModel.$formatters.unshift(function(modelValue) {
	          return modelValue ? $sce.trustAsHtml(modelValue) : '';
	        });

	        ngModel.$parsers.unshift(function(viewValue) {
	          return viewValue ? $sce.getTrustedHtml(viewValue) : '';
	        });

	        ngModel.$render = function() {
	          ensureInstance();

	          var viewValue = ngModel.$viewValue ?
	            $sce.getTrustedHtml(ngModel.$viewValue) : '';

	          // instance.getDoc() check is a guard against null value
	          // when destruction & recreation of instances happen
	          if (tinyInstance &&
	            tinyInstance.getDoc()
	          ) {
	            tinyInstance.setContent(viewValue);
	            // Triggering change event due to TinyMCE not firing event &
	            // becoming out of sync for change callbacks
	            tinyInstance.fire('change');
	          }
	        };

	        attrs.$observe('disabled', toggleDisable);

	        // This block is because of TinyMCE not playing well with removal and
	        // recreation of instances, requiring instances to have different
	        // selectors in order to render new instances properly
	        var unbindEventListener = scope.$on('$tinymce:refresh', function(e, id) {
	          var eid = attrs.id;
	          if (angular.isUndefined(id) || id === eid) {
	            var parentElement = element.parent();
	            var clonedElement = element.clone();
	            clonedElement.removeAttr('id');
	            clonedElement.removeAttr('style');
	            clonedElement.removeAttr('aria-hidden');
	            tinymce.execCommand('mceRemoveEditor', false, eid);
	            parentElement.append($compile(clonedElement)(scope));
	            unbindEventListener();
	          }
	        });

	        scope.$on('$destroy', function() {
	          ensureInstance();

	          if (tinyInstance) {
	            tinyInstance.remove();
	            tinyInstance = null;
	          }
	        });

	        function ensureInstance() {
	          if (!tinyInstance) {
	            tinyInstance = tinymce.get(attrs.id);
	          }
	        }
	      }
	    };
	  }])
	  .service('uiTinymceService', [
	    /**
	     * A service is used to create unique ID's, this prevents duplicate ID's if there are multiple editors on screen.
	     */
	    function() {
	      var UITinymceService = function() {
	   	    var ID_ATTR = 'ui-tinymce';
	    	// uniqueId keeps track of the latest assigned ID
	    	var uniqueId = 0;
	        // getUniqueId returns a unique ID
	    	var getUniqueId = function() {
	          uniqueId ++;
	          return ID_ATTR + '-' + uniqueId;
	        };
	        // return the function as a public method of the service
	        return {
	        	getUniqueId: getUniqueId
	        };
	      };
	      // return a new instance of the service
	      return new UITinymceService();
	    }
	  ]);


/***/ },
/* 197 */
/***/ function(module, exports) {

	

	(function(){
	    angular.module('app.widgets')
	        .directive('obtList2FormItem', obtList2FormFn);

	    function obtList2FormFn(){

	        return {
	            restrict: 'E',
	            scope:{
	                isCreateMode:'@?',
	                data:'=?listModel',
	                chan : '=?changeVar'
	            },
	            templateUrl:'./../../app/widgets/section2formItem/section2FormItem.directive.html',
	            controller:updatePageSectionType2Ctrl
	        };
	    }
	    /*@ngInject*/
	    function updatePageSectionType2Ctrl($scope){
	        //$scope.newItem = null;
	        $scope.data = $scope.data || [];

	        $scope.addNewItem = addNewItem;
	        $scope.deleteItem = deleteItem;
	        $scope.moveUpItem = moveUpItem;
	        $scope.moveDownItem = moveDownItem;

	        function addNewItem(newItem){
	            if (newItem){
	                $scope.data.push(newItem);
	                if ($scope.chan === true){
	                    $scope.chan=false;
	                }
	                newItem = '';
	            }
	        }

	        function move(items, from,to){
	            if(items){
	                items.splice(to,0,items.splice(from,1)[0]);
	                if ($scope.chan === true){
	                    $scope.chan=false;
	                }
	            }
	            return items;
	        }

	        function moveUpItem(item){
	            var index = $scope.data.indexOf(item);
	            move($scope.data, index, index-1);
	            if ($scope.chan === true){
	                $scope.chan=false;
	            }
	        }
	        function moveDownItem(item){
	            var index = $scope.data.indexOf(item);
	            move($scope.data, index, index+1);
	            if ($scope.chan === true){
	                $scope.chan=false;
	            }
	        }
	        function deleteItem(item){
	            if($scope.data && item){
	                $scope.data.splice($scope.data.indexOf(item), 1);
	                if ($scope.chan === true){
	                    $scope.chan=false;
	                }
	            }
	        }
	    }
	    updatePageSectionType2Ctrl.$inject = ["$scope"];
	})();


/***/ },
/* 198 */
/***/ function(module, exports) {

	

	(function(){
	    angular.module('app.widgets')
	        .service("obtGalleryService", galleryService)
	        .directive('viewGallery', viewGallery);
	/*@ngInject*/
	    function viewGallery(obtGalleryService,sessionServices){

	        return {
	            restrict: 'EA',
	            scope:{
	                data:'=?',
	                galleryId:'=?',
	                gallery:'=?'
	            },
	            link:function(scope){
	              var args = {uId:sessionServices.getSession().uId , galleryId :scope.galleryId};
	              obtGalleryService.getItems(args).
	               then(function (response){
	                 console.log(response);
	                 scope.gallery = response ;
	                 scope.tampon = response [0] || { };
	               })

	            },
	            controller:viewGalleryPageSectionCtrl,
	            template:'<table class="table col-md-12" border="0"><tr>'+
	            '<td  style="padding-top:30%" class="col-md-1"><button   ng-if="current !== 0 " type="button" ng-click="moveLeft()" class="btn btn-default btn-xs"><span class="glyphicon glyphicon-circle-arrow-left" aria-hidden="true"></span></button></td>'+
	            '<td class="col-md-10 text-center"><div class="col-md-12"><div class="thumbnail"><img ng-src="{{tampon.url}}" alt=""><div class="caption"> <h4><input  type="text" class="text-center" ng-model="tampon.details[getKey(tampon.details)].name" style="width:100%"></h4><textarea ui-tinymce="tinymceOptions" ng-model="tampon.details[getKey(tampon.details)].description"></textarea>'+
	            '<p> <div  class="btn btn-primary btn-xs btn-upload"  accept="image/*"   upload-button url="./php/simpleUpload.php" on-success="onUploadSuccess(response)">'+
	            '<i class="fa fa-upload" aria-hidden="true"></i> {{\'UPLOAD\'|translate}}</div><a href class="btn btn-primary btn-xs" role="button" ng-click="updateGallery()" ><i class="fa fa-plus" aria-hidden="true"></i>{{\'UPDATE\'|translate}}</a><a href class="btn btn-danger btn-xs" role="button"><i class="fa fa-trash" aria-hidden="true"></i>{{\'DELETE\'|translate}}</a></p>'+
	            '</div></div>'+
	            '</div></td>'+
	            '<td style="padding-top:30%" class="col-md-1"><button   ng-if="current !== data.length - 1" ng-click="moveRight()" type="button" class="btn btn-default btn-xs"><span class="glyphicon glyphicon-circle-arrow-right" aria-hidden="true"></span></button></td>'+
	            '</tr></table>'
	        };


	    }
	    viewGallery.$inject = ["obtGalleryService", "sessionServices"];
	    /*@ngInject*/
	    function viewGalleryPageSectionCtrl($scope,sessionServices,obtGalleryService,queryservice,dataservice){

	        loadComboBox()
	        .then(setOptions)
	        .then(setLanguage);
	        $scope.options = [];
	        $scope.languageKey = {} ;
	        $scope.tmp = $scope.gallery ;
	        $scope.updateGallery = updateGallery ;
	      //  $scope.getKeyDetailsByLocaleId = getKeyDetailsByLocaleId ;
	        $scope.onUploadSuccess = onUploadSuccess;
	        $scope.current = 0 ;
	        $scope.moveRight = moveRight;
	        $scope.moveLeft = moveLeft;
	        function updateGallery(){
	          console.log($scope.tampon,'my tampon');
	          console.log($scope.current);
	         obtGalleryService.updateItem($scope.tampon)
	         .then(function (response){
	           console.log(response);
	         })
	        }
	        function onUploadSuccess (response){
	                  //  console.log(response,tampon);
	                $scope.tampon.url = response.data.path;
	                }





	        $scope.tinymceOptions = {
	             script_url: 'http://tinymce.moxiecode.com/js/tinymce/jscripts/tiny_mce/tiny_mce.js'
	           };
	        function moveRight(){
	            $scope.current =   $scope.current + 1 ;
	              $scope.tampon = $scope.gallery[$scope.current];

	        }
	        function moveLeft(){
	          $scope.current =   $scope.current - 1 ;
	          $scope.tampon = $scope.gallery[$scope.current];

	        }
	        $scope.getKey = function (details){
	          var CurrentKey = 0;
	                  angular.forEach(details,function(value,key){
	                        if(value.localeId === $scope.languageKey){
	                               CurrentKey = key ;
	                             }
	                             })
	                    return CurrentKey ;
	        }
	        function setOptions(options){
	            $scope.options = options;
	            return options ;
	        }
	        function setLanguage(options){
	              $scope.languageKey = dataservice.form.findOptionNamePerCODE(sessionServices.getSession().language,options.languages);
	        }
	        function loadComboBox(params) {
	            var cbIdList = params || [
	                    {'id': 7, 'name': 'languages'}
	                ];
	            return queryservice.getFormOptions(cbIdList, undefined, undefined, {isTool: true}).then(
	                function success(result) {
	                    return result;
	                }
	              )
	        }
	    }
	    viewGalleryPageSectionCtrl.$inject = ["$scope", "sessionServices", "obtGalleryService", "queryservice", "dataservice"];

	    function galleryService (queryservice ) {
	      function getItems(args){
	          args = args || {};
	          console.log('service',args);
	          queryservice.setEvnArgs(args);

	          return queryservice.callServer("obtDbGalleriesHelper.getGallery", args, null);
	      }

	      function addItem (data){
	          var args = data;
	          console.log(args);
	          queryservice.setEvnArgs(args);
	          return queryservice.callServer("obtDbGalleriesHelper.addGallery", args, null);
	      }

	      function updateItem (data){
	          var args = data;
	          queryservice.setEvnArgs(args, undefined, args.id);
	          return queryservice.callServer("obtDbGalleriesHelper.updateGallery", args, null);
	      }
	      function updateGalleryOrder (data){

	          var args= {};
	          args.newOrder = data;
	          console.log(args);
	          //var args = data;
	          queryservice.setEvnArgs(args);
	          return queryservice.callServer("obtDbGalleriesHelper.updateGalleryOrder", args, null);
	      }

	      function deleteItem (key){
	          var args={} ;
	          args.galleryId = key;
	          console.log('deleteItem',key);
	          queryservice.setEvnArgs( args );

	          return queryservice.callServer("obtDbGalleriesHelper.removeGallery", args, null);
	      }

	      function deleteGalleryItem (keyItem , keyGalleryItem){
	          //console.log('deleteGalleryItem',keyItem , keyGalleryItem);
	          //data.id,data.galleryItemId
	          var args = {};
	          args.id  = keyItem ;
	          args.galleryItemId = keyGalleryItem
	          queryservice.setEvnArgs(args);

	          return queryservice.callServer("obtDbGalleriesHelper.removeGalleryItem", args, null);
	      }
	      function renameGallery(data){
	          var args = data;
	          queryservice.setEvnArgs(args);

	          return queryservice.callServer("obtDbGalleriesHelper.renameGallery", args, null);
	      }

	      // Return the public API.
	      return {
	          getItems : getItems,
	          updateItem : updateItem,
	          addItem : addItem,
	          renameGallery : renameGallery,
	          deleteGalleryItem:deleteGalleryItem,
	          updateGalleryOrder:updateGalleryOrder,
	          deleteItem:deleteItem
	      };
	  }
	  galleryService.$inject = ["queryservice"];

	})();


/***/ },
/* 199 */
/***/ function(module, exports) {

	

	(function(){
	    angular.module('app.widgets')
	        .directive('owlCarousel', owlCarousel)
	        .directive('owlCarouselItem', owlCarouselItem);

	  
	        function owlCarousel () {
	            return {
	                restrict: 'E',
	                transclude: false,
	                link: function (scope) {
	                    scope.initCarousel = function(element) {
	                      // provide any default options you want
	                        var defaultOptions = {
	                        };
	                        var customOptions = scope.$eval($(element).attr('data-options'));
	                        // combine the two options objects
	                        for(var key in customOptions) {
	                            defaultOptions[key] = customOptions[key];
	                        }
	                        // init carousel
	                        $(element).owlCarousel(defaultOptions);
	                    };
	                }
	            };
	        }
	        function owlCarouselItem () {
	            return {
	                restrict: 'A',
	                transclude: false,
	                link: function(scope, element) {
	                  // wait for the last item in the ng-repeat then call init
	                    if(scope.$last) {
	                        scope.initCarousel(element.parent());
	                    }
	                }
	            };
	        }

	})();


/***/ },
/* 200 */
/***/ function(module, exports) {

	

	(function(){
	    angular.module('app.widgets')
	        .directive('viewService', viewService);
	/*@ngInject*/
	    function viewService(sessionServices){

	        return {
	            restrict: 'EA',
	            scope:{
	                data:'=?',
	                services:'=?'
	            },
	            link:function(scope){
	            //  console.log(service , 'my');
	              scope.tampon = scope.services [0] || { };
	            //  var args = {uId:sessionServices.getSession().uId , galleryId :scope.galleryId};

	              // obtGalleryService.getItems(args).
	              //  then(function (response){
	              //    console.log(response);
	              //    scope.gallery = response ;
	              //    scope.tampon = response [0] || { };
	              //  })

	            },
	            controller:viewServicePageSectionCtrl,
	            template:'<table class="table col-md-12" border="0"><tr>'+
	            '<td  style="padding-top:30%" class="col-md-1"><button   ng-if="current !== 0 " type="button" ng-click="moveLeft()" class="btn btn-default btn-xs"><span class="glyphicon glyphicon-circle-arrow-left" aria-hidden="true"></span></button></td>'+
	            '<td class="col-md-10 text-center"><div class="col-md-12"><div class="thumbnail"><img ng-src="{{tampon.avatar}}" alt=""><div class="caption"> <h4><input  type="text" class="text-center" ng-model="tampon.name" style="width:100%"></h4>'+
	            '<p> <div  class="btn btn-primary btn-xs btn-upload"  accept="image/*"   upload-button url="./php/simpleUpload.php" on-success="onUploadSuccess(response)">'+
	            '<i class="fa fa-upload" aria-hidden="true"></i> {{\'UPLOAD\'|translate}}</div><a href class="btn btn-primary btn-xs" role="button" ng-click="updateService()" ><i class="fa fa-plus" aria-hidden="true"></i>{{\'UPDATE\'|translate}}</a><a href class="btn btn-danger btn-xs" role="button"><i class="fa fa-trash" aria-hidden="true"></i>{{\'DELETE\'|translate}}</a></p>'+
	            '</div></div>'+
	            '</div></td>'+
	            '<td style="padding-top:30%" class="col-md-1"><button   ng-if="current !== services.length - 1" ng-click="moveRight()" type="button" class="btn btn-default btn-xs"><span class="glyphicon glyphicon-circle-arrow-right" aria-hidden="true"></span></button></td>'+
	            '</tr></table>'
	        };


	    }
	    viewService.$inject = ["sessionServices"];
	    /*@ngInject*/
	    function viewServicePageSectionCtrl($scope,sessionServices,queryservice,dataservice){

	        loadComboBox()
	        .then(setOptions)
	        .then(setLanguage);
	        $scope.options = [];
	        $scope.languageKey = {} ;
	        $scope.tmp = $scope.services ;
	        $scope.updateService = updateService ;
	      //  $scope.getKeyDetailsByLocaleId = getKeyDetailsByLocaleId ;
	        $scope.onUploadSuccess = onUploadSuccess;
	        $scope.current = 0 ;
	        $scope.moveRight = moveRight;
	        $scope.moveLeft = moveLeft;
	        function updateService(){
	          console.log($scope.tampon,'my tampon');
	          console.log($scope.current);
	        }
	        function onUploadSuccess (response){
	                  //  console.log(response,tampon);
	                $scope.tampon.avatar = response.data.path;
	                }





	        $scope.tinymceOptions = {
	             script_url: 'http://tinymce.moxiecode.com/js/tinymce/jscripts/tiny_mce/tiny_mce.js'
	           };
	        function moveRight(){
	            $scope.current =   $scope.current + 1 ;
	            $scope.tampon = $scope.services[$scope.current];

	        }
	        function moveLeft(){
	          $scope.current =   $scope.current - 1 ;
	          $scope.tampon = $scope.services[$scope.current];

	        }
	        // $scope.getKey = function (){
	        //   var CurrentKey = 0;
	        //           angular.forEach(service,function(value,key){
	        //                 if(value.localeId === $scope.languageKey){
	        //                        CurrentKey = key ;
	        //                      }
	        //                      })
	        //             return CurrentKey ;
	        // }
	        function setOptions(options){
	            $scope.options = options;
	            return options ;
	        }
	        function setLanguage(options){
	              $scope.languageKey = dataservice.form.findOptionNamePerCODE(sessionServices.getSession().language,options.languages);
	        }
	        function loadComboBox(params) {
	            var cbIdList = params || [
	                    {'id': 7, 'name': 'languages'}
	                ];
	            return queryservice.getFormOptions(cbIdList, undefined, undefined, {isTool: true}).then(
	                function success(result) {
	                    return result;
	                }
	              )
	        }
	    }
	    viewServicePageSectionCtrl.$inject = ["$scope", "sessionServices", "queryservice", "dataservice"];
	  //
	  //   function galleryService (queryservice ) {
	  //     function getItems(args){
	  //         args = args || {};
	  //         console.log('service',args);
	  //         queryservice.setEvnArgs(args);
	  //
	  //         return queryservice.callServer("obtDbGalleriesHelper.getGallery", args, null);
	  //     }
	  //
	  //     function addItem (data){
	  //         var args = data;
	  //         console.log(args);
	  //         queryservice.setEvnArgs(args);
	  //         return queryservice.callServer("obtDbGalleriesHelper.addGallery", args, null);
	  //     }
	  //
	  //     function updateItem (data){
	  //         var args = data;
	  //         queryservice.setEvnArgs(args, undefined, args.id);
	  //         return queryservice.callServer("obtDbGalleriesHelper.updateService", args, null);
	  //     }
	  //     function updateServiceOrder (data){
	  //
	  //         var args= {};
	  //         args.newOrder = data;
	  //         console.log(args);
	  //         //var args = data;
	  //         queryservice.setEvnArgs(args);
	  //         return queryservice.callServer("obtDbGalleriesHelper.updateServiceOrder", args, null);
	  //     }
	  //
	  //     function deleteItem (key){
	  //         var args={} ;
	  //         args.galleryId = key;
	  //         console.log('deleteItem',key);
	  //         queryservice.setEvnArgs( args );
	  //
	  //         return queryservice.callServer("obtDbGalleriesHelper.removeGallery", args, null);
	  //     }
	  //
	  //     function deleteGalleryItem (keyItem , keyGalleryItem){
	  //         //console.log('deleteGalleryItem',keyItem , keyGalleryItem);
	  //         //data.id,data.galleryItemId
	  //         var args = {};
	  //         args.id  = keyItem ;
	  //         args.galleryItemId = keyGalleryItem
	  //         queryservice.setEvnArgs(args);
	  //
	  //         return queryservice.callServer("obtDbGalleriesHelper.removeGalleryItem", args, null);
	  //     }
	  //     function renameGallery(data){
	  //         var args = data;
	  //         queryservice.setEvnArgs(args);
	  //
	  //         return queryservice.callServer("obtDbGalleriesHelper.renameGallery", args, null);
	  //     }
	  //
	  //     // Return the public API.
	  //     return {
	  //         getItems : getItems,
	  //         updateItem : updateItem,
	  //         addItem : addItem,
	  //         renameGallery : renameGallery,
	  //         deleteGalleryItem:deleteGalleryItem,
	  //         updateServiceOrder:updateServiceOrder,
	  //         deleteItem:deleteItem
	  //     };
	  // }

	})();


/***/ },
/* 201 */
/***/ function(module, exports) {

	/**
	 * Created by LENOVO T440 on 08/04/2016.
	 */

	(function(){
	    angular.module('app.widgets')
	        .directive('obtUploadChange', obtChangeFn);

	    obtChangeFn.$inject=[];
	    function obtChangeFn(){
	        return {
	            restrict:'E',
	            scope:{
	                form:'=?',
	                item:'=?',
	                ngChange :'&',
	                uploadData:'=?',
	                placeholder:'@?'
	            },
	            template:'<div class="thumbnail" >\n  <img ng-if="vm.item && !vm.url" class="thumbnailSize"  ng-src="{{\'./\' + vm.item}}" />\n   <img ng-if="vm.item && vm.url" class="thumbnailSize"  ng-src="{{vm.item}}" />  \n     <img ng-if="!vm.item" class="thumbnailSize" ng-src="{{vm.placeholder ? vm.placeholder : \'./img/default_avatar.png\'}}" /></div> \n<div class="btn btn-primary btn-upload"\n     upload-button\n     accept="image/*"\n     data="vm.uploadData"\n     url="./php/simpleUpload.php"\n     on-success="vm.onUploadSuccess(response)"\n        >{{\'UPLOAD\'|translate}}</div>&nbsp;<div class="btn btn-danger "\n        ng-click="vm.deleteImage()"\n        >{{\'DELETE_IMAGE\'|translate}}</div> <br/><br/>  <div><input class="col-md-12" type="text" ng-model="vm.newItem"/></div>\n <br/><br/> <div class="btn btn-primary "  ng-click="vm.urlImage(vm.newItem)"\n        >{{\'url_IMAGE\'|translate}}</div>',
	            controller: ctrlFn2,
	            controllerAs:'vm',
	            bindToController:true
	        };
	    }
	    ctrlFn2.$inject=['$scope','uploadService'];
	    function ctrlFn2($scope,uploadService){
	        var vm = this;
	         init();
	        function init (){
	         if(vm.item){
	             var test =  vm.item.indexOf('cData');
	             var test1 =  vm.item.indexOf('upload');
	             if(test !== -1 || test1 !== -1){
	                 vm.url= true;
	             }
	             else{
	                 vm.url= false;
	             }
	         }
	        }
	        vm.onUploadSuccess = onUploadSuccess;
	        vm.deleteImage = deleteImage;
	        vm.urlImage = urlImage;

	        function onUploadSuccess (response){
	            uploadService.broadcast(uploadService.CHANNEL.UPLOAD_DATA_CHANGED,'changed');
	            console.log(response);
	            vm.url= false;
	            vm.item = response.data.path;
	            if(vm.form){
	                vm.form.$pristine = false;
	            }
	        }
	        function deleteImage (){
	            vm.item = '';
	            if(vm.form){
	                vm.form.$pristine = false;
	            }

	        }

	        function urlImage (data){
	           if(data !==null || data !== undefined){
	               console.log('data',data);
	               vm.url= true;
	               vm.item = data;
	               console.log('item',vm.item);
	             //  vm.newItem = null;
	               if(vm.form){
	                   vm.form.$pristine = false;
	               }
	           }

	        }
	    }
	})();


/***/ },
/* 202 */
/***/ function(module, exports) {

	(function () {
	    'use strict';
	    angular
	        .module('app.widgets')
	        .service('uploadService', uploadService)

	    /* @ngInject */
	    // function calendarService() {
	    //     return{
	    //         moveDateTimeZone:moveDateTimeZone
	    //     };
	    //
	    //     function moveDateTimeZone(timezone, date) {
	    //         if (timezone) {
	    //             date.zone(timezone, true);
	    //         }
	    //         return date;
	    //     }
	    // }

	    function uploadService($rootScope){
	    this.CHANNEL = {
	        UPLOAD_DATA_CHANGED : 'changed'
	    };

	    this.broadcast = function(channel, msg){
	        console.log('broadUpload');
	        if (channel && typeof channel === 'string') {
	            $rootScope.$broadcast(channel, msg);
	        }

	    };
	    this.listener = function(channel, callback){
	        console.log('listener');
	        if (channel && typeof channel === 'string' && callback && typeof callback === 'function') {
	            return $rootScope.$on(channel, callback);
	        }
	    };
	}
	uploadService.$inject = ["$rootScope"];
	})();


/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';

	(function (angular) {
	  // Create all modules and define dependencies to make sure they exist
	  // and are loaded in the correct order to satisfy dependency injection
	  // before all nested files are concatenated by Gulp

	  // Config
	  angular.module('ui.carousel.config', []).value('ui.carousel.config', {
	    debug: true
	  });

	  // Modules
	  angular.module('ui.carousel.providers', []);
	  angular.module('ui.carousel.controllers', []);
	  angular.module('ui.carousel.directives', []);
	  angular.module('ui.carousel', ['ui.carousel.config', 'ui.carousel.directives', 'ui.carousel.controllers', 'ui.carousel.providers']);
	})(angular);
	'use strict';

	/**
	 * angular-ui-carousel
	 * for example:
	 * length = 8, show = 4, scroll = 3, current = 0
	 *          ---------
	 *          |       |
	 *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
	 *          |       |
	 *          ---------
	 * rectangle is visible for users
	 */
	angular.module('ui.carousel.controllers').controller('CarouselController', ['$scope', '$element', '$timeout', '$q', 'Carousel', '$window', function ($scope, $element, $timeout, $q, Carousel, $window) {
	  var _this = this;

	  /**
	   * Initial carousel
	   *
	   * Mirgate to angularjs 1.6
	   * @see https://docs.angularjs.org/guide/migration#commit-bcd0d4
	   */
	  this.$onInit = function () {
	    _this.initOptions();
	    _this.initRanges();
	    _this.setProps();
	    _this.setupInfinite();
	  };

	  /**
	   * Init option based on directive config
	   */
	  this.initOptions = function () {
	    _this.options = angular.extend({}, Carousel.getOptions());

	    // TODO customize attribute from directive
	    if (_this.initialSlide !== undefined) {
	      _this.options.initialSlide = _this.initialSlide;
	    }
	    if (_this.fade !== undefined) {
	      _this.options.fade = _this.fade;
	    }
	    if (_this.autoplay !== undefined) {
	      _this.options.autoplay = _this.autoplay;
	    }
	    if (_this.autoplaySpeed !== undefined) {
	      _this.options.autoplaySpeed = _this.autoplaySpeed;
	    }
	    if (_this.cssEase !== undefined) {
	      _this.options.cssEase = _this.cssEase;
	    }
	    if (_this.speed !== undefined) {
	      _this.options.speed = _this.speed;
	    }
	    if (_this.infinite !== undefined) {
	      _this.options.infinite = _this.infinite;
	    }
	    if (_this.arrows !== undefined) {
	      _this.options.arrows = _this.arrows;
	    }
	    if (_this.dots !== undefined) {
	      _this.options.dots = _this.dots;
	    }
	    if (_this.visiblePrev !== undefined) {
	      _this.options.visiblePrev = _this.visiblePrev;
	    }
	    if (_this.visibleNext !== undefined) {
	      _this.options.visibleNext = _this.visibleNext;
	    }

	    // TODO write more options for fade mode
	    // In fade mode we have to setting slides-to-show and slides-to-scroll
	    // to 1 slide
	    if (_this.options.fade) {
	      _this.options.slidesToShow = 1;
	      _this.options.slidesToScroll = 1;
	    } else {
	      if (_this.show) {
	        _this.options.slidesToShow = _this.show;
	      }
	      if (_this.scroll) {
	        _this.options.slidesToScroll = _this.scroll;
	      }
	    }
	  };

	  /**
	   * init variables, slides, ..
	   */
	  this.initRanges = function () {
	    if (!_this.slides) {
	      _this.slides = [];
	    }

	    _this.isCarouselReady = false;
	    _this.isTrackMoving = false;
	    _this.track = $element.find('.track');
	    _this.width = 1; // Fake width
	    _this.currentSlide = _this.options.initialSlide;
	    _this.trackStyle = {};
	    _this.slideStyle = {};

	    _this.isVisibleDots = false;
	    _this.isVisiblePrev = _this.options.visiblePrev;
	    _this.isVisibleNext = _this.options.visibleNext;

	    _this.isClickablePrev = false;
	    _this.isClickableNext = false;

	    _this.animType = null;
	    _this.transformType = null;
	    _this.transitionType = null;
	  };

	  /**
	   * Init UI and carousel track
	   */
	  this.initUI = function () {
	    _this.width = $element[0].clientWidth;

	    // Update track width first
	    _this.initTrack();

	    // Then item style
	    $timeout(function () {
	      _this.updateItemStyle();
	    }, 200);
	  };

	  /**
	   * update common style for each carousel item
	   */
	  this.updateItemStyle = function () {
	    _this.itemWidth = _this.width / _this.options.slidesToShow;
	    _this.slideStyle = {
	      'width': _this.itemWidth + 'px'
	    };
	  };

	  /**
	   * init carousel track
	   * also make Carousel is Ready
	   */
	  this.initTrack = function () {
	    var itemWidth = _this.width / _this.options.slidesToShow;
	    var trackWidth = itemWidth * _this.slidesInTrack.length;

	    _this.trackStyle.width = trackWidth + 'px';

	    _this.slideHandler(_this.currentSlide).finally(function () {
	      _this.isCarouselReady = true;

	      if (!_this.options.fade) {
	        _this.refreshTrackStyle();
	      }

	      // onInit callback
	      if (_this.onInit) {
	        _this.onInit();
	      }
	    }).catch(function () {
	      // Catch err
	    });
	  };

	  /**
	   * @see https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L680
	   *
	   * Sync slide to place it should be
	   * for example:
	   * - 9 total, 3 show, 3 scroll, current 1
	   *   => next index = 3 (previous index counted = 0)
	   *
	   * and scroll to next page:
	   * - 6 total, 1 show, 1 scroll, current 0 => next index = 1
	   * - 9 total, 3 show, 3 scroll, current 1 => next index = 3
	   * - 9 total, 3 show, 3 scroll, current 3 => next index = 6
	   * - 9 total, 3 show, 3 scroll, current 8 => next index = 3
	   * - 8 total, 4 show, 3 scroll, current 1 => next index = 4
	   */
	  this.next = function () {
	    if (!_this.isClickableNext) {
	      return false;
	    }

	    var indexOffset = _this.getIndexOffset();
	    var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : indexOffset;

	    _this.slideHandler(_this.currentSlide + slideOffset).catch(function () {
	      // Catch err
	    });
	  };

	  /**
	   * move to previous slide
	   * same calculate with next
	   * @see next function
	   */
	  this.prev = function () {
	    if (!_this.isClickablePrev) {
	      return false;
	    }

	    var indexOffset = _this.getIndexOffset();
	    var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : _this.options.slidesToShow - indexOffset;

	    _this.slideHandler(_this.currentSlide - slideOffset).catch(function () {
	      // Catch err
	    });
	  };

	  /**
	   * Get index offset
	   */
	  this.getIndexOffset = function () {
	    var scrollOffset = _this.slides.length % _this.options.slidesToScroll !== 0;
	    var indexOffset = scrollOffset ? 0 : (_this.slides.length - _this.currentSlide) % _this.options.slidesToScroll;

	    return indexOffset;
	  };

	  /**
	   * move to page
	   * @params int page
	   * Page counter from 0 (start = 0)
	   */
	  this.movePage = function (page) {
	    var target = _this.options.slidesToScroll * page;
	    _this.slideHandler(target).catch(function () {
	      // Catch err
	    });
	  };

	  /**
	   * hanlder carousel
	   * @description move carousel to correct page
	   *
	   * @params int index
	   */
	  this.slideHandler = function (index) {
	    // TODO prevent when slides not exists
	    if (!_this.slides) {
	      return $q.reject('Carousel not fully setup');
	    }

	    // TODO Prevent when track is moving
	    if (_this.isTrackMoving) {
	      return $q.reject('Track is moving');
	    }

	    var len = _this.slides.length;
	    var show = _this.options.slidesToShow;

	    if (len <= show) {
	      _this.correctTrack();
	      return $q.reject('Length of slides smaller than slides to show');
	    }

	    // We need target to destination
	    // and a anim slide to translate track
	    //
	    // anim = animSlide (which we use to move)
	    // target = targetSlide
	    var anim = index;
	    var target = null;

	    if (anim < 0) {
	      if (len % _this.options.slidesToScroll !== 0) {
	        target = len - len % _this.options.slidesToScroll;
	      } else {
	        target = len + anim;
	      }
	    } else if (anim >= len) {
	      if (len % _this.options.slidesToScroll !== 0) {
	        target = 0;
	      } else {
	        target = anim - len;
	      }
	    } else {
	      target = anim;
	    }

	    if (_this.onBeforeChange) {
	      // @see https://docs.angularjs.org/guide/directive
	      _this.onBeforeChange({ currentSlide: _this.currentSlide, target: target });
	    }

	    // Fade handler
	    if (_this.options.fade) {
	      _this.currentSlide = target;

	      // XXX
	      // afterChange method
	      // fire after faded
	      // Should be revised
	      $timeout(function () {
	        _this.autoplayTrack();

	        if (_this.onAfterChange) {
	          _this.onAfterChange({ currentSlide: _this.currentSlide });
	        }
	      }, _this.options.speed);
	      return $q.when('Handler fade');
	    }

	    // No-fade handler
	    var itemWidth = _this.width / _this.options.slidesToShow;
	    var left = -1 * target * itemWidth;
	    if (_this.options.infinite) {
	      left = -1 * (anim + show) * itemWidth;
	    }

	    _this.isTrackMoving = true;
	    return _this.moveTrack(left).then(function () {
	      _this.isTrackMoving = false;
	      _this.currentSlide = target;
	      _this.autoplayTrack();

	      if (target !== anim) {
	        _this.correctTrack();
	      }

	      if (!_this.options.infinite) {
	        if (_this.currentSlide === 0) {
	          _this.isClickablePrev = false;
	          _this.isClickableNext = true;
	        } else if (_this.currentSlide === _this.slidesInTrack.length - _this.options.slidesToShow) {
	          _this.isClickableNext = false;
	          _this.isClickablePrev = true;
	        } else {
	          _this.isClickablePrev = true;
	          _this.isClickableNext = true;
	        }
	      }

	      // XXX
	      // afterChange method
	      // fire after 200ms wakeup and correct track
	      // Should be revised
	      $timeout(function () {
	        if (_this.onAfterChange) {
	          _this.onAfterChange({ currentSlide: _this.currentSlide });
	        }
	      }, 200);
	    });
	  };

	  /**
	   * moveTrack
	   * move track to left position using css3 translate
	   * for example left: -1000px
	   */
	  this.moveTrack = function (left) {
	    var deferred = $q.defer();
	    if (_this.options.vertical === false) {
	      _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0px, 0px)';
	    } else {
	      _this.trackStyle[_this.animType] = 'translate3d(0px, ' + left + 'px, 0px)';
	    }

	    $timeout(function () {
	      deferred.resolve('Track moved');
	    }, _this.options.speed);

	    return deferred.promise;
	  };

	  /**
	   * correctTrack
	   * @description correct track after move to animSlide we have to move track
	   * to exactly its position
	   */
	  this.correctTrack = function () {
	    if (_this.options.infinite) {
	      (function () {
	        var left = 0;
	        if (_this.slides.length > _this.options.slidesToShow) {
	          left = -1 * (_this.currentSlide + _this.options.slidesToShow) * _this.itemWidth;
	        }

	        // Move without anim
	        _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + 0 + 'ms ' + _this.options.cssEase;

	        _this.isTrackMoving = true;
	        $timeout(function () {
	          _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0, 0px)';

	          // Revert animation
	          $timeout(function () {
	            _this.refreshTrackStyle();
	            _this.isTrackMoving = false;
	          }, 200);
	        });
	      })();
	    }
	  };

	  /**
	   * Refresh track style
	   */
	  this.refreshTrackStyle = function () {
	    _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + _this.options.speed + 'ms ' + _this.options.cssEase;
	  };

	  /**
	   * autoplay track
	   * @description autoplay = true
	   */
	  this.autoplayTrack = function () {
	    if (_this.options.autoplay) {
	      if (_this.timeout) {
	        $timeout.cancel(_this.timeout);
	      }

	      _this.timeout = $timeout(function () {
	        _this.next();

	        $timeout.cancel(_this.timeout);
	        _this.timeout = null;
	      }, _this.options.autoplaySpeed);
	    }
	  };

	  this.getSlideStyle = function (index) {
	    var style = _this.slideStyle;
	    if (_this.options.fade) {
	      var left = -1 * index * _this.itemWidth;
	      var uniqueStyle = {
	        position: 'relative',
	        top: '0px',
	        left: left + 'px',
	        'z-index': index === _this.currentSlide ? 10 : 9,
	        opacity: index === _this.currentSlide ? 1 : 0
	      };

	      if (index >= _this.currentSlide - 1 && index <= _this.currentSlide + 1) {
	        uniqueStyle.transition = 'opacity 250ms linear';
	      }

	      style = angular.extend(style, uniqueStyle);
	    }

	    return style;
	  };

	  /**
	   * setupInfinite
	   * To make carouse infinite we need close number of slidesToShow elements to
	   * previous elements and to after elements
	   *
	   * length = 8, show = 4, scroll = 3, current = 0
	   *          ---------
	   *          |       |
	   *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
	   *          |       |
	   *          ---------
	   */
	  this.setupInfinite = function () {
	    // Clone
	    var len = _this.slides.length;
	    var show = _this.options.slidesToShow;

	    var tmpTrack = angular.copy(_this.slides);

	    if (_this.options.infinite && _this.options.fade === false) {
	      if (len > show) {
	        var number = show;
	        for (var i = 0; i < number; i++) {
	          tmpTrack.push(angular.copy(_this.slides[i]));
	        }
	        for (var _i = len - 1; _i >= len - show; _i--) {
	          tmpTrack.unshift(angular.copy(_this.slides[_i]));
	        }
	      }
	    }

	    _this.slidesInTrack = tmpTrack;
	  };

	  /**
	   * get number of dosts
	   *
	   * @return Array
	   */
	  this.getDots = function () {
	    if (!_this.slides) {
	      return [];
	    }

	    var dots = Math.ceil(_this.slides.length / _this.options.slidesToScroll);

	    var res = [];
	    for (var i = 0; i < dots; i++) {
	      res.push(i);
	    }
	    return res;
	  };

	  /**
	   * set carousel property
	   *
	   * - animType
	   * - transformType
	   * - transitionType
	   */
	  this.setProps = function () {
	    var bodyStyle = document.body.style;

	    /* eslint-disable */
	    if (bodyStyle.OTransform !== undefined) {
	      _this.animType = 'OTransform';
	      _this.transformType = '-o-transform';
	      _this.transitionType = 'OTransition';
	    }
	    if (bodyStyle.MozTransform !== undefined) {
	      _this.animType = 'MozTransform';
	      _this.transformType = '-moz-transform';
	      _this.transitionType = 'MozTransition';
	    }
	    if (bodyStyle.webkitTransform !== undefined) {
	      _this.animType = 'webkitTransform';
	      _this.transformType = '-webkit-transform';
	      _this.transitionType = 'webkitTransition';
	    }
	    if (bodyStyle.msTransform !== undefined) {
	      _this.animType = 'msTransform';
	      _this.transformType = '-ms-transform';
	      _this.transitionType = 'msTransition';
	    }
	    if (bodyStyle.transform !== undefined && _this.animType !== false) {
	      _this.animType = 'transform';
	      _this.transformType = 'transform';
	      _this.transitionType = 'transition';
	    }
	    /* eslint-enable */

	    _this.transformsEnabled = true;
	  };

	  /**
	   * Refresh carousel
	   */
	  this.refreshCarousel = function () {
	    if (_this.slides && _this.slides.length && _this.slides.length > _this.options.slidesToShow) {
	      _this.isVisibleDots = true;
	      _this.isVisiblePrev = true;
	      _this.isVisibleNext = true;
	      _this.isClickablePrev = true;
	      _this.isClickableNext = true;
	    } else {
	      _this.isVisibleDots = false;
	      _this.isVisiblePrev = _this.options.visiblePrev || false;
	      _this.isVisibleNext = _this.options.visibleNext || false;
	      _this.isClickablePrev = false;
	      _this.isClickableNext = false;
	    }

	    // Re-init UI
	    _this.initUI();
	  };

	  /**
	   * refresh model
	   */
	  $scope.$watchCollection('ctrl.slides', function (slides) {
	    if (!slides) {
	      return;
	    }

	    // Init carousel
	    if (_this.currentSlide > slides.length - 1) {
	      _this.currentSlide = slides.length - 1;
	    }

	    _this.setupInfinite();
	    _this.refreshCarousel();
	  });

	  /**
	   * update when resize
	   *
	   * @see https://github.com/mihnsen/ui-carousel/issues/10
	   * @author tarkant
	   */
	  angular.element($window).on('resize', this.refreshCarousel);

	  /**
	   * cleanup when done
	   *
	   * @see https://github.com/mihnsen/ui-carousel/issues/10
	   * @author tarkant
	   */
	  $scope.$on('$destroy', function () {
	    angular.element($window).off('resize');
	  });

	  // Prior to v1.5, we need to call `$onInit()` manually.
	  // (Bindings will always be pre-assigned in these versions.)
	  if (angular.version.major === 1 && angular.version.minor < 5) {
	    this.$onInit();
	  }
	}]);
	'use strict';

	angular.module('ui.carousel.directives').directive('uiCarousel', ['$compile', '$templateCache', '$sce', function ($compile, $templateCache, $sce) {

	  return { restrict: 'AE',
	    bindToController: true,
	    scope: {
	      name: '=?',
	      slides: '=',
	      show: '=?slidesToShow',
	      scroll: '=?slidesToScroll',
	      classes: '@',
	      fade: '=?',
	      onChange: '=?',
	      disableArrow: '=?',
	      autoplay: '=?',
	      autoplaySpeed: '=?',
	      cssEase: '=?',
	      speed: '=?',
	      infinite: '=?',
	      arrows: '=?',
	      dots: '=?',
	      initialSlide: '=?',
	      visibleNext: '=?',
	      visiblePrev: '=?',

	      // Method
	      onBeforeChange: '&',
	      onAfterChange: '&',
	      onInit: '&'
	    },
	    link: function link($scope, el) {
	      var template = angular.element($templateCache.get('ui-carousel/carousel.template.html'));

	      // dynamic injections to override the inner layers' components
	      var injectComponentMap = {
	        'carousel-item': '.carousel-item',
	        'carousel-prev': '.carousel-prev',
	        'carousel-next': '.carousel-next'
	      };

	      var templateInstance = template.clone();
	      angular.forEach(injectComponentMap, function (innerSelector, outerSelector) {
	        var outerElement = el[0].querySelector(outerSelector);
	        if (outerElement) {
	          angular.element(templateInstance[0].querySelector(innerSelector)).html(outerElement.innerHTML);
	        }
	      });

	      var compiledElement = $compile(templateInstance)($scope);
	      el.addClass('ui-carousel').html('').append(compiledElement);
	    },


	    controller: 'CarouselController',
	    controllerAs: 'ctrl'
	  };
	}]);
	'use strict';

	angular.module('ui.carousel.providers').provider('Carousel', function () {
	  var _this = this;

	  this.options = {
	    // Init like Slick carousel
	    // XXX Should be revised
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    cssEase: 'ease',
	    dots: false,

	    easing: 'linear',
	    fade: false,
	    infinite: true,
	    initialSlide: 0,

	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,

	    visiblePrev: false,
	    visibleNext: false,

	    // Not available right now
	    draggable: true,

	    lazyLoad: 'ondemand',

	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,

	    vertical: false,
	    verticalSwiping: false
	  };
	  this.$get = [function () {
	    return {
	      setOptions: function setOptions(options) {
	        _this.options = angular.extend(_this.options, options);
	      },
	      getOptions: function getOptions() {
	        return _this.options;
	      }
	    };
	  }];
	});
	'use strict';

	(function (module) {
	  try {
	    module = angular.module('ui.carousel');
	  } catch (e) {
	    module = angular.module('ui.carousel', []);
	  }
	  module.run(['$templateCache', function ($templateCache) {
	    $templateCache.put('ui-carousel/carousel.template.html', '<div class="carousel-wrapper" ng-show="ctrl.isCarouselReady"><div class="track-wrapper"><div class="track" ng-style="ctrl.trackStyle"><div class="slide" ng-repeat="item in ctrl.slidesInTrack track by $index" ng-style="ctrl.getSlideStyle($index)"><div class="carousel-item"></div></div></div></div><div class="carousel-prev" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisiblePrev &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickablePrev}" ng-click="ctrl.prev()"><button class="carousel-btn"><i class="ui-icon-prev"></i></button></div><div class="carousel-next" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisibleNext &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickableNext}" ng-click="ctrl.next()"><button class="carousel-btn"><i class="ui-icon-next"></i></button></div><ul class="carousel-dots" ng-show="ctrl.isVisibleDots &amp;&amp; ctrl.options.dots"><li ng-repeat="dot in ctrl.getDots()" ng-class="{ \'carousel-active\': dot == ctrl.currentSlide/ctrl.options.slidesToScroll }" ng-click="ctrl.movePage(dot)"><button>{{ dot }}</button></li></ul></div>');
	  }]);
	})();


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(205);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(6)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./ui.carousel.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./ui.carousel.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports


	// module
	exports.push([module.id, ".ui-carousel .carousel-btn,.v-middle{display:block;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}@font-face{font-family:ui-carousel;src:url(" + __webpack_require__(207) + ");src:url(" + __webpack_require__(207) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(206) + ") format(\"woff\"),url(" + __webpack_require__(208) + ") format(\"truetype\"),url(" + __webpack_require__(209) + "#ui-carousel) format(\"svg\");font-weight:400;font-style:normal}[data-icon]:before{content:attr(data-icon)}[class*=\" ui-icon-\"]:before,[class^=ui-icon-]:before,[data-icon]:before{font-family:ui-carousel!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ui-icon-prev:before{content:\"a\"}.ui-icon-next:before{content:\"b\"}.ui-icon-dot:before{content:\"c\"}.ui-carousel{display:block;margin-bottom:30px}.ui-carousel .carousel-wrapper{position:relative}.ui-carousel .track-wrapper{position:relative;display:block;overflow:hidden;margin:0;padding:0}.ui-carousel .track{position:relative;display:block;float:left}.ui-carousel .slide{float:left;height:100%;min-height:1px}.ui-carousel .carousel-btn{position:absolute;z-index:10;background-color:transparent;outline:none;border:none;font-size:20px;opacity:.75}.ui-carousel .carousel-btn:hover{opacity:1}.ui-carousel .carousel-prev .carousel-btn{left:-25px}.ui-carousel .carousel-next .carousel-btn{right:-25px}.ui-carousel .carousel-disable{opacity:.5}.ui-carousel .carousel-disable .carousel-btn:hover{opacity:.75}.carousel-dots{position:absolute;bottom:-30px;display:block;width:100%;padding:0;margin:0;list-style:none;text-align:center}.carousel-dots li{position:relative;display:inline-block;width:15px;height:15px;margin:0 5px;padding:0;cursor:pointer}.carousel-dots li button{font-size:0;line-height:0;display:block;width:15px;height:15px;padding:5px;cursor:pointer;color:transparent;border:0;outline:none;background:transparent}.carousel-dots li button:before{font-family:ui-carousel;font-size:9px;line-height:15px;position:absolute;top:0;left:0;width:15px;height:15px;content:\"c\";text-align:center;opacity:.25;color:#000;-webkit-font-smoothing:antialiased}.carousel-dots li.carousel-active button:before{opacity:.75}", ""]);

	// exports


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bfc9522fd9297e7a58cee7182f5ab5e3.woff";

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "0a2746f94a78dacd0fef8286050f375e.eot";

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "344c48ba4e2a6d128559606ccac19aaa.ttf";

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "26e40a45c7b897d68d30f0b7ed82d98e.svg";

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/4/15.
	 */
	__webpack_require__(211);
	__webpack_require__(212);
	__webpack_require__(213);
	__webpack_require__(214);


/***/ },
/* 211 */
/***/ function(module, exports) {

	(function() {
	    'use strict';
	    angular.module('app.language', []);
	})();


/***/ },
/* 212 */
/***/ function(module, exports) {

	(function (app) {
	    'use strict';

	    app.factory('languageServices', languageServices);

	    /*@ngInject*/
	    function languageServices($translate, $state, $stateParams, dataservice, logger){
	        var languages = null;
	        var options = [{'id': 7, 'name': 'languages'}];
	        var passthrough = {validOnly:true};
	        return  {
	            updateLanguage:updateLanguage,
	            getLanguagesPromise:getLanguagesPromise
	        };

	        function updateLanguage(key){
	            if(key && $translate){
	                $translate.use(key);
	//                obtSession.setLanguage(key); // set the selected language for the session
	                if(!$stateParams){$stateParams = {}}
	                $stateParams.language = key;
	                var stateToRedirect = $state.current.data && $state.current.data.home ? $state.current.data.home : $state.current.name;
	                console.log(stateToRedirect);
	                $state.transitionTo(stateToRedirect, $stateParams, { reload: true });
	            }
	        }

	        function getLanguagesPromise(args, passThroughArgs){
	            var passThroughExtended = angular.extend({}, passthrough, passThroughArgs); //keep order

	            return dataservice.form.getOptions(options, passThroughExtended , args)
	                .then(function(result){
	                    if(result){//} && result.error === 0){
	                        return result.languages || []; //dataservice.form.getOptionsFrom(result.updateComboBox, 'languages');
	                    }else{
	                        logger.error(result.body ? result.body : 'Get language failed', result);
	                        return [];
	                    }
	                });
	        }
	    }
	    languageServices.$inject = ["$translate", "$state", "$stateParams", "dataservice", "logger"];
	})(angular.module('app.data'));


/***/ },
/* 213 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.language')
	        .directive('obtLanguage', obtLanguage);

	    function obtLanguage () {
	       return  {
	            controller:languageController,
	            controllerAs:'vmLanguages',
	            scope:{
	                cid:'@?',
	                tid:'@?'
	            },
	            bindToController:true,
	            replace:true,
	            template:'<li class="dropdown tasks-menu">\n    <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">\n        <i class="fa fa-flag-o"></i>\n        <span class="label label-danger">{{vmLanguages.selectedLanguageId}}</span>\n    </a>\n    <ul class="dropdown-menu">\n        <li>\n            <ul class="menu">\n                <li ng-repeat="language in vmLanguages.languages">\n                    <a href="javascript:void(0)" ng-click="vmLanguages.updateLanguage(language.CODE)">\n                        <h3>\n                            {{language.VALUE}}\n                            <small class="pull-right">{{language.CODE}}</small>\n                        </h3>\n                    </a>\n                </li>\n            </ul>\n        </li>\n    </ul>\n</li>      ',
	            restrict: 'AE'
	        };
	    }

	    languageController.$inject=['languageServices', '$stateParams', 'config'];
	    /*@ngInject*/
	    function languageController(languageServices, $stateParams, config){
	        var vm = this;
	        vm.languages = [];
	        vm.selectedLanguageId = $stateParams.language || config.language;//obtSession.get('language');
	        vm.updateLanguage = updateLanguage;
	        vm.getCurrentLanguage = getCurrentLanguage ;
	        getLanguages(); //fill the combobox
	      function getCurrentLanguage(){
	      return  vm.selectedLanguageId ;
	      }
	        function updateLanguage (key){
	            if(key){
	                vm.selectedLanguageId = key;
	                languageServices.updateLanguage(vm.selectedLanguageId);
	            }
	        }

	        function getLanguages(){
	            var args = {cId:vm.cid || null, tId:vm.tid || null };
	            languageServices.getLanguagesPromise(args)
	                .then(function(result){
	                    vm.languages = result;
	                }
	            );
	        }
	    }
	})();


/***/ },
/* 214 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 8/4/15.
	 */
	(function (app) {
	    'use strict';
	    app.run(enableLanguageSwitching);

	    /*@ngInject*/
	    function enableLanguageSwitching($rootScope, $translate){
	        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                if (toParams.language !== $translate.use()) {
	                    $translate.use(toParams.language);  //switch language
	                }
	            }
	        );
	    }
	    enableLanguageSwitching.$inject = ["$rootScope", "$translate"];

	})(angular.module('app.data'));


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/5/15.
	 */
	__webpack_require__(216);
	__webpack_require__(217);


/***/ },
/* 216 */
/***/ function(module, exports) {

	(function() {
	    'use strict';
	    angular.module('app.booking', []);
	})();


/***/ },
/* 217 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.booking')
	        .controller('BookingController', BookingController);

	    BookingController.$inject = ['$scope', '$q', 'dataservice', 'logger', '$uibModalInstance', 'modalModel', 'vcRecaptchaService', 'translateFilter', '$stateParams', '$analytics'];
	    /* @ngInject */
	    function BookingController($scope, $q, dataservice, logger, $uibModalInstance, modalModel, vcRecaptchaService,  translateFilter, $stateParams, $analytics) {
	        var vm = this;
	        vm.responseKey = null;
	        vm.widgetId = null;
	        vm.key = '6LflOkIUAAAAAHywKymkFP3qML2h5Z0TH5axVJ8S';

	        vm.title = 'Booking';
	        vm.alert=null;
	        vm.data = {};/*from form*/
	        vm.reseller = null;
	        vm.modalModel = modalModel || {};
	        vm.cId = vm.modalModel.cId;
	        vm.session = dataservice.login.status;
	        vm.isQuickBooking = null;

	        vm.options = {};
	        vm.cascadeOptions = [];
	        vm.cascadeOrder = [];  //

	        if(vm.modalModel.formOptions){
	            var mode = vm.modalModel.allDayType || 'default';  //default, NA, onRequest,

	            if(vm.modalModel.formOptions[mode]){
	                vm.cascadeOptions = vm.modalModel.formOptions[mode].cascadeOptions || [];
	                vm.cascadeOrder = vm.modalModel.formOptions[mode].cascadeOrder || [];
	            }
	            //= vm.modalModel.formOptions ? ;
	        }

	        if(vm.modalModel.minTime){
	          vm.modalModel.minTime = newTime(vm.modalModel.minTime);
	        }

	        if(vm.modalModel.maxTime){
	          vm.modalModel.maxTime = newTime(vm.modalModel.maxTime);
	        }
	        //    [
	        //    {value:1, options:[
	        //        {value:10, options:[
	        //            {value:110, options:[]},
	        //            {value:111, options:[]}
	        //        ]},
	        //        {value:11, options:[
	        //            {value:110, options:[]},
	        //            {value:111, options:[]}
	        //        ]}
	        //    ]},
	        //    {value:2, options:[
	        //        {value:20, options:[
	        //            {value:210, options:[]},
	        //            {value:211, options:[]}
	        //        ]},
	        //        {value:21, options:[
	        //            {value:210, options:[]},
	        //            {value:211, options:[]}
	        //        ]}
	        //    ]},
	        //];
	        vm.setResponse = function (response) {
	                     console.info('Response available',response);
	                     vm.responseKey = response;
	                 };
	                 vm.setWidgetId = function (widgetId) {
	                     console.info('Created widget ID: %s', widgetId);
	                     vm.widgetId = widgetId;
	                 };
	                 vm.cbExpiration = function() {
	                     console.info('Captcha expired. Resetting response object');
	                     vcRecaptchaService.reload(vm.widgetId);
	                    vm.responseKey = null;
	                  };
	        vm.applyBooking = applyBooking;

	        vm.requestBooking = requestBooking;
	        vm.addToWaitingList = addToWaitingList;

	        vm.getBookingTime = getBookingTime;

	        vm.startTimeChanged = startTimeChanged;
	        vm.isLoading = false;
	        vm.data.today = newTime("00:00");
	        activate();

	        $scope.$on('obt_recaptcha_created', function(evt) {
	            $analytics.eventTrack('BOOKING_CAPTCHA_DISPLAY', {  category: 'captcha', label: vm.modalModel.description || 'booking_description' });
	        });

	        function getOptions(){
	            var options = [{'id': 9, 'name': 'worktypes'}, {'id': 10, 'name': 'therapists'},{'id': 4, 'name': 'locations'}];
	            var args ={cId : vm.cId, wq : vm.wq, lq : vm.lq};
	            return dataservice.form.getOptions(options, {}, args)
	                .then(function(result){
	                    vm.options = result;
	                });
	        }

	        function getBookingTime(){
	            var start = vm.modalModel.start;
	            var end = vm.modalModel.end;
	            if(!start || !end){
	              return null;
	            }

	            if(start.isSame(end, 'day')){//check if the event start and end the same day
	                return translateFilter('THE') + ' ' +
	                    start.format("LL")
	                    + ' '+ translateFilter('FROM') + ' ' +
	                    start.format("LT")
	                    + ' '+translateFilter('TO') + ' ' +
	                    end.format("LT"); //'27 Mars 2015 de 1:00 a 2:00';
	            }else{
	                return translateFilter('FROM_DAY')
	                    + ' '+start.format("LL")
	                    + ' '+ translateFilter('TO_DAY')
	                    + ' '+end.format("LL");
	            }
	        }

	        function isQuickBookingState(){
	            return !vm.session || vm.session.reseller ? true : false;
	        }
	        function activate() {

	            vm.isQuickBooking = isQuickBookingState();
	            var promises = [getOptions()]; //getBookingInfos()
	            return $q.all(promises).then(function() {
	                // logger.info('Activated Booking View');
	            });
	        }

	        function requestBooking(){
	          console.log('requestBooking');
	            return applyBooking('requestBooking');
	        }
	        function addToWaitingList(){
	            return applyBooking('addToWaitingList');
	        }
	        function applyBooking(mode) {
	            startTimeChanged();
	            vm.isLoading = true;
	            vm.alert=null;
	            var args = getBookingData();
	            console.log(args,'my args');
	            var promise = null;
	            if(mode=='requestBooking'){
	                promise = dataservice.booking.requestBooking(args, vm.cId);
	            }else if(mode=='addToWaitingList'){
	                promise = dataservice.booking.addToWaitingList(args, vm.cId);
	            }else{
	                promise = dataservice.booking.addBooking(args, vm.cId);
	            }

	            console.debug('applyBooking', args );
	            return promise.then(function(data) {
	              console.debug('applyBooking response', data );
	                    vm.isLoading = false;
	                    if (data !== null) {
	                        if (data.error === 0 || data.error === 2) {
	                            vm.alert = null;
	                            $uibModalInstance.close({error: data.error, message: data.body});
	                        }else {
	                            vm.alert = data.body;
	                            // In case of a failed validation you need to reload the captcha because each challenge can be checked just once
	                          vcRecaptchaService.reload($scope.widgetId);
	                        }
	                    } else {
	                        vm.alert = 'booking process failed, empty response received!';
	                      vcRecaptchaService.reload($scope.widgetId);// In case of a failed validation you need to reload the captcha because each challenge can be checked just once-
	                    }
	                    return data;
	                }, function(data) {
	                    vm.isLoading = false;
	                    vm.alert =  data || 'booking process failed, empty response received!';
	                  vcRecaptchaService.reload($scope.widgetId);// In case of a failed validation you need to reload the captcha because each challenge can be checked just once
	                });
	        }

	        function getBookingData(){
	            var args = {};
	            console.log(vm.data,'my modalModel');
	            //convert to moment if date
	            console.log(vm.modalModel,'modelmodel vm');
	            var start = vm.modalModel.start && !moment.isMoment(vm.modalModel.start) ? moment(vm.modalModel.start) : vm.modalModel.start;
	            var end = vm.modalModel.end && !moment.isMoment(vm.modalModel.end) ? moment(vm.modalModel.end) : vm.modalModel.end;

	            if (vm.isQuickBooking) {
	                //The user is not logged
	                args = {
	                    email: vm.data.cEmail,
	                    fName: vm.data.fName,
	                    lName: vm.data.lName,
	                    comment: vm.data.comment,
	                    phone :  vm.data.phone,
	                    captcha: vm.data.captcha,
	                    refName:  vm.data.refName,

	                    fullDateStart: start ? start.format() : null, //toUTCString(),
	                    fullDateEnd:  end ? end.format() : null, //toUTCString(),
	                    therapistId:  vm.modalModel.therapistId,
	                    workTypeId:  vm.modalModel.workTypeId,
	                    locationId:  vm.modalModel.locationId,
	                    shiftlistID:  vm.modalModel.shiftlistID,
	                    dayID:  vm.modalModel.dayID,
	                   

	                    reseller: vm.session ? vm.session.reseller : null,
	                    isQuickBooking: vm.isQuickBooking
	                };
	            } else {
	                //User is logged

	                args = {
	                    email: vm.session.email,
	                    sessionId: vm.session.sessionId,

	                    comment: vm.data.comment,
	                    refName:  vm.data.refName,

	                    fullDateStart:  start ? start.format() : null, //.toUTCString(),
	                    fullDateEnd: end ?  end.format() : null, //.toUTCString(),
	                    therapistId:  vm.modalModel.therapistId,
	                    workTypeId:  vm.modalModel.workTypeId,
	                    locationId:  vm.modalModel.locationId,
	                    shiftlistID:  vm.modalModel.shiftlistID,
	                    dayID:  vm.modalModel.dayID,
	                    // refName:  vm.modalModel.refName,

	                    isQuickBooking: vm.isQuickBooking
	                };
	            }

	            return angular.extend({}, vm.modalModel, args);
	        }

	        function newTime(timeStr){
	          var hours=0, minutes =0, seconds = 0;
	          if(timeStr && typeof timeStr == 'string'){
	            var splitime = timeStr.split(':');
	            if(splitime[0]) hours = splitime[0];
	            if(splitime[1]) minutes = splitime[1];
	            if(splitime[2]) seconds = splitime[2];
	          }

	          seconds = seconds ? seconds : 0;
	          var time = new Date();
	          time.setHours(hours);
	          time.setMinutes(minutes);
	          time.setSeconds(seconds);
	          //this is required, otherwise rollover edges cases tests will have
	          //time reset to dates that are off by milliseconds.
	          time.setMilliseconds(0);
	          return time;
	        }

	        function startTimeChanged(){
	          if(!vm.data.startTime) return;

	          if(!vm.modalModel.start){
	            vm.modalModel.start = vm.data.startTime;
	          }else{
	            vm.modalModel.start.setHours(vm.data.startTime.getHours());
	            vm.modalModel.start.setMinutes(vm.data.startTime.getMinutes());
	            vm.modalModel.start.setSeconds(0);
	          }
	        }
	    }
	})();


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	//layout.require.js
	__webpack_require__(219);
	//require('./ht-sidebar.directive.js');
	//require('./ht-top-nav.directive.js');
	__webpack_require__(220);
	__webpack_require__(221);
	//require('./sidebar.controller.js');
	__webpack_require__(222);

	__webpack_require__(223);


/***/ },
/* 219 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular.module('app.layout', []); //'app.core'
	})();


/***/ },
/* 220 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('app.layout')
	        .controller('LayoutController', LayoutController);

	    LayoutController.$inject = [ '$stateParams', 'dataservice'];
	    /*@ngInject*/
	    function LayoutController($stateParams, dataservice){

	        setEmbded();

	        function setEmbded(){
	            if($stateParams.embded){
	                dataservice.page.setEmbded($stateParams.embded);
	            }
	        }
	    }
	})();


/***/ },
/* 221 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('app.layout')
	        .controller('ShellController', ShellController);

	    /* @ngInject */
	    function ShellController($timeout, config, logger, translateFilter) {
	        var vm = this;
	        vm.busyMessage = translateFilter('ADVISOR_PLEASE_WAIT');
	        vm.isBusy = true;
	        vm.showSplash = true;
	        vm.footerData = {};
	        vm.setFooter = setFooter;


	        activate();

	        function activate() {
	            // logger.success( translateFilter('ADVISOR_LOADED') , null);
	            hideSplash();
	        }



	        function setFooter(data){
	            vm.footer = data;
	        }
	        function hideSplash() {
	            //Force a 1 second delay so we can see the splash.
	            $timeout(function() {
	                vm.showSplash = false;
	            }, 1000);
	        }
	    }
	    ShellController.$inject = ["$timeout", "config", "logger", "translateFilter"];
	})();


/***/ },
/* 222 */
/***/ function(module, exports) {

	(function() {
	    'use strict';

	    angular
	        .module('app.layout')
	        .controller('AppController', AppController);

	    /*@ngInject*/
	    function AppController($state, $stateParams, DOMAIN_UI, $anchorScroll, $location){
	        var vm = this;
	        vm.isFixedLayout = isFixedLayout;
	        vm.class={skin: DOMAIN_UI.skin};
	        vm.gotoAnchor = gotoAnchor;
	        vm.setSeo = setSeo;
	        vm.buildAbsoluteUrl = buildAbsoluteUrl;

	        vm.setFavicon = setFavicon;

	        function setFavicon(faviconLink){
	            //set favicon
	            vm.favicon = faviconLink;
	        }

	        function buildAbsoluteUrl(toState, params, locale){
	            var locale = {language:locale};
	            // if(toState){
	            //     console.debug('!!!!!+', toState);
	            //     return  $state.href(toState, params, {absolute: true})
	            // }else{
	                var logoutstate = $state.current.name;
	                // console.debug('!!!!!',$state.current, logoutstate, params);
	                return  $state.href(logoutstate, angular.extend({}, $stateParams, params, locale), {absolute: true})
	            // }
	        }

	        function setSeo(data){
	            if (!data){
	                return;
	            }

	            if(!  vm.seo){
	                vm.seo = {};
	            }
	            vm.seo.SEO_Description = data.SEO_Description;
	            vm.seo.SEO_Keywords = data.SEO_Keywords;
	            vm.seo.SEO_Title = data.SEO_Title;
	            vm.seo.SEO_hreflang = data.SEO_hreflang;

	            vm.favicon = data.faviconLink;

	            console.log('SEO_UPDATE', vm.seo);
	        }
	        function setSkinClass(skin){
	            if(skin){
	                if(!  vm.class){
	                    vm.class = {};
	                }
	                vm.class.skin = skin;
	            }
	        }
	        function isFixedLayout(){
	            return $state.includes('advisor') || $state.includes('advisor_w') || $state.includes('advisor_wl');
	        }

	        function gotoAnchor(x) {
	            var newHash = 'anchor' + x;
	            if ($location.hash() !== newHash) {
	                // set the $location.hash to `newHash` and
	                // $anchorScroll will automatically scroll to it
	                $location.hash('anchor' + x);
	            } else {
	                // call $anchorScroll() explicitly,
	                // since $location.hash hasn't changed
	                $anchorScroll();
	            }
	        }
	    }
	    AppController.$inject = ["$state", "$stateParams", "DOMAIN_UI", "$anchorScroll", "$location"];

	})();


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	    'use strict';

	    angular
	        .module('app.layout')
	        .run(appRun);

	    /* @ngInject */
	    function appRun(routerHelper, DOMAINCONFIG, DOMAINMODE) {
	        var stateConfig = getStates();
	        //console.log('DOMAINCONFIG = ', JSON.stringify(DOMAINCONFIG));
	        if(DOMAINCONFIG && ! _.isEmpty(DOMAINCONFIG)) {
	            if(DOMAINMODE != 'l'){
	                stateConfig[0].config.params = DOMAINCONFIG;
	            }
	        }
	        console.log('state = ',stateConfig);
	        routerHelper.configureStates(stateConfig);
	    }
	    appRun.$inject = ["routerHelper", "DOMAINCONFIG", "DOMAINMODE"];

	    function getStates() {
	        return [
	            {
	                state: 'layout',
	                config: {
	                    url:  '/{language:(?:fr|en)}', // '/{language:[fr|en]}', // '/:language?embded', //
	                    controller:'LayoutController',
	                    abstract: true,
	                    template: __webpack_require__(224),
	                    resolve:{/*@ngInject*/
	                        language : ["$stateParams", function ($stateParams){
	                            return $stateParams.language;
	                        }]
	                    }
	                }
	            }
	        ];
	    }
	})();


/***/ },
/* 224 */
/***/ function(module, exports) {

	module.exports = "<div ng-controller=\"ShellController as vmShell\"><ui-view></ui-view><footer ng-if=!embded.noHeader class=main-footer ng-include=\"'app/layout/footer.html'\"></footer></div>";

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/4/15.
	 */
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);


/***/ },
/* 226 */
/***/ function(module, exports) {

	(function() {
	    'use strict';
	    angular.module('app.login', []);
	})();


/***/ },
/* 227 */
/***/ function(module, exports) {

	(function () {
	    'use strict';

	    angular
	        .module('app.login')
	        .controller('LoginController', LoginController);

	    /* @ngInject */
	    function LoginController($q, dataservice, logger, loginServices, $uibModalInstance, $stateParams) {
	        var vm = this;
	        vm.forgetPassword = false ;
	        vm.title = 'Login';
	        vm.isCPhone = false ;
	        vm.fName = false ;
	        vm.alert=null; /*message alert*/
	        vm.login={}; /*email, password, remember*/
	        vm.sendPassword={};/*Email*/

	        vm.cId = $stateParams.cId;

	        vm.signIn = signIn;
	        vm.forgetPasswordFunction = forgetPasswordFunction;


	        activate();

	        function activate() {
	            var promises = []; //
	            return $q.all(promises).then(function() {
	                // logger.info('Activated Login View');
	            });
	        }
	        function signIn(){
	            vm.alert="";
	            return loginServices.signIn(vm.login, vm.cId)
	                .then(function(data){
	               if(data && (data.isCPhone === true  || data.fName === true) ){
	                 if(data && data.isCPhone === true){
	                       console.log(data,'in controller');
	                     vm.isCPhone = data.isCPhone;
	                 }
	                  if (data &&  data.fName === true ) {
	                     vm.fName = data.fName;
	             }
	               }
	              else{
	                console.log('no cphone');
	              closeModalOrShowAlert(data);
	               }



	                });
	        }

	          function setIsCphone (data){

	          vm.isCPhone = data;
	        }

	        // function signIn(){
	        //     vm.alert="";
	        //     return loginServices.signIn(vm.login.email, vm.login.password, vm.cId)
	        //         .then(closeModalOrShowAlert)
	        //         .catch(function(data){
	        //             vm.alert = data;
	        //         });
	        //
	        // }

	        function closeModalOrShowAlert(data){
	          console.log(data,'response connection');
	            if(data && (!data.error || data.error === 0)){
	                vm.login={}; /*email, password, remember*/
	                $uibModalInstance.close({error: 0, message: "Connected"});
	            }else{
	                vm.alert = data ? data.body : 'empty response received';
	            }
	            return data;
	        }
	        vm.forgetPasswordActive = function (){
	          vm.isCPhone = false ;
	          vm.fName = false ;
	          vm.forgetPassword = !vm.forgetPassword
	        }
	        function forgetPasswordFunction() {
	            vm.alert="";
	//            vm.sendPassword={};/*Email*/
	       console.log( vm.sendPassword ,'before');
	            if(vm.isCPhone === false){
	              delete vm.sendPassword.isCPhone;
	            }
	            if(vm.fName === false){
	              delete vm.sendPassword.fName;
	            }
	            console.log( vm.sendPassword ,'after');
	            return dataservice.login.sendPassword(vm.clinicId, vm.sendPassword )
	                .then(function (data) {
	                  if(data && (data.isCPhone === true || data.fName === true)){
	                      console.log(data,'in controller');
	                    if(data.isCPhone === true){
	                    vm.isCPhone = true;
	                    }
	                    if(data.fName === true){
	                    vm.fName = true;
	                    }

	                  }
	                  else {
	                    console.log(data ,'send password response');
	                      vm.login = data;
	                      $uibModalInstance.close({error: 0, message: data.body});
	                      return data;
	                  }

	            });

	        }
	    }
	    LoginController.$inject = ["$q", "dataservice", "logger", "loginServices", "$uibModalInstance", "$stateParams"];
	})();


/***/ },
/* 228 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 12/03/15.
	 */
	(function () {
	    'use strict';

	    angular
	        .module('app.login')
	        .directive('obtLogin', obtLogin);

	    function obtLogin () {
	        var directive = {
	            //link: link,
	//            transclude:true,
	            controller:obtLoginCtlr,
	            controllerAs:'vmLogin',
	            restrict:'EA',
	            replace:true,
	            template:'<li class="tasks-menu">\n    <button ng-if="!vmLogin.isLogged()" href="" ng-click="signIn()" class="navbar-btn btn btn-secondary-outline" >{{\'SIGN_IN\'|translate}}</button>\n    <button ng-if="vmLogin.isLogged()" href="#" class="navbar-btn btn btn-secondary-outline dropdown-toggle" data-toggle="dropdown">{{vmLogin.userName()}}<span class="caret"></span></button>\n    <ul ng-if="vmLogin.isLogged()" class="dropdown-menu" role="menu">\n        <li>\n            <ul class="menu">\n                <li><a href ng-click="vmLogin.openPreference()"><h3>{{\'PREFERENCE\'|translate}}</h3></a></li>\n                <li><a href ng-click="vmLogin.openHistory()"><h3>{{\'HISTORY\'|translate}}</h3></a></li>\n                <li ng-if="vmLogin.isReseller()"><a  href ng-click="vmLogin.openResellerReport()"><h3>{{\'RESELLER_REPORT\'|translate}}</h3></a></li>\n                <!--<li class="divider"></li>-->\n                <li><a href ng-click="vmLogin.signOut()"><h3>{{\'LOG_OUT\' | translate}}</h3></a></li>\n            </ul>\n        </li>\n    </ul>\n    <obt-modal-popup\n            title=\'login\'\n            open-modal-promise=\'signIn\'\n            template-url=\'app/login/signIn.html\'\n            template-controller=\'LoginController as vmLogin\'>\n    </obt-modal-popup>\n</li>'
	        };
	        return directive;
	    }

	    //obtLoginCtlr.$inject=['loginServices', '$state', '$stateParams', 'logger'];
	    /*@ngInject*/
	    function obtLoginCtlr(loginServices, $state, $stateParams, logger){
	        var vm = this;
	        vm.session = loginServices;
	        vm.isLogged = isLogged;
	        vm.isReseller = isReseller;
	        vm.signOut = signOut;
	        vm.userName = getUserName;
	        vm.openPreference = openPreference;
	        vm.openHistory = openHistory;
	        vm.openResellerReport = openResellerReport;

	        function openResellerReport(){
	            if(isLogged() && isReseller()) {
	                var params = {
	                    uId: loginServices.status.uId,
	                    cId: $stateParams.cId,
	                    tId: $stateParams.tId
	                };
	                var resellerState = $state.current.resellerState ? $state.current.resellerState : 'resellerBookingReport';

	                $state.go(resellerState, params);
	            }else{
	                logger.info('user not logged');
	            }
	        }

	        function openPreference(){

	            if(isLogged()) {
	                var params = {
	                    uId: loginServices.status.uId,
	                    cId: $stateParams.cId,
	                    tId: $stateParams.tId
	                };
	                var preferenceState = $state.current.preferenceState ? $state.current.preferenceState : 'preference';

	                $state.go(preferenceState, params);
	            }else{
	                logger.info('user not logged');
	            }
	        }

	        function openHistory(){

	            if(isLogged()) {
	                var params = {
	                    uId: loginServices.status.uId,
	                    cId: $stateParams.cId,
	                    tId: $stateParams.tId
	                };
	                var historyState = $state.current.historyState ? $state.current.historyState : 'history';

	                $state.go(historyState, params);
	            }else{
	                logger.info('user not logged');
	            }
	        }
	        function getUserName (){
	            return loginServices.status ? loginServices.status.fName + ' ' + loginServices.status.lName  : "";
	        }
	        function isLogged(){
	            return loginServices.status && loginServices.status.isLogged;
	        }
	        function isReseller(){
	            return loginServices.status && loginServices.status.reseller;
	        }
	        function signOut(){
	            loginServices.signOut().then(function(){
	                // Redirect to selected page, or stay on the same page
	                var logoutState = $state.current.logoutState;
	                if(logoutState){
	                    $state.go(logoutState, $stateParams, {reload:true});
	                }
	            });
	        }
	    }
	    obtLoginCtlr.$inject = ["loginServices", "$state", "$stateParams", "logger"];
	    //function link(scope, element, attrs) {
	    //}
	})();


/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * Created by pmnia on 12/03/15.
	 */
	(function () {
	    'use strict';

	    angular
	        .module('app.login')
	        .directive('obtUpdateSectionDirective', obtUpdateSectionDirective);

	    function obtUpdateSectionDirective () {
	        var directive = {
	          scope:{
	            data:'=?',
	            pageId:'@?',
	            pageSectionId:'@?',
	            type:'@?',
	            anchor:'@?'
	          },
	            controller:obtSectionUpdateCtlr,
	            restrict:'EA',
	            replace:true,
	             templateUrl:'app/login/updateSectionDirective/updateSectionDirective.html'



	              };
	        return directive;
	    }

	    //obtLoginCtlr.$inject=['loginServices', '$state', '$stateParams', 'logger'];
	    /*@ngInject*/
	    function obtSectionUpdateCtlr($scope,loginServices, $state, $stateParams, logger,$rootScope){

	      $scope.getData = function (){
	        var obj = {};
	        if($scope.type === '7' || $scope.type === '9'){
	          var items = $rootScope.pageSection ;
	                angular.forEach(items , function (value){
	                          if(value.anchor === $scope.anchor && value.data){
	                                  $scope.data = value.data ;
	                          }
	               })
	        }

	          obj = {type : $scope.type , anchor : $scope.anchor ,data : $scope.data , pageId : $scope.pageId ,pageSectionId : $scope.pageSectionId};
	           console.log(obj , 'my objet');
	           return obj;
	      }
	    }
	    obtSectionUpdateCtlr.$inject = ["$scope", "loginServices", "$state", "$stateParams", "logger", "$rootScope"];
	    //function link(scope, element, attrs) {
	    //}
	})();


/***/ },
/* 230 */
/***/ function(module, exports) {

	/**
	 * Created by LENOVO T440 on 27/09/2017.
	 */




	(function () {
	    'use strict';

	    angular
	        .module('app.login')
	        .controller('updateSectionController', updateSectionController);

	    /* @ngInject */
	    function updateSectionController($scope,modalModel,queryservice,sessionServices,obtGalleryService,$stateParams,languageServices,dataservice,$timeout) {
	      loadComboBox()
	      .then(setOptions)
	      .then(setLanguage);
	      $scope.getGalleryForDirective = getGalleryForDirective ;
	      $scope.notifyMsg = notifyMsg
	      $scope.galeryTamp = [];
	      $scope.options = [];
	      $scope.languageKey = {} ;
	      $scope.updateGalleryData = updateGalleryData;
	      console.log(sessionServices.getSession(), 'mes donnees ');
	      $scope.model = modalModel ;
	      $scope.currentSession = sessionServices.getSession();
	      $scope.updateData = updateData ;
	        //function closeModalOrShowAlert(data){
	        //    if(data && (!data.error || data.error === 0)){
	        //        vm.login={}; /*email, password, remember*/
	        //        $uibModalInstance.close({error: 0, message: "Connected"});
	        //    }else{
	        //        vm.alert = data ? data.body : 'empty response received';
	        //    }
	        //    return data;
	        //}
	        function setgalleryTamp (data){
	            $scope.galeryTamp = data ;
	        }



	          // angular.forEach(response,function(values){
	          //
	          //
	          // })
	          function  getGalleryForDirective (){
	                var args = {uId:sessionServices.getSession().uId , galleryId :modalModel.data.galleryId};
	                obtGalleryService.getItems(args).
	                 then(function (response){
	                   return response ;
	                 })
	                }
	        function  getGallery (){
	              var args = {uId:sessionServices.getSession().uId , galleryId :modalModel.data.galleryId};
	              obtGalleryService.getItems(args).
	               then(function (response){
	                 UpdateGallery(response,$scope.model.data.gallery)
	               })
	              }
	              function helpUpdateGalleryType7_9(serveur,client,direction){
	                  if(direction === 'serveur'){
	                    angular.forEach(serveur,function(value,key){
	                          angular.forEach($scope.model.data.gallery,function(values,keys){
	                                  if(value.galleryItemId === values.galleryItemId){
	                                          value.thumbUrl = values.thumbUrl ;
	                                          value.url = values.url ;
	                                              angular.forEach(values.details,function(valueDetail,keyDetail){
	                                                if(valueDetail.localeId === $scope.languageKey){
	                                                  valueDetail.name = ((values.title).replace(/<[^>]*>/g,"")).replace(/↵/g, "");
	                                                   valueDetail.description = values.description;
	                                       }
	                                             })

	                                    }

	                          })
	                     })


	                  }
	               }
	              function helpUpdateGalleryType4(serveur,client,direction){
	                if(direction === 'serveur'){
	                  angular.forEach(serveur,function(value,key){
	                        angular.forEach($scope.model.data.gallery,function(values,keys){
	                                if(value.galleryItemId === values.galleryItemId){
	                                        value.thumbUrl = value.url = values.bgImg ;
	                                            angular.forEach(values.details,function(valueDetail,keyDetail){
	                                              if(valueDetail.localeId === $scope.languageKey){
	                                                valueDetail.name = ((values.title).replace(/<[^>]*>/g,"")).replace(/↵/g, "");
	                                                 valueDetail.description = values.description;
	                                     }
	                                           })

	                                  }

	                        })
	                   })


	                }
	             }
	              function helpUpdateGalleryType8(serveur,client,direction){
	                 if(direction === 'serveur'){
	                   angular.forEach(serveur,function(value,key){
	                         angular.forEach($scope.model.data.gallery,function(values,keys){
	                                 if(value.galleryItemId === values.galleryItemId){
	                                         value.thumbUrl = value.url = values.avatar ;
	                                             angular.forEach(values.details,function(valueDetail,keyDetail){
	                                               if(valueDetail.localeId === $scope.languageKey){
	                                             valueDetail.name = ((values.title).replace(/<[^>]*>/g,"")).replace(/↵/g, "");
	                                              valueDetail.description = values.description;
	                                      }
	                                            })

	                                   }

	                         })
	                    })


	                 }
	              }
	// function UpdateGallery(serveur,client){
	//   switch (modalModel.type) {
	//   case "7":
	//      console.log("type7");
	//      console.log(client,'client');
	//      console.log(serveur,'serveur');
	//      helpUpdateGalleryType7_9(serveur,client,'serveur');
	//     console.log('after',serveur);
	//     break;
	//   case "8":
	//     console.log("type8");
	//     console.log(client,'client');
	//     console.log(serveur,'serveur');
	//     helpUpdateGalleryType8(serveur,client,'serveur');
	//       console.log('after',serveur);
	//     break;
	//   case "4":
	//     console.log("type4");
	//     console.log(client,'client');
	//     console.log(serveur,'serveur');
	//     helpUpdateGalleryType4(serveur,client,'serveur');
	//     console.log('after',serveur);
	//     break;
	//   case "9":
	//     console.log("type9");
	//     console.log(client,'client');
	//     console.log(serveur,'serveur');
	//     helpUpdateGalleryType7_9(serveur,client,'serveur');
	//       console.log('after',serveur);
	//     break;
	//   default:
	//     console.log("Désolé, nous n'avons pas de gallery.");
	//
	// }
	//
	//
	// return $scope.notifyMsg(
	//   obtGalleryService.updateItem(serveur)
	//   .then(function (response) {
	//       console.log('update done');
	//       console.log(response);
	//       return response;
	//   })
	// );
	//
	// }

	function updateGalleryData(){
	  console.log($scope.model,'my newModalModel');
	  console.log(modalModel,'my newModalModel');

	}
	function notifyMsg(promise){
	    if(promise) {
	        promise.then(function success(response) {
	            if (response && response.error && response.error == 1) {
	                toaster.pop('error', '', response.body);
	            } else {
	                toaster.pop('success', translateFilter('SUCCESS'), response.body);
	            }
	        });
	    }
	    return promise;
	}
	function  updateData(){
	if(modalModel.type === '4' || modalModel.type === '7' || modalModel.type === '8' || modalModel.type === '9' ){
	  getGallery() ;
	}
	else {
	  alert('pas de gLLERU');
	}
	//  console.log($scope.model,'my modelData');
	}
	        function setOptions(options){
	            $scope.options = options;
	            return options ;
	        }
	        function setLanguage(options){
	          console.log(options,'my options');
	              $scope.languageKey = dataservice.form.findOptionNamePerCODE(sessionServices.getSession().language,options.languages);
	        }
	        function loadComboBox(params) {
	            var cbIdList = params || [
	                    {'id': 7, 'name': 'languages'},
	                    {'id': 30, 'name': 'types'},
	                    {'id': 31, 'name': 'shapes'},
	                    {'id': 64, 'name': 'csss'},
	                    {'id': 69, 'name': 'sizes'},
	                    {'id': 71 ,'name': 'items'},
	                    {'id': 92 ,'name': 'boxs'},
	                    {'id': 93 ,'name': 'fuls'},
	                    {'id': 80 ,'name': 'buttonTypes'},
	                    {'id': 9, 'name': 'worktypes'}
	                ];
	            return queryservice.getFormOptions(cbIdList, undefined, undefined, {isTool: true}).then(
	                function success(result) {
	                  console.log(result,'advisor');
	                    return result;
	                }
	              )
	        }
	    }
	    updateSectionController.$inject = ["$scope", "modalModel", "queryservice", "sessionServices", "obtGalleryService", "$stateParams", "languageServices", "dataservice", "$timeout"];
	})();


/***/ },
/* 231 */
/***/ function(module, exports) {

	(function () {
	  'use strict';

	  /*
	   * Angular matchMedia Module
	   * Version 0.6.0
	   * Uses Bootstrap 3 breakpoint sizes
	   * Exposes service "screenSize" which returns true if breakpoint(s) matches.
	   * Includes matchMedia polyfill for backward compatibility.
	   * Copyright © Jack Tarantino <https://jack.ofspades.com>.
	   **/


	  var app = angular.module('matchMedia', []);


	  app.run(function initializeNgMatchMedia() {
	    /*! matchMedia() polyfill - Test a CSS media type/query in JS.
	     * Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight.
	     * Dual MIT/BSD license
	     **/

	    window.matchMedia || (window.matchMedia = function matchMediaPolyfill() {

	      // For browsers that support matchMedium api such as IE 9 and webkit
	      var styleMedia = (window.styleMedia || window.media);

	      // For those that don't support matchMedium
	      if (!styleMedia) {
	        var style = document.createElement('style'),
	          script = document.getElementsByTagName('script')[0],
	          info = null;

	        style.type = 'text/css';
	        style.id = 'matchmediajs-test';

	        script.parentNode.insertBefore(style, script);

	        // 'style.currentStyle' is used by IE <= 8
	        // 'window.getComputedStyle' for all other browsers
	        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

	        styleMedia = {
	          matchMedium: function (media) {
	            var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

	            // 'style.styleSheet' is used by IE <= 8
	            // 'style.textContent' for all other browsers
	            if (style.styleSheet) {
	              style.styleSheet.cssText = text;
	            } else {
	              style.textContent = text;
	            }

	            // Test if media query is true or false
	            return info.width === '1px';
	          }
	        };
	      }

	      return function (media) {
	        return {
	          matches: styleMedia.matchMedium(media || 'all'),
	          media: media || 'all'
	        };
	      };
	    }());
	  });

	  //Service to use in controllers
	  app.service('screenSize', screenSize);

	  screenSize.$inject = ['$rootScope'];

	  function screenSize($rootScope) {

	    var defaultRules = {
	      lg: '(min-width: 1200px)',
	      md: '(min-width: 992px) and (max-width: 1199px)',
	      sm: '(min-width: 768px) and (max-width: 991px)',
	      xs: '(max-width: 767px)'
	    };

	    this.isRetina = (
	    	window.devicePixelRatio > 1 ||
	    	(window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),(min-device-pixel-ratio: 1.5),(min-resolution: 192dpi),(min-resolution: 2dppx)').matches)
	    );

	    var that = this;

	    // Executes Angular $apply in a safe way
	    var safeApply = function (fn, scope) {
	      scope = scope || $rootScope;
	      var phase = scope.$root.$$phase;
	      if (phase === '$apply' || phase === '$digest') {
	        if (fn && (typeof (fn) === 'function')) {
	          fn();
	        }
	      } else {
	        scope.$apply(fn);
	      }
	    };

	    // Validates that we're getting a string or array.
	    // When string: converts string(comma seperated) to an array.
	    var assureList = function (list) {

	      if (typeof list !== 'string' && Object.prototype.toString.call(list) !== '[object Array]') {
	        throw new Error('screenSize requires array or comma-separated list');
	      }

	      return typeof list === 'string' ? list.split(/\s*,\s*/) : list;
	    };

	    var getCurrentMatch = function () {
	      var rules = that.rules || defaultRules;

	      for (var property in rules) {
	        if (rules.hasOwnProperty(property)) {
	          if (window.matchMedia(rules[property]).matches) {
	            return property;
	          }
	        }
	      }
	    };
	    
	    // Return the actual size (it's string name defined in the rules)
	    this.get = getCurrentMatch;

	    this.is = function (list) {
	      list = assureList(list);
	      return list.indexOf(getCurrentMatch()) !== -1;
	    };

	    // Executes the callback function on window resize with the match truthiness as the first argument.
	    // Returns the current match truthiness.
	    // The 'scope' parameter is optional. If it's not passed in, '$rootScope' is used.
	    this.on = function (list, callback, scope) {
	      window.addEventListener('resize', listenerFunc);

	      if (scope) {
	        scope.$on('$destroy', function () {
	          window.removeEventListener('resize', listenerFunc);
	        });
	      }

	      return that.is(list);

	      function listenerFunc() {
	        safeApply(callback(that.is(list)), scope);
	      }
	    };

	    // Executes the callback function ONLY when the match differs from previous match.
	    // Returns the current match truthiness.
	    // The 'scope' parameter is required for cleanup reasons (destroy event).
	    this.onChange = function (scope, list, callback) {
	      var currentMatch = getCurrentMatch();
	      list = assureList(list);
	      if (!scope) {
	        throw 'scope has to be applied for cleanup reasons. (destroy)';
	      }

	      window.addEventListener('resize', listenerFunc);

	      scope.$on('$destroy', function () {
	        window.removeEventListener('resize', listenerFunc);
	      });

	      return that.is(list);

	      function listenerFunc() {
	        var previousMatch = currentMatch;
	        currentMatch = getCurrentMatch();

	        var wasPreviousMatch = list.indexOf(previousMatch) !== -1;
	        var doesCurrentMatch = list.indexOf(currentMatch) !== -1;
	        if (wasPreviousMatch !== doesCurrentMatch) {
	          safeApply(callback(doesCurrentMatch), scope);
	        }
	      }
	    };

	    // Executes the callback only when inside of the particular screensize.
	    // The 'scope' parameter is optional. If it's not passed in, '$rootScope' is used.
	    this.when = function (list, callback, scope) {
	      window.addEventListener('resize', function () {
	        if (that.is(list) === true) {
	          safeApply(callback(that.is(list)), scope);
	        }
	      });

	      return that.is(list);
	    };
	  }

	  app.filter('media', ['screenSize', function (screenSize) {

	    var mediaFilter = function (inputValue, options) {
	      // Get actual size
	      var size = screenSize.get();

	      // Variable for the value being return (either a size/rule name or a group name)
	      var returnedName = '';

	      if (!options) {
	        // Return the size/rule name
	        return size;
	      }

	      // Replace placeholder with group name in input value
	      if (options.groups) {
	        for (var prop in options.groups) {
	          if (options.groups.hasOwnProperty(prop)) {
	            var index = options.groups[prop].indexOf(size);
	            if (index >= 0) {
	              returnedName = prop;
	            }
	          }
	        }

	        // If no group name is found for size use the size itself
	        if (returnedName === '') {
	          returnedName = size;
	        }
	      }

	      // Replace or return size/rule name?
	      if (options.replace && typeof options.replace === 'string' && options.replace.length > 0) {
	        return inputValue.replace(options.replace, returnedName);
	      } else {
	        return returnedName;
	      }
	    };

	    // Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	    // have to explicit define this behavior.
	    mediaFilter.$stateful = true;
	    return mediaFilter;
	  }]);

	})();


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	(function() {
	    var app = angular.module('app');
	    app.config(['$stateProvider', 'DOMAIN_UI', '$locationProvider', '$ocLazyLoadProvider','$sceDelegateProvider',
	        function ($stateProvider, DOMAIN_UI, $locationProvider, $ocLazyLoadProvider,$sceDelegateProvider) {

	            var config = {
	                docTitle: undefined,
	                resolveAlways: {},
	                parent:'layout'
	            };
	            $sceDelegateProvider.resourceUrlWhitelist([
	                'self',
	                'https://www.youtube.com/**',
	                '*://www.youtube.com/**',
	                '*://www.vimeo.com/**',
	                '*://player.vimeo.com/**'

	            ]);

	            // with lazy loading
	            $stateProvider

	                //.state('pageOracle', { // when page is nor found then this state is caller
	                //    //abstract:true,
	                //    url: '/oracle',
	                //    parent: config.parent,
	                //    resolve:{
	                //        fallback : /*@ngInject*/function ($q, dataservice, $state, $location){
	                //            //call server to gert the
	                //            //var currentStateData = {
	                //            //    Name: $state.current.name,
	                //            //    Params: $state.params,
	                //            //    URL: $state.href($state.current.name, $state.params)
	                //            //};
	                //            console.log($location.absUrl());
	                //            dataservice.oracle.getFallbackPage({url:$location.absUrl()})
	                //                .then(function(data){
	                //
	                //                        //call redirection
	                //                        if(data && data.page) {
	                //                            $state.go(data.page, angular.extend({}, data.args));
	                //                        }else{
	                //                            $state.go('404', {language: 'fr'});
	                //                        }
	                //
	                //                        return $q.reject('Error!');
	                //                    }
	                //                    ,function(){ // if error, we redirect to 404
	                //                        $state.go('404', {language: 'fr'});
	                //                        return $q.reject('Error!');
	                //                    })
	                //        }
	                //    }
	                //})

	                //Association
	                .state('association', {
	                    url: '/a/:cId',
	                    controller: 'AssociationController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'association',
	                    data:{
	                        home: 'association',
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Association'
	                    },
	                    obtVid : 2,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(1, function () {
	                            //var isMobile = false;
	                            //var templateName = isMobile ? './association/association_mobile.html' : './association/association.html';
	                            //var templateName = './association/association.html';
	                            var template = __webpack_require__(233);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(2, function () {
	                                __webpack_require__(234);
	                                __webpack_require__(235);
	                                $ocLazyLoad.load({
	                                    name: 'app.association'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('therapistMaster', {
	                    abstract: true,
	                    url: '/t/:cId/:tId',
	                    controller: 'TherapistMasterController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'therapistMaster',
	                    data:{
	                        home: 'therapistClinic',
	                    },
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(3, function () {
	                            var template = __webpack_require__(236);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(4, function () {
	                                __webpack_require__(237);
	                                __webpack_require__(238);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapistMaster'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],

	                      data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                        return dataservice.page.getFooterContent($stateParams.cId, $stateParams.tId);
	                      }]
	                    }
	                })

	                .state('clinicMaster', {
	                    abstract: true,
	                    url: '/c/:cId',
	                    controller: 'ClinicMasterController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'clinicMaster',
	                    data:{
	                        home: 'clinic',
	                    },
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(5, function () {
	                            var template = __webpack_require__(239);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(6, function () {
	                                __webpack_require__(240);
	                                __webpack_require__(241);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinicMaster'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('therapist', {
	                    parent : 'clinicMaster',
	                    url: '/t/:tId',
	                    controller: 'TherapistController',
	                    controllerAs: 'vm',
	                    title: 'therapist',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Therapist'
	                    },
	                    obtVid : 1,
	                    obtPage: 2,
	                    logoutState : 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                      var deferred = $q.defer();
	                      __webpack_require__.e/* nsure */(7, function () {
	                        var template = (DOMAIN_UI.mode == 2)
	                          ? __webpack_require__(242)
	                          : __webpack_require__(243);
	                        // var template = require('html!./therapist/therapist.html');
	                        deferred.resolve(template);
	                      });
	                      return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(8, function () {
	                                __webpack_require__(244);
	                                __webpack_require__(245);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapist'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_profile: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            console.log('therapistConfig');
	                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);

	                        }],
	                        data_calendar: /*@ngInject*/["module", "dataservice", "$stateParams", function(module, dataservice, $stateParams){
	                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('clinic', {
	                    parent : 'clinicMaster',
	                    url: '',
	                    controller: 'ClinicController',
	                    controllerAs: 'vm',
	                    title: 'clinic',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Clinic'
	                    },
	                    obtVid : 1,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(9, function () {
	                            var template = __webpack_require__(246);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(10, function () {
	                                __webpack_require__(247);
	                                __webpack_require__(248);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinic'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        calendarProfile:/*@ngInject*/["module", "dataservice", "$stateParams", function (module, dataservice, $stateParams){
	                            return dataservice.calendar.getProfile($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('therapistClinic', {
	                    parent: 'therapistMaster',
	                    url: '',
	                    controller: 'TherapistController',
	                    controllerAs: 'vm',
	                    title: 'Therapist - Clinic',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Therapist'
	                    },
	                    //resolve:{
	                    //    calendarProfile:getCalendarProfile
	                    //},
	                    obtVid: 3,
	                    obtPage: 2,
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(11, function () {
	                            var template = __webpack_require__(243);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(8/* duplicate */, function () {
	                                __webpack_require__(244);
	                                __webpack_require__(245);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapist'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_profile: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            console.log('therapistClinicConfig');
	                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);

	                        }],
	                        data_calendar: /*@ngInject*/["module", "dataservice", "$stateParams", function(module, dataservice, $stateParams){
	                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('preference', {
	                    parent : 'clinicMaster',
	                    url: '/p/:uId',
	                    controller: 'PreferenceController',
	                    controllerAs: 'vm',
	                    title: 'preference',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Preference'
	                    },
	                    obtVid : 1,
	                    obtPage: 3,
	                    logoutState : 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(12, function () {
	                            var template = __webpack_require__(249);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(13, function () {
	                                __webpack_require__(250);
	                                __webpack_require__(251);
	                                $ocLazyLoad.load({
	                                    name: 'app.preference'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('preferenceTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/p/:uId',
	                    controller: 'PreferenceController',
	                    controllerAs: 'vm',
	                    title: 'preference',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Preference'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapistClinic',
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(12/* duplicate */, function () {
	                            var template = __webpack_require__(249);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(13/* duplicate */, function () {
	                                __webpack_require__(250);
	                                __webpack_require__(251);
	                                $ocLazyLoad.load({
	                                    name: 'app.preference'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('history', {
	                    parent : 'clinicMaster',
	                    url: '/h/:uId',
	                    controller: 'HistoryController',
	                    controllerAs: 'vm',
	                    title: 'history',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> History'
	                    },
	                    obtVid : 1,
	                    obtPage: 3,
	                    logoutState : 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(14, function () {
	                            var template = __webpack_require__(252);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(15, function () {
	                                __webpack_require__(253);
	                                __webpack_require__(254);
	                                $ocLazyLoad.load({
	                                    name: 'app.history'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('historyTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/h/:uId',
	                    controller: 'HistoryController',
	                    controllerAs: 'vm',
	                    title: 'history',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> History'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapistClinic',
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(14/* duplicate */, function () {
	                            var template = __webpack_require__(252);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(15/* duplicate */, function () {
	                                __webpack_require__(253);
	                                __webpack_require__(254);
	                                $ocLazyLoad.load({
	                                    name: 'app.history'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('dynamic', {
	                    parent: config.parent,
	                    url: '/dynamicPage/:cId/:kId',
	                    controller: 'DynamicController',
	                    controllerAs: 'vm',
	                    title: 'dynamic',
	                    // data:{
	                    //     home: '',
	                    // },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Dynamic'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(16, function () {
	                            var template = __webpack_require__(255);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(17, function () {
	                                __webpack_require__(256);
	                                __webpack_require__(257);
	                                $ocLazyLoad.load({
	                                    name: 'app.dynamic'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                //Parent set to clinic
	                .state('clinic.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid : 1,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }]
	                    }
	                })
	                //Parent set to therapist
	                .state('therapist.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid: 1,
	                    obtPage: 2,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }]
	                    }
	                })

	                //Parent set to therapistClinic
	                .state('therapistClinic.service', {
	                    //parent: 'therapistClinic',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid : 3,
	                    obtPage: 2,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('advisor_wl', {
	                    parent: config.parent,
	                    url: '/l/:cId/:wq/:lq',
	                    controller: 'AdvisorController',
	                    controllerAs: 'vm',
	                    title: 'advisor',
	                    data:{
	                        home: 'advisor_wl',
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Advisor'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(20, function () {
	                            var template = __webpack_require__(262);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(21, function () {
	                                __webpack_require__(263);
	                                __webpack_require__(264);
	                                $ocLazyLoad.load({
	                                    name: 'app.advisor'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('advisor_w', {
	                    parent: config.parent,
	                    url: '/l/:cId/:wq',
	                    controller: 'AdvisorController',
	                    controllerAs: 'vm',
	                    title: 'advisor',
	                    data:{
	                        home: 'advisor_w',
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Advisor'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(20/* duplicate */, function () {
	                            var template = __webpack_require__(262);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(21/* duplicate */, function () {
	                                __webpack_require__(263);
	                                __webpack_require__(264);
	                                $ocLazyLoad.load({
	                                    name: 'app.advisor'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('advisor', {
	                    parent: config.parent,
	                    url: '/l/:cId',
	                    controller: 'AdvisorController',
	                    controllerAs: 'vm',
	                    title: 'advisor',
	                    data:{
	                        home: 'advisor',
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Advisor'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(20/* duplicate */, function () {
	                            var template = __webpack_require__(262);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(21/* duplicate */, function () {
	                                __webpack_require__(263);
	                                __webpack_require__(264);
	                                $ocLazyLoad.load({
	                                    name: 'app.advisor'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('formly', {
	                    parent: config.parent,
	                    url: '/formly/:cId/:kId',
	                    controller: 'FormlyController',
	                    controllerAs: 'vm',
	                    title: 'formly',
	                    data:{
	                        home: 'formly',
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Formly'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(22, function () {
	                            var template = __webpack_require__(265);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(23, function () {
	                                //require('./../bower_components/apiCheck/dist/api-check.min.js');
	                                //require('./../bower_components/angular-formly/dist/formly.min.js');
	                                //require('./../bower_components/angular-formly-templates-bootstrap/dist/angular-formly-templates-bootstrap.min.js');
	                                __webpack_require__(266);
	                                __webpack_require__(267);
	                                $ocLazyLoad.load({
	                                    name: 'app.formly'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                //resellers report
	                .state('resellerBookingReport', {
	                    parent : 'clinicMaster',
	                    url: '/report/:uId',
	                    controller: 'resellerBookingReportCtrl',
	                    controllerAs: 'vm',
	                    title: 'report',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> report'
	                    },
	                    obtVid : 1,
	                    obtPage: 3,
	                    logoutState : 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(24, function () {
	                            var template = __webpack_require__(268);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module:['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(25, function () {
	                                __webpack_require__(269);
	                                __webpack_require__(270);
	                                __webpack_require__(271);
	                                $ocLazyLoad.load({
	                                    name: 'app.resellers'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        comboOptions : /*@ngInject*/["dataservice", "logger", "$stateParams", function loadComboBox(dataservice, logger, $stateParams){
	                            var options = [
	                                {'id': 10, 'name': 'therapists'}
	                            ];
	                            var args = {cId:$stateParams.cId || null };

	                            return dataservice.form.getOptions(options, {isTool:true}, args)
	                                .then(function(result){
	                                    if(result){
	                                        return result;
	                                    }else{
	                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
	                                        return [];
	                                    }
	                                });
	                        }]
	                    }
	                })

	                .state('resellerBookingReportTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/report/:uId',
	                    controller: 'resellerBookingReportCtrl',
	                    controllerAs: 'vm',
	                    title: 'report',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> report'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(24/* duplicate */, function () {
	                            var template = __webpack_require__(268);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module:['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(25/* duplicate */, function () {
	                                __webpack_require__(269);
	                                __webpack_require__(270);
	                                __webpack_require__(271);
	                                $ocLazyLoad.load({
	                                    name: 'app.resellers'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        comboOptions : /*@ngInject*/["dataservice", "logger", "$stateParams", function loadComboBox(dataservice, logger, $stateParams){
	                            var options = [
	                                {'id': 10, 'name': 'therapists'}
	                            ];
	                            var args = {cId:$stateParams.cId || null };

	                            return dataservice.form.getOptions(options, {isTool:true}, args)
	                                .then(function(result){
	                                    if(result){
	                                        return result;
	                                    }else{
	                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
	                                        return [];
	                                    }
	                                });
	                        }]
	                    }
	                });
	        }]);
	})();


/***/ },
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	    'use strict';

	    __webpack_require__(2);

	    angular.module('appTherapist', ['vcRecaptcha',
	        /*
	         * Everybody has access to these.
	         * We could place these under every feature area,
	         * but this is easier to maintain.
	         */
	        'app.core',
	        'app.data', // needs core
	        'app.widgets', // needs core
	        /*SHELL*/
	        'app.layout',
	        'app.login',
	        'app.language',
	        'app.booking'
	        /* features*/
	        //'app.association',
	        //'app.therapistMaster',
	        //'app.therapist',
	        //'app.clinicMaster',
	        //'app.clinic',

	        //'app.preference',
	        //'app.dynamic',
	        //'app.advisor',
	        //'app.formly'
	    ]);

	    __webpack_require__(274);
	})();


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	(function() {
	    var app = angular.module('appTherapist');
	    app.config(['$stateProvider', 'DOMAIN_UI', '$locationProvider', '$ocLazyLoadProvider',
	        function ($stateProvider, DOMAIN_UI, $locationProvider, $ocLazyLoadProvider) {

	            var config = {
	                docTitle: undefined,
	                resolveAlways: {},
	                parent:'layout'
	            };

	            // with lazy loading
	            $stateProvider

	                .state('therapistMaster', {
	                    abstract: true,
	                    url: '',
	                    controller: 'TherapistMasterController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'therapistMaster',
	                    data:{
	                        home: 'therapistClinic',
	                    },
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(3/* duplicate */, function () {
	                            var template = __webpack_require__(236);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', 'language', function ($q, $ocLazyLoad, language) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(4/* duplicate */, function () {
	                                __webpack_require__(237);
	                                __webpack_require__(238);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapistMaster'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.page.getFooterContent($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('therapistClinic', {
	                    parent: 'therapistMaster',
	                    url: '',
	                    controller: 'TherapistController',
	                    controllerAs: 'vm',
	                    title: 'Therapist - Clinic',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Therapist'
	                    },
	                    //resolve:{
	                    //    calendarProfile:getCalendarProfile
	                    //},
	                    obtVid: 3,
	                    obtPage: 2,
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(7/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(242)
	                                : __webpack_require__(243);
	                            // var template = require('html!./therapist/therapist.html');
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['language', 'data_footer', '$q', '$ocLazyLoad', function (language, data_footer, $q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(8/* duplicate */, function () {
	                                __webpack_require__(244);
	                                __webpack_require__(245);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapist'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_profile: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);
	                        }]
	                        ,
	                        data_calendar: /*@ngInject*/["module", "dataservice", "$stateParams", function(module, dataservice, $stateParams){
	                            return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('preferenceTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/p/:uId',
	                    controller: 'PreferenceController',
	                    controllerAs: 'vm',
	                    title: 'preference',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Preference'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapistClinic',
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(12/* duplicate */, function () {
	                            var template = __webpack_require__(249);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(13/* duplicate */, function () {
	                                __webpack_require__(250);
	                                __webpack_require__(251);
	                                $ocLazyLoad.load({
	                                    name: 'app.preference'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('historyTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/h/:uId',
	                    controller: 'HistoryController',
	                    controllerAs: 'vm',
	                    title: 'history',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> History'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapistClinic',
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(14/* duplicate */, function () {
	                            var template = __webpack_require__(252);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(15/* duplicate */, function () {
	                                __webpack_require__(253);
	                                __webpack_require__(254);
	                                $ocLazyLoad.load({
	                                    name: 'app.history'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_history: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                          return dataservice.preference.getHistory($stateParams.cId, $stateParams.uId);
	                        }]
	                    }
	                })

	                .state('dynamic', {
	                    parent: config.parent,
	                    url: '/dynamicPage/:cId/:kId',
	                    controller: 'DynamicController',
	                    controllerAs: 'vm',
	                    title: 'dynamic',
	                    data:{
	                        home: 'dynamic',
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Dynamic'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(16/* duplicate */, function () {
	                            var template = __webpack_require__(255);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(17/* duplicate */, function () {
	                                __webpack_require__(256);
	                                __webpack_require__(257);
	                                $ocLazyLoad.load({
	                                    name: 'app.dynamic'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                          return dataservice.dynamic.getContent($stateParams.kId, $stateParams.cId)
	                        }]
	                    }
	                })

	                //Parent set to therapistClinic
	                .state('therapistClinic.service', {
	                    //parent: 'therapistClinic',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid : 3,
	                    obtPage: 2,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                          return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })

	                .state('resellerBookingReportTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/report/:uId',
	                    controller: 'resellerBookingReportCtrl',
	                    controllerAs: 'vm',
	                    title: 'report',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> report'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapist',
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(24/* duplicate */, function () {
	                            var template = __webpack_require__(268);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module:['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(25/* duplicate */, function () {
	                                __webpack_require__(269);
	                                __webpack_require__(270);
	                                __webpack_require__(271);
	                                $ocLazyLoad.load({
	                                    name: 'app.resellers'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        comboOptions : /*@ngInject*/["dataservice", "logger", "$stateParams", function loadComboBox(dataservice, logger, $stateParams){
	                            var options = [
	                                {'id': 10, 'name': 'therapists'}
	                            ];
	                            var args = {cId:$stateParams.cId || null };

	                            return dataservice.form.getOptions(options, {isTool:true}, args)
	                                .then(function(result){
	                                    if(result){
	                                        return result;
	                                    }else{
	                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
	                                        return [];
	                                    }
	                                });
	                        }]
	                    }
	                });
	        }]);
	})();


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	    'use strict';

	    __webpack_require__(2);

	    angular.module('appClinic', [
	        /*
	         * Everybody has access to these.
	         * We could place these under every feature area,
	         * but this is easier to maintain.
	         */
	        'app.core',
	        'app.data', // needs core
	        'app.widgets', // needs core
	        /*SHELL*/
	        'app.layout',
	        'app.login',
	        'app.language',
	        'app.booking'
	        /* features*/
	        //'app.association',
	        //'app.therapistMaster',
	        //'app.therapist',
	        //'app.clinicMaster',
	        //'app.clinic',

	        //'app.preference',
	        //'app.dynamic',
	        //'app.advisor',
	        //'app.formly'
	    ]);

	    __webpack_require__(276);
	})();


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	(function () {
	    var app = angular.module('appClinic');
	    app.config(['$stateProvider', '$locationProvider', 'DOMAIN_UI', '$ocLazyLoadProvider', '$urlRouterProvider',
	        function ($stateProvider, $locationProvider, DOMAIN_UI, $ocLazyLoadProvider, $urlRouterProvider) {

	            var config = {
	                docTitle: undefined,
	                resolveAlways: {},
	                parent: 'layout'
	            };

	            // $urlRouterProvider.when('/', '/fr/t/3');

	            // with lazy loading
	            $stateProvider

	                .state('clinicMaster', {
	                    abstract: true,
	                    url: '/:cId',
	                    controller: 'ClinicMasterController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'clinicMaster',
	                    data: {
	                        home: 'clinic'
	                    },
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(5/* duplicate */, function () {
	                            var template = __webpack_require__(239);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(6/* duplicate */, function () {
	                                __webpack_require__(240);
	                                __webpack_require__(241);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinicMaster'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.page.getFooterContent($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('therapist', {
	                    parent: 'clinicMaster',
	                    url: '/t/:tId',
	                    controller: 'TherapistController',
	                    controllerAs: 'vm',
	                    title: 'therapist',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Therapist'
	                    },
	                    obtVid: 1,
	                    obtPage: 2,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(7/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(242)
	                                : __webpack_require__(243);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(8/* duplicate */, function () {
	                                __webpack_require__(244);
	                                __webpack_require__(245);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapist'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_profile: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);
	                        }],
	                        data_calendar: /*@ngInject*/["module", "dataservice", "$stateParams", function(module, dataservice, $stateParams){
	                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('clinic', {
	                    parent: 'clinicMaster',
	                    url: '',
	                    controller: 'ClinicController',
	                    controllerAs: 'vm',
	                    title: 'clinic',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Clinic'
	                    },
	                    obtVid: 1,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(9/* duplicate */, function () {
	                            var template = __webpack_require__(246);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(10/* duplicate */, function () {
	                                __webpack_require__(247);
	                                __webpack_require__(248);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinic'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        calendarProfile: /*@ngInject*/["module", "dataservice", "$stateParams", function (module, dataservice, $stateParams) {
	                            return dataservice.calendar.getProfile($stateParams.cId);
	                        }],
	                        data_clinic: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.clinic.getClinic($stateParams.cId)
	                        }],
	                        data_therapists: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.clinic.getTherapists($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('preference', {
	                    parent: 'clinicMaster',
	                    url: '/p/:uId',
	                    controller: 'PreferenceController',
	                    controllerAs: 'vm',
	                    title: 'preference',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Preference'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(12/* duplicate */, function () {
	                            var template = __webpack_require__(249);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(13/* duplicate */, function () {
	                                __webpack_require__(250);
	                                __webpack_require__(251);
	                                $ocLazyLoad.load({
	                                    name: 'app.preference'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('history', {
	                    parent: 'clinicMaster',
	                    url: '/h/:uId',
	                    controller: 'HistoryController',
	                    controllerAs: 'vm',
	                    title: 'history',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> History'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(14/* duplicate */, function () {
	                            var template = __webpack_require__(252);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(15/* duplicate */, function () {
	                                __webpack_require__(253);
	                                __webpack_require__(254);
	                                $ocLazyLoad.load({
	                                    name: 'app.history'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_history: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.preference.getHistory($stateParams.cId, $stateParams.uId);
	                        }]
	                    }
	                })

	                .state('dynamic', {
	                    parent: config.parent,
	                    url: '/dynamicPage/:cId/:kId',
	                    controller: 'DynamicController',
	                    controllerAs: 'vm',
	                    title: 'dynamic',
	                    // data:{
	                    //     home: '',
	                    // },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Dynamic'
	                    },
	                    obtVid: 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(16/* duplicate */, function () {
	                            var template = __webpack_require__(255);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(17/* duplicate */, function () {
	                                __webpack_require__(256);
	                                __webpack_require__(257);
	                                $ocLazyLoad.load({
	                                    name: 'app.dynamic'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getContent($stateParams.kId, $stateParams.cId)
	                        }]
	                    }
	                })

	                //Parent set to clinic
	                .state('clinic.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid: 1,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })
	                //Parent set to therapist
	                .state('therapist.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid: 1,
	                    obtPage: 2,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })

	                //resellers report
	                .state('resellerBookingReport', {
	                    parent: 'clinicMaster',
	                    url: '/report/:uId',
	                    controller: 'resellerBookingReportCtrl',
	                    controllerAs: 'vm',
	                    title: 'report',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> report'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(24/* duplicate */, function () {
	                            var template = __webpack_require__(268);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(25/* duplicate */, function () {
	                                __webpack_require__(269);
	                                __webpack_require__(270);
	                                __webpack_require__(271);
	                                $ocLazyLoad.load({
	                                    name: 'app.resellers'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        comboOptions: /*@ngInject*/["dataservice", "logger", "$stateParams", function loadComboBox(dataservice, logger, $stateParams) {
	                            var options = [
	                                {'id': 10, 'name': 'therapists'}
	                            ];
	                            var args = {cId: $stateParams.cId || null};

	                            return dataservice.form.getOptions(options, {isTool: true}, args)
	                                .then(function (result) {
	                                    if (result) {
	                                        return result;
	                                    } else {
	                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
	                                        return [];
	                                    }
	                                });
	                        }]
	                    }
	                })

	        }]);
	})();


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	    'use strict';

	    __webpack_require__(2);

	    angular.module('appClinicNoParams', [
	        /*
	         * Everybody has access to these.
	         * We could place these under every feature area,
	         * but this is easier to maintain.
	         */
	        'app.core',
	        'app.data', // needs core
	        'app.widgets', // needs core
	        /*SHELL*/
	        'app.layout',
	        'app.login',
	        'app.language',
	        'app.booking'
	        /* features*/
	        //'app.association',
	        //'app.therapistMaster',
	        //'app.therapist',
	        //'app.clinicMaster',
	        //'app.clinic',

	        //'app.preference',
	        //'app.dynamic',
	        //'app.advisor',
	        //'app.formly'
	    ]);

	    __webpack_require__(278);
	})();


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	(function () {
	    var app = angular.module('appClinicNoParams');
	    app.config(['$stateProvider', '$locationProvider', 'DOMAIN_UI', '$ocLazyLoadProvider', '$urlRouterProvider',
	        function ($stateProvider, $locationProvider, DOMAIN_UI, $ocLazyLoadProvider, $urlRouterProvider) {

	            var config = {
	                docTitle: undefined,
	                resolveAlways: {},
	                parent: 'layout'
	            };

	            // $urlRouterProvider.when('/', '/fr/t/3');

	            // with lazy loading
	            $stateProvider

	                .state('clinicMaster', {
	                    abstract: true,
	                    // url: '/:cId',
	                    url: '',
	                    controller: 'ClinicMasterController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'clinicMaster',
	                    data: {
	                        home: 'clinic'
	                    },
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(5/* duplicate */, function () {
	                            var template = __webpack_require__(239);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(6/* duplicate */, function () {
	                                __webpack_require__(240);
	                                __webpack_require__(241);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinicMaster'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.page.getFooterContent($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('therapist', {
	                    parent: 'clinicMaster',
	                    url: '/t/:tId',
	                    controller: 'TherapistController',
	                    controllerAs: 'vm',
	                    title: 'therapist',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Therapist'
	                    },
	                    obtVid: 1,
	                    obtPage: 2,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(7/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(242)
	                                : __webpack_require__(243);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(8/* duplicate */, function () {
	                                __webpack_require__(244);
	                                __webpack_require__(245);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapist'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_profile: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);

	                        }],
	                        data_calendar: /*@ngInject*/["module", "dataservice", "$stateParams", function(module, dataservice, $stateParams){
	                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('clinic', {
	                    parent: 'clinicMaster',
	                    url: '',
	                    controller: 'ClinicController',
	                    controllerAs: 'vm',
	                    title: 'clinic',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Clinic'
	                    },
	                    obtVid: 1,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(9/* duplicate */, function () {
	                            var template = __webpack_require__(246);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(10/* duplicate */, function () {
	                                __webpack_require__(247);
	                                __webpack_require__(248);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinic'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        calendarProfile: /*@ngInject*/["module", "dataservice", "$stateParams", function (module, dataservice, $stateParams) {
	                            return dataservice.calendar.getProfile($stateParams.cId);
	                        }],
	                        data_clinic: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.clinic.getClinic($stateParams.cId)
	                        }],
	                        data_therapists: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.clinic.getTherapists($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('preference', {
	                    parent: 'clinicMaster',
	                    url: '/p/:uId',
	                    controller: 'PreferenceController',
	                    controllerAs: 'vm',
	                    title: 'preference',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Preference'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(12/* duplicate */, function () {
	                            var template = __webpack_require__(249);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(13/* duplicate */, function () {
	                                __webpack_require__(250);
	                                __webpack_require__(251);
	                                $ocLazyLoad.load({
	                                    name: 'app.preference'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('history', {
	                    parent: 'clinicMaster',
	                    url: '/h/:uId',
	                    controller: 'HistoryController',
	                    controllerAs: 'vm',
	                    title: 'history',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> History'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(14/* duplicate */, function () {
	                            var template = __webpack_require__(252);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(15/* duplicate */, function () {
	                                __webpack_require__(253);
	                                __webpack_require__(254);
	                                $ocLazyLoad.load({
	                                    name: 'app.history'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_history: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.preference.getHistory($stateParams.cId, $stateParams.uId);
	                        }]
	                    }
	                })

	                .state('dynamic', {
	                    parent: config.parent,
	                    url: '/dynamicPage/:cId/:kId',
	                    controller: 'DynamicController',
	                    controllerAs: 'vm',
	                    title: 'dynamic',
	                    // data:{
	                    //     home: '',
	                    // },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Dynamic'
	                    },
	                    obtVid: 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(16/* duplicate */, function () {
	                            var template = __webpack_require__(255);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(17/* duplicate */, function () {
	                                __webpack_require__(256);
	                                __webpack_require__(257);
	                                $ocLazyLoad.load({
	                                    name: 'app.dynamic'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getContent($stateParams.kId, $stateParams.cId)
	                        }]
	                    }
	                })

	                //Parent set to clinic
	                .state('clinic.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid: 1,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })
	                //Parent set to therapist
	                .state('therapist.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid: 1,
	                    obtPage: 2,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })

	                //resellers report
	                .state('resellerBookingReport', {
	                    parent: 'clinicMaster',
	                    url: '/report/:uId',
	                    controller: 'resellerBookingReportCtrl',
	                    controllerAs: 'vm',
	                    title: 'report',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> report'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(24/* duplicate */, function () {
	                            var template = __webpack_require__(268);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(25/* duplicate */, function () {
	                                __webpack_require__(269);
	                                __webpack_require__(270);
	                                __webpack_require__(271);
	                                $ocLazyLoad.load({
	                                    name: 'app.resellers'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        comboOptions: /*@ngInject*/["dataservice", "logger", "$stateParams", function loadComboBox(dataservice, logger, $stateParams) {
	                            var options = [
	                                {'id': 10, 'name': 'therapists'}
	                            ];
	                            var args = {cId: $stateParams.cId || null};

	                            return dataservice.form.getOptions(options, {isTool: true}, args)
	                                .then(function (result) {
	                                    if (result) {
	                                        return result;
	                                    } else {
	                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
	                                        return [];
	                                    }
	                                });
	                        }]
	                    }
	                })

	        }]);
	})();


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	    'use strict';

	    __webpack_require__(2);

	    angular.module('appClinicTherapist', [
	        /*
	         * Everybody has access to these.
	         * We could place these under every feature area,
	         * but this is easier to maintain.
	         */
	        'app.core',
	        'app.data', // needs core
	        'app.widgets', // needs core
	        /*SHELL*/
	        'app.layout',
	        'app.login',
	        'app.language',
	        'app.booking'
	        /* features*/
	        //'app.association',
	        //'app.therapistMaster',
	        //'app.therapist',
	        //'app.clinicMaster',
	        //'app.clinic',

	        //'app.preference',
	        //'app.dynamic',
	        //'app.advisor',
	        //'app.formly'
	    ]);

	    __webpack_require__(280);
	})();


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	(function () {
	    var app = angular.module('appClinicTherapist');
	    app.config(['$stateProvider', '$locationProvider', 'DOMAIN_UI', '$ocLazyLoadProvider', '$urlRouterProvider',
	        function ($stateProvider, $locationProvider, DOMAIN_UI, $ocLazyLoadProvider, $urlRouterProvider) {

	            var config = {
	                docTitle: undefined,
	                resolveAlways: {},
	                parent: 'layout'
	            };

	            // $urlRouterProvider.when('/', '/fr/t/3');

	            // with lazy loading
	            $stateProvider

	                .state('clinicMaster', {
	                    abstract: true,
	                    // url: '/:cId',
	                    url:'',
	                    controller: 'ClinicMasterController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'clinicMaster',
	                    data: {
	                        home: 'therapist'
	                    },
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(26, function () {
	                            var template = __webpack_require__(281);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(6/* duplicate */, function () {
	                                __webpack_require__(240);
	                                __webpack_require__(241);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinicMaster'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.page.getFooterContent($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('therapist', {
	                    parent: 'clinicMaster',
	                    // url: '/:tId',
	                    url: '',
	                    controller: 'TherapistController',
	                    controllerAs: 'vm',
	                    title: 'therapist',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Therapist'
	                    },
	                    obtVid: 1,
	                    obtPage: 2,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(7/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(242)
	                                : __webpack_require__(243);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(8/* duplicate */, function () {
	                                __webpack_require__(244);
	                                __webpack_require__(245);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapist'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_profile: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);
	                        }],
	                        data_calendar: /*@ngInject*/["module", "dataservice", "$stateParams", function(module, dataservice, $stateParams){
	                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('preference', {
	                    parent: 'clinicMaster',
	                    url: '/p/:uId',
	                    controller: 'PreferenceController',
	                    controllerAs: 'vm',
	                    title: 'preference',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Preference'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(12/* duplicate */, function () {
	                            var template = __webpack_require__(249);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(13/* duplicate */, function () {
	                                __webpack_require__(250);
	                                __webpack_require__(251);
	                                $ocLazyLoad.load({
	                                    name: 'app.preference'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('history', {
	                    parent: 'clinicMaster',
	                    url: '/h/:uId',
	                    controller: 'HistoryController',
	                    controllerAs: 'vm',
	                    title: 'history',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> History'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(14/* duplicate */, function () {
	                            var template = __webpack_require__(252);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(15/* duplicate */, function () {
	                                __webpack_require__(253);
	                                __webpack_require__(254);
	                                $ocLazyLoad.load({
	                                    name: 'app.history'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_history: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.preference.getHistory($stateParams.cId, $stateParams.uId);
	                        }]
	                    }
	                })

	                .state('dynamic', {
	                    parent: config.parent,
	                    url: '/dynamicPage/:cId/:kId',
	                    controller: 'DynamicController',
	                    controllerAs: 'vm',
	                    title: 'dynamic',
	                    // data:{
	                    //     home: '',
	                    // },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Dynamic'
	                    },
	                    obtVid: 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(16/* duplicate */, function () {
	                            var template = __webpack_require__(255);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(17/* duplicate */, function () {
	                                __webpack_require__(256);
	                                __webpack_require__(257);
	                                $ocLazyLoad.load({
	                                    name: 'app.dynamic'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getContent($stateParams.kId, $stateParams.cId)
	                        }]
	                    }
	                })

	                //Parent set to therapist
	                .state('therapist.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid: 1,
	                    obtPage: 2,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })

	                //resellers report
	                .state('resellerBookingReport', {
	                    parent: 'clinicMaster',
	                    url: '/report/:uId',
	                    controller: 'resellerBookingReportCtrl',
	                    controllerAs: 'vm',
	                    title: 'report',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> report'
	                    },
	                    obtVid: 1,
	                    obtPage: 3,
	                    logoutState: 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(24/* duplicate */, function () {
	                            var template = __webpack_require__(268);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(25/* duplicate */, function () {
	                                __webpack_require__(269);
	                                __webpack_require__(270);
	                                __webpack_require__(271);
	                                $ocLazyLoad.load({
	                                    name: 'app.resellers'
	                                }).then(function () {
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        comboOptions: /*@ngInject*/["dataservice", "logger", "$stateParams", function loadComboBox(dataservice, logger, $stateParams) {
	                            var options = [
	                                {'id': 10, 'name': 'therapists'}
	                            ];
	                            var args = {cId: $stateParams.cId || null};

	                            return dataservice.form.getOptions(options, {isTool: true}, args)
	                                .then(function (result) {
	                                    if (result) {
	                                        return result;
	                                    } else {
	                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
	                                        return [];
	                                    }
	                                });
	                        }]
	                    }
	                })

	        }]);
	})();


/***/ },
/* 281 */,
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	    'use strict';

	    __webpack_require__(2);

	    angular.module('appAssociation', [
	        /*
	         * Everybody has access to these.
	         * We could place these under every feature area,
	         * but this is easier to maintain.
	         */
	        'app.core',
	        'app.data', // needs core
	        'app.widgets', // needs core
	        /*SHELL*/
	        'app.layout',
	        'app.login',
	        'app.language',
	        'app.booking'
	        /* features*/
	        //'app.association',
	        //'app.therapistMaster',
	        //'app.therapist',
	        //'app.clinicMaster',
	        //'app.clinic',

	        //'app.preference',
	        //'app.dynamic',
	        //'app.advisor',
	        //'app.formly'
	    ]);

	    __webpack_require__(283);
	})();


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	(function() {
	    var app = angular.module('appAssociation');
	    app.config(['$stateProvider', '$locationProvider', '$ocLazyLoadProvider',
	        function ($stateProvider, $locationProvider, $ocLazyLoadProvider) {

	            var config = {
	                docTitle: undefined,
	                resolveAlways: {},
	                parent:'layout'
	            };

	            // with lazy loading
	            $stateProvider
	                //Association
	                .state('association', {
	                    url: '/:cId',
	                    controller: 'AssociationController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'association',
	                    data:{
	                        home: 'association',
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Association'
	                    },
	                    obtVid : 2,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(1/* duplicate */, function () {
	                            //var isMobile = false;
	                            //var templateName = isMobile ? './association/association_mobile.html' : './association/association.html';
	                            //var templateName = './association/association.html';
	                            var template = __webpack_require__(233);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(2/* duplicate */, function () {
	                                __webpack_require__(234);
	                                __webpack_require__(235);
	                                $ocLazyLoad.load({
	                                    name: 'app.association'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.page.getFooterContent($stateParams.cId);
	                        }],
	                        data_association: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.association.getAssociation($stateParams.cId);
	                        }],
	                        data_therapists: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.association.getTherapists($stateParams.cId);
	                        }]
	                    }
	                })
	        }]);
	})();


/***/ },
/* 284 */
/***/ function(module, exports) {

	(function() {
	    var initInjector = angular.injector(['ng']); //, 'app.data', 'app.core'

	    var $http = initInjector.get('$http');
	    //var oracleServices = initInjector.get('oracleServices');
	    //oracleServices.getFallbackPage({url:'toto_is_testing'})
	    $http.get('./php/getDomainInfo.php')
	        .then(function (response){
	                //{mode:'c', cId:{value:'cpoq', squash: true}} }
	                console.log(response.data);
	                // response.data = {args:{
	                    // cId:{squash:false,value:"barber"},
	                    // language:{squash:false,value:"fr"},
	                    // tId:{squash:false,value:"3"}
	                    // },
	                    // mode:"ct"};

	                // console.log('+--- Updated domain config --> ',response.data);
	                var domain = response && response.data;
	                var mode = domain ? domain.mode : null;
	                if (mode){
	                    var DOMAIN_CONFIG = domain ? domain.args : {};

	                    var appName = 'app';
	                    switch (mode){
	                        case 'a':
	                            appName='appAssociation';
	                            break;

	                        case 't':
	                            appName='appTherapist';
	                            break;

	                        case 'c':
	                            appName='appClinic';
	                            break;

	                        case 'cx':
	                            appName='appClinicNoParams';
	                            break;

	                        case 'ct':
	                            appName='appClinicTherapist';
	                            break;

	                        case 'l':
	                            appName='appAdvisor';
	                            break;

	                        default:
	                            appName='app';
	                            DOMAIN_CONFIG = {};
	                    }

	                    angular.module(appName).constant('DOMAINCONFIG', DOMAIN_CONFIG);
	                    angular.module(appName).constant('DOMAINMODE', mode);
	                    angular.module(appName).constant('DOMAIN_UI', {'skin':domain ? domain.skin : null, 'mode':domain ? domain.template : null});
	                    angular.element(document).ready(function() {
	                        var visitor_id;
	                        _paq.push([ function() {
	                            visitor_id = this.getVisitorId();
	                            angular.module(appName).constant('PIWIKUID', visitor_id);
	                            console.log('piwik UID', visitor_id);
	                        }]);
	                        angular.bootstrap(document, [appName]);


	                    });
	                }else{
	                    // redirect to SimplifyStack 404 pages
	                    // window.location.replace('http://www.simplifystack.com/');

	                    //redirect to 404
	                    window.location.replace('./404.html');
	                }
	            }
	        );
	})();


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	(function () {
	    'use strict';

	    __webpack_require__(2);

	    angular.module('appAdvisor', [
	        /*
	         * Everybody has access to these.
	         * We could place these under every feature area,
	         * but this is easier to maintain.
	         */
	        'app.core',
	        'app.data', // needs core
	        'app.widgets', // needs core
	        /*SHELL*/
	        'app.layout',
	        'app.login',
	        'app.language',
	        'app.booking'
	        /* features*/
	        //'app.association',
	        //'app.therapistMaster',
	        //'app.therapist',
	        //'app.clinicMaster',
	        //'app.clinic',

	        //'app.preference',
	        //'app.dynamic',
	        //'app.advisor',
	        //'app.formly'
	    ]);

	    __webpack_require__(286);
	})();


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by pmnia on 7/1/15.
	 */
	(function() {
	    var app = angular.module('appAdvisor');
	    app.config(['$stateProvider', '$locationProvider', 'DOMAIN_UI', '$ocLazyLoadProvider', '$urlRouterProvider',
	        function ($stateProvider, $locationProvider, DOMAIN_UI, $ocLazyLoadProvider, $urlRouterProvider) {

	            var config = {
	                docTitle: undefined,
	                resolveAlways: {},
	                parent:'layout'
	            };



	            // with lazy loading
	            $stateProvider
	                .state('association', {
	                    url: '/a/:cId',
	                    controller: 'AssociationController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'association',
	                    data:{
	                        home: 'association',
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Association'
	                    },
	                    obtVid : 2,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(1/* duplicate */, function () {
	                            //var isMobile = false;
	                            //var templateName = isMobile ? './association/association_mobile.html' : './association/association.html';
	                            //var templateName = './association/association.html';
	                            var template = __webpack_require__(233);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(2/* duplicate */, function () {
	                                __webpack_require__(234);
	                                __webpack_require__(235);
	                                $ocLazyLoad.load({
	                                    name: 'app.association'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.page.getFooterContent($stateParams.cId);
	                        }],
	                        data_association: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.association.getAssociation($stateParams.cId);
	                        }],
	                        data_therapists: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.association.getTherapists($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('clinicMaster', {
	                    abstract: true,
	                    url: '/c/:cId',
	                    controller: 'ClinicMasterController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'clinicMaster',
	                    data:{
	                        home: 'clinic',
	                    },
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(5/* duplicate */, function () {
	                            var template = __webpack_require__(239);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(6/* duplicate */, function () {
	                                __webpack_require__(240);
	                                __webpack_require__(241);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinicMaster'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                            return dataservice.page.getFooterContent($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('therapist', {
	                    parent : 'clinicMaster',
	                    url: '/t/:tId',
	                    controller: 'TherapistController',
	                    controllerAs: 'vm',
	                    title: 'therapist',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Therapist'
	                    },
	                    obtVid : 1,
	                    obtPage: 2,
	                    logoutState : 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(7/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(242)
	                                : __webpack_require__(243);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(8/* duplicate */, function () {
	                                __webpack_require__(244);
	                                __webpack_require__(245);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapist'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_profile: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);
	                        }],
	                        data_calendar: /*@ngInject*/["module", "dataservice", "$stateParams", function(module, dataservice, $stateParams){
	                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('preference', {
	                    parent : 'clinicMaster',
	                    url: '/p/:uId',
	                    controller: 'PreferenceController',
	                    controllerAs: 'vm',
	                    title: 'preference',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Preference'
	                    },
	                    obtVid : 1,
	                    obtPage: 3,
	                    logoutState : 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(12/* duplicate */, function () {
	                            var template = __webpack_require__(249);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(13/* duplicate */, function () {
	                                __webpack_require__(250);
	                                __webpack_require__(251);
	                                $ocLazyLoad.load({
	                                    name: 'app.preference'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('clinic', {
	                    parent : 'clinicMaster',
	                    url: '',
	                    controller: 'ClinicController',
	                    controllerAs: 'vm',
	                    title: 'clinic',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Clinic'
	                    },
	                    obtVid : 1,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(9/* duplicate */, function () {
	                            var template = __webpack_require__(246);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(10/* duplicate */, function () {
	                                __webpack_require__(247);
	                                __webpack_require__(248);
	                                $ocLazyLoad.load({
	                                    name: 'app.clinic'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        calendarProfile: /*@ngInject*/["module", "dataservice", "$stateParams", function (module, dataservice, $stateParams) {
	                            return dataservice.calendar.getProfile($stateParams.cId);
	                        }],
	                        data_clinic: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.clinic.getClinic($stateParams.cId)
	                        }],
	                        data_therapists: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.clinic.getTherapists($stateParams.cId);
	                        }]
	                    }
	                })

	                .state('therapistClinic', {
	                    parent: 'therapistMaster',
	                    url: '',
	                    controller: 'TherapistController',
	                    controllerAs: 'vm',
	                    title: 'Therapist - Clinic',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Therapist'
	                    },
	                    //resolve:{
	                    //    calendarProfile:getCalendarProfile
	                    //},
	                    obtVid: 3,
	                    obtPage: 2,
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(7/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(242)
	                                : __webpack_require__(243);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(8/* duplicate */, function () {
	                                __webpack_require__(244);
	                                __webpack_require__(245);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapist'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_profile: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                          return dataservice.therapist.getTherapist($stateParams.cId, $stateParams.tId);
	                        }],
	                        data_calendar: /*@ngInject*/["module", "dataservice", "$stateParams", function(module, dataservice, $stateParams){
	                          return dataservice.calendar.getProfile($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('preferenceTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/p/:uId',
	                    controller: 'PreferenceController',
	                    controllerAs: 'vm',
	                    title: 'preference',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Preference'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapistClinic',
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(12/* duplicate */, function () {
	                            var template = __webpack_require__(249);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(13/* duplicate */, function () {
	                                __webpack_require__(250);
	                                __webpack_require__(251);
	                                $ocLazyLoad.load({
	                                    name: 'app.preference'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('history', {
	                    parent : 'clinicMaster',
	                    url: '/h/:uId',
	                    controller: 'HistoryController',
	                    controllerAs: 'vm',
	                    title: 'history',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> History'
	                    },
	                    obtVid : 1,
	                    obtPage: 3,
	                    logoutState : 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(14/* duplicate */, function () {
	                            var template = __webpack_require__(252);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(15/* duplicate */, function () {
	                                __webpack_require__(253);
	                                __webpack_require__(254);
	                                $ocLazyLoad.load({
	                                    name: 'app.history'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_history: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.preference.getHistory($stateParams.cId, $stateParams.uId);
	                        }]
	                    }
	                })

	                .state('historyTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/h/:uId',
	                    controller: 'HistoryController',
	                    controllerAs: 'vm',
	                    title: 'history',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> History'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapistClinic',
	                    preferenceState : 'preferenceTherapist',
	                    historyState : 'historyTherapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(14/* duplicate */, function () {
	                            var template = __webpack_require__(252);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(15/* duplicate */, function () {
	                                __webpack_require__(253);
	                                __webpack_require__(254);
	                                $ocLazyLoad.load({
	                                    name: 'app.history'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_history: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.preference.getHistory($stateParams.cId, $stateParams.uId);
	                        }]
	                    }
	                })

	                .state('dynamic', {
	                    parent: config.parent,
	                    url: '/dynamicPage/:cId/:kId',
	                    controller: 'DynamicController',
	                    controllerAs: 'vm',
	                    title: 'dynamic',
	                    // data:{
	                    //     home: '',
	                    // },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Dynamic'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(16/* duplicate */, function () {
	                            var template = __webpack_require__(255);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(17/* duplicate */, function () {
	                                __webpack_require__(256);
	                                __webpack_require__(257);
	                                $ocLazyLoad.load({
	                                    name: 'app.dynamic'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getContent($stateParams.kId, $stateParams.cId)
	                        }]
	                    }
	                })

	                //Parent set to clinic
	                .state('clinic.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid : 1,
	                    obtPage: 1,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })
	                //Parent set to therapist
	                .state('therapist.service', {
	                    //parent: 'therapist',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid: 1,
	                    obtPage: 2,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })

	                //Parent set to therapistClinic
	                .state('therapistClinic.service', {
	                    //parent: 'therapistClinic',
	                    url: '/service/:sId',
	                    controller: 'ServiceController',
	                    controllerAs: 'vmService',
	                    title: 'service',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Service'
	                    },
	                    obtVid : 3,
	                    obtPage: 2,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(18/* duplicate */, function () {
	                            var template = (DOMAIN_UI.mode == 2)
	                                ? __webpack_require__(258)
	                                : __webpack_require__(259);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(19/* duplicate */, function () {
	                                __webpack_require__(260);
	                                __webpack_require__(261);
	                                $ocLazyLoad.load({
	                                    name: 'app.service'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        data_content: /*@ngInject*/["module", "dataservice", "$stateParams", "$state", function(module, dataservice, $stateParams, $state){
	                            return dataservice.dynamic.getServiceContent($stateParams.sId, $stateParams.cId);
	                        }]
	                    }
	                })

	                .state('formly', {
	                    parent: config.parent,
	                    url: '/formly/:cId/:kId',
	                    controller: 'FormlyController',
	                    controllerAs: 'vm',
	                    title: 'formly',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Formly'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(22/* duplicate */, function () {
	                            var template = __webpack_require__(265);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(23/* duplicate */, function () {
	                                //require('./../bower_components/apiCheck/dist/api-check.min.js');
	                                //require('./../bower_components/angular-formly/dist/formly.min.js');
	                                //require('./../bower_components/angular-formly-templates-bootstrap/dist/angular-formly-templates-bootstrap.min.js');
	                                __webpack_require__(266);
	                                __webpack_require__(267);
	                                $ocLazyLoad.load({
	                                    name: 'app.formly'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                //resellers report
	                .state('resellerBookingReport', {
	                    parent : 'clinicMaster',
	                    url: '/report/:uId',
	                    controller: 'resellerBookingReportCtrl',
	                    controllerAs: 'vm',
	                    title: 'report',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> report'
	                    },
	                    obtVid : 1,
	                    obtPage: 3,
	                    logoutState : 'clinic',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(24/* duplicate */, function () {
	                            var template = __webpack_require__(268);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module:['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(25/* duplicate */, function () {
	                                __webpack_require__(269);
	                                __webpack_require__(270);
	                                __webpack_require__(271);
	                                $ocLazyLoad.load({
	                                    name: 'app.resellers'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        comboOptions : /*@ngInject*/["dataservice", "logger", "$stateParams", function loadComboBox(dataservice, logger, $stateParams){
	                            var options = [
	                                {'id': 10, 'name': 'therapists'}
	                            ];
	                            var args = {cId:$stateParams.cId || null };

	                            return dataservice.form.getOptions(options, {isTool:true}, args)
	                                .then(function(result){
	                                    if(result){
	                                        return result;
	                                    }else{
	                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
	                                        return [];
	                                    }
	                                });
	                        }]
	                    }
	                })

	                .state('resellerBookingReportTherapist', {
	                    parent : 'therapistMaster',
	                    url: '/report/:uId',
	                    controller: 'resellerBookingReportCtrl',
	                    controllerAs: 'vm',
	                    title: 'report',
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> report'
	                    },
	                    obtVid : 3,
	                    obtPage: 3,
	                    logoutState : 'therapist',
	                    resellerState : 'resellerBookingReportTherapist',
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(24/* duplicate */, function () {
	                            var template = __webpack_require__(268);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module:['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(25/* duplicate */, function () {
	                                __webpack_require__(269);
	                                __webpack_require__(270);
	                                __webpack_require__(271);
	                                $ocLazyLoad.load({
	                                    name: 'app.resellers'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });
	                            return deferred.promise;
	                        }],
	                        comboOptions : /*@ngInject*/["dataservice", "logger", "$stateParams", function loadComboBox(dataservice, logger, $stateParams){
	                            var options = [
	                                {'id': 10, 'name': 'therapists'}
	                            ];
	                            var args = {cId:$stateParams.cId || null };

	                            return dataservice.form.getOptions(options, {isTool:true}, args)
	                                .then(function(result){
	                                    if(result){
	                                        return result;
	                                    }else{
	                                        logger.error(result.body ? result.body : 'Get combobox options failed', result);
	                                        return [];
	                                    }
	                                });
	                        }]
	                    }
	                })

	                .state('therapistMaster', {
	                    abstract: true,
	                    url: '/t/:cId/:tId',
	                    controller: 'TherapistMasterController',
	                    controllerAs: 'vm',
	                    parent: config.parent,
	                    title: 'therapistMaster',
	                    data:{
	                        home: 'therapistClinic',
	                    },
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(3/* duplicate */, function () {
	                            var template = __webpack_require__(236);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(4/* duplicate */, function () {
	                                __webpack_require__(237);
	                                __webpack_require__(238);
	                                $ocLazyLoad.load({
	                                    name: 'app.therapistMaster'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }],
	                        data_footer: /*@ngInject*/["dataservice", "$stateParams", function(dataservice, $stateParams){
	                          return dataservice.page.getFooterContent($stateParams.cId, $stateParams.tId);
	                        }]
	                    }
	                })

	                .state('advisor_wl', {
	                    parent: config.parent,
	                    url: '/:cId/:wq/:lq',
	                    controller: 'AdvisorController',
	                    controllerAs: 'vm',
	                    title: 'advisor',
	                    data:{
	                        home: 'advisor_wl',
	                    },
	                    params: {
	                        language: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.language && DOMAINCONFIG.language.value ? DOMAINCONFIG.language.value : undefined}], squash: true},
	                        cId: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.cId && DOMAINCONFIG.cId.value ? DOMAINCONFIG.cId.value : undefined }], squash: true},
	                        wq: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.wq && DOMAINCONFIG.wq.value ? DOMAINCONFIG.wq.value : undefined }], squash: true},
	                        lq: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.lq && DOMAINCONFIG.lq.value ? DOMAINCONFIG.lq.value : undefined }], squash: true}
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Advisor'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(20/* duplicate */, function () {
	                            var template = __webpack_require__(262);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(21/* duplicate */, function () {
	                                __webpack_require__(263);
	                                __webpack_require__(264);
	                                $ocLazyLoad.load({
	                                    name: 'app.advisor'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('advisor_w', {
	                    parent: config.parent,
	                    url: '/:cId/:wq',
	                    controller: 'AdvisorController',
	                    controllerAs: 'vm',
	                    title: 'advisor',
	                    data:{
	                        home: 'advisor_w',
	                    },
	                    params: {
	                        language: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.language && DOMAINCONFIG.language.value ? DOMAINCONFIG.language.value : undefined}], squash: true},
	                        cId: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.cId && DOMAINCONFIG.cId.value ? DOMAINCONFIG.cId.value : undefined }], squash: true},
	                        wq: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.wq && DOMAINCONFIG.wq.value ? DOMAINCONFIG.wq.value : undefined }], squash: true},
	                        lq: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.lq && DOMAINCONFIG.lq.value ? DOMAINCONFIG.lq.value : undefined }], squash: true}
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Advisor'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(20/* duplicate */, function () {
	                            var template = __webpack_require__(262);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(21/* duplicate */, function () {
	                                __webpack_require__(263);
	                                __webpack_require__(264);
	                                $ocLazyLoad.load({
	                                    name: 'app.advisor'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                })

	                .state('advisor', {
	                    parent: config.parent,
	                    url: ':cId',  //:cId
	                    controller: 'AdvisorController',
	                    controllerAs: 'vm',
	                    title: 'advisor',
	                    data:{
	                        home: 'advisor',
	                    },
	                    params: {
	                        language: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.language && DOMAINCONFIG.language.value ? DOMAINCONFIG.language.value : undefined}], squash: true},
	                        cId: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.cId && DOMAINCONFIG.cId.value ? DOMAINCONFIG.cId.value : undefined }], squash: true},
	                        wq: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.wq && DOMAINCONFIG.wq.value ? DOMAINCONFIG.wq.value : undefined }], squash: true},
	                        lq: {value: /*@ngInject*/["DOMAINCONFIG", function(DOMAINCONFIG){return DOMAINCONFIG.lq && DOMAINCONFIG.lq.value ? DOMAINCONFIG.lq.value : undefined }], squash: true}
	                    },
	                    settings: {
	                        nav: 1,
	                        content: '<i class="fa fa-dashboard"></i> Advisor'
	                    },
	                    obtVid : 1,
	                    obtPage: 0,
	                    templateProvider: ['$q', function ($q) {
	                        var deferred = $q.defer();
	                        __webpack_require__.e/* nsure */(20/* duplicate */, function () {
	                            var template = __webpack_require__(262);
	                            deferred.resolve(template);
	                        });
	                        return deferred.promise;
	                    }],
	                    resolve: {
	                        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	                            var deferred = $q.defer();
	                            __webpack_require__.e/* nsure */(21/* duplicate */, function () {
	                                __webpack_require__(263);
	                                __webpack_require__(264);
	                                $ocLazyLoad.load({
	                                    name: 'app.advisor'
	                                }).then(function(){
	                                    deferred.resolve(true);
	                                });
	                            });

	                            return deferred.promise;
	                        }]
	                    }
	                });

	            $urlRouterProvider.when('/', '/fr');
	        }
	    ]);
	})();

	//.state('advisor_wl_root', {
	//    parent: config.parent,
	//    url: '',
	//    controller: 'AdvisorController',
	//    controllerAs: 'vm',
	//    title: 'advisor',
	//    params: {
	//        language: {value: /*@ngInject*/function(DOMAINCONFIG){return DOMAINCONFIG.language && DOMAINCONFIG.language.value ? DOMAINCONFIG.language.value : undefined}, squash: true},
	//        cId: {value: /*@ngInject*/function(DOMAINCONFIG){return DOMAINCONFIG.cId && DOMAINCONFIG.cId.value ? DOMAINCONFIG.cId.value : undefined }, squash: true},
	//        wq: {value: /*@ngInject*/function(DOMAINCONFIG){return DOMAINCONFIG.wq && DOMAINCONFIG.wq.value ? DOMAINCONFIG.wq.value : undefined }, squash: true},
	//        lq: {value: /*@ngInject*/function(DOMAINCONFIG){return DOMAINCONFIG.lq && DOMAINCONFIG.lq.value ? DOMAINCONFIG.lq.value : undefined }, squash: true}
	//    },
	//    settings: {
	//        nav: 1,
	//        content: '<i class="fa fa-dashboard"></i> Advisor'
	//    },
	//    obtVid : 1,
	//    obtPage: 0,
	//    templateProvider: ['$q', function ($q) {
	//        var deferred = $q.defer();
	//        require.ensure([], function () {
	//            var template = require('html!./advisor/advisor.html');
	//            deferred.resolve(template);
	//        });
	//        return deferred.promise;
	//    }],
	//    resolve: {
	//        module: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	//            var deferred = $q.defer();
	//            require.ensure([], function () {
	//                require('./advisor/advisor.module.js');
	//                require('./advisor/advisor.controller.js');
	//                $ocLazyLoad.load({
	//                    name: 'app.advisor'
	//                }).then(function(){
	//                    deferred.resolve(true);
	//                });
	//            });
	//
	//            return deferred.promise;
	//        }]
	//    }
	//})


/***/ }
]);


/** WEBPACK FOOTER **
 ** app.bundle.min.js
 **/